import type { ITokenMetadata } from '../types.js'

export const tokens: ITokenMetadata[] = [
  {
    "id": "0x0-ai-ai-smart-contract",
    "filePath": "token:0X0",
    "symbol": "0x0",
    "name": "0x0.ai: AI Smart Contract",
    "marketCapRank": 376,
    "addresses": {
      "ethereum": "0x5a3e6a77ba2f983ec0d371ea3b475f8bc0811ad5"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "0xgasless-2",
    "filePath": "token:0XGAS",
    "symbol": "0xgas",
    "name": "0xGasless",
    "marketCapRank": 3040,
    "addresses": {
      "ethereum": "0x5fc111f3fa4c6b32eaf65659cfebdeed57234069"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "1art",
    "filePath": "token:1ART",
    "symbol": "1art",
    "name": "OneArt",
    "marketCapRank": 2680,
    "addresses": {
      "binance-smart-chain": "0xd3c325848d7c6e29b574cb0789998b2ff901f17e",
      "fantom": "0xd3c325848d7c6e29b574cb0789998b2ff901f17e",
      "ethereum": "0xd3c325848d7c6e29b574cb0789998b2ff901f17e"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "1inch",
    "filePath": "token:1INCH",
    "symbol": "1inch",
    "name": "1inch",
    "marketCapRank": 165,
    "addresses": {
      "ethereum": "0x111111111117dc0aa78b770fa6a738034120c302",
      "harmony-shard-0": "0x58f1b044d8308812881a1433d9bbeff99975e70c",
      "avalanche": "0xd501281565bf7789224523144fe5d98e8b28f267",
      "binance-smart-chain": "0x111111111117dc0aa78b770fa6a738034120c302",
      "near-protocol": "111111111117dc0aa78b770fa6a738034120c302.factory.bridge.near",
      "polygon-pos": "0x9c2c5fd7b07e95ee044ddeba0e97a665f142394f",
      "energi": "0xdda6205dc3f47e5280eb726613b27374eee9d130"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "2dai-io",
    "filePath": "token:2DAI",
    "symbol": "2dai",
    "name": "2DAI.io",
    "marketCapRank": 2443,
    "addresses": {
      "ethereum": "0xb44b653f147569d88a684cbf6549e1968e8b2a1d"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "a-hunters-dream",
    "filePath": "token:CAW",
    "symbol": "caw",
    "name": "A Hunters Dream",
    "marketCapRank": 725,
    "addresses": {
      "ethereum": "0xf3b9569f82b18aef890de263b84189bd33ebe452"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "aag-ventures",
    "filePath": "token:AAG",
    "symbol": "aag",
    "name": "AAG",
    "marketCapRank": 2030,
    "addresses": {
      "ethereum": "0x5ba19d656b65f1684cfea4af428c23b9f3628f97",
      "harmony-shard-0": "0xae0609a062a4eaed49de28c5f6a193261e0150ea"
    },
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "aave",
    "filePath": "token:AAVE",
    "symbol": "aave",
    "name": "Aave",
    "marketCapRank": 66,
    "addresses": {
      "ethereum": "0x7fc66500c84a76ad7e9c93437bfc5ac33e2ddae9",
      "avalanche": "0x63a72806098bd3d9520cc43356dd78afe5d386d9",
      "sora": "0x0091bd8d8295b25cab5a7b8b0e44498e678cfc15d872ede3215f7d4c7635ba36",
      "optimistic-ethereum": "0x76fb31fb4af56892a25e32cfc43de717950c9278",
      "near-protocol": "7fc66500c84a76ad7e9c93437bfc5ac33e2ddae9.factory.bridge.near",
      "huobi-token": "0x202b4936fe1a82a4965220860ae46d7d3939bb25",
      "polygon-pos": "0xd6df932a45c0f255f85145f286ea0b292b21c90b",
      "fantom": "0x6a07a792ab2965c72a5b8088d3a069a7ac3a993b",
      "harmony-shard-0": "0xcf323aad9e522b93f11c352caa519ad0e14eb40f",
      "binance-smart-chain": "0xfb6115445bff7b52feb98650c87f44907e58f802",
      "energi": "0xa7f2f790355e0c32cab03f92f6eb7f488e6f049a"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "aavegotchi",
    "filePath": "token:GHST",
    "symbol": "ghst",
    "name": "Aavegotchi",
    "marketCapRank": 575,
    "addresses": {
      "ethereum": "0x3f382dbd960e3a9bbceae22651e88158d2791550",
      "polygon-pos": "0x385eeac5cb85a38a9a07a70c73e0a3271cfb54a7",
      "energi": "0x4bd75f8c7e067ea9b6e2dfbecd99d805396bc5ff"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "access-protocol",
    "filePath": "token:ACS",
    "symbol": "acs",
    "name": "Access Protocol",
    "marketCapRank": 0,
    "addresses": {},
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "acet-token",
    "filePath": "token:ACT",
    "symbol": "act",
    "name": "Acet",
    "marketCapRank": 0,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "acquire-fi",
    "filePath": "token:ACQ",
    "symbol": "acq",
    "name": "Acquire.Fi",
    "marketCapRank": 1334,
    "addresses": {
      "ethereum": "0x4bdcb66b968060d9390c1d12bd29734496205581"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "acria",
    "filePath": "token:ACRIA",
    "symbol": "acria",
    "name": "Acria.AI",
    "marketCapRank": 1944,
    "addresses": {
      "ethereum": "0x44f5909e97e1cbf5fbbdf0fc92fd83cde5d5c58a",
      "binance-smart-chain": "0x44f5909e97e1cbf5fbbdf0fc92fd83cde5d5c58a"
    },
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "across-protocol",
    "filePath": "token:ACX",
    "symbol": "acx",
    "name": "Across Protocol",
    "marketCapRank": 568,
    "addresses": {
      "ethereum": "0x44108f0223a3c3028f5fe7aec7f9bb2e66bef82f",
      "polygon-pos": "0xf328b73b6c685831f238c30a23fc19140cb4d8fc",
      "optimistic-ethereum": "0xff733b2a3557a7ed6697007ab5d11b79fdd1b76b",
      "arbitrum-one": "0x53691596d1bce8cea565b84d4915e69e03d9c99d",
      "boba": "0x96821b258955587069f680729cd77369c0892b40"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "adapad",
    "filePath": "token:ADAPAD",
    "symbol": "adapad",
    "name": "ADAPad",
    "marketCapRank": 1962,
    "addresses": {
      "binance-smart-chain": "0xdb0170e2d0c1cc1b2e7a90313d9b9afa4f250289",
      "ethereum": "0xdb0170e2d0c1cc1b2e7a90313d9b9afa4f250289"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "aelf",
    "filePath": "token:ELF",
    "symbol": "elf",
    "name": "aelf",
    "marketCapRank": 195,
    "addresses": {
      "ethereum": "0xbf2179859fc6d5bee9bf9158632dc51678a4100e"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "affyn",
    "filePath": "token:FYN",
    "symbol": "fyn",
    "name": "Affyn",
    "marketCapRank": 848,
    "addresses": {
      "polygon-pos": "0x3b56a704c01d650147ade2b8cee594066b3f9421"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "agoras-currency-of-tau",
    "filePath": "token:AGRS",
    "symbol": "agrs",
    "name": "Agoras: Currency of Tau",
    "marketCapRank": 588,
    "addresses": {
      "ethereum": "0x738865301a9b7dd80dc3666dd48cf034ec42bdda"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "agoric",
    "filePath": "token:BLD",
    "symbol": "bld",
    "name": "Agoric",
    "marketCapRank": 576,
    "addresses": {
      "osmosis": "ibc/2DA9C149E9AD2BD27FEFA635458FB37093C256C1A940392634A16BEA45262604",
      "archway": "ibc/8CB56C813A5C2387140BBEAABCCE797AFA0960C8D07B171F71A5188726CFED2C",
      "secret": "secret1uxvpq889uxjcpj656yjjexsqa3zqm6ntkyjsjq"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "ahatoken",
    "filePath": "token:AHT",
    "symbol": "aht",
    "name": "AhaToken",
    "marketCapRank": 771,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "ai-network",
    "filePath": "token:AIN",
    "symbol": "ain",
    "name": "AI Network",
    "marketCapRank": 1388,
    "addresses": {
      "ethereum": "0x3a810ff7211b40c4fa76205a14efe161615d0385"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "aimbot",
    "filePath": "token:AIMBOT",
    "symbol": "aimbot",
    "name": "Aimbot AI",
    "marketCapRank": 1820,
    "addresses": {
      "ethereum": "0x0c48250eb1f29491f1efbeec0261eb556f0973c7"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "aimedis-new",
    "filePath": "token:AIMX",
    "symbol": "aimx",
    "name": "Aimedis (NEW)",
    "marketCapRank": 1928,
    "addresses": {
      "polygon-pos": "0x33b6d77c607ea499ab5db7e2201c5a516a78a5db"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "aioz-network",
    "filePath": "token:AIOZ",
    "symbol": "aioz",
    "name": "AIOZ Network",
    "marketCapRank": 122,
    "addresses": {
      "ethereum": "0x626e8036deb333b408be468f951bdb42433cbf18",
      "binance-smart-chain": "0x33d08d8c7a168333a85285a68c0042b39fc3741d"
    },
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "aipad",
    "filePath": "token:AIPAD",
    "symbol": "aipad",
    "name": "AIPad",
    "marketCapRank": 1249,
    "addresses": {
      "ethereum": "0xe55d97a97ae6a17706ee281486e98a84095d8aaf",
      "binance-smart-chain": "0xe55d97a97ae6a17706ee281486e98a84095d8aaf"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "airbloc-protocol",
    "filePath": "token:ABL",
    "symbol": "abl",
    "name": "Airbloc",
    "marketCapRank": 2698,
    "addresses": {
      "ethereum": "0xf8b358b3397a8ea5464f8cc753645d42e14b79ea"
    },
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "airight",
    "filePath": "token:AIRI",
    "symbol": "airi",
    "name": "aiRight",
    "marketCapRank": 1615,
    "addresses": {
      "binance-smart-chain": "0x7e2a35c746f2f7c240b664f1da4dd100141ae71f"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "airtor-protocol",
    "filePath": "token:ATOR",
    "symbol": "ator",
    "name": "AirTor Protocol",
    "marketCapRank": 313,
    "addresses": {
      "ethereum": "0x0f7b3f5a8fed821c5eb60049538a548db2d479ce"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "aisociety",
    "filePath": "token:AIS",
    "symbol": "ais",
    "name": "AISociety",
    "marketCapRank": 2439,
    "addresses": {
      "ethereum": "0x42a7797351dfd281a80807196c8508eb70bb2af9"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "ait-protocol",
    "filePath": "token:AIT",
    "symbol": "ait",
    "name": "AIT Protocol",
    "marketCapRank": 736,
    "addresses": {
      "ethereum": "0x89d584a1edb3a70b3b07963f9a3ea5399e38b136"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "akash-network",
    "filePath": "token:AKT",
    "symbol": "akt",
    "name": "Akash Network",
    "marketCapRank": 102,
    "addresses": {
      "akash": "uakt"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "alaska-gold-rush",
    "filePath": "token:CARAT",
    "symbol": "carat",
    "name": "Alaska Gold Rush",
    "marketCapRank": 2010,
    "addresses": {
      "binance-smart-chain": "0x426c1c971fb00caaf1883bd801323a8becb0c919"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "alchemix",
    "filePath": "token:ALCX",
    "symbol": "alcx",
    "name": "Alchemix",
    "marketCapRank": 616,
    "addresses": {
      "ethereum": "0xdbdb4d16eda451d0503b854cf79d55697f90c8df",
      "near-protocol": "dbdb4d16eda451d0503b854cf79d55697f90c8df.factory.bridge.near"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "alchemy-pay",
    "filePath": "token:ACH",
    "symbol": "ach",
    "name": "Alchemy Pay",
    "marketCapRank": 355,
    "addresses": {
      "ethereum": "0xed04915c23f00a313a544955524eb7dbd823143d",
      "binance-smart-chain": "0xbc7d6b50616989655afd682fb42743507003056d"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "aldrin",
    "filePath": "token:RIN",
    "symbol": "rin",
    "name": "Aldrin",
    "marketCapRank": 2004,
    "addresses": {
      "solana": "E5ndSkaB17Dm7CsD22dvcjfrYSDLCxFcMd6z8ddCk5wp"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "aleph",
    "filePath": "token:ALEPH",
    "symbol": "aleph",
    "name": "Aleph.im",
    "marketCapRank": 758,
    "addresses": {
      "ethereum": "0x27702a26126e0b3702af63ee09ac4d1a084ef628",
      "binance-smart-chain": "0x82d2f8e02afb160dd5a480a617692e62de9038c4"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "aleph-zero",
    "filePath": "token:AZERO",
    "symbol": "azero",
    "name": "Aleph Zero",
    "marketCapRank": 256,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "alephium",
    "filePath": "token:ALPH",
    "symbol": "alph",
    "name": "Alephium",
    "marketCapRank": 342,
    "addresses": {
      "ethereum": "0x590f820444fa3638e022776752c5eef34e2f89a6"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "alethea-artificial-liquid-intelligence-token",
    "filePath": "token:ALI",
    "symbol": "ali",
    "name": "Artificial Liquid Intelligence",
    "marketCapRank": 553,
    "addresses": {
      "ethereum": "0x6b0b3a982b4634ac68dd83a4dbf02311ce324181",
      "cronos": "0x45c135c1cdce8d25a3b729a28659561385c52671",
      "polygon-pos": "0xbfc70507384047aa74c29cdc8c5cb88d0f7213ac",
      "base": "0x97c806e7665d3afd84a8fe1837921403d59f3dcc"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "alexgo",
    "filePath": "token:ALEX",
    "symbol": "alex",
    "name": "ALEX Lab",
    "marketCapRank": 239,
    "addresses": {
      "ethereum": "0xe7c3755482d0da522678af05945062d4427e0923"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "algebra",
    "filePath": "token:ALGB",
    "symbol": "algb",
    "name": "Algebra",
    "marketCapRank": 1431,
    "addresses": {
      "polygon-pos": "0x0169ec1f8f639b32eec6d923e24c2a2ff45b9dd6"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "algorand",
    "filePath": "token:ALGO",
    "symbol": "algo",
    "name": "Algorand",
    "marketCapRank": 61,
    "addresses": {},
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "alien-worlds",
    "filePath": "token:TLM",
    "symbol": "tlm",
    "name": "Alien Worlds",
    "marketCapRank": 500,
    "addresses": {
      "ethereum": "0x888888848b652b3e3a0f34c96e00eec0f3a23f72",
      "binance-smart-chain": "0x2222227e22102fe3322098e4cbfe18cfebd57c95"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "all-art",
    "filePath": "token:AART",
    "symbol": "aart",
    "name": "ALL.ART",
    "marketCapRank": 2009,
    "addresses": {
      "solana": "F3nefJBcejYbtdREjui1T9DPh5dBgpkKq7u2GAAMXs5B"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "all-in",
    "filePath": "token:ALLIN",
    "symbol": "allin",
    "name": "All In",
    "marketCapRank": 2510,
    "addresses": {
      "ethereum": "0x9b2b931d6ab97b6a887b2c5d8529537e6fe73ebe"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "allbridge",
    "filePath": "token:ABR",
    "symbol": "abr",
    "name": "Allbridge",
    "marketCapRank": 1822,
    "addresses": {
      "ethereum": "0xa11bd36801d8fa4448f0ac4ea7a62e3634ce8c7c",
      "avalanche": "0xafc43610c7840b20b90caaf93759be5b54b291c9",
      "near-protocol": "abr.a11bd.near",
      "polygon-pos": "0x04429fbb948bbd09327763214b45e505a5293346",
      "huobi-token": "0x2d7e64def6c3311a75c2f6eb45e835cd58e52cde",
      "fantom": "0x543acd673960041eee1305500893260f1887b679",
      "binance-smart-chain": "0x68784ffaa6ff05e3e04575df77960dc1d9f42b4a",
      "aurora": "0x2bae00c8bc1868a5f7a216e881bae9e662630111",
      "celo": "0x6e512bfc33be36f2666754e996ff103ad1680cc9",
      "solana": "a11bdAAuV8iB2fu7X6AxAvDTo1QZ8FXB3kk5eecdasp"
    },
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "allianceblock-nexera",
    "filePath": "token:NXRA",
    "symbol": "nxra",
    "name": "AllianceBlock Nexera",
    "marketCapRank": 349,
    "addresses": {
      "ethereum": "0x644192291cc835a93d6330b24ea5f5fedd0eef9e",
      "avalanche": "0x644192291cc835a93d6330b24ea5f5fedd0eef9e",
      "polygon-pos": "0x644192291cc835a93d6330b24ea5f5fedd0eef9e",
      "binance-smart-chain": "0x644192291cc835a93d6330b24ea5f5fedd0eef9e"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "alpaca-finance",
    "filePath": "token:ALPACA",
    "symbol": "alpaca",
    "name": "Alpaca Finance",
    "marketCapRank": 892,
    "addresses": {
      "binance-smart-chain": "0x8f0528ce5ef7b51152a59745befdd91d97091d2f",
      "fantom": "0xad996a45fd2373ed0b10efa4a8ecb9de445a4302"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "alpha-quark-token",
    "filePath": "token:AQT",
    "symbol": "aqt",
    "name": "Alpha Quark",
    "marketCapRank": 764,
    "addresses": {
      "ethereum": "0x2a9bdcff37ab68b95a53435adfd8892e86084f93"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "altair",
    "filePath": "token:AIR",
    "symbol": "air",
    "name": "Altair",
    "marketCapRank": 1299,
    "addresses": {},
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "alva",
    "filePath": "token:AA",
    "symbol": "aa",
    "name": "ALVA",
    "marketCapRank": 788,
    "addresses": {
      "binance-smart-chain": "0x99e6ca7e6c5c5aea22b4a992eb6895bc6d433298"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "alvey-chain",
    "filePath": "token:WALV",
    "symbol": "walv",
    "name": "Alvey Chain",
    "marketCapRank": 2288,
    "addresses": {
      "binance-smart-chain": "0x256d1fce1b1221e8398f65f9b36033ce50b2d497",
      "ethereum": "0x256d1fce1b1221e8398f65f9b36033ce50b2d497"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "ambire-wallet",
    "filePath": "token:WALLET",
    "symbol": "wallet",
    "name": "Ambire Wallet",
    "marketCapRank": 1583,
    "addresses": {
      "ethereum": "0x88800092ff476844f74dc2fc427974bbee2794ae",
      "polygon-pos": "0x564906ec1df8399f00e4ad32c0ecac0404a27a1c"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "ampleforth-governance-token",
    "filePath": "token:FORTH",
    "symbol": "forth",
    "name": "Ampleforth Governance",
    "marketCapRank": 649,
    "addresses": {
      "ethereum": "0x77fba179c79de5b7653f68b5039af940ada60ce0"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "angola",
    "filePath": "token:AGLA",
    "symbol": "agla",
    "name": "Angola",
    "marketCapRank": 1395,
    "addresses": {
      "polygon-pos": "0xd6a33f67b733d422c821c36f0f79ca145b930d01",
      "ethereum": "0x1f7e5118521b550bb1a9b435727c003eb033fc51"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "apecoin",
    "filePath": "token:APE",
    "symbol": "ape",
    "name": "ApeCoin",
    "marketCapRank": 97,
    "addresses": {
      "ethereum": "0x4d224452801aced8b2f0aebe155379bb5d594381",
      "polygon-pos": "0xb7b31a6bc18e48888545ce79e83e06003be70930"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "apefi",
    "filePath": "token:APEFI",
    "symbol": "apefi",
    "name": "apefi",
    "marketCapRank": null,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "apex-token-2",
    "filePath": "token:APEX",
    "symbol": "apex",
    "name": "ApeX",
    "marketCapRank": 412,
    "addresses": {
      "ethereum": "0x52a8845df664d76c69d2eea607cd793565af42b8",
      "arbitrum-one": "0x61a1ff55c5216b636a294a07d77c6f4df10d3b56"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "apf-coin",
    "filePath": "token:APFC",
    "symbol": "apfc",
    "name": "APF coin",
    "marketCapRank": 1787,
    "addresses": {
      "ethereum": "0x8ed955a2b7d2c3a17a9d05daca95e01818f8c11e"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "apm-coin",
    "filePath": "token:APM",
    "symbol": "apm",
    "name": "apM Coin",
    "marketCapRank": 2050,
    "addresses": {
      "ethereum": "0xc8c424b91d8ce0137bab4b832b7f7d154156ba6c"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "apollo-2",
    "filePath": "token:APOLLO",
    "symbol": "apollo",
    "name": "Apollo",
    "marketCapRank": 1317,
    "addresses": {
      "neutron": "neutron154gg0wtm2v4h9ur8xg32ep64e8ef0g5twlsgvfeajqwghdryvyqsqhgk8e"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "apollon-limassol",
    "filePath": "token:APL",
    "symbol": "apl",
    "name": "Apollon Limassol Fan Token",
    "marketCapRank": 2001,
    "addresses": {
      "chiliz": "0xb407a167fe99eb97970e41b2608d0d9484c489c8"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "apollox-2",
    "filePath": "token:APX",
    "symbol": "apx",
    "name": "APX",
    "marketCapRank": 663,
    "addresses": {
      "binance-smart-chain": "0x78f5d389f5cdccfc41594abab4b0ed02f31398b3"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "aptos",
    "filePath": "token:APT",
    "symbol": "apt",
    "name": "Aptos",
    "marketCapRank": 24,
    "addresses": {
      "aptos": "0x1::aptos_coin::AptosCoin"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "apwine",
    "filePath": "token:APW",
    "symbol": "apw",
    "name": "Spectra",
    "marketCapRank": 1162,
    "addresses": {
      "ethereum": "0x4104b135dbc9609fc1a9490e61369036497660c8",
      "polygon-pos": "0x6c0ab120dbd11ba701aff6748568311668f63fe0"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "aqtis",
    "filePath": "token:AQTIS",
    "symbol": "aqtis",
    "name": "AQTIS",
    "marketCapRank": 1073,
    "addresses": {
      "ethereum": "0x6ff2241756549b5816a177659e766eaf14b34429"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "aquarius",
    "filePath": "token:AQUA",
    "symbol": "aqua",
    "name": "Aquarius",
    "marketCapRank": 1124,
    "addresses": {
      "stellar": "GBNZILSTVQZ4R7IKQDGHYGY2QXL5QOFJYQMXPKWRRM5PAV7Y4M67AQUA"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "aragon",
    "filePath": "token:ANT",
    "symbol": "ant",
    "name": "Aragon",
    "marketCapRank": 236,
    "addresses": {
      "ethereum": "0xa117000000f279d81a1d3cc75430faa017fa5a2e",
      "energi": "0x4b3686eec98b2b89102f2830003097c7d4e1f691"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "arbitrum",
    "filePath": "token:ARB",
    "symbol": "arb",
    "name": "Arbitrum",
    "marketCapRank": 32,
    "addresses": {
      "arbitrum-one": "0x912ce59144191c1204e64559fe8253a0e49e6548",
      "arbitrum-nova": "0xf823c3cd3cebe0a1fa952ba88dc9eef8e0bf46ad",
      "ethereum": "0xb50721bcf8d664c30412cfbc6cf7a15145234ad1"
    },
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "arc",
    "filePath": "token:ARC",
    "symbol": "arc",
    "name": "Arc",
    "marketCapRank": 567,
    "addresses": {
      "ethereum": "0xc82e3db60a52cf7529253b4ec688f631aad9e7c2"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "arcblock",
    "filePath": "token:ABT",
    "symbol": "abt",
    "name": "Arcblock",
    "marketCapRank": 343,
    "addresses": {
      "ethereum": "0xb98d4c97425d9908e66e53a6fdf673acca0be986"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "archway",
    "filePath": "token:ARCH",
    "symbol": "arch",
    "name": "Archway",
    "marketCapRank": 745,
    "addresses": {
      "archway": "aarch",
      "osmosis": "ibc/23AB778D694C1ECFC59B91D8C399C115CC53B0BD1C61020D8E19519F002BDD85"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "ardor",
    "filePath": "token:ARDR",
    "symbol": "ardr",
    "name": "Ardor",
    "marketCapRank": 431,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "areon-network",
    "filePath": "token:AREA",
    "symbol": "area",
    "name": "Areon Network",
    "marketCapRank": 1339,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "ari10",
    "filePath": "token:ARI10",
    "symbol": "ari10",
    "name": "Ari10",
    "marketCapRank": 1579,
    "addresses": {
      "binance-smart-chain": "0x80262f604acac839724f66846f290a2cc8b48662"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "arianee",
    "filePath": "token:ARIA20",
    "symbol": "aria20",
    "name": "Arianee",
    "marketCapRank": 1594,
    "addresses": {
      "ethereum": "0xedf6568618a00c6f0908bf7758a16f76b6e04af9",
      "polygon-pos": "0x46f48fbdedaa6f5500993bede9539ef85f4bee8e"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "arix",
    "filePath": "token:ARIX",
    "symbol": "arix",
    "name": "Arix",
    "marketCapRank": 2127,
    "addresses": {
      "binance-smart-chain": "0x4db2495afad4c0e481ffc40fdaf66e13a786b619",
      "ethereum": "0xbb6cf73a00f480d0951ba979a7606857cdde626b"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "ark",
    "filePath": "token:ARK",
    "symbol": "ark",
    "name": "ARK",
    "marketCapRank": 354,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "arkadiko-protocol",
    "filePath": "token:DIKO",
    "symbol": "diko",
    "name": "Arkadiko",
    "marketCapRank": 790,
    "addresses": {
      "stacks": "SP2C2YFP12AJZB4MABJBAJ55XECVS7E4PMMZ89YZR"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "arkham",
    "filePath": "token:ARKM",
    "symbol": "arkm",
    "name": "Arkham",
    "marketCapRank": 180,
    "addresses": {
      "ethereum": "0x6e2a43be0b1d33b726f0ca3b8de60b3482b8b050"
    },
    "variants": [
      "mono"
    ]
  },
  {
    "id": "arpa",
    "filePath": "token:ARPA",
    "symbol": "arpa",
    "name": "ARPA",
    "marketCapRank": 535,
    "addresses": {
      "ethereum": "0xba50933c268f567bdc86e1ac131be072c6b0b71a",
      "binance-smart-chain": "0x6f769e65c14ebd1f68817f5f1dcdb61cfa2d6f7e",
      "polygon-pos": "0xee800b277a96b0f490a1a732e1d6395fad960a26"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "arthswap",
    "filePath": "token:ARSW",
    "symbol": "arsw",
    "name": "ArthSwap",
    "marketCapRank": 2351,
    "addresses": {
      "astar": "0xde2578edec4669ba7f41c5d5d2386300bcea4678"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "artrade",
    "filePath": "token:ATR",
    "symbol": "atr",
    "name": "Artrade",
    "marketCapRank": 480,
    "addresses": {
      "solana": "ATRLuHph8dxnPny4WSNW7fxkhbeivBrtWbY6BfB4xpLj"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "arweave",
    "filePath": "token:AR",
    "symbol": "ar",
    "name": "Arweave",
    "marketCapRank": 53,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "assetmantle",
    "filePath": "token:MNTL",
    "symbol": "mntl",
    "name": "AssetMantle",
    "marketCapRank": 1750,
    "addresses": {
      "cosmos": "ibc/00F2B62EB069321A454B708876476AFCD9C23C8C9C4A5A206DDF1CD96B645057",
      "polygon-pos": "0x38a536a31ba4d8c1bcca016abbf786ecd25877e8",
      "ethereum": "0x2c4f1df9c7de0c59778936c9b145ff56813f3295"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "aston-villa-fan-token",
    "filePath": "token:AVL",
    "symbol": "avl",
    "name": "Aston Villa Fan Token",
    "marketCapRank": 2573,
    "addresses": {
      "chiliz": "0x095726841dc9bf395114ac83f8fd42b176cfad10"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "atari",
    "filePath": "token:ATRI",
    "symbol": "atri",
    "name": "Atari",
    "marketCapRank": 2016,
    "addresses": {
      "ethereum": "0xdacd69347de42babfaecd09dc88958378780fb62",
      "fantom": "0x818ec0a7fe18ff94269904fced6ae3dae6d6dc0b",
      "polygon-pos": "0xb140665dde25c644c6b418e417c930de8a8a6ac9",
      "binance-smart-chain": "0xc0c6e4c6e70c6231b20979bda581a66f062a7967"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "athenadao-token",
    "filePath": "token:ATH",
    "symbol": "ath",
    "name": "AthenaDAO",
    "marketCapRank": 1593,
    "addresses": {
      "ethereum": "0xa4ffdf3208f46898ce063e25c1c43056fa754739"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "atlas-navi",
    "filePath": "token:NAVI",
    "symbol": "navi",
    "name": "Atlas Navi",
    "marketCapRank": 831,
    "addresses": {
      "ethereum": "0xfc1c93a2507975e98b9d0e9260ded61a00152bf1"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "atletico-madrid",
    "filePath": "token:ATM",
    "symbol": "atm",
    "name": "Atletico Madrid Fan Token",
    "marketCapRank": 1327,
    "addresses": {
      "chiliz": "0xe9506f70be469d2369803ccf41823713bafe8154"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "atpay",
    "filePath": "token:ATPAY",
    "symbol": "atpay",
    "name": "AtPay",
    "marketCapRank": 1328,
    "addresses": {
      "solana": "8sF1JWbZVCUvb6TyHYbsu9CkM8Qm6jnFVe6PqtAsdzCU"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "auction",
    "filePath": "token:AUCTION",
    "symbol": "auction",
    "name": "Bounce",
    "marketCapRank": 385,
    "addresses": {
      "ethereum": "0xa9b1eb5908cfc3cdf91f9b8b3a74108598009096"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "audius",
    "filePath": "token:AUDIO",
    "symbol": "audio",
    "name": "Audius",
    "marketCapRank": 229,
    "addresses": {
      "ethereum": "0x18aaa7115705e8be94bffebde57af9bfc265b998",
      "energi": "0x2c25972d4adb478773be354a09e4596f29e31fb3"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "augur",
    "filePath": "token:REP",
    "symbol": "rep",
    "name": "Augur",
    "marketCapRank": 1478,
    "addresses": {
      "ethereum": "0x221657776846890989a759ba2973e427dff5c9bb",
      "energi": "0x2a2666f62157769d09a64488bbb51bd77036f6ce"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "aura-bal",
    "filePath": "token:AURABAL",
    "symbol": "aurabal",
    "name": "Aura BAL",
    "marketCapRank": 786,
    "addresses": {
      "ethereum": "0x616e8bfa43f920657b3497dbf40d6b1a02d4608d"
    },
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "aura-finance",
    "filePath": "token:AURA",
    "symbol": "aura",
    "name": "Aura Finance",
    "marketCapRank": 906,
    "addresses": {
      "ethereum": "0xc0c293ce456ff0ed870add98a0828dd4d2903dbf",
      "xdai": "0x1509706a6c66ca549ff0cb464de88231ddbe213b"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "aurigami",
    "filePath": "token:PLY",
    "symbol": "ply",
    "name": "Aurigami",
    "marketCapRank": 2303,
    "addresses": {
      "aurora": "0x09c9d464b58d96837f8d8b6f4d9fe4ad408d3a4f",
      "ethereum": "0x1ab43204a195a0fd37edec621482afd3792ef90b",
      "near-protocol": "1ab43204a195a0fd37edec621482afd3792ef90b.factory.bridge.near"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "aurora-dao",
    "filePath": "token:IDEX",
    "symbol": "idex",
    "name": "IDEX",
    "marketCapRank": 605,
    "addresses": {
      "ethereum": "0xb705268213d593b8fd88d3fdeff93aff5cbdcfae",
      "polygon-pos": "0x9cb74c8032b007466865f060ad2c46145d45553d"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "aurora-near",
    "filePath": "token:AURORA",
    "symbol": "aurora",
    "name": "Aurora",
    "marketCapRank": 388,
    "addresses": {
      "ethereum": "0xaaaaaa20d9e0e2461697782ef11675f668207961",
      "aurora": "0x8bec47865ade3b172a928df8f990bc7f2a3b9f79",
      "near-protocol": "aaaaaa20d9e0e2461697782ef11675f668207961.factory.bridge.near"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "aurory",
    "filePath": "token:AURY",
    "symbol": "aury",
    "name": "Aurory",
    "marketCapRank": 820,
    "addresses": {
      "solana": "AURYydfxJib1ZkTir1Jn1J9ECYUtjb6rKQVmtYaixWPP",
      "arbitrum-one": "0x11bf4f05eb28b802ed3ab672594decb20ffe2313"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "automata",
    "filePath": "token:ATA",
    "symbol": "ata",
    "name": "Automata",
    "marketCapRank": 563,
    "addresses": {
      "ethereum": "0xa2120b9e674d3fc3875f415a7df52e382f141225",
      "binance-smart-chain": "0xa2120b9e674d3fc3875f415a7df52e382f141225",
      "polygon-pos": "0x0df0f72ee0e5c9b7ca761ecec42754992b2da5bf"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "avalanche-2",
    "filePath": "token:AVAX",
    "symbol": "avax",
    "name": "Avalanche",
    "marketCapRank": 11,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "avalaunch",
    "filePath": "token:XAVA",
    "symbol": "xava",
    "name": "Avalaunch",
    "marketCapRank": 760,
    "addresses": {
      "avalanche": "0xd1c3f94de7e5b45fa4edbba472491a9f4b166fc4"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "avaocado-dao",
    "filePath": "token:AVG",
    "symbol": "avg",
    "name": "Avocado DAO",
    "marketCapRank": 2104,
    "addresses": {
      "ethereum": "0xa41f142b6eb2b164f8164cae0716892ce02f311f",
      "binance-smart-chain": "0xa41f142b6eb2b164f8164cae0716892ce02f311f"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "aventus",
    "filePath": "token:AVT",
    "symbol": "avt",
    "name": "Aventus",
    "marketCapRank": 806,
    "addresses": {
      "ethereum": "0x0d88ed6e74bbfd96b831231638b66c05571e824f"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "aviator",
    "filePath": "token:AVI",
    "symbol": "avi",
    "name": "Aviator",
    "marketCapRank": 890,
    "addresses": {
      "ethereum": "0xd2bdaaf2b9cc6981fd273dcb7c04023bfbe0a7fe"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "avinoc",
    "filePath": "token:AVINOC",
    "symbol": "avinoc",
    "name": "AVINOC",
    "marketCapRank": 1119,
    "addresses": {
      "ethereum": "0xf1ca9cb74685755965c7458528a36934df52a3ef"
    },
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "axe-cap",
    "filePath": "token:AXE",
    "symbol": "axe",
    "name": "Axe Cap",
    "marketCapRank": 2384,
    "addresses": {
      "ethereum": "0x070e984fda37dd942f5c953f6b2375339adac308"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "axel",
    "filePath": "token:AXEL",
    "symbol": "axel",
    "name": "AXEL",
    "marketCapRank": 1398,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "axelar",
    "filePath": "token:AXL",
    "symbol": "axl",
    "name": "Axelar",
    "marketCapRank": 99,
    "addresses": {
      "ethereum": "0x467719ad09025fcc6cf6f8311755809d45a5e5f3",
      "avalanche": "0x44c784266cf024a60e8acf2427b9857ace194c5d",
      "optimistic-ethereum": "0x23ee2343b892b1bb63503a4fabc840e0e2c6810f",
      "arbitrum-one": "0x23ee2343b892b1bb63503a4fabc840e0e2c6810f",
      "base": "0x23ee2343b892b1bb63503a4fabc840e0e2c6810f",
      "binance-smart-chain": "0x8b1f4432f943c465a973fedc6d7aa50fc96f1f65",
      "secret": "secret1vcau4rkn7mvfwl8hf0dqa9p0jr59983e3qqe3z",
      "moonbeam": "0x467719ad09025fcc6cf6f8311755809d45a5e5f3",
      "fantom": "0x8b1f4432f943c465a973fedc6d7aa50fc96f1f65",
      "osmosis": "ibc/903A61A498756EA560B85A85132D3AEE21B5DEDD41213725D22ABF276EA6945E",
      "polygon-pos": "0x6e4e624106cb12e168e6533f8ec7c82263358940"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "axie-infinity",
    "filePath": "token:AXS",
    "symbol": "axs",
    "name": "Axie Infinity",
    "marketCapRank": 78,
    "addresses": {
      "ethereum": "0xbb0e17ef65f82ab018d8edd776e8dd940327b28b",
      "ronin": "0x97a9107c1793bc407d6f527b77e7fff4d812bece",
      "binance-smart-chain": "0x715d400f88c167884bbcc41c5fea407ed4d2f8a0",
      "harmony-shard-0": "0x14a7b318fed66ffdcc80c1517c172c13852865de",
      "energi": "0x7cd3d51bee45434dd80822c5d58b999333b69ffb"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "azit",
    "filePath": "token:AZIT",
    "symbol": "azit",
    "name": "azit",
    "marketCapRank": 1234,
    "addresses": {
      "klay-token": "0x6cef6dd9a3c4ad226b8b66effeea2c125df194f1"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "b-cube-ai",
    "filePath": "token:BCUBE",
    "symbol": "bcube",
    "name": "B-cube.ai",
    "marketCapRank": 1834,
    "addresses": {
      "ethereum": "0x93c9175e26f57d2888c7df8b470c9eea5c0b0a93"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "babb",
    "filePath": "token:BAX",
    "symbol": "bax",
    "name": "BABB",
    "marketCapRank": 1358,
    "addresses": {
      "ethereum": "0xf920e4f3fbef5b3ad0a25017514b769bdc4ac135"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "bananacat",
    "filePath": "token:BCAT",
    "symbol": "bcat",
    "name": "BananaCat",
    "marketCapRank": 2589,
    "addresses": {
      "ethereum": "0x0590cc9232ebf68d81f6707a119898219342ecb9"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "bancor",
    "filePath": "token:BNT",
    "symbol": "bnt",
    "name": "Bancor Network",
    "marketCapRank": 481,
    "addresses": {
      "ethereum": "0x1f573d6fb3f13d689ff844b4ce37794d79a7ff1c",
      "energi": "0x9419e8edcf570a71eb0dd006602949742b711a80"
    },
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "barnbridge",
    "filePath": "token:BOND",
    "symbol": "bond",
    "name": "BarnBridge",
    "marketCapRank": 817,
    "addresses": {
      "ethereum": "0x0391d2021f89dc339f60fff84546ea23e337750f",
      "optimistic-ethereum": "0x3e7ef8f50246f725885102e8238cbba33f276747",
      "arbitrum-one": "0x0d81e50bc677fa67341c44d7eaa9228dee64a4e1"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "basic-attention-token",
    "filePath": "token:BAT",
    "symbol": "bat",
    "name": "Basic Attention",
    "marketCapRank": 189,
    "addresses": {
      "ethereum": "0x0d8775f648430679a709e98d2b0cb6250d2887ef",
      "harmony-shard-0": "0x2875b4cfab0a4cc4bdc7fbdf94b6e376826a4332",
      "avalanche": "0x98443b96ea4b0858fdf3219cd13e98c7a4690588",
      "near-protocol": "0d8775f648430679a709e98d2b0cb6250d2887ef.factory.bridge.near",
      "polygon-pos": "0x3cef98bb43d732e2f285ee605a8158cde967d219",
      "energi": "0xe8ba8d7765bd33ba7ff3b19b9020c15bf14123b6",
      "solana": "EPeUFDgHRxs9xxEPVaL6kfGQvCon7jmAWKVUHuux1Tpz"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "basilisk",
    "filePath": "token:BSX",
    "symbol": "bsx",
    "name": "Basilisk",
    "marketCapRank": 1907,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "bata",
    "filePath": "token:BTA",
    "symbol": "bta",
    "name": "Bata",
    "marketCapRank": 2474,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "battle-infinity",
    "filePath": "token:IBAT",
    "symbol": "ibat",
    "name": "Battle Infinity",
    "marketCapRank": 2567,
    "addresses": {
      "binance-smart-chain": "0x19cd9b8e42d4ef62c3ea124110d5cfd283ceac43"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "bazaars",
    "filePath": "token:BZR",
    "symbol": "bzr",
    "name": "Bazaars",
    "marketCapRank": 527,
    "addresses": {
      "ethereum": "0x8d96b4ab6c741a4c8679ae323a100d74f085ba8f"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "beam-2",
    "filePath": "token:BEAM",
    "symbol": "beam",
    "name": "Beam",
    "marketCapRank": 70,
    "addresses": {
      "ethereum": "0x62d0a8458ed7719fdaf978fe5929c6d342b0bfce",
      "binance-smart-chain": "0x62d0a8458ed7719fdaf978fe5929c6d342b0bfce"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "bean",
    "filePath": "token:BEAN",
    "symbol": "bean",
    "name": "Bean",
    "marketCapRank": 813,
    "addresses": {
      "ethereum": "0xbea0000029ad1c77d3d5d23ba2d8893db9d1efab"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "beethoven-x",
    "filePath": "token:BEETS",
    "symbol": "beets",
    "name": "Beethoven X",
    "marketCapRank": 1535,
    "addresses": {
      "fantom": "0xf24bcf4d1e507740041c9cfd2dddb29585adce1e",
      "optimistic-ethereum": "0xb4bc46bc6cb217b59ea8f4530bae26bf69f677f0"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "beldex",
    "filePath": "token:BDX",
    "symbol": "bdx",
    "name": "Beldex",
    "marketCapRank": 288,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "bella-protocol",
    "filePath": "token:BEL",
    "symbol": "bel",
    "name": "Bella Protocol",
    "marketCapRank": 715,
    "addresses": {
      "ethereum": "0xa91ac63d040deb1b7a5e4d4134ad23eb0ba07e14",
      "manta-pacific": "0xb385e52903c802b3bdca7c4d0c78460a8988e1ce",
      "binance-smart-chain": "0x8443f091997f06a61670b735ed92734f5628692f"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "belt",
    "filePath": "token:BELT",
    "symbol": "belt",
    "name": "Belt",
    "marketCapRank": 2293,
    "addresses": {
      "binance-smart-chain": "0xe0e514c71282b6f4e823703a39374cf58dc3ea4f"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "ben-2",
    "filePath": "token:BEN",
    "symbol": "ben",
    "name": "Ben",
    "marketCapRank": 1331,
    "addresses": {
      "ethereum": "0x9bf1d7d63dd7a4ce167cf4866388226eeefa702e"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "benddao",
    "filePath": "token:BEND",
    "symbol": "bend",
    "name": "BendDAO",
    "marketCapRank": 1862,
    "addresses": {
      "ethereum": "0x0d02755a5700414b26ff040e1de35d337df56218"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "beoble",
    "filePath": "token:BBL",
    "symbol": "bbl",
    "name": "Beoble",
    "marketCapRank": 1198,
    "addresses": {
      "ethereum": "0xd979c468a68062e7bdff4ba6df7842dfd3492e0f"
    },
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "bepro-network",
    "filePath": "token:BEPRO",
    "symbol": "bepro",
    "name": "Bepro",
    "marketCapRank": 1317,
    "addresses": {
      "ethereum": "0xcf3c8be2e2c42331da80ef210e9b1b307c03d36a"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "berry",
    "filePath": "token:BERRY",
    "symbol": "berry",
    "name": "Berry",
    "marketCapRank": 1814,
    "addresses": {
      "ethereum": "0x2d787d4f5005bd66ac910c2e821241625c406ed5"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "beta-finance",
    "filePath": "token:BETA",
    "symbol": "beta",
    "name": "Beta Finance",
    "marketCapRank": 590,
    "addresses": {
      "ethereum": "0xbe1a001fe942f96eea22ba08783140b9dcc09d28",
      "avalanche": "0x511d35c52a3c244e7b8bd92c0c297755fbd89212",
      "binance-smart-chain": "0xbe1a001fe942f96eea22ba08783140b9dcc09d28"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "betswap-gg",
    "filePath": "token:BSGG",
    "symbol": "bsgg",
    "name": "Betswap.gg",
    "marketCapRank": 1903,
    "addresses": {
      "ethereum": "0xda16cf041e2780618c49dbae5d734b89a6bac9b3",
      "avalanche": "0x49f519002eeced6902f24c0be72b6d898e4d27fc",
      "fantom": "0xce22c3e95b5e118ea61c4fb9357fe45cbb34cb56"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "biconomy-exchange-token",
    "filePath": "token:BIT",
    "symbol": "bit",
    "name": "Biconomy Exchange Token",
    "marketCapRank": 2455,
    "addresses": {
      "binance-smart-chain": "0xc864019047b864b6ab609a968ae2725dfaee808a"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "big-data-protocol",
    "filePath": "token:BDP",
    "symbol": "bdp",
    "name": "Big Data Protocol",
    "marketCapRank": 1596,
    "addresses": {
      "ethereum": "0xf3dcbc6d72a4e1892f7917b7c43b74131df8480e"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "bilira",
    "filePath": "token:TRYB",
    "symbol": "tryb",
    "name": "BiLira",
    "marketCapRank": 1022,
    "addresses": {
      "ethereum": "0x2c537e5624e4af88a7ae4060c022609376c8d0eb",
      "avalanche": "0x564a341df6c126f90cf3ecb92120fd7190acb401",
      "binance-smart-chain": "0xc1fdbed7dac39cae2ccc0748f7a80dc446f6a594",
      "polygon-pos": "0x4fb71290ac171e1d144f7221d882becac7196eb5",
      "solana": "A94X2fRy3wydNShU4dRaDyap2UuoeWJGWyATtyp61WZf"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "binancecoin",
    "filePath": "token:BNB",
    "symbol": "bnb",
    "name": "BNB",
    "marketCapRank": 4,
    "addresses": {
      "ethereum": "0xb8c77482e45f1f44de1745f52c74426c631bdd52"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "binaryx",
    "filePath": "token:BNX",
    "symbol": "bnx",
    "name": "BinaryX [OLD]",
    "marketCapRank": 2545,
    "addresses": {
      "binance-smart-chain": "0x8c851d1a123ff703bd1f9dabe631b69902df5f97"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "bistroo",
    "filePath": "token:BIST",
    "symbol": "bist",
    "name": "Bistroo",
    "marketCapRank": 2498,
    "addresses": {
      "ethereum": "0x6e8908cfa881c9f6f2c64d3436e7b80b1bf0093f",
      "binance-smart-chain": "0xbd525e51384905c6c0936a431bc7efb6c4903ea0"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "biswap",
    "filePath": "token:BSW",
    "symbol": "bsw",
    "name": "Biswap",
    "marketCapRank": 632,
    "addresses": {
      "binance-smart-chain": "0x965f527d9159dce6288a2219db51fc6eef120dd1"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "bitcicoin",
    "filePath": "token:BITCI",
    "symbol": "bitci",
    "name": "Bitcicoin",
    "marketCapRank": 1361,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "bitcoin",
    "filePath": "token:BTC",
    "symbol": "btc",
    "name": "Bitcoin",
    "marketCapRank": null,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "bitcoin-2",
    "filePath": "token:BTC2",
    "symbol": "btc2",
    "name": "Bitcoin 2",
    "marketCapRank": 1648,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "bitcoin-cash",
    "filePath": "token:BCH",
    "symbol": "bch",
    "name": "Bitcoin Cash",
    "marketCapRank": 15,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "bitcoin-cash-sv",
    "filePath": "token:BSV",
    "symbol": "bsv",
    "name": "Bitcoin SV",
    "marketCapRank": 65,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "bitcoin-diamond",
    "filePath": "token:BCD",
    "symbol": "bcd",
    "name": "Bitcoin Diamond",
    "marketCapRank": 1048,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "bitcoin-gold",
    "filePath": "token:BTG",
    "symbol": "btg",
    "name": "Bitcoin Gold",
    "marketCapRank": 122,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "bitcoin-pro",
    "filePath": "token:BTCP",
    "symbol": "btcp",
    "name": "Bitcoin Pro",
    "marketCapRank": 1722,
    "addresses": {
      "ethereum": "0x723cbfc05e2cfcc71d3d89e770d32801a5eef5ab"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "bitcone",
    "filePath": "token:CONE",
    "symbol": "cone",
    "name": "BitCone",
    "marketCapRank": 1986,
    "addresses": {
      "polygon-pos": "0xba777ae3a3c91fcd83ef85bfe65410592bdd0f7c"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "bitkub-coin",
    "filePath": "token:KUB",
    "symbol": "kub",
    "name": "Bitkub Coin",
    "marketCapRank": 313,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "bitmart-token",
    "filePath": "token:BMX",
    "symbol": "bmx",
    "name": "BitMart",
    "marketCapRank": 521,
    "addresses": {
      "ethereum": "0x986ee2b944c42d017f52af21c4c69b84dbea35d8"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "bitmex-token",
    "filePath": "token:BMEX",
    "symbol": "bmex",
    "name": "BitMEX",
    "marketCapRank": 1028,
    "addresses": {
      "ethereum": "0xb113c6cf239f60d380359b762e95c13817275277"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "bitrise-token",
    "filePath": "token:BRISE",
    "symbol": "brise",
    "name": "Bitgert",
    "marketCapRank": 534,
    "addresses": {
      "binance-smart-chain": "0x8fff93e810a2edaafc326edee51071da9d398e83",
      "ethereum": "0xf2b2f7b47715256ce4ea43363a867fdce9353e3a"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "bitrock",
    "filePath": "token:BROCK",
    "symbol": "brock",
    "name": "Bitrock",
    "marketCapRank": 1084,
    "addresses": {
      "ethereum": "0xde67d97b8770dc98c746a3fc0093c538666eb493"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "bitshares",
    "filePath": "token:BTS",
    "symbol": "bts",
    "name": "BitShares",
    "marketCapRank": 1443,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "bittensor",
    "filePath": "token:TAO",
    "symbol": "tao",
    "name": "Bittensor",
    "marketCapRank": 44,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "blackdragon-token",
    "filePath": "token:BDT",
    "symbol": "bdt",
    "name": "BlackDragon",
    "marketCapRank": null,
    "addresses": {
      "arbitrum-one": "0x21ccbc5e7f353ec43b2f5b1fb12c3e9d89d30dca"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "blacksmith-token",
    "filePath": "token:BS",
    "symbol": "bs",
    "name": "Blacksmith Token",
    "marketCapRank": 2848,
    "addresses": {
      "ethereum": "0x5eca7b975e34567d9460fa613013a7a6993ad185"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "blank",
    "filePath": "token:BLANK",
    "symbol": "blank",
    "name": "BlockWallet",
    "marketCapRank": 2517,
    "addresses": {
      "ethereum": "0x41a3dba3d677e573636ba691a70ff2d606c29666",
      "polygon-pos": "0xf4c83080e80ae530d6f8180572cbbf1ac9d5d435"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "blastar",
    "filePath": "token:BLAST",
    "symbol": "blast",
    "name": "Blastar",
    "marketCapRank": 2530,
    "addresses": {
      "pulsechain": "0x6a44be19d96f087494bafa66ee5df1bf7aaf220f"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "blockasset",
    "filePath": "token:BLOCK",
    "symbol": "block",
    "name": "Blockasset",
    "marketCapRank": 1212,
    "addresses": {
      "solana": "NFTUkR4u7wKxy9QLaX2TGvd9oZSWoMo4jqSJqdMb7Nk",
      "binance-smart-chain": "0xbc7a566b85ef73f935e640a06b5a8b031cd975df"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "blockbank",
    "filePath": "token:BBANK",
    "symbol": "bbank",
    "name": "blockbank",
    "marketCapRank": 2930,
    "addresses": {
      "ethereum": "0xf4b5470523ccd314c6b9da041076e7d79e0df267",
      "binance-smart-chain": "0xf4b5470523ccd314c6b9da041076e7d79e0df267"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "blockchain-bets",
    "filePath": "token:BCB",
    "symbol": "bcb",
    "name": "Blockchain Bets",
    "marketCapRank": 1192,
    "addresses": {
      "ethereum": "0x2d886570a0da04885bfd6eb48ed8b8ff01a0eb7e"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "blockchain-brawlers",
    "filePath": "token:BRWL",
    "symbol": "brwl",
    "name": "Blockchain Brawlers",
    "marketCapRank": 1442,
    "addresses": {
      "ethereum": "0x4086e77c5e993fdb90a406285d00111a974f877a"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "blockchain-certified-data-token",
    "filePath": "token:BCDT",
    "symbol": "bcdt",
    "name": "EvidenZ",
    "marketCapRank": 2475,
    "addresses": {
      "ethereum": "0xacfa209fb73bf3dd5bbfb1101b9bc999c49062a5",
      "binance-smart-chain": "0x8683e604cdf911cd72652a04bf9d571697a86a60"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "blockchain-monster-hunt",
    "filePath": "token:BCMC",
    "symbol": "bcmc",
    "name": "Blockchain Monster Hunt",
    "marketCapRank": 2373,
    "addresses": {
      "ethereum": "0x2ba8349123de45e931a8c8264c332e6e9cf593f9",
      "binance-smart-chain": "0xc10358f062663448a3489fc258139944534592ac",
      "polygon-pos": "0xc10358f062663448a3489fc258139944534592ac"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "blockchainspace",
    "filePath": "token:GUILD",
    "symbol": "guild",
    "name": "BlockchainSpace",
    "marketCapRank": 2108,
    "addresses": {
      "ethereum": "0x83e9f223e1edb3486f876ee888d76bfba26c475a",
      "polygon-pos": "0xaff41da975501e5b71848c975834341777d1a473",
      "binance-smart-chain": "0x0565805ca3a4105faee51983b0bd8ffb5ce1455c"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "blocksquare",
    "filePath": "token:BST",
    "symbol": "bst",
    "name": "Blocksquare",
    "marketCapRank": 883,
    "addresses": {
      "ethereum": "0x509a38b7a1cc0dcd83aa9d06214663d9ec7c7f4a"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "blockstack",
    "filePath": "token:STX",
    "symbol": "stx",
    "name": "Stacks",
    "marketCapRank": 27,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "blockv",
    "filePath": "token:VEE",
    "symbol": "vee",
    "name": "BLOCKv",
    "marketCapRank": 1006,
    "addresses": {
      "ethereum": "0x340d2bde5eb28c1eed91b2f790723e3b160613b7",
      "optimistic-ethereum": "0xe3c332a5dce0e1d9bc2cc72a68437790570c28a4",
      "polygon-pos": "0xf1c1a3c2481a3a8a3f173a9ab5ade275292a6fa3"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "blocto-token",
    "filePath": "token:BLT",
    "symbol": "blt",
    "name": "Blocto",
    "marketCapRank": 1694,
    "addresses": {
      "solana": "BLT1noyNr3GttckEVrtcfC6oyK6yV1DpPgSyXbncMwef"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "blocx-3",
    "filePath": "token:BLX",
    "symbol": "blx",
    "name": "BlocX",
    "marketCapRank": 2644,
    "addresses": {
      "binance-smart-chain": "0xe9da86435265477bcde46c7e9aa7ace5aa7e2d18"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "blox",
    "filePath": "token:CDT",
    "symbol": "cdt",
    "name": "Blox",
    "marketCapRank": 202,
    "addresses": {
      "ethereum": "0x177d39ac676ed1c67a2b268ad7f1e58826e5b0af"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "blox-2",
    "filePath": "token:BLOX",
    "symbol": "blox",
    "name": "BLOX",
    "marketCapRank": 2240,
    "addresses": {
      "ethereum": "0xc9f00080d96cea3ef92d2e2e563d4cd41fb5bb36"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "bloxmove-erc20",
    "filePath": "token:BLXM",
    "symbol": "blxm",
    "name": "bloXmove",
    "marketCapRank": 2078,
    "addresses": {
      "ethereum": "0x38d9eb07a7b8df7d86f440a4a5c4a4c1a27e1a08",
      "binance-smart-chain": "0x40e51e0ec04283e300f12f6bb98da157bb22036e"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "bluemove",
    "filePath": "token:MOVE",
    "symbol": "move",
    "name": "BlueMove",
    "marketCapRank": 1608,
    "addresses": {
      "aptos": "0x27fafcc4e39daac97556af8a803dbb52bcb03f0821898dc845ac54225b9793eb::move_coin::MoveCoin",
      "sui": "0xd9f9b0b4f35276eecd1eea6985bfabe2a2bbd5575f9adb9162ccbdb4ddebde7f::smove::SMOVE"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "bluesparrow",
    "filePath": "token:BLUESPARROW",
    "symbol": "bluesparrow",
    "name": "BlueSparrow",
    "marketCapRank": 2241,
    "addresses": {
      "ethereum": "0x24ccedebf841544c9e6a62af4e8c2fa6e5a46fde"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "blur",
    "filePath": "token:BLUR",
    "symbol": "blur",
    "name": "Blur",
    "marketCapRank": 121,
    "addresses": {
      "ethereum": "0x5283d291dbcf85356a21ba090e6db59121208b44"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "bluzelle",
    "filePath": "token:BLZ",
    "symbol": "blz",
    "name": "Bluzelle",
    "marketCapRank": 386,
    "addresses": {
      "ethereum": "0x5732046a883704404f284ce41ffadd5b007fd668",
      "binance-smart-chain": "0x935a544bf5816e3a7c13db2efe3009ffda0acda2",
      "energi": "0x3fa2c976654a6ba6dcb1e532a4b1e31fd4dcd3b9"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "bnb48-club-token",
    "filePath": "token:KOGE",
    "symbol": "koge",
    "name": "KOGE",
    "marketCapRank": 681,
    "addresses": {
      "binance-smart-chain": "0xe6df05ce8c8301223373cf5b969afcb1498c5528"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "bob-token",
    "filePath": "token:BOB",
    "symbol": "bob",
    "name": "BOB Token",
    "marketCapRank": 1071,
    "addresses": {
      "ethereum": "0x7d8146cf21e8d7cbe46054e01588207b51198729"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "boba-network",
    "filePath": "token:BOBA",
    "symbol": "boba",
    "name": "Boba Network",
    "marketCapRank": 332,
    "addresses": {
      "ethereum": "0x42bbfa2e77757c645eeaad1655e0911a7553efbc",
      "boba": "0xa18bf3994c0cc6e3b63ac420308e5383f53120d7"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "bolide",
    "filePath": "token:BLID",
    "symbol": "blid",
    "name": "Bolide",
    "marketCapRank": 1461,
    "addresses": {
      "ethereum": "0x8a7adc1b690e81c758f1bd0f72dfe27ae6ec56a5",
      "polygon-pos": "0x4b27cd6e6a5e83d236ead376d256fe2f9e9f0d2e",
      "arbitrum-one": "0x81de4945807bb31425362f8f7109c18e3dc4f8f0",
      "binance-smart-chain": "0x766afcf83fd5eaf884b3d529b432ca27a6d84617"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "bolt",
    "filePath": "token:BOLT",
    "symbol": "bolt",
    "name": "Bolt",
    "marketCapRank": 1945,
    "addresses": {
      "ethereum": "0xd5930c307d7395ff807f2921f12c5eb82131a789"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "bomber-coin",
    "filePath": "token:BCOIN",
    "symbol": "bcoin",
    "name": "BombCrypto",
    "marketCapRank": 1703,
    "addresses": {
      "binance-smart-chain": "0x00e1656e45f18ec6747f5a8496fd39b50b38396d"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "bonfida",
    "filePath": "token:FIDA",
    "symbol": "fida",
    "name": "Bonfida",
    "marketCapRank": 620,
    "addresses": {
      "solana": "EchesyfXePKdLtoiZSL8pBe8Myagyy8ZRqsACNCFGnvp"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "boosted-lusd",
    "filePath": "token:BLUSD",
    "symbol": "blusd",
    "name": "Boosted LUSD",
    "marketCapRank": 1829,
    "addresses": {
      "ethereum": "0xb9d7dddca9a4ac480991865efef82e01273f79c3"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "bosagora",
    "filePath": "token:BOA",
    "symbol": "boa",
    "name": "BOSagora",
    "marketCapRank": 1425,
    "addresses": {
      "ethereum": "0x746dda2ea243400d5a63e0700f190ab79f06489e"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "bountymarketcap",
    "filePath": "token:BMC",
    "symbol": "bmc",
    "name": "BountyMarketCap",
    "marketCapRank": 1614,
    "addresses": {
      "ethereum": "0xd945d2031b4c63c0e363304fb771f709b502dc0a"
    },
    "variants": [
      "mono"
    ]
  },
  {
    "id": "brick",
    "filePath": "token:BRICK",
    "symbol": "brick",
    "name": "r/FortNiteBR Bricks",
    "marketCapRank": 1550,
    "addresses": {
      "arbitrum-nova": "0x6dcb98f460457fe4952e12779ba852f82ecc62c1"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "brickken",
    "filePath": "token:BKN",
    "symbol": "bkn",
    "name": "Brickken",
    "marketCapRank": 1044,
    "addresses": {
      "ethereum": "0x0a638f07acc6969abf392bb009f216d22adea36d",
      "binance-smart-chain": "0x0e28bc9b03971e95acf9ae1326e51ecf9c55b498"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "bridge-oracle",
    "filePath": "token:BRG",
    "symbol": "brg",
    "name": "Bridge Oracle",
    "marketCapRank": 1592,
    "addresses": {
      "binance-smart-chain": "0x6e4a971b81ca58045a2aa982eaa3d50c4ac38f42",
      "ethereum": "0xc9c4fd7579133701fa2769b6955e7e56bb386db1",
      "arbitrum-one": "0xc9c4fd7579133701fa2769b6955e7e56bb386db1",
      "nuls": "NULSd6Hgu5DRgAg11zwyq1C1NGpKBGYUm3Uhu"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "brn-metaverse",
    "filePath": "token:BRN",
    "symbol": "brn",
    "name": "BRN Metaverse",
    "marketCapRank": 1299,
    "addresses": {
      "binance-smart-chain": "0x926ecc7687fcfb296e97a2b4501f41a6f5f8c214"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "bsc-station",
    "filePath": "token:BSCS",
    "symbol": "bscs",
    "name": "BSCS",
    "marketCapRank": 2168,
    "addresses": {
      "binance-smart-chain": "0xbcb24afb019be7e93ea9c43b7e22bb55d5b7f45d"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "bscpad",
    "filePath": "token:BSCPAD",
    "symbol": "bscpad",
    "name": "BSCPAD",
    "marketCapRank": 1312,
    "addresses": {
      "binance-smart-chain": "0x5a3010d4d8d3b5fb49f8b6e57fb9e48063f16700"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "btc-standard-hashrate-token",
    "filePath": "token:BTCST",
    "symbol": "btcst",
    "name": "BTC Standard Hashrate Token",
    "marketCapRank": 1972,
    "addresses": {
      "binance-smart-chain": "0x78650b139471520656b9e7aa7a5e9276814a38e9"
    },
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "btse-token",
    "filePath": "token:BTSE",
    "symbol": "btse",
    "name": "BTSE Token",
    "marketCapRank": 446,
    "addresses": {
      "ethereum": "0x666d875c600aa06ac1cf15641361dec3b00432ef"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "bullperks",
    "filePath": "token:BLP",
    "symbol": "blp",
    "name": "BullPerks",
    "marketCapRank": 1813,
    "addresses": {
      "binance-smart-chain": "0xfe1d7f7a8f0bda6e415593a2e4f82c64b446d404"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "burrow",
    "filePath": "token:BRRR",
    "symbol": "brrr",
    "name": "Burrow",
    "marketCapRank": 1756,
    "addresses": {
      "near-protocol": "token.burrow.near"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "bware-infra",
    "filePath": "token:INFRA",
    "symbol": "infra",
    "name": "Bware",
    "marketCapRank": 1824,
    "addresses": {
      "ethereum": "0x013062189dc3dcc99e9cee714c513033b8d99e3c",
      "avalanche": "0xa4fb4f0ff2431262d236778495145ecbc975c38b"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "byteball",
    "filePath": "token:GBYTE",
    "symbol": "gbyte",
    "name": "Obyte",
    "marketCapRank": 1250,
    "addresses": {
      "binance-smart-chain": "0xeb34de0c4b2955ce0ff1526cdf735c9e6d249d09",
      "kava": "0x0b93109d05ef330acd2c75148891cc61d20c3ef1",
      "ethereum": "0x31f69de127c8a0ff10819c0955490a4ae46fcc2a",
      "polygon-pos": "0xab5f7a0e20b0d056aed4aa4528c78da45be7308b"
    },
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "bytecoin",
    "filePath": "token:BCN",
    "symbol": "bcn",
    "name": "Bytecoin",
    "marketCapRank": 1660,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "bytom",
    "filePath": "token:BTM",
    "symbol": "btm",
    "name": "Bytom",
    "marketCapRank": 1130,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "bzx-protocol",
    "filePath": "token:BZRX",
    "symbol": "bzrx",
    "name": "bZx Protocol",
    "marketCapRank": 992,
    "addresses": {
      "ethereum": "0x56d811088235f11c8920698a204a5010a788f4b3",
      "energi": "0xe19ab0a7f5bf5b243e011bd070cf9e26296f7ebc"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "cakepie-xyz",
    "filePath": "token:CKP",
    "symbol": "ckp",
    "name": "Cakepie",
    "marketCapRank": 1140,
    "addresses": {
      "binance-smart-chain": "0x2b5d9adea07b590b638ffc165792b2c610eda649"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "calamari-network",
    "filePath": "token:KMA",
    "symbol": "kma",
    "name": "Calamari Network",
    "marketCapRank": 1783,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "calaxy",
    "filePath": "token:CLXY",
    "symbol": "clxy",
    "name": "Calaxy",
    "marketCapRank": 1603,
    "addresses": {
      "hedera-hashgraph": "0x00000000000000000000000000000000000d1ea6"
    },
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "camelot-token",
    "filePath": "token:GRAIL",
    "symbol": "grail",
    "name": "Camelot Token",
    "marketCapRank": 855,
    "addresses": {
      "arbitrum-one": "0x3d9907f9a368ad0a51be60f7da3b97cf940982d8"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "canto",
    "filePath": "token:CANTO",
    "symbol": "canto",
    "name": "CANTO",
    "marketCapRank": 358,
    "addresses": {
      "canto": "0x826551890dc65655a0aceca109ab11abdbd7a07b",
      "ethereum": "0x56c03b8c4fa80ba37f5a7b60caaaef749bb5b220"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "cap",
    "filePath": "token:CAP",
    "symbol": "cap",
    "name": "Cap",
    "marketCapRank": 2574,
    "addresses": {
      "arbitrum-one": "0x031d35296154279dc1984dcd93e392b1f946737b",
      "ethereum": "0x43044f861ec040db59a7e324c40507addb673142"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "carbify",
    "filePath": "token:CBY",
    "symbol": "cby",
    "name": "Carbify",
    "marketCapRank": 898,
    "addresses": {
      "polygon-pos": "0xb6a5ae40e79891e4deadad06c8a7ca47396df21c",
      "ethereum": "0xb9d27bc093ed0a3b7c18366266704cfe5e7af77b"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "carbon",
    "filePath": "token:CARBON",
    "symbol": "carbon",
    "name": "Carbon",
    "marketCapRank": 2627,
    "addresses": {
      "binance-smart-chain": "0xefb5df8eb84055026018030e71bc2cdfa2f138b9"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "carbon-browser",
    "filePath": "token:CSIX",
    "symbol": "csix",
    "name": "Carbon Browser",
    "marketCapRank": 950,
    "addresses": {
      "binance-smart-chain": "0x04756126f044634c9a0f0e985e60c88a51acc206",
      "ethereum": "0x345887cdb19e12833ed376bbf8b8b38269f5f5c8"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "carbon-credit",
    "filePath": "token:CCT",
    "symbol": "cct",
    "name": "Carbon Credit",
    "marketCapRank": 1921,
    "addresses": {
      "algorand": "657291910"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "cardano",
    "filePath": "token:ADA",
    "symbol": "ada",
    "name": "Cardano",
    "marketCapRank": 10,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "cardstack",
    "filePath": "token:CARD",
    "symbol": "card",
    "name": "Cardstack",
    "marketCapRank": 2272,
    "addresses": {
      "ethereum": "0x954b890704693af242613edef1b603825afcd708"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "cargox",
    "filePath": "token:CXO",
    "symbol": "cxo",
    "name": "CargoX",
    "marketCapRank": 1271,
    "addresses": {
      "ethereum": "0xb6ee9668771a79be7967ee29a63d4184f8097143",
      "polygon-pos": "0xf2ae0038696774d65e67892c9d301c5f2cbbda58"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "carry",
    "filePath": "token:CRE",
    "symbol": "cre",
    "name": "Carry",
    "marketCapRank": 596,
    "addresses": {
      "ethereum": "0x115ec79f1de567ec68b7ae7eda501b406626478e"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "cartesi",
    "filePath": "token:CTSI",
    "symbol": "ctsi",
    "name": "Cartesi",
    "marketCapRank": 298,
    "addresses": {
      "ethereum": "0x491604c0fdf08347dd1fa4ee062a822a5dd06b5d",
      "avalanche": "0x6b289cceaa8639e3831095d75a3e43520fabf552",
      "optimistic-ethereum": "0xec6adef5e1006bb305bb1975333e8fc4071295bf",
      "arbitrum-one": "0x319f865b287fcc10b30d8ce6144e8b6d1b476999",
      "polygon-pos": "0x2727ab1c2d22170abc9b595177b2d5c6e1ab7b7b",
      "binance-smart-chain": "0x8da443f84fea710266c8eb6bc34b71702d033ef2"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "cashaa",
    "filePath": "token:CAS",
    "symbol": "cas",
    "name": "Cashaa",
    "marketCapRank": 2057,
    "addresses": {
      "binance-smart-chain": "0x780207b8c0fdc32cf60e957415bfa1f2d4d9718c"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "casper-network",
    "filePath": "token:CSPR",
    "symbol": "cspr",
    "name": "Casper Network",
    "marketCapRank": 199,
    "addresses": {},
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "castello-coin",
    "filePath": "token:CAST",
    "symbol": "cast",
    "name": "Castello Coin",
    "marketCapRank": 1102,
    "addresses": {
      "ethereum": "0x3fab0bbaa03bceaf7c49e2b12877db0142be65fc"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "catapult",
    "filePath": "token:ATD",
    "symbol": "atd",
    "name": "A2DAO",
    "marketCapRank": 2620,
    "addresses": {
      "ethereum": "0x8052327f1baf94a9dc8b26b9100f211ee3774f54",
      "binance-smart-chain": "0x1ce440d1a64eea6aa1db2a5aa51c9b326930957c"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "catcoin-cash",
    "filePath": "token:CAT",
    "symbol": "cat",
    "name": "Catcoin",
    "marketCapRank": 841,
    "addresses": {
      "binance-smart-chain": "0x59f4f336bf3d0c49dbfba4a74ebd2a6ace40539a",
      "ethereum": "0x59f4f336bf3d0c49dbfba4a74ebd2a6ace40539a",
      "solana": "7hWcHohzwtLddDUG81H2PkWq6KEkMtSDNkYXsso18Fy3"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "catgirl",
    "filePath": "token:CATGIRL",
    "symbol": "catgirl",
    "name": "Catgirl",
    "marketCapRank": 1031,
    "addresses": {
      "binance-smart-chain": "0x79ebc9a2ce02277a4b5b3a768b1c0a4ed75bd936"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "catheon-gaming",
    "filePath": "token:CATHEON",
    "symbol": "catheon",
    "name": "Catheon Gaming",
    "marketCapRank": 2305,
    "addresses": {
      "polygon-pos": "0x7e7737c40878e720b32e7bc9cd096259f876d69f"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "caviar",
    "filePath": "token:CVR",
    "symbol": "cvr",
    "name": "Caviar",
    "marketCapRank": 2319,
    "addresses": {
      "polygon-pos": "0x6ae96cc93331c19148541d4d2f31363684917092"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "cdai",
    "filePath": "token:CDAI",
    "symbol": "cdai",
    "name": "cDAI",
    "marketCapRank": 639,
    "addresses": {
      "ethereum": "0x5d3a536e4d6dbd6114cc1ead35777bab948e3643"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "ceek",
    "filePath": "token:CEEK",
    "symbol": "ceek",
    "name": "CEEK Smart VR",
    "marketCapRank": 605,
    "addresses": {
      "ethereum": "0xb056c38f6b7dc4064367403e26424cd2c60655e1",
      "binance-smart-chain": "0xe0f94ac5462997d2bc57287ac3a3ae4c31345d66"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "celer-network",
    "filePath": "token:CELR",
    "symbol": "celr",
    "name": "Celer Network",
    "marketCapRank": 362,
    "addresses": {
      "ethereum": "0x4f9254c83eb525f9fcf346490bbb3ed28a81c667",
      "arbitrum-one": "0x3a8b787f78d775aecfeea15706d4221b40f345ab",
      "energi": "0x1833e138fadf220eb951a8590b8ba9058785ddde"
    },
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "celestia",
    "filePath": "token:TIA",
    "symbol": "tia",
    "name": "Celestia",
    "marketCapRank": 52,
    "addresses": {
      "cosmos": "ibc/D79E7D83AB399BFFF93433E54FAA480C191248FC556924A2A8351AE2638B3877",
      "secret": "secret1s9h6mrp4k9gll4zfv5h78ll68hdq8ml7jrnn20"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "cellframe",
    "filePath": "token:CELL",
    "symbol": "cell",
    "name": "Cellframe",
    "marketCapRank": 801,
    "addresses": {
      "ethereum": "0x26c8afbbfe1ebaca03c2bb082e69d0476bffe099",
      "binance-smart-chain": "0xd98438889ae7364c7e2a3540547fad042fb24642"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "celo",
    "filePath": "token:CELO",
    "symbol": "celo",
    "name": "Celo",
    "marketCapRank": 154,
    "addresses": {
      "celo": "0x471ece3750da237f93b8e339c536989b8978a438"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "celo-dollar",
    "filePath": "token:CUSD",
    "symbol": "cusd",
    "name": "Celo Dollar",
    "marketCapRank": 889,
    "addresses": {
      "celo": "0x765de816845861e75a25fca122bb6898b8b1282a",
      "near-protocol": "cusd.token.a11bd.near"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "celo-euro",
    "filePath": "token:CEUR",
    "symbol": "ceur",
    "name": "Celo Euro",
    "marketCapRank": 1497,
    "addresses": {
      "celo": "0xd8763cba276a3738e6de85b4b3bf5fded6d6ca73"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "celsius-degree-token",
    "filePath": "token:CEL",
    "symbol": "cel",
    "name": "Celsius Network",
    "marketCapRank": 476,
    "addresses": {
      "ethereum": "0xaaaebe6fe48e54f431b0c390cfaf0b017d09d42d",
      "fantom": "0x2c78f1b70ccf63cdee49f9233e9faa99d43aa07e",
      "energi": "0x1b53c0662414b195fcd5802c09754765b930a312",
      "polygon-pos": "0xd85d1e945766fea5eda9103f918bd915fbca63e6",
      "harmony-shard-0": "0xd562c88e0f8e7dae43076018bb1ea3115617984d"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "centrifuge",
    "filePath": "token:CFG",
    "symbol": "cfg",
    "name": "Centrifuge",
    "marketCapRank": 204,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "cere-network",
    "filePath": "token:CERE",
    "symbol": "cere",
    "name": "Cere Network",
    "marketCapRank": 677,
    "addresses": {
      "ethereum": "0x2da719db753dfa10a62e140f436e1d67f2ddb0d6"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "certik",
    "filePath": "token:CTK",
    "symbol": "ctk",
    "name": "Shentu",
    "marketCapRank": 442,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "cetus-protocol",
    "filePath": "token:CETUS",
    "symbol": "cetus",
    "name": "Cetus Protocol",
    "marketCapRank": 699,
    "addresses": {
      "sui": "0x6864a6f921804860930db6ddbe2e16acdf8504495ea7481637a1c8b9a8fe54b::cetus::CETUS"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "chain-games",
    "filePath": "token:CHAIN",
    "symbol": "chain",
    "name": "Chain Games",
    "marketCapRank": 1721,
    "addresses": {
      "ethereum": "0xc4c2614e694cf534d407ee49f8e44d125e4681c4",
      "harmony-shard-0": "0x84ec08c887dd8c14d389abe56e609379b7c5262e",
      "polygon-pos": "0xd55fce7cdab84d84f2ef3f99816d765a2a94a509",
      "binance-smart-chain": "0x35de111558f691f77f791fb0c08b2d6b931a9d47"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "chain-guardians",
    "filePath": "token:CGG",
    "symbol": "cgg",
    "name": "Chain Guardians",
    "marketCapRank": 1875,
    "addresses": {
      "ethereum": "0x1fe24f25b1cf609b9c4e7e12d802e3640dfa5e43",
      "polygon-pos": "0x2ab4f9ac80f33071211729e45cfc346c1f8446d5",
      "binance-smart-chain": "0x1613957159e9b0ac6c80e824f7eea748a32a0ae2"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "chaingpt",
    "filePath": "token:CGPT",
    "symbol": "cgpt",
    "name": "ChainGPT",
    "marketCapRank": 407,
    "addresses": {
      "binance-smart-chain": "0x9840652dc04fb9db2c43853633f0f62be6f00f98",
      "ethereum": "0x25931894a86d47441213199621f1f2994e1c39aa"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "chainlink",
    "filePath": "token:LINK",
    "symbol": "link",
    "name": "Chainlink",
    "marketCapRank": 16,
    "addresses": {
      "ethereum": "0x514910771af9ca656af840dff83e8264ecf986ca",
      "fantom": "0xb3654dc3d10ea7645f8319668e8f54d2574fbdc8",
      "avalanche": "0x5947bb275c521040051d82396192181b413227a3",
      "energi": "0x68ca48ca2626c415a89756471d4ade2cc9034008",
      "optimistic-ethereum": "0x350a791bfc2c21f9ed5d10980dad2e2638ffa7f6",
      "near-protocol": "514910771af9ca656af840dff83e8264ecf986ca.factory.bridge.near",
      "arbitrum-one": "0xf97f4df75117a78c1a5a0dbb814af92458539fb4",
      "huobi-token": "0x9e004545c59d359f6b7bfb06a26390b087717b42",
      "xdai": "0xe2e73a1c69ecf83f464efce6a5be353a37ca09b2",
      "polygon-pos": "0x53e0bca35ec356bd5dddfebbd1fc0fd03fabad39",
      "harmony-shard-0": "0x218532a12a389a4a92fc0c5fb22901d1c19198aa",
      "sora": "0x008484148dcf23d1b48908393e7a00d5fdc3bf81029a73eeca62a15ebfb1205a",
      "binance-smart-chain": "0xf8a0bf9cf54bb92f17374d9e9a321e6a111a51bd",
      "milkomeda-cardano": "0xf390830df829cf22c53c8840554b98eafc5dcbc2",
      "osmosis": "ibc/D3327A763C23F01EC43D1F0DB3CEFEC390C362569B6FD191F40A5192F8960049"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "chainport",
    "filePath": "token:PORTX",
    "symbol": "portx",
    "name": "ChainPort",
    "marketCapRank": 2446,
    "addresses": {
      "ethereum": "0x104f3152d8ebfc3f679392977356962ff36566ac",
      "polygon-pos": "0x189586b5f6317538ae50c20a976597da38984a24"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "champignons-of-arborethia",
    "filePath": "token:CHAMPZ",
    "symbol": "champz",
    "name": "Champignons of Arborethia",
    "marketCapRank": 1660,
    "addresses": {
      "ethereum": "0x571e21a545842c6ce596663cda5caa8196ac1c7a"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "charged-particles",
    "filePath": "token:IONX",
    "symbol": "ionx",
    "name": "Charged Particles",
    "marketCapRank": 2468,
    "addresses": {
      "ethereum": "0x02d3a27ac3f55d5d91fb0f52759842696a864217"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "charli3",
    "filePath": "token:C3",
    "symbol": "c3",
    "name": "Charli3",
    "marketCapRank": 1917,
    "addresses": {
      "cardano": "8e51398904a5d3fc129fbf4f1589701de23c7824d5c90fdb9490e15a"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "cheems",
    "filePath": "token:CHEEMS",
    "symbol": "cheems",
    "name": "Cheems",
    "marketCapRank": 2218,
    "addresses": {
      "solana": "3FoUAsGDbvTD6YZ4wVKJgTB76onJUKz7GPEBNiR5b8wc"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "cheqd-network",
    "filePath": "token:CHEQ",
    "symbol": "cheq",
    "name": "CHEQD Network",
    "marketCapRank": 632,
    "addresses": {
      "ethereum": "0x70edf1c215d0ce69e7f16fd4e6276ba0d99d4de7"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "chia",
    "filePath": "token:XCH",
    "symbol": "xch",
    "name": "Chia",
    "marketCapRank": 209,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "chihuahua-token",
    "filePath": "token:HUAHUA",
    "symbol": "huahua",
    "name": "Chihuahua Chain",
    "marketCapRank": 1228,
    "addresses": {
      "osmosis": "ibc/B9E0A1A524E98BB407D3CED8720EFEFD186002F90C1B1B7964811DD0CCC12228"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "chiliz",
    "filePath": "token:CHZ",
    "symbol": "chz",
    "name": "Chiliz",
    "marketCapRank": 89,
    "addresses": {
      "ethereum": "0x3506424f91fd33084466f402d5d97f05f8e3b4af",
      "energi": "0xa82fc24687ffbde40776dede7c70f845b67f3ef7"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "chirpley",
    "filePath": "token:CHRP",
    "symbol": "chrp",
    "name": "Chirpley",
    "marketCapRank": 1275,
    "addresses": {
      "binance-smart-chain": "0xed00fc7d48b57b81fe65d1ce71c0985e4cf442cb",
      "ethereum": "0x70bc0dc6414eb8974bc70685f798838a87d8cce4"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "choise",
    "filePath": "token:CHO",
    "symbol": "cho",
    "name": "Choise.com",
    "marketCapRank": 1721,
    "addresses": {
      "ethereum": "0xbba39fd2935d5769116ce38d46a71bde9cf03099"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "chromaway",
    "filePath": "token:CHR",
    "symbol": "chr",
    "name": "Chromia",
    "marketCapRank": 228,
    "addresses": {
      "ethereum": "0x8a2279d4a90b6fe1c4b30fa660cc9f926797baa2",
      "binance-smart-chain": "0xf9cec8d50f6c8ad3fb6dccec577e05aa32b224fe"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "chronobank",
    "filePath": "token:TIME",
    "symbol": "time",
    "name": "chrono.tech",
    "marketCapRank": 1109,
    "addresses": {
      "ethereum": "0x485d17a6f1b8780392d53d64751824253011a260",
      "binance-smart-chain": "0x3b198e26e473b8fab2085b37978e36c9de5d7f68"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "chumbai-valley",
    "filePath": "token:CHMB",
    "symbol": "chmb",
    "name": "Chumbi Valley",
    "marketCapRank": 1692,
    "addresses": {
      "binance-smart-chain": "0x5492ef6aeeba1a3896357359ef039a8b11621b45"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "cindicator",
    "filePath": "token:CND",
    "symbol": "cnd",
    "name": "Cindicator",
    "marketCapRank": 2437,
    "addresses": {
      "ethereum": "0xd4c435f5b09f855c3317c8524cb1f586e42795fa"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "circuits-of-value",
    "filePath": "token:COVAL",
    "symbol": "coval",
    "name": "Circuits of Value",
    "marketCapRank": 695,
    "addresses": {
      "ethereum": "0x3d658390460295fb963f54dc0899cfb1c30776df",
      "xdai": "0x8b8407c6184f1f0fd1082e83d6a3b8349caced12",
      "fantom": "0x8b8407c6184f1f0fd1082e83d6a3b8349caced12",
      "polygon-pos": "0x4597c8a59ab28b36840b82b3a674994a279593d0",
      "binance-smart-chain": "0xd15cee1deafbad6c0b3fd7489677cc102b141464"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "cirus",
    "filePath": "token:CIRUS",
    "symbol": "cirus",
    "name": "Cirus",
    "marketCapRank": 1949,
    "addresses": {
      "ethereum": "0xa01199c61841fce3b3dafb83fefc1899715c8756"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "city-tycoon-games",
    "filePath": "token:CTG",
    "symbol": "ctg",
    "name": "City Tycoon Games",
    "marketCapRank": 2454,
    "addresses": {
      "binance-smart-chain": "0xb3ba14f6a482dfdebc3c2fb726ac10df91ee504c"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "civic",
    "filePath": "token:CVC",
    "symbol": "cvc",
    "name": "Civic",
    "marketCapRank": 374,
    "addresses": {
      "ethereum": "0x41e5560054824ea6b0732e656e3ad64e20e94e45",
      "energi": "0x0d91d554768dc20e1d3d95ff9d5bc041edc3ba0f",
      "polygon-pos": "0x66dc5a08091d1968e08c16aa5b27bac8398b02be"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "cjournal",
    "filePath": "token:UCJL",
    "symbol": "ucjl",
    "name": "Utility Cjournal",
    "marketCapRank": 2343,
    "addresses": {
      "binance-smart-chain": "0xf5355ddc7ffbf7ca119bf3222cb0ecac2fbb4502"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "clash-of-lilliput",
    "filePath": "token:COL",
    "symbol": "col",
    "name": "Clash of Lilliput",
    "marketCapRank": 635,
    "addresses": {
      "binance-smart-chain": "0x9ce116224459296abc7858627abd5879514bc629"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "cleardao",
    "filePath": "token:CLH",
    "symbol": "clh",
    "name": "ClearDAO",
    "marketCapRank": 2414,
    "addresses": {
      "ethereum": "0xd7d8f3b8bc8bc48d3acc37879eaba7b85889fa52"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "clearpool",
    "filePath": "token:CPOOL",
    "symbol": "cpool",
    "name": "Clearpool",
    "marketCapRank": 446,
    "addresses": {
      "ethereum": "0x66761fa41377003622aee3c7675fc7b5c1c2fac5"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "clintex-cti",
    "filePath": "token:CTI",
    "symbol": "cti",
    "name": "ClinTex CTi",
    "marketCapRank": 1855,
    "addresses": {
      "ethereum": "0xcb8fb2438a805664cd8c3e640b85ac473da5be87",
      "binance-smart-chain": "0x7c3b67b30efbacc8f787f7ebd3bdc65234299f4c",
      "polygon-pos": "0x03c2f6808502ffd4ab2787ad1a98ec13dbd5718b",
      "solana": "9ET2QCQJdFkeKkuaampNbmicbA8eLYauFCWch9Ddh9p5"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "clore-ai",
    "filePath": "token:CLORE",
    "symbol": "clore",
    "name": "Clore.ai",
    "marketCapRank": 547,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "clover-finance",
    "filePath": "token:CLV",
    "symbol": "clv",
    "name": "Clover Finance",
    "marketCapRank": 517,
    "addresses": {
      "ethereum": "0x80c62fe4487e1351b47ba49809ebd60ed085bf52",
      "binance-smart-chain": "0x09e889bb4d5b474f561db0491c38702f367a4e4d"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "cnh-tether",
    "filePath": "token:CNHT",
    "symbol": "cnht",
    "name": "CNH Tether",
    "marketCapRank": 2125,
    "addresses": {
      "ethereum": "0x6e109e9dd7fa1a58bc3eff667e8e41fc3cc07aef"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "cocktailbar",
    "filePath": "token:COC",
    "symbol": "coc",
    "name": "The Cocktailbar",
    "marketCapRank": 1961,
    "addresses": {
      "ethereum": "0x22b6c31c2beb8f2d0d5373146eed41ab9ede3caf"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "cocos-bcx",
    "filePath": "token:COMBO",
    "symbol": "combo",
    "name": "COMBO",
    "marketCapRank": 600,
    "addresses": {
      "ethereum": "0xc03fbf20a586fa89c2a5f6f941458e1fbc40c661",
      "binance-smart-chain": "0xc03fbf20a586fa89c2a5f6f941458e1fbc40c661"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "coin-capsule",
    "filePath": "token:CAPS",
    "symbol": "caps",
    "name": "Ternoa",
    "marketCapRank": 847,
    "addresses": {
      "ethereum": "0x03be5c903c727ee2c8c4e9bc0acc860cca4715e2",
      "binance-smart-chain": "0xffba7529ac181c2ee1844548e6d7061c9a597df4"
    },
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "coin98",
    "filePath": "token:C98",
    "symbol": "c98",
    "name": "Coin98",
    "marketCapRank": 302,
    "addresses": {
      "binance-smart-chain": "0xaec945e04baf28b135fa7c640f624f8d90f1c3a6",
      "tomochain": "0x0fd0288aaae91eaf935e2ec14b23486f86516c8c",
      "ethereum": "0xae12c5930881c53715b369cec7606b70d8eb229f",
      "polygon-pos": "0x77f56cf9365955486b12c4816992388ee8606f0e",
      "solana": "C98A4nkJXhpVZNAZdHUA95RpTF3T4whtQubL3YobiUX9"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "coinbase-wrapped-staked-eth",
    "filePath": "token:CBETH",
    "symbol": "cbeth",
    "name": "Coinbase Wrapped Staked ETH",
    "marketCapRank": 153,
    "addresses": {
      "ethereum": "0xbe9895146f7af43049ca1c1ae358b0541ea49704",
      "optimistic-ethereum": "0xaddb6a0412de1ba0f936dcaeb8aaa24578dcf3b2",
      "polygon-pos": "0x4b4327db1600b8b1440163f667e199cef35385f5",
      "arbitrum-one": "0x1debd73e752beaf79865fd6446b0c970eae7732f",
      "base": "0x2ae3f1ec7f1f5012cfeab0185bfc7aa3cf0dec22"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "coinmerge-os",
    "filePath": "token:CMOS",
    "symbol": "cmos",
    "name": "CoinMerge OS",
    "marketCapRank": 2742,
    "addresses": {
      "ethereum": "0x87869a9789291a6cec99f3c3ef2ff71fceb12a8e"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "coinmetro",
    "filePath": "token:XCM",
    "symbol": "xcm",
    "name": "Coinmetro",
    "marketCapRank": 1065,
    "addresses": {
      "ethereum": "0x36ac219f90f5a6a3c77f2a7b660e3cc701f68e25"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "coinnavigator",
    "filePath": "token:CNG",
    "symbol": "cng",
    "name": "CoinNavigator",
    "marketCapRank": 1905,
    "addresses": {
      "binance-smart-chain": "0xfd60b3c3c1916bdbb4319a3d264894f1dfd5eca2"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "coinweb",
    "filePath": "token:CWEB",
    "symbol": "cweb",
    "name": "Coinweb",
    "marketCapRank": 686,
    "addresses": {
      "ethereum": "0x505b5eda5e25a67e1c24a2bf1a527ed9eb88bf04"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "coldstack",
    "filePath": "token:CLS",
    "symbol": "cls",
    "name": "Coldstack",
    "marketCapRank": 1762,
    "addresses": {
      "ethereum": "0x675bbc7514013e2073db7a919f6e4cbef576de37",
      "binance-smart-chain": "0x668048e70284107a6afab1711f28d88df3e72948"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "collab-land",
    "filePath": "token:COLLAB",
    "symbol": "collab",
    "name": "Collab.Land",
    "marketCapRank": 2462,
    "addresses": {
      "arbitrum-one": "0xf18c263ec50cc211ef3f172228549b6618f10613"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "colony",
    "filePath": "token:CLY",
    "symbol": "cly",
    "name": "Colony",
    "marketCapRank": 1008,
    "addresses": {
      "avalanche": "0xec3492a2508ddf4fdc0cd76f31f340b30d1793e6"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "comdex",
    "filePath": "token:CMDX",
    "symbol": "cmdx",
    "name": "COMDEX",
    "marketCapRank": 1733,
    "addresses": {
      "comdex": "ucmdx",
      "archway": "ibc/BF8BDCAA292B56035E669D80711D9881CC96796AC6BCB0376836FAD045355E37",
      "osmosis": "ibc/EA3E1640F9B1532AB129A571203A0B9F789A7F14BB66E350DCBFA18E1A1931F0"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "compound-governance-token",
    "filePath": "token:COMP",
    "symbol": "comp",
    "name": "Compound",
    "marketCapRank": 181,
    "addresses": {
      "ethereum": "0xc00e94cb662c3520282e6f5717214004a7f26888",
      "energi": "0x66bc411714e16b6f0c68be12bd9c666cc4576063",
      "avalanche": "0xc3048e19e76cb9a3aa9d77d8c03c29fc906e2437",
      "near-protocol": "c00e94cb662c3520282e6f5717214004a7f26888.factory.bridge.near",
      "polygon-pos": "0x8505b9d2254a7ae468c0e9dd10ccea3a837aef5c",
      "harmony-shard-0": "0x32137b9275ea35162812883582623cd6f6950958",
      "arbitrum-one": "0x354a6da3fcde098f8389cad84b0182725c6c91de",
      "binance-smart-chain": "0x52ce071bd9b1c4b00a0b92d298c512478cad67e8",
      "sora": "0x00dbd45af9f2ea406746f9025110297469e9d29efc60df8d88efb9b0179d6c2c"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "compound-usd-coin",
    "filePath": "token:CUSDC",
    "symbol": "cusdc",
    "name": "cUSDC",
    "marketCapRank": 636,
    "addresses": {
      "ethereum": "0x39aa39c021dfbae8fac545936693ac917d5e7563"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "comtech-gold",
    "filePath": "token:CGO",
    "symbol": "cgo",
    "name": "Comtech Gold",
    "marketCapRank": 1473,
    "addresses": {
      "xdc-network": "xdc8f9920283470f52128bf11b0c14e798be704fd15"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "concentrated-voting-power",
    "filePath": "token:CVP",
    "symbol": "cvp",
    "name": "PowerPool Concentrated Voting Power",
    "marketCapRank": 1163,
    "addresses": {
      "ethereum": "0x38e4adb44ef08f22f5b5b76a8f0c2d0dcbe7dca1"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "concentrator",
    "filePath": "token:CTR",
    "symbol": "ctr",
    "name": "Concentrator",
    "marketCapRank": 2765,
    "addresses": {
      "ethereum": "0xb3ad645db386d7f6d753b2b9c3f4b853da6890b8"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "concierge-io",
    "filePath": "token:AVA",
    "symbol": "ava",
    "name": "AVA",
    "marketCapRank": 780,
    "addresses": {
      "ethereum": "0xa6c0c097741d55ecd9a3a7def3a8253fd022ceb9",
      "energi": "0x8476d1c07cbc7e2dd9e97ffbd9850836835ee7a8"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "concordium",
    "filePath": "token:CCD",
    "symbol": "ccd",
    "name": "Concordium",
    "marketCapRank": 793,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "conflux-token",
    "filePath": "token:CFX",
    "symbol": "cfx",
    "name": "Conflux",
    "marketCapRank": 69,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "conic-finance",
    "filePath": "token:CNC",
    "symbol": "cnc",
    "name": "Conic",
    "marketCapRank": 1865,
    "addresses": {
      "ethereum": "0x9ae380f0272e2162340a5bb646c354271c0f5cfc"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "connect-financial",
    "filePath": "token:CNFI",
    "symbol": "cnfi",
    "name": "Connect Financial",
    "marketCapRank": 2211,
    "addresses": {
      "ethereum": "0xeabb8996ea1662cad2f7fb715127852cd3262ae9",
      "arbitrum-one": "0x6f5401c53e2769c858665621d22ddbf53d8d27c5"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "constellation-labs",
    "filePath": "token:DAG",
    "symbol": "dag",
    "name": "Constellation",
    "marketCapRank": 355,
    "addresses": {},
    "variants": [
      "mono"
    ]
  },
  {
    "id": "constitutiondao",
    "filePath": "token:PEOPLE",
    "symbol": "people",
    "name": "ConstitutionDAO",
    "marketCapRank": 349,
    "addresses": {
      "ethereum": "0x7a58c0be72be218b41c608b7fe7c5bb630736c71"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "contentos",
    "filePath": "token:COS",
    "symbol": "cos",
    "name": "Contentos",
    "marketCapRank": 757,
    "addresses": {
      "binancecoin": "COS-2E4"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "convergence",
    "filePath": "token:CONV",
    "symbol": "conv",
    "name": "Convergence",
    "marketCapRank": 2157,
    "addresses": {
      "ethereum": "0xc834fa996fa3bec7aad3693af486ae53d8aa8b50"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "cope",
    "filePath": "token:COPE",
    "symbol": "cope",
    "name": "Cope",
    "marketCapRank": 2330,
    "addresses": {
      "solana": "8HGyAAB1yoM1ttS7pXjHMa3dukTFGQggnFFH3hJZgzQh"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "coredaoorg",
    "filePath": "token:CORE",
    "symbol": "core",
    "name": "Core",
    "marketCapRank": 112,
    "addresses": {},
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "cornucopias",
    "filePath": "token:COPI",
    "symbol": "copi",
    "name": "Cornucopias",
    "marketCapRank": 619,
    "addresses": {
      "binance-smart-chain": "0xfea292e5ea4510881bdb840e3cec63abd43f936f",
      "cardano": "asset1c6uau7pufsxhnm7eg0eerhu4snwfd9sn7kvvvz",
      "ethereum": "0x42baf1f659d765c65ade5bb7e08eb2c680360d9d"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "cortex",
    "filePath": "token:CTXC",
    "symbol": "ctxc",
    "name": "Cortex",
    "marketCapRank": 513,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "cosmos",
    "filePath": "token:ATOM",
    "symbol": "atom",
    "name": "Cosmos Hub",
    "marketCapRank": 29,
    "addresses": {
      "kava": "0x15932e26f5bd4923d46a2b205191c4b5d5f43fe3",
      "evmos": "0xc5e00d3b04563950941f7137b5afa3a534f0d6d6",
      "archway": "ibc/27394fb092d2eccd56123c74f36e4c1f926001ceada9ca97ea622b25f41e5eb2",
      "osmosis": "ibc/27394FB092D2ECCD56123C74F36E4C1F926001CEADA9CA97EA622B25F41E5EB2",
      "binance-smart-chain": "0x0eb3a705fc54725037cc9e008bdede697f62f335",
      "canto": "0xeceeefcee421d8062ef8d6b4d814efe4dc898265"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "coti",
    "filePath": "token:COTI",
    "symbol": "coti",
    "name": "COTI",
    "marketCapRank": 274,
    "addresses": {
      "ethereum": "0xddb3422497e61e13543bea06989c0789117555c5"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "counterparty",
    "filePath": "token:XCP",
    "symbol": "xcp",
    "name": "Counterparty",
    "marketCapRank": 1070,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "covalent",
    "filePath": "token:CQT",
    "symbol": "cqt",
    "name": "Covalent",
    "marketCapRank": 339,
    "addresses": {
      "ethereum": "0xd417144312dbf50465b1c641d016962017ef6240"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "covesting",
    "filePath": "token:COV",
    "symbol": "cov",
    "name": "Covesting",
    "marketCapRank": 2782,
    "addresses": {
      "ethereum": "0xada86b1b313d1d5267e3fc0bb303f0a2b66d0ea7",
      "binance-smart-chain": "0x0f237db17aa4e6de062e6f052bd9c805789b01c3"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "cow-protocol",
    "filePath": "token:COW",
    "symbol": "cow",
    "name": "CoW Protocol",
    "marketCapRank": 639,
    "addresses": {
      "ethereum": "0xdef1ca1fb7fbcdc777520aa7f396b4e015f497ab",
      "xdai": "0x177127622c4a00f3d409b75571e12cb3c8973d3c"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "cratos",
    "filePath": "token:CRTS",
    "symbol": "crts",
    "name": "Cratos",
    "marketCapRank": 640,
    "addresses": {
      "ethereum": "0x678e840c640f619e17848045d23072844224dd37",
      "binance-smart-chain": "0x678e840c640f619e17848045d23072844224dd37"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "cream-2",
    "filePath": "token:CREAM",
    "symbol": "cream",
    "name": "Cream",
    "marketCapRank": 1121,
    "addresses": {
      "ethereum": "0x2ba592f78db6436527729929aaf6c908497cb200",
      "energi": "0x1cca61099dcebe517f8cac58f27218e7aff2d3bf",
      "sora": "0x00521ad5caeadc2e3e04be4d4ebb0b7c8c9b71ba657c2362a3953490ebc81410",
      "near-protocol": "2ba592f78db6436527729929aaf6c908497cb200.factory.bridge.near",
      "arbitrum-one": "0xf4d48ce3ee1ac3651998971541badbb9a14d7234",
      "fantom": "0x657a1861c15a3ded9af0b6799a195a249ebdcbc6"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "credefi",
    "filePath": "token:CREDI",
    "symbol": "credi",
    "name": "Credefi",
    "marketCapRank": 1122,
    "addresses": {
      "ethereum": "0xae6e307c3fe9e922e5674dbd7f830ed49c014c6b",
      "binance-smart-chain": "0x2235e79086dd23135119366da45851c741874e5b"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "creditcoin-2",
    "filePath": "token:CTC",
    "symbol": "ctc",
    "name": "Creditcoin",
    "marketCapRank": 262,
    "addresses": {
      "ethereum": "0xa3ee21c306a700e682abcdfe9baa6a08f3820419"
    },
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "creo-engine",
    "filePath": "token:CREO",
    "symbol": "creo",
    "name": "Creo Engine",
    "marketCapRank": 846,
    "addresses": {
      "binance-smart-chain": "0x9521728bf66a867bc65a93ece4a543d817871eb7"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "cronos-id",
    "filePath": "token:CROID",
    "symbol": "croid",
    "name": "Cronos ID",
    "marketCapRank": 1034,
    "addresses": {
      "cronos": "0xcbf0adea24fd5f32c6e7f0474f0d1b94ace4e2e7"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "cropbytes",
    "filePath": "token:CBX",
    "symbol": "cbx",
    "name": "CropBytes",
    "marketCapRank": 1779,
    "addresses": {
      "ethereum": "0x37fc4b48ce93469dbea9918468993c735049642a"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "crowdswap",
    "filePath": "token:CROWD",
    "symbol": "crowd",
    "name": "CrowdSwap",
    "marketCapRank": 1996,
    "addresses": {
      "polygon-pos": "0x483dd3425278c1f79f377f1034d9d2cae55648b6"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "crown-by-third-time-games",
    "filePath": "token:CROWN",
    "symbol": "crown",
    "name": "Crown by Third Time Games",
    "marketCapRank": 313,
    "addresses": {
      "solana": "GDfnEsia2WLAW5t8yx2X5j2mkfA74i5kwGdDuZHt7XmG"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "crowns",
    "filePath": "token:CWS",
    "symbol": "cws",
    "name": "Seascape Crowns",
    "marketCapRank": 1989,
    "addresses": {
      "binance-smart-chain": "0x99aa29ac023057951781dc5d1784e9a4c362ce23"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "crowny-token",
    "filePath": "token:CRWNY",
    "symbol": "crwny",
    "name": "Crowny",
    "marketCapRank": 1584,
    "addresses": {
      "solana": "CRWNYkqdgvhGGae9CKfNka58j6QQkaD5bLhKXvUYqnc1"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "crust-network",
    "filePath": "token:CRU",
    "symbol": "cru",
    "name": "Crust Network",
    "marketCapRank": 707,
    "addresses": {
      "ethereum": "0x32a7c02e79c4ea1008dd6564b35f131428673c41"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "crvusd",
    "filePath": "token:CRVUSD",
    "symbol": "crvusd",
    "name": "crvUSD",
    "marketCapRank": 411,
    "addresses": {
      "ethereum": "0xf939e0a03fb07f59a73314e73794be0e57ac1b4e",
      "arbitrum-one": "0x498bf2b1e120fed3ad3d42ea2165e9b73f99c1e5",
      "optimistic-ethereum": "0xc52d7f23a2e460248db6ee192cb23dd12bddcbf6",
      "base": "0x417ac0e078398c154edfadd9ef675d30be60af93",
      "xdai": "0xabef652195f98a91e490f047a5006b71c85f058d",
      "polygon-pos": "0xc4ce1d6f5d98d65ee25cf85e9f2e9dcfee6cb5d6"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "cryowar-token",
    "filePath": "token:CWAR",
    "symbol": "cwar",
    "name": "Cryowar",
    "marketCapRank": 1561,
    "addresses": {
      "solana": "HfYFjMKNZygfMC8LsQ8LtpPsPxEJoXJx4M6tqi75Hajo"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "crypterium",
    "filePath": "token:CRPT",
    "symbol": "crpt",
    "name": "Crypterium",
    "marketCapRank": 1815,
    "addresses": {
      "ethereum": "0x08389495d7456e1951ddf7c3a1314a4bfb646d8b"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "cryptex-finance",
    "filePath": "token:CTX",
    "symbol": "ctx",
    "name": "Cryptex Finance",
    "marketCapRank": 1057,
    "addresses": {
      "ethereum": "0x321c2fe4446c7c963dc41dd58879af648838f98d"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "crypto-com-chain",
    "filePath": "token:CRO",
    "symbol": "cro",
    "name": "Cronos",
    "marketCapRank": 36,
    "addresses": {
      "ethereum": "0xa0b73e1ff0b80914ab6fe0444e65848c4c34450b"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "crypto-gladiator-shards",
    "filePath": "token:CGL",
    "symbol": "cgl",
    "name": "Crypto Gladiator League",
    "marketCapRank": 1258,
    "addresses": {
      "polygon-pos": "0x2627c26b33f5193da4adfb26df60202479ccd2d3"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "cryptocart",
    "filePath": "token:CCV2",
    "symbol": "ccv2",
    "name": "CryptoCart V2",
    "marketCapRank": 2466,
    "addresses": {
      "ethereum": "0x612e1726435fe38dd49a0b35b4065b56f49c8f11",
      "binance-smart-chain": "0x612e1726435fe38dd49a0b35b4065b56f49c8f11"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "cryptofranc",
    "filePath": "token:XCHF",
    "symbol": "xchf",
    "name": "CryptoFranc",
    "marketCapRank": 2295,
    "addresses": {
      "ethereum": "0xb4272071ecadd69d933adcd19ca99fe80664fc08"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "cryptogpt-token",
    "filePath": "token:LAI",
    "symbol": "lai",
    "name": "LayerAI",
    "marketCapRank": 1173,
    "addresses": {
      "ethereum": "0x168e209d7b2f58f1f24b8ae7b7d35e662bbf11cc",
      "binance-smart-chain": "0x776f9987d9deed90eed791cbd824d971fd5ccf09"
    },
    "variants": [
      "mono"
    ]
  },
  {
    "id": "csp-dao-network",
    "filePath": "token:NEBO",
    "symbol": "nebo",
    "name": "CSP DAO Network",
    "marketCapRank": 1796,
    "addresses": {
      "ethereum": "0x7f0c8b125040f707441cad9e5ed8a8408673b455"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "cube-intelligence",
    "filePath": "token:AUTO",
    "symbol": "auto",
    "name": "Cube Intelligence",
    "marketCapRank": 2017,
    "addresses": {
      "ethereum": "0x622dffcc4e83c64ba959530a5a5580687a57581b"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "cudos",
    "filePath": "token:CUDOS",
    "symbol": "cudos",
    "name": "Cudos",
    "marketCapRank": 438,
    "addresses": {
      "ethereum": "0x817bbdbc3e8a1204f3691d14bb44992841e3db35",
      "archway": "ibc/2AE1ECA44CAD0C933CE178742595CE6796530FA1983E4FA7F4E43FBB5854D505"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "cult-dao",
    "filePath": "token:CULT",
    "symbol": "cult",
    "name": "Cult DAO",
    "marketCapRank": 1200,
    "addresses": {
      "ethereum": "0xf0f9d895aca5c8678f706fb8216fa22957685a13"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "cuminu",
    "filePath": "token:CUMINU",
    "symbol": "cuminu",
    "name": "Cuminu",
    "marketCapRank": 1851,
    "addresses": {
      "ethereum": "0xd6327ce1fb9d6020e8c2c0e124a1ec23dcab7536"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "cumrocket",
    "filePath": "token:CUMMIES",
    "symbol": "cummies",
    "name": "CumRocket",
    "marketCapRank": 1223,
    "addresses": {
      "binance-smart-chain": "0x27ae27110350b98d564b9a3eed31baebc82d878d"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "curate",
    "filePath": "token:XCUR",
    "symbol": "xcur",
    "name": "Curate",
    "marketCapRank": 2519,
    "addresses": {
      "ethereum": "0xe1c7e30c42c24582888c758984f6e382096786bd",
      "binance-smart-chain": "0xd52669712f253cd6b2fe8a8638f66ed726cb770c",
      "solana": "35r2jMGKytAJ7FyKfKRHPanT8kpjg3emPy7WG6GANCNB"
    },
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "curio-governance",
    "filePath": "token:CGT",
    "symbol": "cgt",
    "name": "Curio Governance Token",
    "marketCapRank": 1954,
    "addresses": {
      "ethereum": "0xf56b164efd3cfc02ba739b719b6526a6fa1ca32a",
      "binance-smart-chain": "0x3d04edc843e74935c09f54cc4b2fe1870e347ac9"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "curve-dao-token",
    "filePath": "token:CRV",
    "symbol": "crv",
    "name": "Curve DAO",
    "marketCapRank": 131,
    "addresses": {
      "ethereum": "0xd533a949740bb3306d119cc777fa900ba034cd52",
      "energi": "0xd3319eaf3c4743ac75aace77befcfa445ed6e69e",
      "optimistic-ethereum": "0x0994206dfe8de6ec6920ff4d779b0d950605fb53",
      "polygon-pos": "0x172370d5cd63279efa6d502dab29171933a610af",
      "fantom": "0x1e4f97b9f9f913c46f1632781732927b9019c68b",
      "arbitrum-one": "0x11cdb42b0eb46d95f990bedd4695a6e3fa034978",
      "sora": "0x002ead91a2de57b8855b53d4a62c25277073fd7f65f7e5e79f4936ed747fcad0"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "cyberconnect",
    "filePath": "token:CYBER",
    "symbol": "cyber",
    "name": "CyberConnect",
    "marketCapRank": 402,
    "addresses": {
      "ethereum": "0x14778860e937f509e651192a90589de711fb88a9",
      "optimistic-ethereum": "0x14778860e937f509e651192a90589de711fb88a9",
      "binance-smart-chain": "0x14778860e937f509e651192a90589de711fb88a9"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "cypherium",
    "filePath": "token:CPH",
    "symbol": "cph",
    "name": "Cypherium",
    "marketCapRank": 1494,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "d3d-social",
    "filePath": "token:D3D",
    "symbol": "d3d",
    "name": "D3D Social",
    "marketCapRank": 1285,
    "addresses": {
      "binance-smart-chain": "0xd3c7e51caab1089002ec05569a04d14bcc478bc4"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "dacxi",
    "filePath": "token:DACXI",
    "symbol": "dacxi",
    "name": "Dacxi",
    "marketCapRank": 1512,
    "addresses": {
      "ethereum": "0xefab7248d36585e2340e5d25f8a8d243e6e3193f"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "dafi-protocol",
    "filePath": "token:DAFI",
    "symbol": "dafi",
    "name": "Dafi Protocol",
    "marketCapRank": 2302,
    "addresses": {
      "ethereum": "0xfc979087305a826c2b2a0056cfaba50aad3e6439",
      "binance-smart-chain": "0x4e0fe270b856eebb91fb4b4364312be59f499a3f",
      "polygon-pos": "0x638df98ad8069a15569da5a6b01181804c47e34c"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "dai",
    "filePath": "token:DAI",
    "symbol": "dai",
    "name": "Dai",
    "marketCapRank": 30,
    "addresses": {
      "ethereum": "0x6b175474e89094c44da98b954eedeac495271d0f",
      "kava": "0x765277eebeca2e31912c9946eae1021199b39c61",
      "fantom": "0x8d11ec38a3eb5e956b052f67da8bdc9bef8abf3e",
      "energi": "0x0ee5893f434017d8881750101ea2f7c49c0eb503",
      "avalanche": "0xd586e7f844cea2f87f50152665bcbc2c279d8d70",
      "polygon-zkevm": "0xc5015b9d9161dca7e18e32f6f25c4ad850731fd4",
      "optimistic-ethereum": "0xda10009cbd5d07dd0cecc66161fc93d7c9000da1",
      "zksync": "0x4b9eb6c0b6ea15176bbf62841c6b2a8a398cb656",
      "cronos": "0xf2001b145b43032aaf5ee2884e456ccd805f677d",
      "arbitrum-one": "0xda10009cbd5d07dd0cecc66161fc93d7c9000da1",
      "base": "0x50c5725949a6f0c72e6c4a641f24049a917db0cb",
      "polygon-pos": "0x8f3cf7ad23cd3cadbd9735aff958023239c6a063",
      "binance-smart-chain": "0x1af3f329e8be154074d8769d1ffa4ee058b1dbc3",
      "metis-andromeda": "0x4651b38e7ec14bb3db731369bfe5b08f2466bd0a",
      "harmony-shard-0": "0xef977d2f931c1978db5f6747666fa1eacb0d0339",
      "sora": "0x0200060000000000000000000000000000000000000000000000000000000000",
      "moonriver": "0x80a16016cc4a2e6a2caca8a4a498b1699ff0f844",
      "aurora": "0xe3520349f477a5f6eb06107066048508498a291b",
      "moonbeam": "0x765277eebeca2e31912c9946eae1021199b39c61",
      "syscoin": "0xefaeee334f0fd1712f9a8cc375f427d9cdd40d73",
      "milkomeda-cardano": "0x639a647fbe20b6c8ac19e48e2de44ea792c62c5c",
      "cosmos": "ibc/0CD3A0285E1341859B5E86B6AB7682F023D03E97607CCC1DC95706411D866DF7",
      "astar": "0x6de33698e9e9b787e09d3bd7771ef63557e148bb",
      "velas": "0xe3f5a90f9cb311505cd691a46596599aa1a0ad7d",
      "arbitrum-nova": "0xda10009cbd5d07dd0cecc66161fc93d7c9000da1",
      "klay-token": "0x078db7827a5531359f6cb63f62cfa20183c4f10c",
      "xdai": "0x44fa8e6f47987339850636f88629646662444217",
      "hydra": "abc2cd00700e06922bcf30fe0ad648507113cc56",
      "near-protocol": "6b175474e89094c44da98b954eedeac495271d0f.factory.bridge.near"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "danchortoken",
    "filePath": "token:USN",
    "symbol": "usn",
    "name": "USN",
    "marketCapRank": null,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "dao-maker",
    "filePath": "token:DAO",
    "symbol": "dao",
    "name": "DAO Maker",
    "marketCapRank": 221,
    "addresses": {
      "ethereum": "0x0f51bb10119727a7e5ea3538074fb341f56b09ad",
      "arbitrum-one": "0xcaa38bcc8fb3077975bbe217acfaa449e6596a84",
      "binance-smart-chain": "0x4d2d32d8652058bf98c772953e1df5c5c85d9f45",
      "step-network": "0xd67de0e0a0fd7b15dc8348bb9be742f3c5850454"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "darwinia-network-native-token",
    "filePath": "token:RING",
    "symbol": "ring",
    "name": "Darwinia Network",
    "marketCapRank": 1513,
    "addresses": {
      "ethereum": "0x9469d013805bffb7d3debe5e7839237e535ec483",
      "arbitrum-one": "0x9e523234d36973f9e38642886197d023c88e307e",
      "polygon-pos": "0x9c1c23e60b72bc88a043bf64afdb16a02540ae8f"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "dash",
    "filePath": "token:DASH",
    "symbol": "dash",
    "name": "Dash",
    "marketCapRank": 200,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "dash-2-trade",
    "filePath": "token:D2T",
    "symbol": "d2t",
    "name": "Dash 2 Trade",
    "marketCapRank": 2360,
    "addresses": {
      "ethereum": "0x4dd942baa75810a3c1e876e79d5cd35e09c97a76"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "data-lake",
    "filePath": "token:LAKE",
    "symbol": "lake",
    "name": "Data Lake",
    "marketCapRank": 1153,
    "addresses": {
      "ethereum": "0xf9ca9523e5b5a42c3018c62b084db8543478c400"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "databroker-dao",
    "filePath": "token:DTX",
    "symbol": "dtx",
    "name": "DaTa eXchange DTX",
    "marketCapRank": 2410,
    "addresses": {
      "ethereum": "0x765f0c16d1ddc279295c1a7c24b0883f62d33f75"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "datamall-coin",
    "filePath": "token:DMC",
    "symbol": "dmc",
    "name": "Datamall Coin",
    "marketCapRank": 803,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "de-fi",
    "filePath": "token:DEFI",
    "symbol": "defi",
    "name": "DeFi",
    "marketCapRank": 983,
    "addresses": {
      "ethereum": "0x6b0faca7ba905a86f221ceb5ca404f605e5b3131",
      "binance-smart-chain": "0x6d106c0b8d2f47c5465bdbd58d1be253762cbbc1"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "deapcoin",
    "filePath": "token:DEP",
    "symbol": "dep",
    "name": "DEAPCOIN",
    "marketCapRank": 677,
    "addresses": {
      "ethereum": "0x1a3496c18d558bd9c6c8f609e1b129f67ab08163",
      "avalanche": "0xd4d026322c88c2d49942a75dff920fcfbc5614c1",
      "binance-smart-chain": "0xcaf5191fc480f43e4df80106c7695eca56e48b18",
      "solana": "BgwQjVNMWvt2d8CN51CsbniwRWyZ9H9HfHkEsvikeVuZ"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "decentr",
    "filePath": "token:DEC",
    "symbol": "dec",
    "name": "Decentr",
    "marketCapRank": 2678,
    "addresses": {
      "ethereum": "0x30f271c9e86d2b7d00a6376cd96a1cfbd5f0b9b3",
      "archway": "ibc/e3409e92f78ae5bf44dbc7c4741901e21ef73b7b8f98c4d48f2bd360af242c00",
      "osmosis": "ibc/9BCB27203424535B6230D594553F1659C77EC173E36D9CF4759E7186EE747E84"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "decentral-games-governance",
    "filePath": "token:XDG",
    "symbol": "xdg",
    "name": "Decentral Games Governance",
    "marketCapRank": 1444,
    "addresses": {
      "ethereum": "0x4f81c790581b240a5c948afd173620ecc8c71c8d",
      "polygon-pos": "0xc6480da81151b2277761024599e8db2ad4c388c8"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "decentraland",
    "filePath": "token:MANA",
    "symbol": "mana",
    "name": "Decentraland",
    "marketCapRank": 94,
    "addresses": {
      "ethereum": "0x0f5d2fb29fb7d3cfee444a200298f468908cc942",
      "polygon-pos": "0xa1c57f48f0deb89f569dfbe6e2b7f46d33606fd4"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "decentralized-advertising",
    "filePath": "token:DAD",
    "symbol": "dad",
    "name": "DAD",
    "marketCapRank": 1651,
    "addresses": {
      "ethereum": "0x5b322514ff727253292637d9054301600c2c81e8"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "decentraweb",
    "filePath": "token:DWEB",
    "symbol": "dweb",
    "name": "DecentraWeb",
    "marketCapRank": 2719,
    "addresses": {
      "ethereum": "0xe7f58a92476056627f9fdb92286778abd83b285f",
      "polygon-pos": "0x8839e639f210b80ffea73aedf51baed8dac04499"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "decimal",
    "filePath": "token:DEL",
    "symbol": "del",
    "name": "Decimal",
    "marketCapRank": 998,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "decred",
    "filePath": "token:DCR",
    "symbol": "dcr",
    "name": "Decred",
    "marketCapRank": 202,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "decubate",
    "filePath": "token:DCB",
    "symbol": "dcb",
    "name": "Decubate",
    "marketCapRank": 792,
    "addresses": {
      "binance-smart-chain": "0xeac9873291ddaca754ea5642114151f3035c67a2"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "deepbrain-chain",
    "filePath": "token:DBC",
    "symbol": "dbc",
    "name": "DeepBrain Chain",
    "marketCapRank": 1221,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "deepfakeai",
    "filePath": "token:FAKEAI",
    "symbol": "fakeai",
    "name": "DeepFakeAI",
    "marketCapRank": 1123,
    "addresses": {
      "ethereum": "0x5aef5bba19e6a1644805bd4f5c93c8557b87c62c"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "deeponion",
    "filePath": "token:ONION",
    "symbol": "onion",
    "name": "DeepOnion",
    "marketCapRank": 2617,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "deepspace",
    "filePath": "token:DPS",
    "symbol": "dps",
    "name": "DEEPSPACE",
    "marketCapRank": 2035,
    "addresses": {
      "ethereum": "0xb7b1570e26315baad369b8ea0a943b7f140db9eb",
      "binance-smart-chain": "0xf275e1ac303a4c9d987a2c48b8e555a77fec3f1c"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "defactor",
    "filePath": "token:FACTR",
    "symbol": "factr",
    "name": "Defactor",
    "marketCapRank": 1180,
    "addresses": {
      "ethereum": "0xe0bceef36f3a6efdd5eebfacd591423f8549b9d5",
      "polygon-pos": "0xe0bceef36f3a6efdd5eebfacd591423f8549b9d5",
      "binance-smart-chain": "0xdefac16715671b7b6aeefe012125f1e19ee4b7d7"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "defi-kingdoms",
    "filePath": "token:JEWEL",
    "symbol": "jewel",
    "name": "DeFi Kingdoms",
    "marketCapRank": 1090,
    "addresses": {
      "avalanche": "0x997ddaa07d716995de90577c123db411584e5e46"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "defi-kingdoms-crystal",
    "filePath": "token:CRYSTAL",
    "symbol": "crystal",
    "name": "DeFi Kingdoms Crystal",
    "marketCapRank": 2331,
    "addresses": {
      "defi-kingdoms-blockchain": "0x04b9da42306b023f3572e106b11d82aad9d32ebb"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "defi-yield-protocol",
    "filePath": "token:DYP",
    "symbol": "dyp",
    "name": "Dypius [OLD]",
    "marketCapRank": 1679,
    "addresses": {
      "ethereum": "0x961c8c0b1aad0c0b10a51fef6a867e3091bcef17",
      "avalanche": "0x961c8c0b1aad0c0b10a51fef6a867e3091bcef17",
      "binance-smart-chain": "0x961c8c0b1aad0c0b10a51fef6a867e3091bcef17"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "defichain",
    "filePath": "token:DFI",
    "symbol": "dfi",
    "name": "DeFiChain",
    "marketCapRank": 641,
    "addresses": {
      "binance-smart-chain": "0x361c60b7c2828fcab80988d00d1d542c83387b50",
      "ethereum": "0x8fc8f8269ebca376d046ce292dc7eac40c8d358a"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "definity",
    "filePath": "token:DEFX",
    "symbol": "defx",
    "name": "DeFinity",
    "marketCapRank": 1526,
    "addresses": {
      "ethereum": "0x5f474906637bdcda05f29c74653f6962bb0f8eda",
      "binance-smart-chain": "0xbe4cb2c354480042a39350a0c6c26bf54786539f"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "defipulse-index",
    "filePath": "token:DPI",
    "symbol": "dpi",
    "name": "DeFi Pulse Index",
    "marketCapRank": 1016,
    "addresses": {
      "ethereum": "0x1494ca1f11d487c2bbe4543e90080aeba4ba3c2b",
      "energi": "0x8b8e6090542b612b7e2d73a934f9f5ea7e9a40af",
      "polygon-pos": "0x85955046df4668e1dd369d2de9f3aeb98dd2a369",
      "xdai": "0xd3d47d5578e55c880505dc40648f7f9307c3e7a8"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "defit",
    "filePath": "token:DEFIT",
    "symbol": "defit",
    "name": "Digital Fitness",
    "marketCapRank": 1693,
    "addresses": {
      "polygon-pos": "0x428360b02c1269bc1c79fbc399ad31d58c1e8fda"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "degen-base",
    "filePath": "token:DEGEN",
    "symbol": "degen",
    "name": "Degen (Base)",
    "marketCapRank": 228,
    "addresses": {
      "base": "0x4ed4e862860bed51a9570b96d89af5e1b0efefed"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "degen-zoo",
    "filePath": "token:DZOO",
    "symbol": "dzoo",
    "name": "Degen Zoo",
    "marketCapRank": 1797,
    "addresses": {
      "ethereum": "0xc97d6c52f3add91fa1c5287a453d7444aecbca83",
      "binance-smart-chain": "0x56d06a78ef8e95d6043341f24759e2834be6f97b"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "degenx",
    "filePath": "token:DGNX",
    "symbol": "dgnx",
    "name": "DegenX",
    "marketCapRank": 2017,
    "addresses": {
      "avalanche": "0x51e48670098173025c477d9aa3f0eff7bf9f7812",
      "ethereum": "0x0000000000300dd8b0230efcfef136ecdf6abcde"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "dego-finance",
    "filePath": "token:DEGO",
    "symbol": "dego",
    "name": "Dego Finance",
    "marketCapRank": 1193,
    "addresses": {
      "ethereum": "0x3da932456d082cba208feb0b096d49b202bf89c8",
      "binance-smart-chain": "0x3da932456d082cba208feb0b096d49b202bf89c8"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "dejitaru-hoshi",
    "filePath": "token:HOSHI",
    "symbol": "hoshi",
    "name": "Dejitaru Hoshi",
    "marketCapRank": 2469,
    "addresses": {
      "ethereum": "0x5362ca75aa3c0e714bc628296640c43dc5cb9ed6"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "dejitaru-tsuka",
    "filePath": "token:TSUKA",
    "symbol": "tsuka",
    "name": "Dejitaru Tsuka",
    "marketCapRank": 875,
    "addresses": {
      "ethereum": "0xc5fb36dd2fb59d3b98deff88425a3f425ee469ed"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "dent",
    "filePath": "token:DENT",
    "symbol": "dent",
    "name": "Dent",
    "marketCapRank": 359,
    "addresses": {
      "ethereum": "0x3597bfd533a99c9aa083587b074434e61eb0a258"
    },
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "derace",
    "filePath": "token:DERC",
    "symbol": "derc",
    "name": "DeRace",
    "marketCapRank": 862,
    "addresses": {
      "ethereum": "0x9fa69536d1cda4a04cfb50688294de75b505a9ae",
      "binance-smart-chain": "0x373e768f79c820aa441540d254dca6d045c6d25b",
      "polygon-pos": "0xb35fcbcf1fd489fce02ee146599e893fdcdc60e6"
    },
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "derby-stars-run",
    "filePath": "token:DSRUN",
    "symbol": "dsrun",
    "name": "Derby Stars RUN",
    "marketCapRank": 1886,
    "addresses": {
      "polygon-pos": "0xff76c0b48363a7c7307868a81548d340049b0023"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "deri-protocol",
    "filePath": "token:DERI",
    "symbol": "deri",
    "name": "Deri Protocol",
    "marketCapRank": 2148,
    "addresses": {
      "ethereum": "0xa487bf43cf3b10dffc97a9a744cbb7036965d3b9",
      "manta-pacific": "0xd212377f71f15a1b962c9265dc44fbceaf0bc46d",
      "arbitrum-one": "0x21e60ee73f17ac0a411ae5d690f908c3ed66fe12",
      "binance-smart-chain": "0xe60eaf5a997dfae83739e035b005a33afdcc6df5",
      "huobi-token": "0x2bda3e331cf735d9420e41567ab843441980c4b8",
      "polygon-pos": "0x3d1d2afd191b165d140e3e8329e634665ffb0e5e"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "dero",
    "filePath": "token:DERO",
    "symbol": "dero",
    "name": "Dero",
    "marketCapRank": 692,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "desmos",
    "filePath": "token:DSM",
    "symbol": "dsm",
    "name": "Desmos",
    "marketCapRank": 2281,
    "addresses": {
      "cosmos": "ibc/EA4C0A9F72E2CEDF10D0E7A9A6A22954DB3444910DB5BE980DF59B05A46DAD1C"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "deso",
    "filePath": "token:DESO",
    "symbol": "deso",
    "name": "Decentralized Social",
    "marketCapRank": 264,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "devour-2",
    "filePath": "token:DPAY",
    "symbol": "dpay",
    "name": "Devour",
    "marketCapRank": 1450,
    "addresses": {
      "ethereum": "0xe5a733681bbe6cd8c764bb8078ef8e13a576dd78",
      "solana": "Gnca3UkjR4a1FFNZuGfEELmbaHkL6GteSC2swpdWRmf7"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "dex-game",
    "filePath": "token:DXGM",
    "symbol": "dxgm",
    "name": "DexGame",
    "marketCapRank": 2427,
    "addresses": {
      "ethereum": "0x66f73d0fd4161cfad4302dc145ff994375c13475"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "dexalot",
    "filePath": "token:ALOT",
    "symbol": "alot",
    "name": "Dexalot",
    "marketCapRank": 947,
    "addresses": {
      "avalanche": "0x093783055f9047c2bff99c4e414501f8a147bc69"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "dexcheck",
    "filePath": "token:DCK",
    "symbol": "dck",
    "name": "DexCheck",
    "marketCapRank": 922,
    "addresses": {
      "binance-smart-chain": "0x16faf9daa401aa42506af503aa3d80b871c467a3",
      "ethereum": "0x672f4fa517894496b8a958b4b3fca068ce513a39"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "dexe",
    "filePath": "token:DEXE",
    "symbol": "dexe",
    "name": "DeXe",
    "marketCapRank": 129,
    "addresses": {
      "ethereum": "0xde4ee8057785a7e8e800db58f9784845a5c2cbd6",
      "binance-smart-chain": "0x6e88056e8376ae7709496ba64d37fa2f8015ce3e"
    },
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "dexkit",
    "filePath": "token:KIT",
    "symbol": "kit",
    "name": "DexKit",
    "marketCapRank": 2590,
    "addresses": {
      "ethereum": "0x7866e48c74cbfb8183cd1a929cd9b95a7a5cb4f4",
      "binance-smart-chain": "0x314593fa9a2fa16432913dbccc96104541d32d11",
      "polygon-pos": "0x4d0def42cf57d6f27cd4983042a55dce1c9f853c"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "dexlab",
    "filePath": "token:DXL",
    "symbol": "dxl",
    "name": "Dexlab",
    "marketCapRank": 2125,
    "addresses": {
      "solana": "GsNzxJfFn6zQdJGeYsupJWzUAm57Ba7335mfhWvFiE9Z"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "dexpools",
    "filePath": "token:DXP",
    "symbol": "dxp",
    "name": "Dexpools",
    "marketCapRank": 1880,
    "addresses": {
      "ethereum": "0x88aa4a6c5050b9a1b2aa7e34d0582025ca6ab745",
      "metis-andromeda": "0xa31848aa61f784cdbb6f74260d224a4356295799"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "dextf",
    "filePath": "token:DEXTF",
    "symbol": "dextf",
    "name": "Domani Protocol",
    "marketCapRank": 1097,
    "addresses": {
      "ethereum": "0x5f64ab1544d28732f0a24f4713c2c8ec0da089f0",
      "avalanche": "0x03e8d118a1864c7dc53bf91e007ab7d91f5a06fa",
      "zksync": "0x9929bcac4417a21d7e6fc86f6dae1cc7f27a2e41"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "dextools",
    "filePath": "token:DEXT",
    "symbol": "dext",
    "name": "DexTools",
    "marketCapRank": 610,
    "addresses": {
      "ethereum": "0xfb7b4564402e5500db5bb6d63ae671302777c75a",
      "binance-smart-chain": "0xe91a8d2c584ca93c7405f15c22cdfe53c29896e3"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "dforce-token",
    "filePath": "token:DF",
    "symbol": "df",
    "name": "dForce",
    "marketCapRank": 807,
    "addresses": {
      "ethereum": "0x431ad2ff6a9c365805ebad47ee021148d6f7dbe0",
      "energi": "0xc588d81d1a9ef1a119446482fc7cbcdb0012292a",
      "arbitrum-one": "0xae6aab43c4f3e0cea4ab83752c278f8debaba689",
      "binance-smart-chain": "0x4a9a2b2b04549c3927dd2c9668a5ef3fca473623"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "dfx-finance",
    "filePath": "token:DFX",
    "symbol": "dfx",
    "name": "DFX Finance",
    "marketCapRank": 2015,
    "addresses": {
      "ethereum": "0x888888435fde8e7d4c54cab67f206e4199454c60",
      "arbitrum-one": "0x27f485b62c4a7e635f561a87560adf5090239e93",
      "polygon-pos": "0x27f485b62c4a7e635f561a87560adf5090239e93"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "dfyn-network",
    "filePath": "token:DFYN",
    "symbol": "dfyn",
    "name": "Dfyn Network",
    "marketCapRank": 1770,
    "addresses": {
      "ethereum": "0x9695e0114e12c0d3a3636fab5a18e6b737529023",
      "polygon-pos": "0xc168e40227e4ebd8c1cae80f7a55a4f0e6d66c97"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "dhedge-dao",
    "filePath": "token:DHT",
    "symbol": "dht",
    "name": "dHEDGE DAO",
    "marketCapRank": 1563,
    "addresses": {
      "ethereum": "0xca1207647ff814039530d7d35df0e1dd2e91fa84",
      "optimistic-ethereum": "0xaf9fe3b5ccdae78188b1f8b9a49da7ae9510f151",
      "base": "0x54bc229d1cb15f8b6415efeab4290a40bc8b7d84",
      "arbitrum-one": "0x8038f3c971414fd1fc220ba727f2d4a0fc98cb65",
      "polygon-pos": "0x8c92e38eca8210f4fcbf17f0951b198dd7668292"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "dia-data",
    "filePath": "token:DIA",
    "symbol": "dia",
    "name": "DIA",
    "marketCapRank": 608,
    "addresses": {
      "ethereum": "0x84ca8bc7997272c7cfb4d0cd3d55cd942b3c9419",
      "sora": "0x001f7a13792061236adfc93fa3aa8bad1dc8a8e8f889432b3d8d416b986f2c43",
      "binance-smart-chain": "0x99956d38059cf7beda96ec91aa7bb2477e0901dd"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "diamond",
    "filePath": "token:DMD",
    "symbol": "dmd",
    "name": "Diamond",
    "marketCapRank": 1640,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "diamond-launch",
    "filePath": "token:DLC",
    "symbol": "dlc",
    "name": "Diamond Launch",
    "marketCapRank": 1312,
    "addresses": {
      "binance-smart-chain": "0xde83180dd1166d4f8e5c2b7de14a2163b1bb4a87"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "digibyte",
    "filePath": "token:DGB",
    "symbol": "dgb",
    "name": "DigiByte",
    "marketCapRank": 306,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "digitalbits",
    "filePath": "token:XDB",
    "symbol": "xdb",
    "name": "XDB CHAIN",
    "marketCapRank": 1289,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "digix-gold",
    "filePath": "token:DGX",
    "symbol": "dgx",
    "name": "Digix Gold",
    "marketCapRank": 2598,
    "addresses": {
      "ethereum": "0x4f3afec4e5a3f2a6a1a411def7d7dfe50ee057bf"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "dimitra",
    "filePath": "token:DMTR",
    "symbol": "dmtr",
    "name": "Dimitra",
    "marketCapRank": 530,
    "addresses": {
      "ethereum": "0x51cb253744189f11241becb29bedd3f1b5384fdb"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "dimo",
    "filePath": "token:DIMO",
    "symbol": "dimo",
    "name": "DIMO",
    "marketCapRank": 562,
    "addresses": {
      "polygon-pos": "0xe261d618a959afffd53168cd07d12e37b26761db",
      "iotex": "0x61db9b084326d2251ccb0252c18fd9b0e887ca4f",
      "ethereum": "0x5fab9761d60419c9eeebe3915a8fa1ed7e8d2e1b"
    },
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "dingocoin",
    "filePath": "token:DINGO",
    "symbol": "dingo",
    "name": "Dingocoin",
    "marketCapRank": 2074,
    "addresses": {
      "solana": "6VYF5jXq6rfq4QRgGMG6co7b1Ev1Lj7KSbHBxfQ9e1L3",
      "binance-smart-chain": "0x9b208b117b2c4f76c1534b6f006b033220a681a4"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "dinox",
    "filePath": "token:DNXC",
    "symbol": "dnxc",
    "name": "DinoX",
    "marketCapRank": 2668,
    "addresses": {
      "ethereum": "0x20a8cec5fffea65be7122bcab2ffe32ed4ebf03a",
      "polygon-pos": "0xcaf5191fc480f43e4df80106c7695eca56e48b18",
      "binance-smart-chain": "0x3c1748d647e6a56b37b66fcd2b5626d0461d3aa0"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "dione",
    "filePath": "token:DIONE",
    "symbol": "dione",
    "name": "Dione",
    "marketCapRank": 476,
    "addresses": {
      "ethereum": "0x89b69f2d1adffa9a253d40840b6baa7fc903d697"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "district0x",
    "filePath": "token:DNT",
    "symbol": "dnt",
    "name": "district0x",
    "marketCapRank": 653,
    "addresses": {
      "ethereum": "0x0abdace70d3790235af448c88547603b945604ea",
      "energi": "0x8dc6bb6ec3caddefb16b0317fa91217a7df93000"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "divergence-protocol",
    "filePath": "token:DIVER",
    "symbol": "diver",
    "name": "Divergence Protocol",
    "marketCapRank": 2069,
    "addresses": {
      "ethereum": "0xfb782396c9b20e564a64896181c7ac8d8979d5f4"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "diversified-staked-eth",
    "filePath": "token:DSETH",
    "symbol": "dseth",
    "name": "Diversified Staked ETH",
    "marketCapRank": 2183,
    "addresses": {
      "ethereum": "0x341c05c0e9b33c0e38d64de76516b2ce970bb3be"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "divi",
    "filePath": "token:DIVI",
    "symbol": "divi",
    "name": "Divi",
    "marketCapRank": 1552,
    "addresses": {
      "ethereum": "0x246908bff0b1ba6ecadcf57fb94f6ae2fcd43a77"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "djed",
    "filePath": "token:DJED",
    "symbol": "djed",
    "name": "Djed",
    "marketCapRank": 1956,
    "addresses": {
      "cardano": "8db269c3ec630e06ae29f74bc39edd1f87c819f1056206e879a1cd61446a65644d6963726f555344"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "dkargo",
    "filePath": "token:DKA",
    "symbol": "dka",
    "name": "dKargo",
    "marketCapRank": 431,
    "addresses": {
      "ethereum": "0x5dc60c4d5e75d22588fa17ffeb90a63e535efce0"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "dodo",
    "filePath": "token:DODO",
    "symbol": "dodo",
    "name": "DODO",
    "marketCapRank": 396,
    "addresses": {
      "ethereum": "0x43dfc4159d86f3a37a5a4b3d4580b888ad7d4ddd",
      "energi": "0x4fec4e046e6b8de5d22785c3fbdb104f14f5a306",
      "near-protocol": "43dfc4159d86f3a37a5a4b3d4580b888ad7d4ddd.factory.bridge.near",
      "arbitrum-one": "0x69eb4fa4a2fbd498c257c57ea8b7655a2559a581",
      "binance-smart-chain": "0x67ee3cb086f8a16f34bee3ca72fad36f7db929e2",
      "aurora": "0xe301ed8c7630c9678c39e4e45193d1e7dfb914f7",
      "polygon-pos": "0xe4bf2864ebec7b7fdf6eeca9bacae7cdfdaffe78"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "dogami",
    "filePath": "token:DOGA",
    "symbol": "doga",
    "name": "Dogami",
    "marketCapRank": 1669,
    "addresses": {
      "tezos": "KT1Ha4yFVeyzw6KRAdkzq6TxDHB97KG4pZe8",
      "polygon-pos": "0x2f3e306d9f02ee8e8850f9040404918d0b345207"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "doge-eat-doge",
    "filePath": "token:OMNOM",
    "symbol": "omnom",
    "name": "Doge Eat Doge",
    "marketCapRank": 813,
    "addresses": {
      "dogechain": "0xe3fca919883950c5cd468156392a6477ff5d18de"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "dogebonk",
    "filePath": "token:DOBO",
    "symbol": "dobo",
    "name": "DogeBonk",
    "marketCapRank": 1753,
    "addresses": {
      "binance-smart-chain": "0xae2df9f730c54400934c06a17462c41c08a06ed8"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "dogechain",
    "filePath": "token:DC",
    "symbol": "dc",
    "name": "Dogechain",
    "marketCapRank": 966,
    "addresses": {
      "dogechain": "0x7b4328c127b85369d9f82ca0503b000d09cf9180",
      "ethereum": "0x7b4328c127b85369d9f82ca0503b000d09cf9180"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "dogecoin",
    "filePath": "token:DOGE",
    "symbol": "doge",
    "name": "Dogecoin",
    "marketCapRank": 9,
    "addresses": {},
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "dogegf",
    "filePath": "token:DOGEGF",
    "symbol": "dogegf",
    "name": "DogeGF",
    "marketCapRank": 1793,
    "addresses": {
      "ethereum": "0xfb130d93e49dca13264344966a611dc79a456bc5",
      "polygon-pos": "0x0e7252706393470ffb0629da2caa39fc9340f2d4"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "dogelon-mars",
    "filePath": "token:ELON",
    "symbol": "elon",
    "name": "Dogelon Mars",
    "marketCapRank": 343,
    "addresses": {
      "ethereum": "0x761d38e5ddf6ccf6cf7c55759d5210750b5d60f3",
      "fuse": "0x5dd8015cec49f4db01fd228f688bf30337d3e0a9",
      "cronos": "0x02dccaf514c98451320a9365c5b46c61d3246ff3",
      "binance-smart-chain": "0x7bd6fabd64813c48545c9c0e312a0099d9be2540",
      "polygon-pos": "0xe0339c80ffde91f3e20494df88d4206d86024cdf",
      "solana": "7ZCm8WBN9aLa3o47SoYctU6iLdj7wkGG5SV2hE5CgtD5"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "dola-borrowing-right",
    "filePath": "token:DBR",
    "symbol": "dbr",
    "name": "DOLA Borrowing Right",
    "marketCapRank": 2510,
    "addresses": {
      "ethereum": "0xad038eb671c44b853887a7e32528fab35dc5d710"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "dola-usd",
    "filePath": "token:DOLA",
    "symbol": "dola",
    "name": "DOLA",
    "marketCapRank": 651,
    "addresses": {
      "ethereum": "0x865377367054516e17014ccded1e7d814edc9ce4",
      "optimistic-ethereum": "0x8ae125e8653821e851f12a49f7765db9a9ce7384",
      "arbitrum-one": "0x6a7661795c374c0bfc635934efaddff3a7ee23b6",
      "base": "0x4621b7a9c75199271f773ebd9a499dbd165c3191",
      "binance-smart-chain": "0x2f29bc0ffaf9bff337b31cbe6cb5fb3bf12e5840",
      "fantom": "0x3129662808bec728a27ab6a6b9afd3cbaca8a43c"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "domi",
    "filePath": "token:DOMI",
    "symbol": "domi",
    "name": "Domi",
    "marketCapRank": 1160,
    "addresses": {
      "binance-smart-chain": "0xbbca42c60b5290f2c48871a596492f93ff0ddc82",
      "avalanche": "0xfc6da929c031162841370af240dec19099861d3b",
      "ethereum": "0x45c2f8c9b4c0bdc76200448cc26c48ab6ffef83f"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "don-t-buy-inu",
    "filePath": "token:DBI",
    "symbol": "dbi",
    "name": "Don't Buy Inu",
    "marketCapRank": 1714,
    "addresses": {
      "ethereum": "0x2de509bf0014ddf697b220be628213034d320ece"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "donut",
    "filePath": "token:DONUT",
    "symbol": "donut",
    "name": "Donut",
    "marketCapRank": 2062,
    "addresses": {
      "ethereum": "0xc0f9bd5fa5698b6505f643900ffa515ea5df54a9",
      "xdai": "0x524b969793a64a602342d89bc2789d43a016b13a"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "dope-wars-paper",
    "filePath": "token:PAPER",
    "symbol": "paper",
    "name": "Dope Wars Paper",
    "marketCapRank": 2199,
    "addresses": {
      "ethereum": "0x7ae1d57b58fa6411f32948314badd83583ee0e8c",
      "optimistic-ethereum": "0x00f932f0fe257456b32deda4758922e56a4f4b42"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "dopex",
    "filePath": "token:DPX",
    "symbol": "dpx",
    "name": "Dopex",
    "marketCapRank": null,
    "addresses": {
      "ethereum": "0xeec2be5c91ae7f8a338e1e5f3b5de49d07afdc81",
      "arbitrum-one": "0x6c2c06790b3e3e3c38e12ee22f8183b37a13ee55"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "dopex-rebate-token",
    "filePath": "token:RDPX",
    "symbol": "rdpx",
    "name": "Dopex Rebate",
    "marketCapRank": 1659,
    "addresses": {
      "ethereum": "0x0ff5a8451a839f5f0bb3562689d9a44089738d11",
      "arbitrum-one": "0x32eb7902d4134bf98a28b963d26de779af92a212"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "dor",
    "filePath": "token:DOR",
    "symbol": "dor",
    "name": "Dor",
    "marketCapRank": 2479,
    "addresses": {},
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "dora-factory-2",
    "filePath": "token:DORA",
    "symbol": "dora",
    "name": "Dora Factory",
    "marketCapRank": 484,
    "addresses": {
      "ethereum": "0x70b790d0948a760e80bc3f892b142f7779b538b2"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "dose-token",
    "filePath": "token:DOSE",
    "symbol": "dose",
    "name": "DOSE",
    "marketCapRank": 1458,
    "addresses": {
      "ethereum": "0xb31ef9e52d94d4120eb44fe1ddfde5b4654a6515",
      "polygon-pos": "0x81382e9693de2afc33f69b70a6c12ca9b3a73f47",
      "binance-smart-chain": "0x7837fd820ba38f95c54d6dac4ca3751b81511357"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "dotmoovs",
    "filePath": "token:MOOV",
    "symbol": "moov",
    "name": "dotmoovs",
    "marketCapRank": 1449,
    "addresses": {
      "ethereum": "0x24ec2ca132abf8f6f8a6e24a1b97943e31f256a7",
      "binance-smart-chain": "0x0ebd9537a25f56713e34c45b38f421a1e7191469",
      "polygon-pos": "0xe46f5128b933e5a6f907fe73ece80059c222db0a"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "dragonchain",
    "filePath": "token:DRGN",
    "symbol": "drgn",
    "name": "Dragonchain",
    "marketCapRank": 1116,
    "addresses": {
      "ethereum": "0x419c4db4b9e25d6db2ad9691ccb832c8d9fda05e"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "dream-machine-token",
    "filePath": "token:DMT",
    "symbol": "dmt",
    "name": "Dream Machine Token",
    "marketCapRank": 972,
    "addresses": {
      "arbitrum-one": "0x8b0e6f19ee57089f7649a455d89d7bc6314d04e8",
      "ethereum": "0x0b7f0e51cd1739d6c96982d55ad8fa634dd43a9c"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "drep-new",
    "filePath": "token:DREP",
    "symbol": "drep",
    "name": "Drep",
    "marketCapRank": 1860,
    "addresses": {
      "ethereum": "0x3ab6ed69ef663bd986ee59205ccad8a20f98b4c2",
      "binance-smart-chain": "0xec583f25a049cc145da9a256cdbe9b6201a705ff"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "drunk-robots",
    "filePath": "token:METAL",
    "symbol": "metal",
    "name": "Badmad Robots",
    "marketCapRank": 825,
    "addresses": {
      "polygon-pos": "0x200c234721b5e549c3693ccc93cf191f90dc2af9",
      "binance-smart-chain": "0x200c234721b5e549c3693ccc93cf191f90dc2af9"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "dtravel",
    "filePath": "token:TRVL",
    "symbol": "trvl",
    "name": "TRVL",
    "marketCapRank": 1053,
    "addresses": {
      "ethereum": "0xd47bdf574b4f76210ed503e0efe81b58aa061f3d",
      "binance-smart-chain": "0x6a8fd46f88dbd7bdc2d536c604f811c63052ce0f"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "dua-token",
    "filePath": "token:DUA",
    "symbol": "dua",
    "name": "Brillion",
    "marketCapRank": 1305,
    "addresses": {
      "avalanche": "0xb418417374fca27bb54169d3c777492e6fe17ee7",
      "ethereum": "0x6c249b6f6492864d914361308601a7abb32e68f8"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "dusk-network",
    "filePath": "token:DUSK",
    "symbol": "dusk",
    "name": "Dusk",
    "marketCapRank": 294,
    "addresses": {
      "ethereum": "0x940a2db1b7008b6c776d4faaca729d6d4a4aa551",
      "energi": "0x458a9f6a008055fd79f321ea7eb3f83a6cb326e2"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "dust-protocol",
    "filePath": "token:DUST",
    "symbol": "dust",
    "name": "Dust Protocol",
    "marketCapRank": 1407,
    "addresses": {
      "ethereum": "0xb5b1b659da79a2507c27aad509f15b4874edc0cc",
      "polygon-pos": "0x4987a49c253c38b3259092e9aac10ec0c7ef7542",
      "solana": "DUSTawucrTsGU8hcqRdHDCbuYhCPADMLM2VcCb8VnFnQ"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "dvision-network",
    "filePath": "token:DVI",
    "symbol": "dvi",
    "name": "Dvision Network",
    "marketCapRank": 1453,
    "addresses": {
      "ethereum": "0x10633216e7e8281e33c86f02bf8e565a635d9770"
    },
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "dydx-chain",
    "filePath": "token:DYDX",
    "symbol": "dydx",
    "name": "dYdX",
    "marketCapRank": 76,
    "addresses": {
      "cosmos": "ibc/831F0B1BBB1D08A2B75311892876D71565478C532967545476DF4C2D7492E48C"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "e-money",
    "filePath": "token:NGM",
    "symbol": "ngm",
    "name": "e-Money",
    "marketCapRank": 2668,
    "addresses": {
      "ethereum": "0xed0d5747a9ab03a75fbfec3228cd55848245b75d",
      "osmosis": "ibc/1DC495FCEFDA068A3820F903EDBD78B942FBD204D7E93D3BA2B432E9669D1A59"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "e-radix",
    "filePath": "token:EXRD",
    "symbol": "exrd",
    "name": "e-Radix",
    "marketCapRank": 571,
    "addresses": {
      "ethereum": "0x6468e79a80c0eab0f9a2b574c8d5bc374af59414"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "ecash",
    "filePath": "token:XEC",
    "symbol": "xec",
    "name": "eCash",
    "marketCapRank": 93,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "echelon-prime",
    "filePath": "token:PRIME",
    "symbol": "prime",
    "name": "Echelon Prime",
    "marketCapRank": 136,
    "addresses": {
      "ethereum": "0xb23d80f5fefcddaa212212f028021b41ded428cf",
      "base": "0xfa980ced6895ac314e7de34ef1bfae90a5add21b"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "eco",
    "filePath": "token:ECO",
    "symbol": "eco",
    "name": "ECO",
    "marketCapRank": 2037,
    "addresses": {
      "ethereum": "0x8dbf9a4c99580fc7fd4024ee08f3994420035727"
    },
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "ecoin-2",
    "filePath": "token:ECOIN",
    "symbol": "ecoin",
    "name": "Ecoin",
    "marketCapRank": 779,
    "addresses": {
      "xdc-network": "xdc536dd70445cea1e97f9bf1bada04cbda5199a2a1"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "ecomi",
    "filePath": "token:OMI",
    "symbol": "omi",
    "name": "ECOMI",
    "marketCapRank": 339,
    "addresses": {
      "ethereum": "0xed35af169af46a02ee13b9d79eb57d6d68c1749e",
      "energi": "0x003d765f3793de38ad5ea9d5fd0021cf12c3ba68"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "ecox",
    "filePath": "token:ECOX",
    "symbol": "ecox",
    "name": "ECOx",
    "marketCapRank": 742,
    "addresses": {
      "ethereum": "0xcccd1ba9f7acd6117834e0d28f25645decb1736a"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "eden",
    "filePath": "token:EDEN",
    "symbol": "eden",
    "name": "EDEN",
    "marketCapRank": 1256,
    "addresses": {
      "ethereum": "0x1559fa1b8f28238fd5d76d9f434ad86fd20d1559"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "edge",
    "filePath": "token:EDGE",
    "symbol": "edge",
    "name": "Edge",
    "marketCapRank": 1684,
    "addresses": {
      "ethereum": "0x4ec1b60b96193a64acae44778e51f7bff2007831"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "edgeware",
    "filePath": "token:EDG",
    "symbol": "edg",
    "name": "Edgeware",
    "marketCapRank": 2128,
    "addresses": {
      "binance-smart-chain": "0x4e0da40b9063dc48364c1c0ffb4ae9d091fc2270",
      "polygon-pos": "0x4e0da40b9063dc48364c1c0ffb4ae9d091fc2270",
      "arbitrum-one": "0x4e0da40b9063dc48364c1c0ffb4ae9d091fc2270"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "edu-coin",
    "filePath": "token:EDU",
    "symbol": "edu",
    "name": "Open Campus",
    "marketCapRank": 284,
    "addresses": {
      "binance-smart-chain": "0xbdeae1ca48894a1759a8374d63925f21f2ee2639",
      "ethereum": "0x26aad156ba8efa501b32b42ffcdc8413f90e9c99",
      "polygon-pos": "0xb03e3b00baf9954bf1604d09a4dbd5cf88e1f695"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "effect-network",
    "filePath": "token:EFX",
    "symbol": "efx",
    "name": "Effect Network",
    "marketCapRank": 1682,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "efinity",
    "filePath": "token:EFI",
    "symbol": "efi",
    "name": "Efinity",
    "marketCapRank": 1461,
    "addresses": {
      "ethereum": "0x656c00e1bcd96f256f224ad9112ff426ef053733"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "eggdog",
    "filePath": "token:EGG",
    "symbol": "egg",
    "name": "Eggdog",
    "marketCapRank": 1899,
    "addresses": {
      "solana": "EXA537HSBVpsFijENbt6Muuy9AADUN8dUmYKD4oKbjJE"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "el-hippo",
    "filePath": "token:HIPP",
    "symbol": "hipp",
    "name": "El Hippo",
    "marketCapRank": 1906,
    "addresses": {
      "ethereum": "0x7b744eea1deca2f1b7b31f15ba036fa1759452d7"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "elastos",
    "filePath": "token:ELA",
    "symbol": "ela",
    "name": "Elastos",
    "marketCapRank": 608,
    "addresses": {
      "ethereum": "0xe6fd75ff38adca4b97fbcd938c86b98772431867",
      "huobi-token": "0xa1ecfc2bec06e4b43ddd423b94fef84d0dbc8f5c"
    },
    "variants": [
      "mono"
    ]
  },
  {
    "id": "electra-protocol",
    "filePath": "token:XEP",
    "symbol": "xep",
    "name": "Electra Protocol",
    "marketCapRank": 1076,
    "addresses": {
      "binance-smart-chain": "0xb897d0a0f68800f8be7d69ffdd1c24b69f57bf3e"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "electroneum",
    "filePath": "token:ETN",
    "symbol": "etn",
    "name": "Electroneum",
    "marketCapRank": 476,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "electronic-usd",
    "filePath": "token:EUSD",
    "symbol": "eusd",
    "name": "Electronic USD",
    "marketCapRank": 1130,
    "addresses": {
      "ethereum": "0xa0d69e286b938e21cbf7e51d71f6a4c8918f482f",
      "base": "0xcfa3ef56d303ae4faaba0592388f19d7c3399fb4"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "electronicgulden",
    "filePath": "token:EFL",
    "symbol": "efl",
    "name": "Electronic Gulden",
    "marketCapRank": 1956,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "elk-finance",
    "filePath": "token:ELK",
    "symbol": "elk",
    "name": "Elk Finance",
    "marketCapRank": 2288,
    "addresses": {
      "avalanche": "0xeeeeeb57642040be42185f49c52f7e9b38f8eeee",
      "fantom": "0xeeeeeb57642040be42185f49c52f7e9b38f8eeee",
      "cronos": "0xeeeeeb57642040be42185f49c52f7e9b38f8eeee",
      "binance-smart-chain": "0xeeeeeb57642040be42185f49c52f7e9b38f8eeee",
      "fuse": "0xeeeeeb57642040be42185f49c52f7e9b38f8eeee",
      "moonriver": "0xeeeeeb57642040be42185f49c52f7e9b38f8eeee",
      "elastos": "0xeeeeeb57642040be42185f49c52f7e9b38f8eeee",
      "telos": "0xeeeeeb57642040be42185f49c52f7e9b38f8eeee",
      "polygon-pos": "0xeeeeeb57642040be42185f49c52f7e9b38f8eeee",
      "ethereum": "0xeeeeeb57642040be42185f49c52f7e9b38f8eeee",
      "xdai": "0xeeeeeb57642040be42185f49c52f7e9b38f8eeee"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "elrond-erd-2",
    "filePath": "token:EGLD",
    "symbol": "egld",
    "name": "MultiversX",
    "marketCapRank": 75,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "elumia",
    "filePath": "token:ELU",
    "symbol": "elu",
    "name": "Elumia",
    "marketCapRank": 1575,
    "addresses": {
      "solana": "4tJZhSdGePuMEfZQ3h5LaHjTPsw1iWTRFTojnZcwsAU6"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "elvishmagic",
    "filePath": "token:EMAGIC",
    "symbol": "emagic",
    "name": "ElvishMagic",
    "marketCapRank": 2162,
    "addresses": {
      "binance-smart-chain": "0xaf55e53cfa099a59aa30554fe106f33c47564a25"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "elysia",
    "filePath": "token:EL",
    "symbol": "el",
    "name": "ELYSIA",
    "marketCapRank": 514,
    "addresses": {
      "ethereum": "0x2781246fe707bb15cee3e5ea354e2154a2877b16"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "eml-protocol",
    "filePath": "token:EML",
    "symbol": "eml",
    "name": "EML Protocol",
    "marketCapRank": 1480,
    "addresses": {
      "ethereum": "0x03dde9e5bb31ee40a471476e2fccf75c67921062"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "empyreal",
    "filePath": "token:EMP",
    "symbol": "emp",
    "name": "Empyreal",
    "marketCapRank": 1214,
    "addresses": {
      "arbitrum-one": "0x772598e9e62155d7fdfe65fdf01eb5a53a8465be",
      "ethereum": "0x39d5313c3750140e5042887413ba8aa6145a9bd2"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "energi",
    "filePath": "token:NRG",
    "symbol": "nrg",
    "name": "Energi",
    "marketCapRank": 1436,
    "addresses": {
      "ethereum": "0x1416946162b1c2c871a73b07e932d2fb6c932069"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "energy-web-token",
    "filePath": "token:EWT",
    "symbol": "ewt",
    "name": "Energy Web",
    "marketCapRank": 473,
    "addresses": {
      "xdai": "0x6a8cb6714b1ee5b471a7d2ec4302cb4f5ff25ec2"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "enigma",
    "filePath": "token:ENG",
    "symbol": "eng",
    "name": "Enigma",
    "marketCapRank": 2645,
    "addresses": {
      "ethereum": "0xf0ee6b27b759c9893ce4f094b49ad28fd15a23e4"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "enjincoin",
    "filePath": "token:ENJ",
    "symbol": "enj",
    "name": "Enjin Coin",
    "marketCapRank": 147,
    "addresses": {
      "ethereum": "0xf629cbd94d3791c9250152bd8dfbdf380e2a3b9c",
      "energi": "0x204a90b57d15417864080df1cd6e907831c206a6",
      "harmony-shard-0": "0xadbd41bfb4389de499535c14a8a3a12fead8f66a"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "enjinstarter",
    "filePath": "token:EJS",
    "symbol": "ejs",
    "name": "Enjinstarter",
    "marketCapRank": 962,
    "addresses": {
      "ethereum": "0x96610186f3ab8d73ebee1cf950c750f3b1fb79c2",
      "binance-smart-chain": "0x09f423ac3c9babbff6f94d372b16e4206e71439f"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "enreachdao",
    "filePath": "token:NRCH",
    "symbol": "nrch",
    "name": "Enreach",
    "marketCapRank": 1996,
    "addresses": {
      "ethereum": "0x69fa8e7f6bf1ca1fb0de61e1366f7412b827cc51",
      "binance-smart-chain": "0x69fa8e7f6bf1ca1fb0de61e1366f7412b827cc51"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "entangle",
    "filePath": "token:NGL",
    "symbol": "ngl",
    "name": "Entangle",
    "marketCapRank": 328,
    "addresses": {
      "ethereum": "0x12652c6d93fdb6f4f37d48a8687783c782bb0d10"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "eos",
    "filePath": "token:EOS",
    "symbol": "eos",
    "name": "EOS",
    "marketCapRank": 97,
    "addresses": {},
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "epic-cash",
    "filePath": "token:EPIC",
    "symbol": "epic",
    "name": "Epic Cash",
    "marketCapRank": 1924,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "epik-prime",
    "filePath": "token:EPIK",
    "symbol": "epik",
    "name": "Epik Prime",
    "marketCapRank": 1382,
    "addresses": {
      "ethereum": "0x4da0c48376c277cdbd7fc6fdc6936dee3e4adf75",
      "binance-smart-chain": "0x368ce786ea190f32439074e8d22e12ecb718b44c"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "eqifi",
    "filePath": "token:EQX",
    "symbol": "eqx",
    "name": "EQIFi",
    "marketCapRank": 1964,
    "addresses": {
      "ethereum": "0xbd3de9a069648c84d27d74d701c9fa3253098b15",
      "binance-smart-chain": "0x436c52a8cee41d5e9c5e6f4cb146e66d552fb700"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "equalizer-dex",
    "filePath": "token:EQUAL",
    "symbol": "equal",
    "name": "Equalizer DEX",
    "marketCapRank": 2086,
    "addresses": {
      "fantom": "0x3fd3a0c85b70754efc07ac9ac0cbbdce664865a6"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "equation",
    "filePath": "token:EQU",
    "symbol": "equ",
    "name": "Equation",
    "marketCapRank": 1973,
    "addresses": {
      "arbitrum-one": "0x87aaffdf26c6885f6010219208d5b161ec7609c0"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "equilibria-finance",
    "filePath": "token:EQB",
    "symbol": "eqb",
    "name": "Equilibria Finance",
    "marketCapRank": 1308,
    "addresses": {
      "arbitrum-one": "0xbfbcfe8873fe28dfa25f1099282b088d52bbad9c",
      "ethereum": "0xfe80d611c6403f70e5b1b9b722d2b3510b740b2b",
      "binance-smart-chain": "0x374ca32fd7934c5d43240e1e73fa9b2283468609"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "equilibrium-eosdt",
    "filePath": "token:EOSDT",
    "symbol": "eosdt",
    "name": "Equilibrium EOSDT",
    "marketCapRank": 2390,
    "addresses": {},
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "era-swap-token",
    "filePath": "token:ES",
    "symbol": "es",
    "name": "Era Swap",
    "marketCapRank": 1602,
    "addresses": {
      "ethereum": "0x72108a8cc3254813c6be2f1b77be53e185abfdd9"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "ergo",
    "filePath": "token:ERG",
    "symbol": "erg",
    "name": "Ergo",
    "marketCapRank": 418,
    "addresses": {},
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "ertha",
    "filePath": "token:ERTHA",
    "symbol": "ertha",
    "name": "Ertha",
    "marketCapRank": 2020,
    "addresses": {
      "binance-smart-chain": "0x62823659d09f9f9d2222058878f89437425eb261"
    },
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "ethereans",
    "filePath": "token:OS",
    "symbol": "os",
    "name": "Ethereans",
    "marketCapRank": 2059,
    "addresses": {
      "ethereum": "0x6100dd79fcaa88420750dcee3f735d168abcb771",
      "optimistic-ethereum": "0x6af3cb766d6cd37449bfd321d961a61b0515c1bc"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "etherempires",
    "filePath": "token:ETE",
    "symbol": "ete",
    "name": "Etherempires",
    "marketCapRank": 1717,
    "addresses": {
      "ethereum": "0xd27b128dc6536309cdebf7f1aff0cb7717bc0268"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "ethereum",
    "filePath": "token:ETH",
    "symbol": "eth",
    "name": "Ethereum",
    "marketCapRank": 2,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "ethereum-classic",
    "filePath": "token:ETC",
    "symbol": "etc",
    "name": "Ethereum Classic",
    "marketCapRank": 29,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "ethereum-meta",
    "filePath": "token:ETHM",
    "symbol": "ethm",
    "name": "Ethereum Meta",
    "marketCapRank": 1245,
    "addresses": {
      "ethereum": "0xfd957f21bd95e723645c07c48a2d8acb8ffb3794",
      "binance-smart-chain": "0x0b33542240d6fa323c796749f6d6869fdb7f13ca",
      "polygon-pos": "0x55b1a124c04a54eefdefe5fa2ef5f852fb5f2f26"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "ethereum-name-service",
    "filePath": "token:ENS",
    "symbol": "ens",
    "name": "Ethereum Name Service",
    "marketCapRank": 152,
    "addresses": {
      "ethereum": "0xc18360217d8f7ab5e7c516566761ea12ce7f9d72"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "ethereum-pow-iou",
    "filePath": "token:ETHW",
    "symbol": "ethw",
    "name": "EthereumPoW",
    "marketCapRank": 188,
    "addresses": {},
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "ethereum-push-notification-service",
    "filePath": "token:PUSH",
    "symbol": "push",
    "name": "Push Protocol",
    "marketCapRank": 1232,
    "addresses": {
      "ethereum": "0xf418588522d5dd018b425e472991e52ebbeeeeee",
      "polygon-pos": "0x58001cc1a9e17a20935079ab40b1b8f4fc19efd1"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "etherisc",
    "filePath": "token:DIP",
    "symbol": "dip",
    "name": "Etherisc DIP",
    "marketCapRank": 1437,
    "addresses": {
      "ethereum": "0xc719d010b63e5bbf2c0551872cd5316ed26acd83",
      "xdai": "0x48b1b0d077b4919b65b4e4114806dd803901e1d9"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "etherland",
    "filePath": "token:ELAND",
    "symbol": "eland",
    "name": "Etherland",
    "marketCapRank": 1602,
    "addresses": {
      "ethereum": "0x33e07f5055173cf8febede8b21b12d1e2b523205",
      "polygon-pos": "0xb0f61c597bbcc29f3f38396b01f9c0f0c2e8bff0",
      "binance-smart-chain": "0x708cb02ad77e1b245b1640cee51b3cc844bcaef4"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "ethernity-chain",
    "filePath": "token:ERN",
    "symbol": "ern",
    "name": "Ethernity Chain",
    "marketCapRank": 473,
    "addresses": {
      "ethereum": "0xbbc2ae13b23d715c30720f079fcd9b4a74093505"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "ethichub",
    "filePath": "token:ETHIX",
    "symbol": "ethix",
    "name": "Ethix",
    "marketCapRank": 1317,
    "addresses": {
      "ethereum": "0xfd09911130e6930bf87f2b0554c44f400bd80d3e",
      "xdai": "0xec3f3e6d7907acda3a7431abd230196cda3fbb19",
      "celo": "0x9995cc8f20db5896943afc8ee0ba463259c931ed"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "ethos",
    "filePath": "token:VGX",
    "symbol": "vgx",
    "name": "Voyager VGX",
    "marketCapRank": 957,
    "addresses": {
      "ethereum": "0x3c4b6e6e1ea3d4863700d7f76b36b7f3d3f13e3d",
      "energi": "0xad3eac6a2ef827833880a10592c6e46605e4f9d6"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "etica",
    "filePath": "token:ETI",
    "symbol": "eti",
    "name": "Etica",
    "marketCapRank": 2646,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "euler",
    "filePath": "token:EUL",
    "symbol": "eul",
    "name": "Euler",
    "marketCapRank": 511,
    "addresses": {
      "ethereum": "0xd9fcd98c322942075a5c3860693e9f4f03aae07b"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "euno",
    "filePath": "token:EUNO",
    "symbol": "euno",
    "name": "EUNO",
    "marketCapRank": 2340,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "euroe-stablecoin",
    "filePath": "token:EUROE",
    "symbol": "euroe",
    "name": "EUROe Stablecoin",
    "marketCapRank": 2328,
    "addresses": {
      "ethereum": "0x820802fa8a99901f52e39acd21177b0be6ee2974",
      "avalanche": "0x820802fa8a99901f52e39acd21177b0be6ee2974",
      "optimistic-ethereum": "0x820802fa8a99901f52e39acd21177b0be6ee2974",
      "arbitrum-one": "0xcf985aba4647a432e60efceeb8054bbd64244305",
      "polygon-pos": "0x820802fa8a99901f52e39acd21177b0be6ee2974",
      "solana": "2VhjJ9WxaGC3EZFwJG9BDUs9KxKCAjQY4vgd1qxgYWVg"
    },
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "eve-ai",
    "filePath": "token:EVEAI",
    "symbol": "eveai",
    "name": "Eve AI",
    "marketCapRank": 1834,
    "addresses": {
      "ethereum": "0x05fe069626543842439ef90d9fa1633640c50cf1"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "everdome",
    "filePath": "token:DOME",
    "symbol": "dome",
    "name": "Everdome",
    "marketCapRank": 1281,
    "addresses": {
      "binance-smart-chain": "0x475bfaa1848591ae0e6ab69600f48d828f61a80e"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "evergrowcoin",
    "filePath": "token:EGC",
    "symbol": "egc",
    "name": "EverGrow Coin",
    "marketCapRank": 723,
    "addresses": {
      "binance-smart-chain": "0xc001bbe2b87079294c63ece98bdd0a88d761434e"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "everipedia",
    "filePath": "token:IQ",
    "symbol": "iq",
    "name": "IQ",
    "marketCapRank": 301,
    "addresses": {
      "ethereum": "0x579cea1889991f68acc35ff5c3dd0621ff29b0c9",
      "polygon-pos": "0xb9638272ad6998708de56bbc0a290a1de534a578",
      "binance-smart-chain": "0x0e37d70b51ffa2b98b4d34a5712c5291115464e3"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "everrise",
    "filePath": "token:RISE",
    "symbol": "rise",
    "name": "EverRise",
    "marketCapRank": 1491,
    "addresses": {
      "binance-smart-chain": "0xc17c30e98541188614df99239cabd40280810ca3",
      "avalanche": "0xc17c30e98541188614df99239cabd40280810ca3",
      "ethereum": "0xc17c30e98541188614df99239cabd40280810ca3",
      "fantom": "0xc17c30e98541188614df99239cabd40280810ca3",
      "polygon-pos": "0xc17c30e98541188614df99239cabd40280810ca3"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "everscale",
    "filePath": "token:EVER",
    "symbol": "ever",
    "name": "Everscale",
    "marketCapRank": 614,
    "addresses": {
      "ethereum": "0x1ffefd8036409cb6d652bd610de465933b226917"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "everton-fan-token",
    "filePath": "token:EFC",
    "symbol": "efc",
    "name": "Everton Fan Token",
    "marketCapRank": 2000,
    "addresses": {
      "chiliz": "0xabee61f8ff0eadd8d4ee87092792aaf2d9b2ca8e"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "evmos",
    "filePath": "token:EVMOS",
    "symbol": "evmos",
    "name": "Evmos",
    "marketCapRank": 854,
    "addresses": {
      "evmos": "0xd4949664cd82660aae99bedc034a0dea8a0bd517",
      "ethereum": "0x93581991f68dbae1ea105233b67f7fa0d6bdee7b"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "exorde",
    "filePath": "token:EXD",
    "symbol": "exd",
    "name": "Exorde",
    "marketCapRank": 2275,
    "addresses": {
      "ethereum": "0x02de007d412266a2e0fa9287c103474170f06560"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "exosama-network",
    "filePath": "token:SAMA",
    "symbol": "sama",
    "name": "Moonsama",
    "marketCapRank": 1531,
    "addresses": {
      "ethereum": "0xe04f47ff45576249bc5083dfdf987e03d0550113",
      "exosama": "0x8c992cba48189a79204223d106fcb1d797a5f87a"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "extra-finance",
    "filePath": "token:EXTRA",
    "symbol": "extra",
    "name": "Extra Finance",
    "marketCapRank": 944,
    "addresses": {
      "optimistic-ethereum": "0x2dad3a13ef0c6366220f989157009e501e7938f8",
      "base": "0x2dad3a13ef0c6366220f989157009e501e7938f8"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "fable-of-the-dragon",
    "filePath": "token:TYRANT",
    "symbol": "tyrant",
    "name": "Fable Of The Dragon",
    "marketCapRank": 2442,
    "addresses": {
      "ethereum": "0x8ee325ae3e54e83956ef2d5952d3c8bc1fa6ec27"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "fabwelt",
    "filePath": "token:WELT",
    "symbol": "welt",
    "name": "Fabwelt",
    "marketCapRank": 1924,
    "addresses": {
      "polygon-pos": "0x23e8b6a3f6891254988b84da3738d2bfe5e703b9",
      "binance-smart-chain": "0x1785113910847770290f5f840b4c74fc46451201"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "factor",
    "filePath": "token:FCTR",
    "symbol": "fctr",
    "name": "FactorDAO",
    "marketCapRank": 2478,
    "addresses": {
      "arbitrum-one": "0x6dd963c510c2d2f09d5eddb48ede45fed063eb36"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "fantom",
    "filePath": "token:FTM",
    "symbol": "ftm",
    "name": "Fantom",
    "marketCapRank": 51,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "faraland",
    "filePath": "token:FARA",
    "symbol": "fara",
    "name": "FaraLand",
    "marketCapRank": 2530,
    "addresses": {
      "binance-smart-chain": "0xf4ed363144981d3a65f42e7d0dc54ff9eef559a1"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "fasttoken",
    "filePath": "network:bahamut",
    "symbol": "ftn",
    "name": "Fasttoken",
    "marketCapRank": 178,
    "addresses": {
      "ethereum": "0xaedf386b755465871ff874e3e37af5976e247064"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "fear",
    "filePath": "token:FEAR",
    "symbol": "fear",
    "name": "FEAR",
    "marketCapRank": 2049,
    "addresses": {
      "ethereum": "0x88a9a52f944315d5b4e917b9689e65445c401e83",
      "polygon-pos": "0xa2ca40dbe72028d3ac78b5250a8cb8c404e7fb8c",
      "binance-smart-chain": "0x9ba6a67a6f3b21705a46b380a1b97373a33da311",
      "fantom": "0x14418c22165553251b002b289f8abe4d1ed41d76"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "feathercoin",
    "filePath": "token:FTC",
    "symbol": "ftc",
    "name": "Feathercoin",
    "marketCapRank": 2570,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "fedoracoin",
    "filePath": "token:TIPS",
    "symbol": "tips",
    "name": "Fedoracoin",
    "marketCapRank": 2101,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "feg-bsc",
    "filePath": "token:FEG",
    "symbol": "feg",
    "name": "FEG BSC",
    "marketCapRank": 857,
    "addresses": {
      "binance-smart-chain": "0xbededdf2ef49e87037c4fb2ca34d1ff3d3992a11"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "fei-usd",
    "filePath": "token:FEI",
    "symbol": "fei",
    "name": "Fei USD",
    "marketCapRank": 1319,
    "addresses": {
      "ethereum": "0x956f47f50a910163d8bf957cf5846d573e7f87ca"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "feisty-doge-nft",
    "filePath": "token:NFD",
    "symbol": "nfd",
    "name": "Feisty Doge NFT",
    "marketCapRank": 1320,
    "addresses": {
      "ethereum": "0xdfdb7f72c1f195c5951a234e8db9806eb0635346"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "ferro",
    "filePath": "token:FER",
    "symbol": "fer",
    "name": "Ferro",
    "marketCapRank": 1464,
    "addresses": {
      "cronos": "0x39bc1e38c842c60775ce37566d03b41a7a66c782",
      "ethereum": "0x2f32b39023da7d6a6486a85d12b346eb9c2a0d19"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "ferrum-network",
    "filePath": "token:FRM",
    "symbol": "frm",
    "name": "Ferrum Network",
    "marketCapRank": 1059,
    "addresses": {
      "ethereum": "0xe5caef4af8780e59df925470b050fb23c43ca68c",
      "energi": "0xee0837e18f64ec6cf3bece2da75a1e5f679a6d84",
      "avalanche": "0xe5caef4af8780e59df925470b050fb23c43ca68c",
      "arbitrum-one": "0x9f6abbf0ba6b5bfa27f4deb6597cc6ec20573fda",
      "polygon-pos": "0xd99bafe5031cc8b345cb2e8c80135991f12d7130",
      "binance-smart-chain": "0xa719b8ab7ea7af0ddb4358719a34631bb79d15dc"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "fetch-ai",
    "filePath": "token:FET",
    "symbol": "fet",
    "name": "Fetch.ai",
    "marketCapRank": 48,
    "addresses": {
      "ethereum": "0xaea46a60368a7bd060eec7df8cba43b7ef41ad85",
      "binance-smart-chain": "0x031b41e504677879370e9dbcf937283a8691fa7f",
      "osmosis": "ibc/5D1F516200EE8C6B2354102143B78A2DEDA25EDE771AC0F8DC3C1837C8FD4447"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "filecoin",
    "filePath": "token:FIL",
    "symbol": "fil",
    "name": "Filecoin",
    "marketCapRank": 26,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "findora",
    "filePath": "token:FRA",
    "symbol": "fra",
    "name": "Fractal",
    "marketCapRank": 1334,
    "addresses": {
      "findora": "0x0000000000000000000000000000000000001000"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "fio-protocol",
    "filePath": "token:FIO",
    "symbol": "fio",
    "name": "FIO Protocol",
    "marketCapRank": 907,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "firestarter",
    "filePath": "token:FLAME",
    "symbol": "flame",
    "name": "FireStarter",
    "marketCapRank": 1563,
    "addresses": {
      "polygon-pos": "0x22e3f02f86bc8ea0d73718a2ae8851854e62adc5"
    },
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "firmachain",
    "filePath": "token:FCT",
    "symbol": "fct",
    "name": "Firmachain",
    "marketCapRank": 659,
    "addresses": {
      "ethereum": "0xe1bad922f84b198a08292fb600319300ae32471b"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "first-digital-usd",
    "filePath": "token:FDUSD",
    "symbol": "fdusd",
    "name": "First Digital USD",
    "marketCapRank": 52,
    "addresses": {
      "ethereum": "0xc5f0f7b66764f6ec8c8dff7ba683102295e16409",
      "binance-smart-chain": "0xc5f0f7b66764f6ec8c8dff7ba683102295e16409"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "flamingo-finance",
    "filePath": "token:FLM",
    "symbol": "flm",
    "name": "Flamingo Finance",
    "marketCapRank": 611,
    "addresses": {},
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "flare-networks",
    "filePath": "token:FLR",
    "symbol": "flr",
    "name": "Flare",
    "marketCapRank": 94,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "flatqube",
    "filePath": "token:QUBE",
    "symbol": "qube",
    "name": "FlatQube",
    "marketCapRank": 2263,
    "addresses": {
      "everscale": "0:9f20666ce123602fd7a995508aeaa0ece4f92133503c0dfbd609b3239f3901e2"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "flex-coin",
    "filePath": "token:FLEX",
    "symbol": "flex",
    "name": "FLEX Coin",
    "marketCapRank": 1137,
    "addresses": {
      "ethereum": "0xfcf8eda095e37a41e002e266daad7efc1579bc0a",
      "smartbch": "0x98dd7ec28fb43b3c4c770ae532417015fa939dd3"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "flits",
    "filePath": "token:FLS",
    "symbol": "fls",
    "name": "Flits",
    "marketCapRank": 2886,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "floordao",
    "filePath": "token:FLOOR",
    "symbol": "floor",
    "name": "FloorDAO (Old)",
    "marketCapRank": 1906,
    "addresses": {
      "ethereum": "0xf59257e961883636290411c11ec5ae622d19455e"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "flow",
    "filePath": "token:FLOW",
    "symbol": "flow",
    "name": "Flow",
    "marketCapRank": 64,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "fluid-2",
    "filePath": "token:FLUID",
    "symbol": "fluid",
    "name": "Fluid",
    "marketCapRank": 2281,
    "addresses": {
      "ethereum": "0x4e47951508fd4a4126f8ff9cf5e6fa3b7cc8e073",
      "arbitrum-one": "0x4e47951508fd4a4126f8ff9cf5e6fa3b7cc8e073"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "flux-token",
    "filePath": "token:FLX",
    "symbol": "flx",
    "name": "SEDA Protocol",
    "marketCapRank": 799,
    "addresses": {
      "ethereum": "0x3ea8ea4237344c9931214796d9417af1a1180770",
      "aurora": "0xea62791aa682d455614eaa2a12ba3d9a2fd197af"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "foam-protocol",
    "filePath": "token:FOAM",
    "symbol": "foam",
    "name": "FOAM",
    "marketCapRank": 1435,
    "addresses": {
      "ethereum": "0x4946fcea7c692606e8908002e55a582af44ac121"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "foom",
    "filePath": "token:FOOM",
    "symbol": "foom",
    "name": "Foom",
    "marketCapRank": 1838,
    "addresses": {
      "ethereum": "0xd0d56273290d339aaf1417d9bfa1bb8cfe8a0933"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "force-protocol",
    "filePath": "token:FOR",
    "symbol": "for",
    "name": "ForTube",
    "marketCapRank": 1152,
    "addresses": {
      "ethereum": "0x1fcdce58959f536621d76f5b7ffb955baa5a672f",
      "binance-smart-chain": "0x658a109c5900bc6d2357c87549b651670e5b0539"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "fore-protocol",
    "filePath": "token:FORE",
    "symbol": "fore",
    "name": "FORE Protocol",
    "marketCapRank": 1924,
    "addresses": {
      "arbitrum-one": "0xcbe94d75ec713b7ead84f55620dc3174beeb1cfe",
      "ethereum": "0xb2ee0adbe0ef1281025d0676511bb1df14600f4d"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "forta",
    "filePath": "token:FORT",
    "symbol": "fort",
    "name": "Forta",
    "marketCapRank": 574,
    "addresses": {
      "ethereum": "0x41545f8b9472d758bb669ed8eaeeecd7a9c4ec29",
      "polygon-pos": "0x9ff62d1fc52a907b6dcba8077c2ddca6e6a9d3e1"
    },
    "variants": [
      "mono"
    ]
  },
  {
    "id": "frax",
    "filePath": "token:FRAX",
    "symbol": "frax",
    "name": "Frax",
    "marketCapRank": 156,
    "addresses": {
      "ethereum": "0x853d955acef822db058eb8505911ed77f175b99e",
      "moonbeam": "0x322e86852e492a7ee17f28a78c663da38fb33bfb",
      "avalanche": "0xd24c2ad096400b6fbcd2ad8b24e7acbc21a1da64",
      "polygon-zkevm": "0xff8544fed5379d9ffa8d47a74ce6b91e632ac44d",
      "optimistic-ethereum": "0x2e3d870790dc77a83dd1d18184acc7439a53f475",
      "near-protocol": "853d955acef822db058eb8505911ed77f175b99e.factory.bridge.near",
      "arbitrum-one": "0x17fc002b466eec40dae837fc4be5c67993ddbd6f",
      "binance-smart-chain": "0x90c97f71e18723b0cf0dfa30ee176ab653e89f40",
      "moonriver": "0x1a93b23281cc1cde4c4741353f3064709a16197d",
      "fantom": "0xdc301622e621166bd8e82f2ca0a26c13ad0be355",
      "harmony-shard-0": "0xfa7191d292d5633f702b0bd7e3e3bccc0e633200",
      "polygon-pos": "0x45c32fa6df82ead1e2ef74d17b76547eddfaff89",
      "evmos": "0xe03494d0033687543a80c9b1ca7d6237f2ea8bd8",
      "solana": "FR87nWEUxVgerFGhZM8Y4AggKGLnaXswr1Pd8wZ4kZcp"
    },
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "frax-price-index-share",
    "filePath": "token:FPIS",
    "symbol": "fpis",
    "name": "Frax Price Index Share",
    "marketCapRank": 919,
    "addresses": {
      "ethereum": "0xc2544a32872a91f4a553b404c6950e89de901fdb",
      "arbitrum-one": "0x3405e88af759992937b84e58f2fe691ef0eea320",
      "binance-smart-chain": "0xd1738eb733a636d1b8665f48bc8a24da889c2562"
    },
    "variants": [
      "mono"
    ]
  },
  {
    "id": "frax-share",
    "filePath": "token:FXS",
    "symbol": "fxs",
    "name": "Frax Share",
    "marketCapRank": 165,
    "addresses": {
      "ethereum": "0x3432b6a60d23ca0dfca7761b7ab56459d9c964d0",
      "fantom": "0x7d016eec9c25232b01f23ef992d98ca97fc2af5a",
      "polygon-zkevm": "0x6b856a14cea1d7dcfaf80fa6936c0b75972ccace",
      "arbitrum-one": "0x9d2f299715d94d8a7e6f5eaa8e654e8c74a988a7",
      "polygon-pos": "0x1a3acf6d19267e2d3e7f898f42803e90c9219062",
      "avalanche": "0x214db107654ff987ad859f34125307783fc8e387",
      "binance-smart-chain": "0xe48a3d7d0bc88d552f730b62c006bc925eadb9ee",
      "moonriver": "0x6f1d1ee50846fcbc3de91723e61cb68cfa6d0e98",
      "harmony-shard-0": "0x0767d8e1b05efa8d6a301a65b324b6b66a1cc14c",
      "evmos": "0xd8176865dd0d672c6ab4a427572f80a72b4b4a9c",
      "solana": "6LX8BhMQ4Sy2otmAWj7Y5sKd9YTVVUgfMsBzT6B9W7ct"
    },
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "freedom-coin",
    "filePath": "token:FREE",
    "symbol": "free",
    "name": "FREEdom coin",
    "marketCapRank": 2231,
    "addresses": {
      "ethereum": "0x2f141ce366a2462f02cea3d12cf93e4dca49e4fd",
      "binance-smart-chain": "0x12e34cdf6a031a10fe241864c32fb03a4fdad739"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "frencoin-2",
    "filePath": "token:FREN",
    "symbol": "fren",
    "name": "Frencoin",
    "marketCapRank": 2541,
    "addresses": {},
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "friends-with-benefits-pro",
    "filePath": "token:FWB",
    "symbol": "fwb",
    "name": "Friends With Benefits Pro",
    "marketCapRank": 1896,
    "addresses": {
      "ethereum": "0x35bd01fc9d6d5d81ca9e055db88dc49aa2c699a8"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "fringe-finance",
    "filePath": "token:FRIN",
    "symbol": "frin",
    "name": "Fringe Finance",
    "marketCapRank": 2236,
    "addresses": {
      "ethereum": "0xc9fe6e1c76210be83dc1b5b20ec7fd010b0b1d15"
    },
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "frontier-token",
    "filePath": "token:FRONT",
    "symbol": "front",
    "name": "Frontier",
    "marketCapRank": 487,
    "addresses": {
      "ethereum": "0xf8c3527cc04340b208c854e985240c02f7b7793f",
      "harmony-shard-0": "0x1ee5839950fd7a227f91cf679b1931dd6f5798b3",
      "polygon-pos": "0xa3ed22eee92a3872709823a6970069e12a4540eb",
      "binance-smart-chain": "0x928e55dab735aa8260af3cedada18b5f70c72f1b"
    },
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "fsn",
    "filePath": "token:FSN",
    "symbol": "fsn",
    "name": "FUSION",
    "marketCapRank": 1293,
    "addresses": {
      "ethereum": "0x979aca85ba37c675e78322ed5d97fa980b9bdf00",
      "binance-smart-chain": "0xfa4fa764f15d0f6e20aaec8e0d696870e5b77c6e",
      "fantom": "0x50eb82cc284e3d35936827023b048106aaecfc5f",
      "huobi-token": "0xa790b07796abed3cdaf81701b4535014bf5e1a65",
      "fusion-network": "0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff",
      "polygon-pos": "0x2bf9b864cdc97b08b6d79ad4663e71b8ab65c45c"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "funfair",
    "filePath": "token:FUN",
    "symbol": "fun",
    "name": "FUNToken",
    "marketCapRank": 622,
    "addresses": {
      "ethereum": "0x419d0d8bdd9af5e606ae2232ed285aff190e711b",
      "energi": "0x04cd06cf05b816f09395375f0143584b4a95ea9f"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "fuse-network-token",
    "filePath": "token:FUSE",
    "symbol": "fuse",
    "name": "Fuse",
    "marketCapRank": 1181,
    "addresses": {
      "ethereum": "0x970b9bb2c0444f5e81e9d0efb84c8ccdcdcaf84d",
      "optimistic-ethereum": "0xe453d6649643f1f460c371dc3d1da98f7922fe51",
      "xdai": "0xd589f00fa2eb83367f732ab3cda92ee0940389cf",
      "arbitrum-one": "0x6b021b3f68491974be6d4009fee61a4e3c708fd6",
      "binance-smart-chain": "0x5857c96dae9cf8511b08cb07f85753c472d36ea3",
      "polygon-pos": "0x6b021b3f68491974be6d4009fee61a4e3c708fd6"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "futurecoin",
    "filePath": "token:FUTURE",
    "symbol": "future",
    "name": "FutureCoin",
    "marketCapRank": 1982,
    "addresses": {
      "binance-smart-chain": "0x9fbff386a9405b4c98329824418ec02b5c20976b"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "fx-coin",
    "filePath": "token:FX",
    "symbol": "fx",
    "name": "Function X",
    "marketCapRank": 428,
    "addresses": {
      "ethereum": "0x8c15ef5b4b21951d50e53e4fbda8298ffad25057"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "g-token",
    "filePath": "token:G",
    "symbol": "g",
    "name": "Gravity",
    "marketCapRank": null,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "gains",
    "filePath": "token:GAINS",
    "symbol": "gains",
    "name": "Gains",
    "marketCapRank": 1331,
    "addresses": {
      "ethereum": "0x056c1d42fb1326f57da7f19ebb7dda4673f1ff55",
      "binance-smart-chain": "0xf1c3e69494e27bf067c4076a6f244a46446719d6"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "gains-network",
    "filePath": "token:GNS",
    "symbol": "gns",
    "name": "Gains Network",
    "marketCapRank": 385,
    "addresses": {
      "polygon-pos": "0xe5417af564e4bfda1c483642db72007871397896",
      "arbitrum-one": "0x18c11fd286c5ec11c3b683caa813b77f5163a122"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "gala",
    "filePath": "token:GALA",
    "symbol": "gala",
    "name": "GALA",
    "marketCapRank": 56,
    "addresses": {
      "ethereum": "0xd1d2eb1b1e90b638588728b4130137d262c87cae"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "gala-music",
    "filePath": "token:MUSIC",
    "symbol": "music",
    "name": "Gala Music",
    "marketCapRank": 1282,
    "addresses": {
      "ethereum": "0xd8c0b13b551718b808fc97ead59499d5ef862775"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "galaxia",
    "filePath": "token:GXA",
    "symbol": "gxa",
    "name": "Galaxia",
    "marketCapRank": 1749,
    "addresses": {
      "klay-token": "0xa80e96cceb1419f9bd9f1c67f7978f51b534a11b"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "galaxy-fight-club",
    "filePath": "token:GCOIN",
    "symbol": "gcoin",
    "name": "Galaxy Fight Club",
    "marketCapRank": 2615,
    "addresses": {
      "polygon-pos": "0x071ac29d569a47ebffb9e57517f855cb577dcc4c"
    },
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "galeon",
    "filePath": "token:GALEON",
    "symbol": "galeon",
    "name": "Galeon",
    "marketCapRank": 1358,
    "addresses": {
      "binance-smart-chain": "0x1d0ac23f03870f768ca005c84cbb6fb82aa884fd"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "gameai",
    "filePath": "token:GAT",
    "symbol": "gat",
    "name": "GameAI",
    "marketCapRank": 1361,
    "addresses": {
      "binance-smart-chain": "0xdacd068618fcdb358f8951eca2af3e2d7e7555c6"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "gamee",
    "filePath": "token:GMEE",
    "symbol": "gmee",
    "name": "GAMEE",
    "marketCapRank": 1423,
    "addresses": {
      "ethereum": "0xd9016a907dc0ecfa3ca425ab20b6b785b42f2373",
      "the-open-network": "EQCqnhZndBGbwjPpV8K_8WOK58ZkQPXlS_bshau9DKWnAF-p",
      "binance-smart-chain": "0x84e9a6f9d240fdd33801f7135908bfa16866939a"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "gamefi",
    "filePath": "token:GAFI",
    "symbol": "gafi",
    "name": "GameFi.org",
    "marketCapRank": 550,
    "addresses": {
      "binance-smart-chain": "0x89af13a10b32f1b2f8d1588f93027f69b6f4e27e"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "gamercoin",
    "filePath": "token:GHX",
    "symbol": "ghx",
    "name": "GamerCoin",
    "marketCapRank": 454,
    "addresses": {
      "ethereum": "0x728f30fa2f100742c7949d1961804fa8e0b1387d",
      "binance-smart-chain": "0xbd7b8e4de08d9b01938f7ff2058f110ee1e0e8d4"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "games-for-a-living",
    "filePath": "token:GFAL",
    "symbol": "gfal",
    "name": "Games for a Living",
    "marketCapRank": 751,
    "addresses": {
      "binance-smart-chain": "0x47c454ca6be2f6def6f32b638c80f91c9c3c5949"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "gamespad",
    "filePath": "token:GMPD",
    "symbol": "gmpd",
    "name": "GamesPad",
    "marketCapRank": 2552,
    "addresses": {
      "binance-smart-chain": "0x9720ca160bbd4e7f3dd4bb3f8bd4227ca0342e63"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "gamestarter",
    "filePath": "token:GAME",
    "symbol": "game",
    "name": "Gamestarter",
    "marketCapRank": 1611,
    "addresses": {
      "ethereum": "0xd567b5f02b9073ad3a982a099a23bf019ff11d1c",
      "binance-smart-chain": "0x66109633715d2110dda791e64a7b2afadb517abb"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "gameswap-org",
    "filePath": "token:GSWAP",
    "symbol": "gswap",
    "name": "Gameswap",
    "marketCapRank": 1667,
    "addresses": {
      "ethereum": "0xaac41ec512808d64625576eddd580e7ea40ef8b2"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "gameswift",
    "filePath": "token:GSWIFT",
    "symbol": "gswift",
    "name": "GameSwift",
    "marketCapRank": 901,
    "addresses": {
      "arbitrum-one": "0x580e933d90091b9ce380740e3a4a39c67eb85b4c",
      "ethereum": "0x580e933d90091b9ce380740e3a4a39c67eb85b4c"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "gamezone",
    "filePath": "token:GZONE",
    "symbol": "gzone",
    "name": "GameZone",
    "marketCapRank": 1461,
    "addresses": {
      "binance-smart-chain": "0xb6adb74efb5801160ff749b1985fd3bd5000e938"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "gami-world",
    "filePath": "token:GAMI",
    "symbol": "gami",
    "name": "GAMI World",
    "marketCapRank": 1628,
    "addresses": {
      "binance-smart-chain": "0x1236a887ef31b4d32e1f0a2b5e4531f52cec7e75"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "gamium",
    "filePath": "token:GMM",
    "symbol": "gmm",
    "name": "Gamium",
    "marketCapRank": 889,
    "addresses": {
      "binance-smart-chain": "0x5b6bf0c7f989de824677cfbd507d9635965e9cd3",
      "ethereum": "0x4b19c70da4c6fa4baa0660825e889d2f7eabc279"
    },
    "variants": [
      "mono"
    ]
  },
  {
    "id": "gamma-strategies",
    "filePath": "token:GAMMA",
    "symbol": "gamma",
    "name": "Gamma Strategies",
    "marketCapRank": 1357,
    "addresses": {
      "ethereum": "0x6bea7cfef803d1e3d5f7c0103f7ded065644e197"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "garden-2",
    "filePath": "token:SEED",
    "symbol": "seed",
    "name": "Garden",
    "marketCapRank": 2138,
    "addresses": {
      "ethereum": "0x5eed99d066a8caf10f3e4327c1b3d8b673485eed",
      "arbitrum-one": "0x86f65121804d2cdbef79f9f072d4e0c2eebabc08"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "gari-network",
    "filePath": "token:GARI",
    "symbol": "gari",
    "name": "Gari Network",
    "marketCapRank": 1268,
    "addresses": {
      "solana": "CKaKtYvz6dKPyMvYq9Rh3UBrnNqYZAyd7iF4hJtjUvks"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "gas",
    "filePath": "token:GAS",
    "symbol": "gas",
    "name": "Gas",
    "marketCapRank": 208,
    "addresses": {
      "neo": "602c79718b16e442de58778e148d0b1084e3b2dffd5de6b7b16cee7969282de7"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "gatechain-token",
    "filePath": "token:GT",
    "symbol": "gt",
    "name": "Gate",
    "marketCapRank": 86,
    "addresses": {
      "ethereum": "0xe66747a101bff2dba3697199dcce5b743b454759"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "geeq",
    "filePath": "token:GEEQ",
    "symbol": "geeq",
    "name": "GEEQ",
    "marketCapRank": 1452,
    "addresses": {
      "ethereum": "0x6b9f031d718dded0d681c20cb754f97b3bb81b78"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "gelato",
    "filePath": "token:GEL",
    "symbol": "gel",
    "name": "Gelato",
    "marketCapRank": 436,
    "addresses": {
      "ethereum": "0x15b7c0c907e4c6b9adaaaabc300c08991d6cea05",
      "fantom": "0x15b7c0c907e4c6b9adaaaabc300c08991d6cea05",
      "polygon-pos": "0x15b7c0c907e4c6b9adaaaabc300c08991d6cea05"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "gemhub",
    "filePath": "token:GHUB",
    "symbol": "ghub",
    "name": "GemHUB",
    "marketCapRank": 1497,
    "addresses": {
      "klay-token": "0x4836cc1f355bb2a61c210eaa0cd3f729160cd95e"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "gemini-dollar",
    "filePath": "token:GUSD",
    "symbol": "gusd",
    "name": "Gemini Dollar",
    "marketCapRank": 454,
    "addresses": {
      "ethereum": "0x056fd409e1d7a124bd7017459dfea2f387b6d5cd",
      "near-protocol": "056fd409e1d7a124bd7017459dfea2f387b6d5cd.factory.bridge.near"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "gemlink",
    "filePath": "token:GLINK",
    "symbol": "glink",
    "name": "GemLink",
    "marketCapRank": 2423,
    "addresses": {
      "binance-smart-chain": "0x0ee7292bd28f4a490f849fb30c28cabab9440f9e"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "generaitiv",
    "filePath": "token:GAI",
    "symbol": "gai",
    "name": "Generaitiv",
    "marketCapRank": 2168,
    "addresses": {
      "ethereum": "0x0d8ca4b20b115d4da5c13dc45dd582a5de3e78bf"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "genesysgo-shadow",
    "filePath": "token:SHDW",
    "symbol": "shdw",
    "name": "Shadow Token",
    "marketCapRank": 264,
    "addresses": {
      "solana": "SHDWyBxihqiCj6YekG2GUr7wqKLeLAMK1gHZck9pL6y"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "genius",
    "filePath": "token:GENI",
    "symbol": "geni",
    "name": "Genius",
    "marketCapRank": 2434,
    "addresses": {
      "ethereum": "0x444444444444c1a66f394025ac839a535246fcc8",
      "avalanche": "0x444444444444c1a66f394025ac839a535246fcc8",
      "polygon-pos": "0x444444444444c1a66f394025ac839a535246fcc8",
      "binance-smart-chain": "0x444444444444c1a66f394025ac839a535246fcc8"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "gensokishis-metaverse",
    "filePath": "token:MV",
    "symbol": "mv",
    "name": "GensoKishi Metaverse",
    "marketCapRank": 1482,
    "addresses": {
      "polygon-pos": "0xa3c322ad15218fbfaed26ba7f616249f7705d945",
      "ethereum": "0xae788f80f2756a86aa2f410c651f2af83639b95b"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "geodnet",
    "filePath": "token:GEOD",
    "symbol": "geod",
    "name": "Geodnet",
    "marketCapRank": 1159,
    "addresses": {
      "polygon-pos": "0xac0f66379a6d7801d7726d5a943356a172549adb"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "geojam",
    "filePath": "token:JAM",
    "symbol": "jam",
    "name": "Geojam",
    "marketCapRank": 1380,
    "addresses": {
      "ethereum": "0x23894dc9da6c94ecb439911caf7d337746575a72"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "get-token",
    "filePath": "token:GET",
    "symbol": "get",
    "name": "GET Protocol",
    "marketCapRank": 696,
    "addresses": {
      "ethereum": "0x8a854288a5976036a725879164ca3e91d30c6a1b",
      "polygon-pos": "0xdb725f82818de83e99f1dac22a9b5b51d3d04dd4"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "getkicks",
    "filePath": "token:KICKS",
    "symbol": "kicks",
    "name": "GetKicks",
    "marketCapRank": 2378,
    "addresses": {
      "binance-smart-chain": "0xfeb4e9b932ef708c498cc997abe51d0ee39300cf"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "gho",
    "filePath": "token:GHO",
    "symbol": "gho",
    "name": "GHO",
    "marketCapRank": 857,
    "addresses": {
      "ethereum": "0x40d16fc0246ad3160ccc09b8d0d3a2cd28ae6c2f"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "ghost-by-mcafee",
    "filePath": "token:GHOST",
    "symbol": "ghost",
    "name": "Ghost",
    "marketCapRank": 2184,
    "addresses": {
      "polygon-pos": "0xb5e0cfe1b4db501ac003b740665bf43192cc7853"
    },
    "variants": [
      "mono"
    ]
  },
  {
    "id": "gifto",
    "filePath": "token:GFT",
    "symbol": "gft",
    "name": "Gifto",
    "marketCapRank": 1009,
    "addresses": {
      "binance-smart-chain": "0x72ff5742319ef07061836f5c924ac6d72c919080"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "gitcoin",
    "filePath": "token:GTC",
    "symbol": "gtc",
    "name": "Gitcoin",
    "marketCapRank": 451,
    "addresses": {
      "ethereum": "0xde30da39c46104798bb5aa3fe8b9e0e1f348163f",
      "near-protocol": "de30da39c46104798bb5aa3fe8b9e0e1f348163f.factory.bridge.near"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "giveth",
    "filePath": "token:GIV",
    "symbol": "giv",
    "name": "Giveth",
    "marketCapRank": 2140,
    "addresses": {
      "ethereum": "0x900db999074d9277c5da2a43f252d74366230da0",
      "xdai": "0x4f4f9b8d5b4d0dc10506e5551b0513b61fd59e75"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "gleec-coin",
    "filePath": "token:GLEEC",
    "symbol": "gleec",
    "name": "Gleec Coin",
    "marketCapRank": 2201,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "global-coin-research",
    "filePath": "token:GCR",
    "symbol": "gcr",
    "name": "Global Coin Research",
    "marketCapRank": 2454,
    "addresses": {
      "ethereum": "0x6307b25a665efc992ec1c1bc403c38f3ddd7c661",
      "polygon-pos": "0xa69d14d6369e414a32a5c7e729b7afbafd285965"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "global-digital-cluster-co",
    "filePath": "token:GDCC",
    "symbol": "gdcc",
    "name": "Global Digital Cluster Coin",
    "marketCapRank": 2163,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "globiance-exchange",
    "filePath": "token:GBEX",
    "symbol": "gbex",
    "name": "Globiance Exchange",
    "marketCapRank": 1222,
    "addresses": {
      "xdc-network": "xdc34514748f86a8da01ef082306b6d6e738f777f5a"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "gmx",
    "filePath": "token:GMX",
    "symbol": "gmx",
    "name": "GMX",
    "marketCapRank": 212,
    "addresses": {
      "arbitrum-one": "0xfc5a1a6eb076a2c7ad06ed22c90d7e710e35ad0a",
      "avalanche": "0x62edc0692bd897d2295872a9ffcac5425011c661"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "gnosis",
    "filePath": "token:GNO",
    "symbol": "gno",
    "name": "Gnosis",
    "marketCapRank": 119,
    "addresses": {
      "ethereum": "0x6810e776880c02933d47db1b9fc05908e5386b96",
      "energi": "0xf452bff8e958c6f335f06fc3aac427ee195366fe",
      "arbitrum-one": "0xa0b862f60edef4452f25b4160f177db44deb6cf1",
      "xdai": "0x9c58bacc331c9aa871afd802db6379a98e80cedb"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "gny",
    "filePath": "token:GNY",
    "symbol": "gny",
    "name": "GNY",
    "marketCapRank": 1826,
    "addresses": {
      "ethereum": "0xb1f871ae9462f1b2c6826e88a7827e76f86751d4"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "gochain",
    "filePath": "token:GO",
    "symbol": "go",
    "name": "GoChain",
    "marketCapRank": 1557,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "gods-unchained",
    "filePath": "token:GODS",
    "symbol": "gods",
    "name": "Gods Unchained",
    "marketCapRank": 519,
    "addresses": {
      "ethereum": "0xccc8cb5229b0ac8069c51fd58367fd1e622afd97"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "gogopool",
    "filePath": "token:GGP",
    "symbol": "ggp",
    "name": "GoGoPool",
    "marketCapRank": 894,
    "addresses": {
      "avalanche": "0x69260b9483f9871ca57f81a90d91e2f96c2cd11d"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "goldcoin",
    "filePath": "token:GLC",
    "symbol": "glc",
    "name": "Goldcoin",
    "marketCapRank": 1467,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "golden-inu-token",
    "filePath": "token:GOLDEN",
    "symbol": "golden",
    "name": "Golden Inu",
    "marketCapRank": 2364,
    "addresses": {
      "ethereum": "0xd87996ff3d06858bfc20989aef50cc5fcd4d84ca"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "golem",
    "filePath": "token:GLM",
    "symbol": "glm",
    "name": "Golem",
    "marketCapRank": 165,
    "addresses": {
      "ethereum": "0x7dd9c5cba05e151c895fde1cf355c9a1d5da6429",
      "energi": "0xf3ff3bf1d1afcbebd98a304482c4099dc953e9a8"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "good-games-guild",
    "filePath": "token:GGG",
    "symbol": "ggg",
    "name": "Good Games Guild",
    "marketCapRank": 1828,
    "addresses": {
      "binance-smart-chain": "0xd8047afecb86e44eff3add991b9f063ed4ca716b"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "good-person-coin",
    "filePath": "token:GPCX",
    "symbol": "gpcx",
    "name": "Good Person Coin",
    "marketCapRank": 1785,
    "addresses": {},
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "goons-of-balatroon",
    "filePath": "token:GOB",
    "symbol": "gob",
    "name": "Goons of Balatroon",
    "marketCapRank": 2289,
    "addresses": {
      "arbitrum-one": "0xa2f9ecf83a48b86265ff5fd36cdbaaa1f349916c",
      "beam": "0x7fb5a9921cf98362aa425e42f66bf3484c2c2b5f",
      "ethereum": "0x830eb1204380e9c44434db8700257025358707c6"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "goosefx",
    "filePath": "token:GOFX",
    "symbol": "gofx",
    "name": "GooseFX",
    "marketCapRank": 1550,
    "addresses": {
      "solana": "GFX1ZjR2P15tmrSwow6FjyDYcEkoFb4p4gJCpLBjaxHD"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "goracle-network",
    "filePath": "token:GORA",
    "symbol": "gora",
    "name": "Gora",
    "marketCapRank": 2130,
    "addresses": {
      "algorand": "1138500612"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "gorilla",
    "filePath": "token:GORILLA",
    "symbol": "gorilla",
    "name": "Gorilla",
    "marketCapRank": 1879,
    "addresses": {
      "ethereum": "0x33c04bed4533e31f2afb8ac4a61a48eda38c4fa0"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "governance-zil",
    "filePath": "token:GZIL",
    "symbol": "gzil",
    "name": "governance ZIL",
    "marketCapRank": 1970,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "govi",
    "filePath": "token:GOVI",
    "symbol": "govi",
    "name": "CVI",
    "marketCapRank": 1850,
    "addresses": {
      "ethereum": "0xeeaa40b28a2d1b0b08f6f97bb1dd4b75316c6107",
      "zksync": "0xd63ef5e9c628c8a0e8984cdfb7444aee44b09044",
      "arbitrum-one": "0x07e49d5de43dda6162fa28d24d5935c151875283",
      "polygon-pos": "0x43df9c0a1156c96cea98737b511ac89d0e2a1f46"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "goztepe-s-k-fan-token",
    "filePath": "token:GOZ",
    "symbol": "goz",
    "name": "Göztepe S.K. Fan Token",
    "marketCapRank": 2226,
    "addresses": {
      "chiliz": "0x0e469d1c78421c7952e4d9626800dad22f45361d"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "grai",
    "filePath": "token:GRAI",
    "symbol": "grai",
    "name": "Grai",
    "marketCapRank": 1747,
    "addresses": {
      "ethereum": "0x15f74458ae0bfdaa1a96ca1aa779d715cc1eefe4",
      "arbitrum-one": "0x894134a25a5fac1c2c26f1d8fbf05111a3cb9487",
      "zksync": "0x5fc44e95eaa48f9eb84be17bd3ac66b6a82af709"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "gram",
    "filePath": "token:GRAM",
    "symbol": "gram",
    "name": "Gram",
    "marketCapRank": 12,
    "addresses": {
      "ton": "EQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAM9c"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "granary",
    "filePath": "token:GRAIN",
    "symbol": "grain",
    "name": "Granary",
    "marketCapRank": 2118,
    "addresses": {
      "ethereum": "0xf88baf18fab7e330fa0c4f83949e23f52fececce",
      "fantom": "0x02838746d9e1413e07ee064fcbada57055417f21",
      "avalanche": "0x9df4ac62f9e435dbcd85e06c990a7f0ea32739a9",
      "optimistic-ethereum": "0xfd389dc9533717239856190f42475d3f263a270d",
      "arbitrum-one": "0x80bb30d62a16e1f2084deae84dc293531c3ac3a1",
      "binance-smart-chain": "0x8f87a7d376821c7b2658a005aaf190ec778bf37a"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "graphlinq-protocol",
    "filePath": "token:GLQ",
    "symbol": "glq",
    "name": "GraphLinq Protocol",
    "marketCapRank": 787,
    "addresses": {
      "ethereum": "0x9f9c8ec3534c3ce16f928381372bfbfbfb9f4d24"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "graviton",
    "filePath": "token:GRAV",
    "symbol": "grav",
    "name": "Graviton",
    "marketCapRank": 2241,
    "addresses": {
      "gravity-bridge": "ugraviton",
      "osmosis": "ibc/E97634A40119F1898989C2A23224ED83FDD0A57EA46B3A094E287288D1672B44",
      "archway": "ibc/31D711D31CD5D83D98E76B1486EEDA1A38CD1F7D6FCBD03521FE51323115AECA",
      "kujira": "kujira1jlyyyg0m649v75nqzm40jfdmjar9sf7rh3qnuz8yqa4345s9tqvqhxwxjq",
      "crescent": "ibc/C950356239AD2A205DE09FDF066B1F9FF19A7CA7145EA48A5B19B76EE47E52F7",
      "evmos": "0x80b5a32e4f032b2a058b4f29ec95eefeeb87adcd"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "gridcoin-research",
    "filePath": "token:GRC",
    "symbol": "grc",
    "name": "Gridcoin",
    "marketCapRank": 1980,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "grin",
    "filePath": "token:GRIN",
    "symbol": "grin",
    "name": "Grin",
    "marketCapRank": 1487,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "grizzly-honey",
    "filePath": "token:GHNY",
    "symbol": "ghny",
    "name": "Grizzly Honey",
    "marketCapRank": 1998,
    "addresses": {
      "binance-smart-chain": "0xa045e37a0d1dd3a45fefb8803d22457abc0a728a"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "groestlcoin",
    "filePath": "token:GRS",
    "symbol": "grs",
    "name": "Groestlcoin",
    "marketCapRank": 669,
    "addresses": {},
    "variants": [
      "mono"
    ]
  },
  {
    "id": "grove",
    "filePath": "token:GRV",
    "symbol": "grv",
    "name": "GroveCoin",
    "marketCapRank": 1806,
    "addresses": {
      "binance-smart-chain": "0xf33893de6eb6ae9a67442e066ae9abd228f5290c",
      "ethereum": "0xf33893de6eb6ae9a67442e066ae9abd228f5290c"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "gsenetwork",
    "filePath": "token:GSE",
    "symbol": "gse",
    "name": "GSENetwork",
    "marketCapRank": 2624,
    "addresses": {
      "ethereum": "0xe530441f4f73bdb6dc2fa5af7c3fc5fd551ec838"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "guild-of-guardians",
    "filePath": "token:GOG",
    "symbol": "gog",
    "name": "Guild of Guardians",
    "marketCapRank": 566,
    "addresses": {
      "ethereum": "0x9ab7bb7fdc60f4357ecfef43986818a2a3569c62"
    },
    "variants": [
      "mono"
    ]
  },
  {
    "id": "gulfcoin-2",
    "filePath": "token:GULF",
    "symbol": "gulf",
    "name": "GulfCoin",
    "marketCapRank": 1760,
    "addresses": {
      "binance-smart-chain": "0x7597bdccf10e41bccc374a6a0104cf430c420884"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "gunstar-metaverse",
    "filePath": "token:GSTS",
    "symbol": "gsts",
    "name": "Gunstar Metaverse",
    "marketCapRank": 2486,
    "addresses": {
      "binance-smart-chain": "0x7edc0ec89f987ecd85617b891c44fe462a325869"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "gxchain",
    "filePath": "token:GXC",
    "symbol": "gxc",
    "name": "GXChain",
    "marketCapRank": 756,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "gyen",
    "filePath": "token:GYEN",
    "symbol": "gyen",
    "name": "GYEN",
    "marketCapRank": 1312,
    "addresses": {
      "ethereum": "0xc08512927d12348f6620a698105e1baac6ecd911",
      "stellar": "GYEN:GDF6VOEGRWLOZ64PQQGKD2IYWA22RLT37GJKS2EJXZHT2VLAGWLC5TOB",
      "solana": "Crn4x1Y2HUKko7ox2EZMT6N2t2ZyH7eKtwkBGVnhEq1g",
      "arbitrum-one": "0x589d35656641d6ab57a545f08cf473ecd9b6d5f7"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "gym-network",
    "filePath": "token:GYMNET",
    "symbol": "gymnet",
    "name": "Gym Network",
    "marketCapRank": 2149,
    "addresses": {
      "binance-smart-chain": "0x0012365f0a1e5f30a5046c680dcb21d07b15fcf7"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "h2o-dao",
    "filePath": "token:H2O",
    "symbol": "h2o",
    "name": "H2O Dao",
    "marketCapRank": 790,
    "addresses": {
      "binance-smart-chain": "0xaf3287cae99c982586c07401c0d911bf7de6cd82"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "hackenai",
    "filePath": "token:HAI",
    "symbol": "hai",
    "name": "Hacken",
    "marketCapRank": 762,
    "addresses": {
      "binance-smart-chain": "0xaa9e582e5751d703f85912903bacaddfed26484c",
      "ethereum": "0x05fb86775fd5c16290f1e838f5caaa7342bd9a63",
      "vechain": "0xacc280010b2ee0efc770bce34774376656d8ce14"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "hairdao",
    "filePath": "token:HAIR",
    "symbol": "hair",
    "name": "HairDAO",
    "marketCapRank": 1022,
    "addresses": {
      "ethereum": "0x9ce115f0341ae5dabc8b477b74e83db2018a6f42"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "handle-fi",
    "filePath": "token:FOREX",
    "symbol": "forex",
    "name": "handle.fi",
    "marketCapRank": 2875,
    "addresses": {
      "ethereum": "0xdb298285fe4c5410b05390ca80e8fbe9de1f259b",
      "arbitrum-one": "0xdb298285fe4c5410b05390ca80e8fbe9de1f259b",
      "polygon-pos": "0xdb298285fe4c5410b05390ca80e8fbe9de1f259b"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "handy",
    "filePath": "token:HANDY",
    "symbol": "handy",
    "name": "Handy",
    "marketCapRank": 2150,
    "addresses": {
      "ethereum": "0x8bbe1a2961b41340468d0548c2cd5b7dfa9b684c"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "hapi",
    "filePath": "token:HAPI",
    "symbol": "hapi",
    "name": "HAPI",
    "marketCapRank": 1268,
    "addresses": {
      "ethereum": "0xd9c2d319cd7e6177336b0a9c93c21cb48d84fb54",
      "near-protocol": "d9c2d319cd7e6177336b0a9c93c21cb48d84fb54.factory.bridge.near",
      "binance-smart-chain": "0xd9c2d319cd7e6177336b0a9c93c21cb48d84fb54",
      "solana": "6VNKqgz9hk7zRShTFdg5AnkfKwZUcojzwAkzxSH3bnUm"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "harmony",
    "filePath": "token:ONE",
    "symbol": "one",
    "name": "Harmony",
    "marketCapRank": 229,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "harvest-finance",
    "filePath": "token:FARM",
    "symbol": "farm",
    "name": "Harvest Finance",
    "marketCapRank": 916,
    "addresses": {
      "ethereum": "0xa0246c9032bc3a600820415ae600c6388619a14d",
      "energi": "0xc59a4b20ea0f8a7e6e216e7f1b070247520a4514",
      "binance-smart-chain": "0x4b5c23cac08a567ecf0c1ffca8372a45a5d33743"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "hashflow",
    "filePath": "token:HFT",
    "symbol": "hft",
    "name": "Hashflow",
    "marketCapRank": 377,
    "addresses": {
      "ethereum": "0xb3999f658c0391d94a37f7ff328f3fec942bcadc",
      "binance-smart-chain": "0x44ec807ce2f4a6f2737a92e985f318d035883e47"
    },
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "hathor",
    "filePath": "token:HTR",
    "symbol": "htr",
    "name": "Hathor",
    "marketCapRank": 918,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "hatom",
    "filePath": "token:HTM",
    "symbol": "htm",
    "name": "Hatom",
    "marketCapRank": 781,
    "addresses": {
      "elrond": "HTM-f51d55"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "havah",
    "filePath": "token:HVH",
    "symbol": "hvh",
    "name": "HAVAH",
    "marketCapRank": 1049,
    "addresses": {
      "ethereum": "0xd076c4ba62c57b3fa10800bcfd8da66742110e0e"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "haven",
    "filePath": "token:XHV",
    "symbol": "xhv",
    "name": "Haven",
    "marketCapRank": 2045,
    "addresses": {},
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "havven",
    "filePath": "token:SNX",
    "symbol": "snx",
    "name": "Synthetix Network",
    "marketCapRank": 81,
    "addresses": {
      "ethereum": "0xc011a73ee8576fb46f5e1c5751ca3b9fe0af2a6f",
      "harmony-shard-0": "0x7b9c523d59aefd362247bd5601a89722e3774dd2",
      "avalanche": "0xbec243c995409e6520d7c41e404da5deba4b209b",
      "near-protocol": "c011a73ee8576fb46f5e1c5751ca3b9fe0af2a6f.factory.bridge.near",
      "optimistic-ethereum": "0x8700daec35af8ff88c16bdf0418774cb3d7599b4",
      "huobi-token": "0x777850281719d5a96c29812ab72f822e0e09f3da",
      "polygon-pos": "0x50b728d8d964fd00c2d0aad81718b71311fef68a",
      "fantom": "0x56ee926bd8c72b2d5fa1af4d9e4cbb515a1e3adc",
      "energi": "0xa255461ff545d6ece153283f421d67d2de5d0e29"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "hawksight",
    "filePath": "token:HAWK",
    "symbol": "hawk",
    "name": "Hawksight",
    "marketCapRank": 2136,
    "addresses": {
      "solana": "BKipkearSqAUdNKa1WDstvcMjoPsSKBuNyvKDQDDu9WE"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "headstarter",
    "filePath": "token:HST",
    "symbol": "hst",
    "name": "HeadStarter",
    "marketCapRank": 1862,
    "addresses": {
      "hedera-hashgraph": "0x00000000000000000000000000000000000ec585"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "hedera-hashgraph",
    "filePath": "token:HBAR",
    "symbol": "hbar",
    "name": "Hedera",
    "marketCapRank": 38,
    "addresses": {},
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "hegic",
    "filePath": "token:HEGIC",
    "symbol": "hegic",
    "name": "Hegic",
    "marketCapRank": 1071,
    "addresses": {
      "ethereum": "0x584bc13c7d411c00c01a62e8019472de68768430",
      "fantom": "0x44b26e839eb3572c5e959f994804a5de66600349",
      "energi": "0x762204d444123bcc511718a24158a86e3d853266",
      "arbitrum-one": "0x431402e8b9de9aa016c743880e04e517074d8cec"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "helium",
    "filePath": "token:HNT",
    "symbol": "hnt",
    "name": "Helium",
    "marketCapRank": 111,
    "addresses": {
      "solana": "hntyVP6YFm1Hg25TN9WGLqM12b8TQmcknKrdu1oxWux"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "helium-mobile",
    "filePath": "token:MOBILE",
    "symbol": "mobile",
    "name": "Helium Mobile",
    "marketCapRank": 254,
    "addresses": {
      "solana": "mb1eu7TzEc71KxDpsmsKoucSSuuoGLv1drys1oP2jh6"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "hello-labs",
    "filePath": "token:HELLO",
    "symbol": "hello",
    "name": "HELLO",
    "marketCapRank": 938,
    "addresses": {
      "ethereum": "0x411099c0b413f4feddb10edf6a8be63bd321311c",
      "binance-smart-chain": "0x0f1cbed8efa0e012adbccb1638d0ab0147d5ac00"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "hera-finance",
    "filePath": "token:HERA",
    "symbol": "hera",
    "name": "Hera Finance",
    "marketCapRank": 1193,
    "addresses": {
      "metis-andromeda": "0x6f05709bc91bad933346f9e159f0d3fdbc2c9dce",
      "ethereum": "0xa2c2c937333165d4c5f2dc5f31a43e1239fecfeb"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "hermes-protocol",
    "filePath": "token:HERMES",
    "symbol": "hermes",
    "name": "Hermes Protocol",
    "marketCapRank": 2022,
    "addresses": {
      "metis-andromeda": "0xb27bbeaaca2c00d6258c3118bab6b5b6975161c8"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "hermez-network-token",
    "filePath": "token:HEZ",
    "symbol": "hez",
    "name": "Hermez Network",
    "marketCapRank": 631,
    "addresses": {
      "ethereum": "0xeef9f339514298c6a857efcfc1a762af84438dee"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "hero-blaze-three-kingdoms",
    "filePath": "token:MUDOL2",
    "symbol": "mudol2",
    "name": "Hero Blaze: Three Kingdoms",
    "marketCapRank": 2141,
    "addresses": {
      "binance-smart-chain": "0x5e7f472b9481c80101b22d0ba4ef4253aa61dabc"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "heroes-of-nft",
    "filePath": "token:HON",
    "symbol": "hon",
    "name": "Heroes of NFT",
    "marketCapRank": 2479,
    "addresses": {
      "avalanche": "0xed2b42d3c9c6e97e11755bb37df29b6375ede3eb"
    },
    "variants": [
      "mono"
    ]
  },
  {
    "id": "hiblocks",
    "filePath": "token:HIBS",
    "symbol": "hibs",
    "name": "Hiblocks",
    "marketCapRank": 2469,
    "addresses": {
      "klay-token": "0xe06b40df899b9717b4e6b50711e1dc72d08184cf"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "hifi-finance",
    "filePath": "token:HIFI",
    "symbol": "hifi",
    "name": "Hifi Finance",
    "marketCapRank": 419,
    "addresses": {
      "ethereum": "0x4b9278b94a1112cad404048903b8d343a810b07e"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "hilo",
    "filePath": "token:HILO",
    "symbol": "hilo",
    "name": "HILO",
    "marketCapRank": 1664,
    "addresses": {
      "ethereum": "0xbb9fd9fa4863c03c574007ff3370787b9ce65ff6"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "hive",
    "filePath": "token:HIVE",
    "symbol": "hive",
    "name": "Hive",
    "marketCapRank": 366,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "hive-game-token",
    "filePath": "token:HGT",
    "symbol": "hgt",
    "name": "Hive Game Token",
    "marketCapRank": 2855,
    "addresses": {
      "solana": "HGTxJQKzuMjzKkHVpRLcFHwE6ngVCJbcP35FDQtmRzhx"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "hivemapper",
    "filePath": "token:HONEY",
    "symbol": "honey",
    "name": "Hivemapper",
    "marketCapRank": 391,
    "addresses": {
      "solana": "4vMsoUT2BWatFweudnQM1xedRLfJgJ7hswhcpz4xgBTy"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "hmx",
    "filePath": "token:HMX",
    "symbol": "hmx",
    "name": "HMX",
    "marketCapRank": 1390,
    "addresses": {
      "arbitrum-one": "0x83d6c8c06ac276465e4c92e7ac8c23740f435140",
      "ethereum": "0x83d6c8c06ac276465e4c92e7ac8c23740f435140"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "hoge-finance",
    "filePath": "token:HOGE",
    "symbol": "hoge",
    "name": "Hoge Finance",
    "marketCapRank": 1351,
    "addresses": {
      "ethereum": "0xfad45e47083e4607302aa43c65fb3106f1cd7607"
    },
    "variants": [
      "mono"
    ]
  },
  {
    "id": "hold-2",
    "filePath": "token:EARN",
    "symbol": "earn",
    "name": "HOLD",
    "marketCapRank": 1991,
    "addresses": {
      "ethereum": "0x0b61c4f33bcdef83359ab97673cb5961c6435f4e",
      "binance-smart-chain": "0x2ac895feba458b42884dcbcb47d57e44c3a303c8",
      "solana": "8CuPzHKuZQUyYbear8fi3u6iuTY652WVZT2cHZ2yeNbE"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "holdstation",
    "filePath": "token:HOLD",
    "symbol": "hold",
    "name": "Holdstation",
    "marketCapRank": 930,
    "addresses": {
      "zksync": "0xed4040fd47629e7c8fbb7da76bb50b3e7695f0f2"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "holoride",
    "filePath": "token:RIDE",
    "symbol": "ride",
    "name": "holoride",
    "marketCapRank": 1336,
    "addresses": {
      "elrond": "RIDE-7d18e9",
      "ethereum": "0xf97e2a78f1f3d1fd438ff7cc3bb7de01e5945b83"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "holotoken",
    "filePath": "token:HOT",
    "symbol": "hot",
    "name": "Holo",
    "marketCapRank": 163,
    "addresses": {
      "ethereum": "0x6c6ee5e31d828de241282b9606c8e98ea48526e2",
      "harmony-shard-0": "0x5dfeadcdd2d4eb29ac5ae876daa07ffd07bf6483",
      "sora": "0x004baaeb9bf0d5210a51fab72d10c84a34f53bea4e0e102d794d531a45ec50f9",
      "energi": "0x34b97eeab6fd9bbe95a5eaf4645307c5a6f3d4d0"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "honeyland-honey",
    "filePath": "token:HXD",
    "symbol": "hxd",
    "name": "Honeyland",
    "marketCapRank": 942,
    "addresses": {
      "solana": "3dgCCb15HMQSA4Pn3Tfii5vRk7aRqTH95LJjxzsG2Mug"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "honk",
    "filePath": "token:HONK",
    "symbol": "honk",
    "name": "Honk",
    "marketCapRank": 1522,
    "addresses": {
      "solana": "3ag1Mj9AKz9FAkCQ6gAEhpLSX8B2pUbPdkb9iBsDLZNB"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "hooked-protocol",
    "filePath": "token:HOOK",
    "symbol": "hook",
    "name": "Hooked Protocol",
    "marketCapRank": 334,
    "addresses": {
      "binance-smart-chain": "0xa260e12d2b924cb899ae80bb58123ac3fee1e2f0"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "hop-protocol",
    "filePath": "token:HOP",
    "symbol": "hop",
    "name": "Hop Protocol",
    "marketCapRank": 1923,
    "addresses": {
      "ethereum": "0xc5102fe9359fd9a28f877a67e36b0f050d81a3cc",
      "polygon-pos": "0xc5102fe9359fd9a28f877a67e36b0f050d81a3cc",
      "optimistic-ethereum": "0xc5102fe9359fd9a28f877a67e36b0f050d81a3cc",
      "base": "0xc5102fe9359fd9a28f877a67e36b0f050d81a3cc",
      "xdai": "0xc5102fe9359fd9a28f877a67e36b0f050d81a3cc",
      "arbitrum-one": "0xc5102fe9359fd9a28f877a67e36b0f050d81a3cc"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "hopr",
    "filePath": "token:HOPR",
    "symbol": "hopr",
    "name": "HOPR",
    "marketCapRank": 628,
    "addresses": {
      "ethereum": "0xf5581dfefd8fb0e4aec526be659cfab1f8c781da",
      "xdai": "0xd057604a14982fe8d88c5fc25aac3267ea142a08"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "hord",
    "filePath": "token:HORD",
    "symbol": "hord",
    "name": "Hord",
    "marketCapRank": 1846,
    "addresses": {
      "ethereum": "0x43a96962254855f16b925556f9e97be436a43448",
      "arbitrum-one": "0xb1bc21f748ae2be95674876710bc6d78235480e0"
    },
    "variants": [
      "mono"
    ]
  },
  {
    "id": "horizon-protocol",
    "filePath": "token:HZN",
    "symbol": "hzn",
    "name": "Horizon Protocol",
    "marketCapRank": 1503,
    "addresses": {
      "binance-smart-chain": "0xc0eff7749b125444953ef89682201fb8c6a917cd"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "hourglass",
    "filePath": "token:WAIT",
    "symbol": "wait",
    "name": "Hourglass",
    "marketCapRank": 1424,
    "addresses": {
      "ethereum": "0x2559813bbb508c4c79e9ccce4703bcb1f149edd7"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "hubble",
    "filePath": "token:HBB",
    "symbol": "hbb",
    "name": "Hubble",
    "marketCapRank": 1185,
    "addresses": {
      "solana": "HBB111SCo9jkCejsZfz8Ec8nH7T6THF8KEKSnvwT6XK6"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "humanode",
    "filePath": "token:HMND",
    "symbol": "hmnd",
    "name": "Humanode",
    "marketCapRank": 1379,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "humans-ai",
    "filePath": "token:HEART",
    "symbol": "heart",
    "name": "Humans.ai",
    "marketCapRank": 310,
    "addresses": {
      "ethereum": "0x8fac8031e079f409135766c7d5de29cf22ef897c",
      "osmosis": "ibc/35CECC330D11DD00FACB555D07687631E0BC7D226260CC5F015F6D7980819533"
    },
    "variants": [
      "mono"
    ]
  },
  {
    "id": "humanscape",
    "filePath": "token:HPO",
    "symbol": "hpo",
    "name": "Hippocrat",
    "marketCapRank": 497,
    "addresses": {
      "ethereum": "0xfe39c384d702914127a005523f9915addb9bd59b"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "hummingbot",
    "filePath": "token:HBOT",
    "symbol": "hbot",
    "name": "Hummingbot",
    "marketCapRank": 2375,
    "addresses": {
      "ethereum": "0xe5097d9baeafb89f9bcb78c9290d545db5f9e9cb"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "hunt-token",
    "filePath": "token:HUNT",
    "symbol": "hunt",
    "name": "Hunt",
    "marketCapRank": 494,
    "addresses": {
      "ethereum": "0x9aab071b4129b083b01cb5a0cb513ce7eca26fa5"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "huobi-btc",
    "filePath": "token:HBTC",
    "symbol": "hbtc",
    "name": "Huobi BTC",
    "marketCapRank": 336,
    "addresses": {
      "ethereum": "0x0316eb71485b0ab14103307bf65a021042c6d380",
      "huobi-token": "0x66a79d23e58475d2738179ca52cd0b41d73f0bea"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "huobi-token",
    "filePath": "token:HT",
    "symbol": "ht",
    "name": "Huobi",
    "marketCapRank": 434,
    "addresses": {
      "ethereum": "0x6f259637dcd74c767781e37bc6133cd6a68aa161",
      "near-protocol": "6f259637dcd74c767781e37bc6133cd6a68aa161.factory.bridge.near",
      "harmony-shard-0": "0xbaa0974354680b0e8146d64bb27fb92c03c4a2f2",
      "elastos": "0xeceefc50f9aacf0795586ed90a8b9e24f55ce3f3"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "husd",
    "filePath": "token:HUSD",
    "symbol": "husd",
    "name": "HUSD",
    "marketCapRank": 1307,
    "addresses": {
      "ethereum": "0xdf574c24545e5ffecb9a659c229253d4111d87e1",
      "huobi-token": "0x0298c2b32eae4da002a15f36fdf7615bea3da047",
      "sora": "0x008ba21aa988b21e86d5b25ed9ea690d28a6ba6c5ba9037424c215fd5b193c32",
      "elastos": "0xf9ca2ea3b1024c0db31adb224b407441becc18bb",
      "cube": "0x9db853f46dd7d541d0fba1c8b6b7e7b1d8ff58d3"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "husky-avax",
    "filePath": "token:HUSKY",
    "symbol": "husky",
    "name": "Husky Avax",
    "marketCapRank": 1544,
    "addresses": {
      "avalanche": "0x65378b697853568da9ff8eab60c13e1ee9f4a654"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "hxro",
    "filePath": "token:HXRO",
    "symbol": "hxro",
    "name": "HXRO",
    "marketCapRank": 664,
    "addresses": {
      "ethereum": "0x4bd70556ae3f8a6ec6c4080a0c327b24325438f3",
      "energi": "0xf25ef66291cc2469781fa18512d6b26431cb0747",
      "solana": "HxhWkVpk5NS4Ltg5nij2G671CKXFRKPK8vy271Ub4uEK"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "hydra",
    "filePath": "token:HYDRA",
    "symbol": "hydra",
    "name": "Hydra",
    "marketCapRank": 1238,
    "addresses": {
      "hydra": "6d9115a21863ce31b44cd231e4c4ccc87566222f"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "hydradx",
    "filePath": "token:HDX",
    "symbol": "hdx",
    "name": "HydraDX",
    "marketCapRank": 769,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "hypergpt",
    "filePath": "token:HGPT",
    "symbol": "hgpt",
    "name": "HyperGPT",
    "marketCapRank": 965,
    "addresses": {
      "binance-smart-chain": "0x529c79f6918665ebe250f32eeeaa1d410a0798c6",
      "the-open-network": "EQAuw01klxL8qKe9cBioTfjst0d6Gdagg51_c73z8X2-zJmj"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "hypersign-identity-token",
    "filePath": "token:HID",
    "symbol": "hid",
    "name": "Hypersign Identity",
    "marketCapRank": 2200,
    "addresses": {
      "ethereum": "0xb14ebf566511b9e6002bb286016ab2497b9b9c9d",
      "polygon-pos": "0x87847703d4bb4fcd42db887ffdcb94496e77e3ab"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "hytopia",
    "filePath": "token:TOPIA",
    "symbol": "topia",
    "name": "HYCHAIN",
    "marketCapRank": 697,
    "addresses": {
      "ethereum": "0xccccb68e1a848cbdb5b60a974e07aae143ed40c3"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "hyve",
    "filePath": "token:HYVE",
    "symbol": "hyve",
    "name": "Hyve",
    "marketCapRank": 2433,
    "addresses": {
      "ethereum": "0xd794dd1cada4cf79c9eebaab8327a1b0507ef7d4",
      "fantom": "0x90b89e881961e1053aeaddba13217d56f747349a",
      "binance-smart-chain": "0xf6565a97dc832d93dc83b75ee9aa5c7e8ecb0f9d",
      "polygon-pos": "0x61aee582896064ecd5d85d66a32ddeb5574a699d"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "ice",
    "filePath": "token:ICE",
    "symbol": "ice",
    "name": "Ice Network",
    "marketCapRank": 1018,
    "addresses": {
      "binance-smart-chain": "0xc335df7c25b72eec661d5aa32a7c2b7b2a1d1874",
      "ethereum": "0x79f05c263055ba20ee0e814acd117c20caa10e0c"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "ichi-farm",
    "filePath": "token:ICHI",
    "symbol": "ichi",
    "name": "ICHI",
    "marketCapRank": 1115,
    "addresses": {
      "ethereum": "0x111111517e4929d3dcbdfa7cce55d30d4b6bc4d6",
      "binance-smart-chain": "0x0ef4a107b48163ab4b57fca36e1352151a587be4",
      "arbitrum-one": "0xadf5dd3e51bf28ab4f07e684ecf5d00691818790",
      "polygon-pos": "0x111111517e4929d3dcbdfa7cce55d30d4b6bc4d6"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "icon",
    "filePath": "token:ICX",
    "symbol": "icx",
    "name": "ICON",
    "marketCapRank": 235,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "idavoll-network",
    "filePath": "token:IDV",
    "symbol": "idv",
    "name": "Idavoll DAO",
    "marketCapRank": 2159,
    "addresses": {
      "ethereum": "0x45448e05020576929fcdeabc228e35b420098840"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "ideaology",
    "filePath": "token:IDEA",
    "symbol": "idea",
    "name": "Ideaology",
    "marketCapRank": 2176,
    "addresses": {
      "ethereum": "0x5d3a4f62124498092ce665f865e0b38ff6f5fbea"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "idena",
    "filePath": "token:IDNA",
    "symbol": "idna",
    "name": "Idena",
    "marketCapRank": 2203,
    "addresses": {
      "binance-smart-chain": "0x0de08c1abe5fb86dd7fd2ac90400ace305138d5b"
    },
    "variants": [
      "mono"
    ]
  },
  {
    "id": "idia",
    "filePath": "token:IDIA",
    "symbol": "idia",
    "name": "Impossible Finance Launchpad",
    "marketCapRank": 655,
    "addresses": {
      "binance-smart-chain": "0x0b15ddf19d47e6a86a56148fb4afffc6929bcb89",
      "avalanche": "0xfcaf13227dcbfa2dc2b1928acfca03b85e2d25dd",
      "arbitrum-one": "0xe6045890b20945d00e6f3c01878265c03c5435d3",
      "moonriver": "0x2d28aa28fa1e5e6bf121cf688309bf3faaae3c70"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "idle",
    "filePath": "token:IDLE",
    "symbol": "idle",
    "name": "IDLE",
    "marketCapRank": 2222,
    "addresses": {
      "ethereum": "0x875773784af8135ea0ef43b5a374aad105c5d39e",
      "polygon-pos": "0xc25351811983818c9fe6d8c580531819c8ade90f"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "iexec-rlc",
    "filePath": "token:RLC",
    "symbol": "rlc",
    "name": "iExec RLC",
    "marketCapRank": 278,
    "addresses": {
      "ethereum": "0x607f4c5bb672230e8672085532f7e901544a7375",
      "sora": "0x008294f7b08f568a661de2b248c34fc574e7e0012a12ef7959eb1a5c6b349e09",
      "energi": "0xb4ff17b5e93c40ff09326b0d538118022f02dc2b"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "ignis",
    "filePath": "token:IGNIS",
    "symbol": "ignis",
    "name": "Ignis",
    "marketCapRank": 1880,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "iguverse-igu",
    "filePath": "token:IGU",
    "symbol": "igu",
    "name": "IguVerse IGU",
    "marketCapRank": 1626,
    "addresses": {
      "binance-smart-chain": "0x201bc9f242f74c47bbd898a5dc99cdcd81a21943"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "illuvium",
    "filePath": "token:ILV",
    "symbol": "ilv",
    "name": "Illuvium",
    "marketCapRank": 128,
    "addresses": {
      "ethereum": "0x767fe9edc9e0df98e07454847909b5e959d7ca0e",
      "energi": "0xa4ecf6d10b8d61d4a022821a6ff8b9536a47c70d"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "ime-lab",
    "filePath": "token:LIME",
    "symbol": "lime",
    "name": "iMe Lab",
    "marketCapRank": 782,
    "addresses": {
      "binance-smart-chain": "0x7bc75e291e656e8658d66be1cc8154a3769a35dd",
      "polygon-pos": "0x7f67639ffc8c93dd558d452b8920b28815638c44"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "imgnai",
    "filePath": "token:IMGNAI",
    "symbol": "imgnai",
    "name": "Image Generation AI",
    "marketCapRank": 1099,
    "addresses": {
      "ethereum": "0xa735a3af76cc30791c61c10d585833829d36cbe0"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "imo",
    "filePath": "token:IMO",
    "symbol": "imo",
    "name": "IMO",
    "marketCapRank": 2145,
    "addresses": {
      "binance-smart-chain": "0x94d79c325268c898d2902050730f27a478c56cc1"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "impt",
    "filePath": "token:IMPT",
    "symbol": "impt",
    "name": "IMPT",
    "marketCapRank": 1739,
    "addresses": {
      "ethereum": "0x04c17b9d3b29a78f7bd062a57cf44fc633e71f85"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "infinity-pad-2",
    "filePath": "token:IPAD",
    "symbol": "ipad",
    "name": "Infinity PAD",
    "marketCapRank": 2251,
    "addresses": {
      "binance-smart-chain": "0xa7266989b0df675cc8257d53b6bc1358faf6626a"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "infinitybit-token",
    "filePath": "token:IBIT",
    "symbol": "ibit",
    "name": "InfinityBit Token",
    "marketCapRank": 1983,
    "addresses": {
      "ethereum": "0xa3cb87080e68ad54d00573983d935fa85d168fde"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "injective-protocol",
    "filePath": "network:injective",
    "symbol": "inj",
    "name": "Injective",
    "marketCapRank": 46,
    "addresses": {
      "ethereum": "0xe28b3b32b6c345a34ff64674606124dd5aceca30",
      "cosmos": "ibc/64BA6E31FE887D66C6F8F31C7B1A80C7CA179239677B4088BB55F5EA07DBE273",
      "binance-smart-chain": "0xa2b726b1145a4773f68593cf171187d8ebe4d495",
      "secret": "secret14706vxakdzkz9a36872cs62vpl5qd84kpwvpew"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "inscribe",
    "filePath": "token:INS",
    "symbol": "ins",
    "name": "Inscribe",
    "marketCapRank": 1848,
    "addresses": {
      "ethereum": "0xe9572938bcbf08adcee86fd12a7c0d08dc4ab841"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "instadapp",
    "filePath": "token:INST",
    "symbol": "inst",
    "name": "Instadapp",
    "marketCapRank": 922,
    "addresses": {
      "ethereum": "0x6f40d4a6237c257fff2db00fa0510deeecd303eb",
      "polygon-pos": "0xf50d05a1402d0adafa880d36050736f9f6ee7dee"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "instadapp-eth",
    "filePath": "token:IETH",
    "symbol": "ieth",
    "name": "iETH v1",
    "marketCapRank": 2509,
    "addresses": {
      "ethereum": "0xc383a3833a87009fd9597f8184979af5edfad019"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "insurace",
    "filePath": "token:INSUR",
    "symbol": "insur",
    "name": "InsurAce",
    "marketCapRank": 2051,
    "addresses": {
      "ethereum": "0x544c42fbb96b39b21df61cf322b5edc285ee7429",
      "avalanche": "0x544c42fbb96b39b21df61cf322b5edc285ee7429",
      "polygon-pos": "0x8a0e8b4b0903929f47c3ea30973940d4a9702067",
      "binance-smart-chain": "0x3192ccddf1cdce4ff055ebc80f3f0231b86a7e30"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "insure",
    "filePath": "token:SURE",
    "symbol": "sure",
    "name": "inSure DeFi",
    "marketCapRank": 398,
    "addresses": {
      "ethereum": "0xcb86c6a22cb56b6cf40cafedb06ba0df188a416e",
      "avalanche": "0x5fc17416925789e0852fbfcd81c490ca4abc51f9",
      "polygon-pos": "0xf88332547c680f755481bf489d890426248bb275",
      "binance-smart-chain": "0x9b17baadf0f21f03e35249e0e59723f34994f806"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "integritee",
    "filePath": "token:TEER",
    "symbol": "teer",
    "name": "Integritee",
    "marketCapRank": 1994,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "inter-stable-token",
    "filePath": "token:IST",
    "symbol": "ist",
    "name": "Inter Stable Token",
    "marketCapRank": 2534,
    "addresses": {
      "osmosis": "ibc/92BE0717F4678905E53F4E45B2DED18BC0CB97BF1F8B6A25AFEDF3D5A879B4D5",
      "archway": "ibc/C0336ECF2DF64E7D2C98B1422EC2B38DE9EF33C34AAADF18C6F2E3FFC7BE3615",
      "secret": "secret1xmqsk8tnge0atzy4e079h0l2wrgz6splcq0a24"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "interlay",
    "filePath": "token:INTR",
    "symbol": "intr",
    "name": "Interlay",
    "marketCapRank": 1618,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "internet-computer",
    "filePath": "token:ICP",
    "symbol": "icp",
    "name": "Internet Computer",
    "marketCapRank": 21,
    "addresses": {
      "internet-computer": "ryjl3-tyaaa-aaaaa-aaaba-cai"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "interport-token",
    "filePath": "token:ITP",
    "symbol": "itp",
    "name": "Interport Token",
    "marketCapRank": 1896,
    "addresses": {
      "ethereum": "0x2b1d36f5b61addaf7da7ebbd11b35fd8cfb0de31",
      "polygon-zkevm": "0x2b1d36f5b61addaf7da7ebbd11b35fd8cfb0de31",
      "linea": "0x2b1d36f5b61addaf7da7ebbd11b35fd8cfb0de31",
      "arbitrum-one": "0x2b1d36f5b61addaf7da7ebbd11b35fd8cfb0de31",
      "optimistic-ethereum": "0x2b1d36f5b61addaf7da7ebbd11b35fd8cfb0de31",
      "zksync": "0xd03465338226ea0178337f4abb16fdd6df529f57",
      "avalanche": "0x2b1d36f5b61addaf7da7ebbd11b35fd8cfb0de31",
      "scroll": "0x2b1d36f5b61addaf7da7ebbd11b35fd8cfb0de31",
      "fantom": "0x2b1d36f5b61addaf7da7ebbd11b35fd8cfb0de31",
      "opbnb": "0x2b1d36f5b61addaf7da7ebbd11b35fd8cfb0de31",
      "polygon-pos": "0x2b1d36f5b61addaf7da7ebbd11b35fd8cfb0de31",
      "base": "0x2b1d36f5b61addaf7da7ebbd11b35fd8cfb0de31",
      "binance-smart-chain": "0x2b1d36f5b61addaf7da7ebbd11b35fd8cfb0de31"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "intrepid-token",
    "filePath": "token:INT",
    "symbol": "int",
    "name": "Intrepid Token",
    "marketCapRank": 2632,
    "addresses": {
      "ethereum": "0xa2762ba628b962f93498d8893b6e4346140fe96d"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "inverse-finance",
    "filePath": "token:INV",
    "symbol": "inv",
    "name": "Inverse Finance",
    "marketCapRank": 988,
    "addresses": {
      "ethereum": "0x41d5d79431a913c4ae7d69a668ecdfe5ff9dfb68"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "ion",
    "filePath": "token:ION",
    "symbol": "ion",
    "name": "Ion",
    "marketCapRank": 1519,
    "addresses": {
      "osmosis": "uion"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "iostoken",
    "filePath": "token:IOST",
    "symbol": "iost",
    "name": "IOST",
    "marketCapRank": 315,
    "addresses": {},
    "variants": [
      "mono"
    ]
  },
  {
    "id": "iota",
    "filePath": "token:IOTA",
    "symbol": "iota",
    "name": "IOTA",
    "marketCapRank": 106,
    "addresses": {},
    "variants": [
      "mono",
      "background",
      "branded"
    ]
  },
  {
    "id": "ipor",
    "filePath": "token:IPOR",
    "symbol": "ipor",
    "name": "IPOR",
    "marketCapRank": 1460,
    "addresses": {
      "ethereum": "0x1e4746dc744503b53b4a082cb3607b169a289090",
      "arbitrum-one": "0x34229b3f16fbcdfa8d8d9d17c0852f9496f4c7bb"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "iris-network",
    "filePath": "token:IRIS",
    "symbol": "iris",
    "name": "IRISnet",
    "marketCapRank": 640,
    "addresses": {
      "osmosis": "ibc/7C4D60AA95E5A7558B0A364860979CA34B7FF8AAF255B87AF9E879374470CEC0"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "iron-fish",
    "filePath": "token:IRON",
    "symbol": "iron",
    "name": "Iron Fish",
    "marketCapRank": 848,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "iskra-token",
    "filePath": "token:ISK",
    "symbol": "isk",
    "name": "ISKRA Token",
    "marketCapRank": 960,
    "addresses": {
      "ethereum": "0x17d2628d30f8e9e966c9ba831c9b9b01ea8ea75c",
      "klay-token": "0x17d2628d30f8e9e966c9ba831c9b9b01ea8ea75c"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "ispolink",
    "filePath": "token:ISP",
    "symbol": "isp",
    "name": "Ispolink",
    "marketCapRank": 1419,
    "addresses": {
      "ethereum": "0xc8807f0f5ba3fa45ffbdc66928d71c5289249014",
      "manta-pacific": "0xbab1c57ec0bb0ae81d948503e51d90166459d154",
      "binance-smart-chain": "0xd2e7b964770fcf51df088a5f0bb2d33a3c60cccf"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "itheum",
    "filePath": "token:ITHEUM",
    "symbol": "itheum",
    "name": "Itheum",
    "marketCapRank": 1370,
    "addresses": {
      "elrond": "ITHEUM-df6f26"
    },
    "variants": [
      "mono"
    ]
  },
  {
    "id": "ix-swap",
    "filePath": "token:IXS",
    "symbol": "ixs",
    "name": "IX Swap",
    "marketCapRank": 486,
    "addresses": {
      "ethereum": "0x73d7c860998ca3c01ce8c808f5577d94d545d1b4",
      "polygon-pos": "0x1ba17c639bdaecd8dc4aac37df062d17ee43a1b8"
    },
    "variants": [
      "mono"
    ]
  },
  {
    "id": "ix-token",
    "filePath": "token:IXT",
    "symbol": "ixt",
    "name": "Planet IX",
    "marketCapRank": 1369,
    "addresses": {
      "polygon-pos": "0xe06bd4f5aac8d0aa337d13ec88db6defc6eaeefe"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "ixo",
    "filePath": "token:IXO",
    "symbol": "ixo",
    "name": "IXO",
    "marketCapRank": 1454,
    "addresses": {
      "cosmos": "ibc/F3FF7A84A73B62921538642F9797C423D2B4C4ACB3C7FCFFCE7F12AA69909C4B"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "jackal-protocol",
    "filePath": "token:JKL",
    "symbol": "jkl",
    "name": "Jackal Protocol",
    "marketCapRank": 700,
    "addresses": {
      "secret": "secret1sgaz455pmtgld6dequqayrdseq8vy2fc48n8y3",
      "osmosis": "ibc/8E697BDABE97ACE8773C6DF7402B2D1D5104DD1EEABE12608E3469B7F64C15BA",
      "archway": "ibc/926432AE1C5FA4F857B36D970BE7774C7472079506820B857B75C5DE041DD7A3"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "jasmycoin",
    "filePath": "token:JASMY",
    "symbol": "jasmy",
    "name": "JasmyCoin",
    "marketCapRank": 113,
    "addresses": {
      "ethereum": "0x7420b4b9a0110cdc71fb720908340c03f9bc03ec"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "jesus-coin",
    "filePath": "token:JESUS",
    "symbol": "jesus",
    "name": "Jesus Coin",
    "marketCapRank": 1060,
    "addresses": {
      "ethereum": "0xba386a4ca26b85fd057ab1ef86e3dc7bdeb5ce70"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "joe",
    "filePath": "token:JOE",
    "symbol": "joe",
    "name": "JOE",
    "marketCapRank": 267,
    "addresses": {
      "avalanche": "0x6e84a6216ea6dacc71ee8e6b0a5b7322eebc0fdd",
      "arbitrum-one": "0x371c7ec6d8039ff7933a2aa28eb827ffe1f52f07",
      "mantle": "0x371c7ec6d8039ff7933a2aa28eb827ffe1f52f07",
      "binance-smart-chain": "0x371c7ec6d8039ff7933a2aa28eb827ffe1f52f07"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "jones-dao",
    "filePath": "token:JONES",
    "symbol": "jones",
    "name": "Jones DAO",
    "marketCapRank": 1945,
    "addresses": {
      "arbitrum-one": "0x10393c20975cf177a3513071bc110f7962cd67da"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "joystream",
    "filePath": "token:JOY",
    "symbol": "joy",
    "name": "Joystream",
    "marketCapRank": 1212,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "julswap",
    "filePath": "token:JULD",
    "symbol": "juld",
    "name": "JulSwap",
    "marketCapRank": 2062,
    "addresses": {
      "binance-smart-chain": "0xf5d8015d625be6f59b8073c8189bd51ba28792e1",
      "harmony-shard-0": "0x504d7d5bd2075fa782fbd0be9bea4cdc7e25f5a1"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "jumptoken",
    "filePath": "token:JMPT",
    "symbol": "jmpt",
    "name": "JumpToken",
    "marketCapRank": 1328,
    "addresses": {
      "binance-smart-chain": "0x88d7e9b65dc24cf54f5edef929225fc3e1580c25",
      "celo": "0x1d18d0386f51ab03e7e84e71bda1681eba865f1f",
      "ethereum": "0x420a24c9c65bd44c48bfb1cc8d6cd1ea8b1ac840",
      "polygon-pos": "0x03cf5d93ca7c70ce0a21a09f4d70779d2c66b25a"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "juno-network",
    "filePath": "token:JUNO",
    "symbol": "juno",
    "name": "JUNO",
    "marketCapRank": 1064,
    "addresses": {
      "cosmos": "ibc/46B44899322F3CD854D2D46DEEF881958467CDD4B3B10086DA49296BBED94BED",
      "evmos": "0x3452e23f9c4cc62c70b7adad699b264af3549c19",
      "secret": "secret1z6e4skg5g9w65u5sqznrmagu05xq8u6zjcdg4a"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "jupiter",
    "filePath": "token:JUP",
    "symbol": "jup",
    "name": "Jupiter Project",
    "marketCapRank": 2628,
    "addresses": {
      "ethereum": "0x4b1e80cac91e2216eeb63e29b957eb91ae9c2be8",
      "binance-smart-chain": "0x0231f91e02debd20345ae8ab7d71a41f8e140ce7"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "just",
    "filePath": "token:JST",
    "symbol": "jst",
    "name": "JUST",
    "marketCapRank": 242,
    "addresses": {
      "tron": "TCFLL5dx5ZJdKnWuesXxi1VPwjLVmWZZy9"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "k21",
    "filePath": "token:K21",
    "symbol": "k21",
    "name": "K21",
    "marketCapRank": 2304,
    "addresses": {
      "ethereum": "0xb9d99c33ea2d86ec5ec6b8a4dd816ebba64404af"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "kadena",
    "filePath": "token:KDA",
    "symbol": "kda",
    "name": "Kadena",
    "marketCapRank": 224,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "kaizen",
    "filePath": "token:KZEN",
    "symbol": "kzen",
    "name": "Kaizen.Finance",
    "marketCapRank": null,
    "addresses": {
      "polygon-pos": "0x4550003152f12014558e5ce025707e4dd841100f",
      "ethereum": "0x4550003152f12014558e5ce025707e4dd841100f",
      "binance-smart-chain": "0x4550003152f12014558e5ce025707e4dd841100f",
      "solana": "kZEn3aDxEzcFADPe2VQ6WcJRbS1hVGjUcgCw4HiuYSU"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "kalmar",
    "filePath": "token:KALM",
    "symbol": "kalm",
    "name": "KALM",
    "marketCapRank": 2581,
    "addresses": {
      "binance-smart-chain": "0x4ba0057f784858a48fe351445c672ff2a3d43515",
      "avalanche": "0x62aceea3e666c5706ce1c61055fac1a669d31d93",
      "fantom": "0x4f851750a3e6f80f1e1f89c67b56960bfc29a934"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "kamaleont",
    "filePath": "token:KLT",
    "symbol": "klt",
    "name": "Kamaleont",
    "marketCapRank": 1566,
    "addresses": {
      "binance-smart-chain": "0xf87940f78f2f4d99a0c5c22e3fcc21795cd53245"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "kan",
    "filePath": "token:KAN",
    "symbol": "kan",
    "name": "BitKan",
    "marketCapRank": 1720,
    "addresses": {
      "ethereum": "0x1410434b0346f5be678d0fb554e5c7ab620f8f4a"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "kapital-dao",
    "filePath": "token:KAP",
    "symbol": "kap",
    "name": "KAP Games",
    "marketCapRank": 1306,
    "addresses": {
      "ethereum": "0x9625ce7753ace1fa1865a47aae2c5c2ce4418569",
      "arbitrum-one": "0x965d00aa7abc62ca10132e641d08593435ac811d",
      "hedera-hashgraph": "0.0.3299785",
      "polygon-pos": "0xc27158bb8e08899d38765752f91d7d778e16ab8e",
      "blast": "0x15d24de366f69b835be19f7cf9447e770315dd80"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "karat",
    "filePath": "token:KAT",
    "symbol": "kat",
    "name": "Karat",
    "marketCapRank": 2213,
    "addresses": {
      "zksync": "0xcdb7d260c107499c80b4b748e8331c64595972a1"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "karate-combat",
    "filePath": "token:KARATE",
    "symbol": "karate",
    "name": "Karate Combat",
    "marketCapRank": 1002,
    "addresses": {
      "ethereum": "0x80008bcd713c38af90a9930288d446bc3bd2e684",
      "hedera-hashgraph": "0.0.2283230"
    },
    "variants": [
      "mono"
    ]
  },
  {
    "id": "kardiachain",
    "filePath": "token:KAI",
    "symbol": "kai",
    "name": "KardiaChain",
    "marketCapRank": 1090,
    "addresses": {
      "kardiachain": "0xaf984e23eaa3e7967f3c5e007fbe397d8566d23d",
      "binance-smart-chain": "0x39ae8eefb05138f418bb27659c21632dc1ddab10"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "karura",
    "filePath": "token:KAR",
    "symbol": "kar",
    "name": "Karura",
    "marketCapRank": 1081,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "kaspa",
    "filePath": "token:KAS",
    "symbol": "kas",
    "name": "Kaspa",
    "marketCapRank": 47,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "kasta",
    "filePath": "token:KASTA",
    "symbol": "kasta",
    "name": "Kasta",
    "marketCapRank": 1163,
    "addresses": {
      "polygon-pos": "0x235737dbb56e8517391473f7c964db31fa6ef280"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "katana-inu",
    "filePath": "token:KATA",
    "symbol": "kata",
    "name": "Katana Inu",
    "marketCapRank": 741,
    "addresses": {
      "ethereum": "0x2e85ae1c47602f7927bcabc2ff99c40aa222ae15",
      "binance-smart-chain": "0x6d6ba21e4c4b29ca7bfa1c344ba1e35b8dae7205"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "kava",
    "filePath": "token:KAVA",
    "symbol": "kava",
    "name": "Kava",
    "marketCapRank": 107,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "kava-lend",
    "filePath": "token:HARD",
    "symbol": "hard",
    "name": "Kava Lend",
    "marketCapRank": 881,
    "addresses": {
      "energi": "0xeeaccbb6ce1b5be68a2cf9d0dea27d4b807848d2"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "keep-network",
    "filePath": "token:KEEP",
    "symbol": "keep",
    "name": "Keep Network",
    "marketCapRank": 447,
    "addresses": {
      "ethereum": "0x85eee30c52b0b379b046fb0f85f4f3dc3009afec",
      "harmony-shard-0": "0x43bf77db5e784b263a459141bdcdf5cf6987936d",
      "energi": "0x9caa73156981600f4d276a10f80970a171abc1d1"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "keep3rv1",
    "filePath": "token:KP3R",
    "symbol": "kp3r",
    "name": "Keep3rV1",
    "marketCapRank": 788,
    "addresses": {
      "ethereum": "0x1ceb5cb57c4d4e2b2433641b95dd330a33185a44",
      "fantom": "0x2a5062d22adcfaafbd5c541d4da82e4b450d4212",
      "energi": "0x09f24e5e54db6705df1a1a71d2bd5eac0d692bea"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "kek",
    "filePath": "token:KEKE",
    "symbol": "keke",
    "name": "KEK",
    "marketCapRank": 2249,
    "addresses": {
      "ethereum": "0xf7168c8abb0ff80116413a8d95396bbdc318a3ff"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "ki",
    "filePath": "token:XKI",
    "symbol": "xki",
    "name": "KI",
    "marketCapRank": 1865,
    "addresses": {
      "cosmos": "ibc/B547DC9B897E7C3AA5B824696110B8E3D2C31E3ED3F02FF363DCBAD82457E07E"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "kiba-inu",
    "filePath": "token:KIBA",
    "symbol": "kiba",
    "name": "Kiba Inu",
    "marketCapRank": 2060,
    "addresses": {
      "ethereum": "0x005d1123878fc55fbd56b54c73963b234a64af3c",
      "binance-smart-chain": "0xc3afde95b6eb9ba8553cdaea6645d45fb3a7faf5"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "kiboshib",
    "filePath": "token:KIBSHI",
    "symbol": "kibshi",
    "name": "KiboShib",
    "marketCapRank": 1867,
    "addresses": {
      "ethereum": "0x02e7f808990638e9e67e1f00313037ede2362361"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "kick",
    "filePath": "token:KICK",
    "symbol": "kick",
    "name": "Kick",
    "marketCapRank": 2161,
    "addresses": {
      "binance-smart-chain": "0x824a50df33ac1b41afc52f4194e2e8356c17c3ac",
      "harmony-shard-0": "0xc63fd3e9c9527ccdf1d331bbadfe21e77e357b5e"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "kilt-protocol",
    "filePath": "token:KILT",
    "symbol": "kilt",
    "name": "KILT Protocol",
    "marketCapRank": 692,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "kin",
    "filePath": "token:KIN",
    "symbol": "kin",
    "name": "Kin",
    "marketCapRank": 645,
    "addresses": {
      "solana": "kinXdEcpDQeHPEuQnqmUgtYykqKGVFq6CeVX5iAHJq6"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "kine-protocol",
    "filePath": "token:KINE",
    "symbol": "kine",
    "name": "Kine Protocol",
    "marketCapRank": 1876,
    "addresses": {
      "ethereum": "0xcbfef8fdd706cde6f208460f2bf39aa9c785f05d"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "kinesis-gold",
    "filePath": "token:KAU",
    "symbol": "kau",
    "name": "Kinesis Gold",
    "marketCapRank": 531,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "kinesis-silver",
    "filePath": "token:KAG",
    "symbol": "kag",
    "name": "Kinesis Silver",
    "marketCapRank": 565,
    "addresses": {},
    "variants": [
      "mono"
    ]
  },
  {
    "id": "king-shiba",
    "filePath": "token:KINGSHIB",
    "symbol": "kingshib",
    "name": "King Shiba",
    "marketCapRank": 2334,
    "addresses": {
      "binance-smart-chain": "0x84f4f7cdb4574c9556a494dab18ffc1d1d22316c"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "kintsugi",
    "filePath": "token:KINT",
    "symbol": "kint",
    "name": "Kintsugi",
    "marketCapRank": 2186,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "kira-network",
    "filePath": "token:KEX",
    "symbol": "kex",
    "name": "KIRA Network",
    "marketCapRank": 1071,
    "addresses": {
      "ethereum": "0x16980b3b4a3f9d89e33311b5aa8f80303e5ca4f8",
      "binance-smart-chain": "0x8d11ec38a3eb5e956b052f67da8bdc9bef8abf3e"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "kishu-inu",
    "filePath": "token:KISHU",
    "symbol": "kishu",
    "name": "Kishu Inu",
    "marketCapRank": 1035,
    "addresses": {
      "ethereum": "0xa2b4c0af19cc16a6cfacce81f192b024d625817d"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "kitty-inu",
    "filePath": "token:KITTY",
    "symbol": "kitty",
    "name": "Kitty Inu",
    "marketCapRank": 1944,
    "addresses": {
      "ethereum": "0x61a35258107563f6b6f102ae25490901c8760b12"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "klay-token",
    "filePath": "token:KLAY",
    "symbol": "klay",
    "name": "Klaytn",
    "marketCapRank": 117,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "klaycity-orb",
    "filePath": "token:ORB",
    "symbol": "orb",
    "name": "Orbcity",
    "marketCapRank": 1432,
    "addresses": {
      "polygon-pos": "0x20c750c57c3bc5145af4b7a33d4fb66a8e79fe05",
      "ethereum": "0x3c917054e03485808137eb306eafa8da0ab695cd"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "kleekai",
    "filePath": "token:KLEE",
    "symbol": "klee",
    "name": "KleeKai",
    "marketCapRank": 2751,
    "addresses": {
      "ethereum": "0xa67e9f021b9d208f7e3365b2a155e3c55b27de71"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "kleros",
    "filePath": "token:PNK",
    "symbol": "pnk",
    "name": "Kleros",
    "marketCapRank": 1124,
    "addresses": {
      "ethereum": "0x93ed3fbe21207ec2e8f2d3c3de6e058cb73bc04d",
      "xdai": "0x37b60f4e9a31a64ccc0024dce7d0fd07eaa0f7b3"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "kleva",
    "filePath": "token:KLEVA",
    "symbol": "kleva",
    "name": "KLEVA",
    "marketCapRank": 1484,
    "addresses": {
      "klay-token": "0x5fff3a6c16c2208103f318f4713d4d90601a7313"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "klever",
    "filePath": "token:KLV",
    "symbol": "klv",
    "name": "Klever",
    "marketCapRank": 946,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "klima-dao",
    "filePath": "token:KLIMA",
    "symbol": "klima",
    "name": "KlimaDAO",
    "marketCapRank": 992,
    "addresses": {
      "polygon-pos": "0x4e78011ce80ee02d2c3e649fb657e45898257815"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "koinos",
    "filePath": "token:KOIN",
    "symbol": "koin",
    "name": "Koinos",
    "marketCapRank": 882,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "kommunitas",
    "filePath": "token:KOM",
    "symbol": "kom",
    "name": "Kommunitas",
    "marketCapRank": 1961,
    "addresses": {
      "polygon-pos": "0xc004e2318722ea2b15499d6375905d75ee5390b8",
      "arbitrum-one": "0xa58663faef461761e44066ea26c1fcddf2927b80",
      "binance-smart-chain": "0x471ea49dd8e60e697f4cac262b5fafcc307506e4"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "komodo",
    "filePath": "token:KMD",
    "symbol": "kmd",
    "name": "Komodo",
    "marketCapRank": 576,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "kompete",
    "filePath": "token:KOMPETE",
    "symbol": "kompete",
    "name": "KOMPETE",
    "marketCapRank": 1026,
    "addresses": {
      "ethereum": "0x1e0b2992079b620aa13a7c2e7c88d2e1e18e46e9",
      "base": "0x8f019931375454fe4ee353427eb94e2e0c9e0a8c"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "kondux-v2",
    "filePath": "token:KNDX",
    "symbol": "kndx",
    "name": "KONDUX",
    "marketCapRank": 660,
    "addresses": {
      "ethereum": "0x7ca5af5ba3472af6049f63c1abc324475d44efc1"
    },
    "variants": [
      "mono"
    ]
  },
  {
    "id": "kromatika",
    "filePath": "token:KROM",
    "symbol": "krom",
    "name": "Kromatika",
    "marketCapRank": 2096,
    "addresses": {
      "ethereum": "0x3af33bef05c2dcb3c7288b77fe1c8d2aeba4d789",
      "optimistic-ethereum": "0xf98dcd95217e15e05d8638da4c91125e59590b07",
      "arbitrum-one": "0x55ff62567f09906a85183b866df84bf599a4bf70",
      "polygon-pos": "0x14af1f2f02dccb1e43402339099a05a5e363b83c"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "kryll",
    "filePath": "token:KRL",
    "symbol": "krl",
    "name": "KRYLL",
    "marketCapRank": 903,
    "addresses": {
      "ethereum": "0x464ebe77c293e473b48cfe96ddcf88fcf7bfdac0"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "kryptomon",
    "filePath": "token:KMON",
    "symbol": "kmon",
    "name": "Kryptomon",
    "marketCapRank": 1343,
    "addresses": {
      "binance-smart-chain": "0xc732b6586a93b6b7cf5fed3470808bc74998224d",
      "ethereum": "0xc4170fd71eced3c80badca77f4e12e8aac1e3436"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "kryptonite",
    "filePath": "token:SEILOR",
    "symbol": "seilor",
    "name": "Kryptonite",
    "marketCapRank": 1224,
    "addresses": {
      "sei-network": "sei10knxlv9e54z0xcywdhtycc63uf970aefeec73ycqwd75ep9nu45sh66m6a",
      "binance-smart-chain": "0xe29142e14e52bdfbb8108076f66f49661f10ec10"
    },
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "ktx-finance",
    "filePath": "token:KTC",
    "symbol": "ktc",
    "name": "KTX.Finance",
    "marketCapRank": null,
    "addresses": {
      "mantle": "0x779f4e5fb773e17bc8e809f4ef1abb140861159a",
      "binance-smart-chain": "0x545356d4d69d8cd1213ee7e339867574738751ca"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "kucoin-shares",
    "filePath": "token:KCS",
    "symbol": "kcs",
    "name": "KuCoin",
    "marketCapRank": 110,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "kujira",
    "filePath": "token:KUJI",
    "symbol": "kuji",
    "name": "Kujira",
    "marketCapRank": 253,
    "addresses": {
      "osmosis": "ibc/BB6BCDB515050BAE97516111873CCD7BCF1FD0CCB723CC12F3C4F704D6C646CE",
      "optimistic-ethereum": "0x3a18dcc9745edcd1ef33ecb93b0b6eba5671e7ca",
      "ethereum": "0x96543ef8d2c75c26387c1a319ae69c0bee6f3fe7",
      "arbitrum-one": "0x3a18dcc9745edcd1ef33ecb93b0b6eba5671e7ca",
      "binance-smart-chain": "0x073690e6ce25be816e68f32dca3e11067c9fb5cc",
      "secret": "secret13hvh0rn0rcf5zr486yxlrucvwpzwqu2dsz6zu8"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "kuma-inu",
    "filePath": "token:KUMA",
    "symbol": "kuma",
    "name": "Kuma Inu",
    "marketCapRank": 2658,
    "addresses": {
      "ethereum": "0x48c276e8d03813224bb1e55f953adb6d02fd3e02"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "kunci-coin",
    "filePath": "token:KUNCI",
    "symbol": "kunci",
    "name": "Kunci Coin",
    "marketCapRank": 3927,
    "addresses": {
      "binance-smart-chain": "0x6cf271270662be1c4fc1b7bb7d7d7fc60cc19125"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "kusama",
    "filePath": "token:KSM",
    "symbol": "ksm",
    "name": "Kusama",
    "marketCapRank": 208,
    "addresses": {},
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "kwai",
    "filePath": "token:KWAI",
    "symbol": "kwai",
    "name": "KWAI",
    "marketCapRank": 1671,
    "addresses": {
      "binance-smart-chain": "0x235d650fc6d9eb7d4bac77e128265295a0054304"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "kwenta",
    "filePath": "token:KWENTA",
    "symbol": "kwenta",
    "name": "Kwenta",
    "marketCapRank": 676,
    "addresses": {
      "optimistic-ethereum": "0x920cf626a271321c151d027030d5d08af699456b"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "kyber-network-crystal",
    "filePath": "token:KNC",
    "symbol": "knc",
    "name": "Kyber Network Crystal",
    "marketCapRank": 408,
    "addresses": {
      "ethereum": "0xdefa4e8a7bcba345f687a2f1456f5edd9ce97202",
      "fantom": "0x1e1085efaa63edfe74aad7c05a28eae4ef917c3f",
      "linea": "0x3b2f62d42db19b30588648bf1c184865d4c3b1d6",
      "polygon-zkevm": "0x6a80a465409ce8d36c513129c0feea61bed579ba",
      "optimistic-ethereum": "0xa00e3a3511aac35ca78530c85007afcd31753819",
      "zksync": "0x6ee46cb7cd2f15ee1ec9534cf29a5b51c83283e6",
      "arbitrum-one": "0xe4dddfe67e7164b0fe14e218d80dc4c08edc01cb",
      "avalanche": "0x39fc9e94caeacb435842fadedecb783589f50f5f",
      "polygon-pos": "0x1c954e8fe737f99f68fa1ccda3e51ebdb291948c",
      "binance-smart-chain": "0xfe56d5892bdffc7bf58f2e84be1b2c32d21c308b"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "kyve-network",
    "filePath": "token:KYVE",
    "symbol": "kyve",
    "name": "KYVE Network",
    "marketCapRank": 702,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "l7dex",
    "filePath": "token:LSD",
    "symbol": "lsd",
    "name": "L7DEX",
    "marketCapRank": 291,
    "addresses": {
      "binance-smart-chain": "0xcd1b51b87a8a7137d6421ba5a976225187a26777"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "lambda",
    "filePath": "token:LAMB",
    "symbol": "lamb",
    "name": "Lambda",
    "marketCapRank": 1238,
    "addresses": {
      "ethereum": "0x8971f9fd7196e5cee2c1032b50f656855af7dd26"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "land-of-conquest-slg",
    "filePath": "token:SLG",
    "symbol": "slg",
    "name": "SLG.GAMES",
    "marketCapRank": 897,
    "addresses": {
      "ethereum": "0xfc0b60e0df5dc9d4b72d957ca2d251cee308019a"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "landshare",
    "filePath": "token:LAND",
    "symbol": "land",
    "name": "Landshare",
    "marketCapRank": 1205,
    "addresses": {
      "binance-smart-chain": "0xa73164db271931cf952cbaeff9e8f5817b42fa5c"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "latoken",
    "filePath": "token:LA",
    "symbol": "la",
    "name": "LA",
    "marketCapRank": 2263,
    "addresses": {
      "ethereum": "0xe50365f5d679cb98a1dd62d6f6e58e59321bcddf"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "lattice-token",
    "filePath": "token:LTX",
    "symbol": "ltx",
    "name": "Lattice",
    "marketCapRank": 1859,
    "addresses": {
      "ethereum": "0xa393473d64d2f9f026b60b6df7859a689715d092"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "launchpool",
    "filePath": "token:LPOOL",
    "symbol": "lpool",
    "name": "Launchpool",
    "marketCapRank": 2213,
    "addresses": {
      "ethereum": "0x6149c26cd2f7b5ccdb32029af817123f6e37df5b",
      "binance-smart-chain": "0xcfb24d3c3767364391340a2e6d99c64f1cbd7a3d"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "law-blocks",
    "filePath": "token:LBT",
    "symbol": "lbt",
    "name": "Law Blocks",
    "marketCapRank": 1679,
    "addresses": {
      "xdc-network": "xdc05940b2df33d6371201e7ae099ced4c363855dfe"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "lazio-fan-token",
    "filePath": "token:LAZIO",
    "symbol": "lazio",
    "name": "Lazio Fan Token",
    "marketCapRank": 1007,
    "addresses": {
      "binance-smart-chain": "0x77d547256a2cd95f32f67ae0313e450ac200648d"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "lcx",
    "filePath": "token:LCX",
    "symbol": "lcx",
    "name": "LCX",
    "marketCapRank": 293,
    "addresses": {
      "ethereum": "0x037a54aab062628c9bbae1fdb1583c195585fe41"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "league-of-kingdoms",
    "filePath": "token:LOKA",
    "symbol": "loka",
    "name": "League of Kingdoms",
    "marketCapRank": 782,
    "addresses": {
      "ethereum": "0x61e90a50137e1f645c9ef4a0d3a4f01477738406"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "leash",
    "filePath": "token:LEASH",
    "symbol": "leash",
    "name": "Doge Killer",
    "marketCapRank": 691,
    "addresses": {
      "ethereum": "0x27c70cd1946795b66be9d954418546998b546634"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "leeds-united-fan-token",
    "filePath": "token:LUFC",
    "symbol": "lufc",
    "name": "Leeds United Fan Token",
    "marketCapRank": 2237,
    "addresses": {
      "chiliz": "0xf67a8a4299f7ebf0c58dbfb38941d0867f300c30"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "leisuremeta",
    "filePath": "token:LM",
    "symbol": "lm",
    "name": "LeisureMeta",
    "marketCapRank": 1100,
    "addresses": {
      "ethereum": "0xc064f4f215b6a1e4e7f39bd8530c4de0fc43ee9d"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "leo-token",
    "filePath": "token:LEO",
    "symbol": "leo",
    "name": "LEO Token",
    "marketCapRank": 25,
    "addresses": {
      "ethereum": "0x2af5d2ad76741191d15dfe7bf6ac92d4bd912ca3",
      "sora": "0x009e199267a6a2c8ae075bb8d4c40ee8d05c1b769085ee59ce98e50c2b2d8756"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "leox",
    "filePath": "token:LEOX",
    "symbol": "leox",
    "name": "LEOX",
    "marketCapRank": 927,
    "addresses": {
      "ethereum": "0xa444ec96ee01bb219a44b285de47bf33c3447ad5"
    },
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "level",
    "filePath": "token:LVL",
    "symbol": "lvl",
    "name": "Level",
    "marketCapRank": 1886,
    "addresses": {
      "binance-smart-chain": "0xb64e280e9d1b5dbec4accedb2257a87b400db149",
      "arbitrum-one": "0xb64e280e9d1b5dbec4accedb2257a87b400db149"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "lever",
    "filePath": "token:LEVER",
    "symbol": "lever",
    "name": "LeverFi",
    "marketCapRank": 599,
    "addresses": {
      "ethereum": "0x4b5f49487ea7b3609b1ad05459be420548789f1f"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "leverj-gluon",
    "filePath": "token:L2",
    "symbol": "l2",
    "name": "Leverj Gluon",
    "marketCapRank": 2833,
    "addresses": {
      "ethereum": "0xbbff34e47e559ef680067a6b1c980639eeb64d24"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "lgcy-network",
    "filePath": "token:LGCY",
    "symbol": "lgcy",
    "name": "LGCY Network",
    "marketCapRank": 2132,
    "addresses": {
      "ethereum": "0xae697f994fc5ebc000f8e22ebffee04612f98a0d"
    },
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "libra-incentix",
    "filePath": "token:LIXX",
    "symbol": "lixx",
    "name": "Libra Incentix",
    "marketCapRank": 1050,
    "addresses": {
      "binance-smart-chain": "0x16530b5c105fcb7c50bc84a039a0a4ed806a5124"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "libre",
    "filePath": "token:LIBRE",
    "symbol": "libre",
    "name": "Libre",
    "marketCapRank": 2207,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "lido-dao",
    "filePath": "token:LDO",
    "symbol": "ldo",
    "name": "Lido DAO",
    "marketCapRank": 55,
    "addresses": {
      "ethereum": "0x5a98fcbea516cf06857215779fd812ca3bef1b32",
      "optimistic-ethereum": "0xfdb794692724153d1488ccdbe0c56c252596735f",
      "polygon-pos": "0xc3c7d422809852031b44ab29eec9f1eff2a58756",
      "arbitrum-one": "0x13ad51ed4f1b7e9dc168d8a00cb3f4ddd85efa60"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "lido-staked-sol",
    "filePath": "token:STSOL",
    "symbol": "stsol",
    "name": "Lido Staked SOL",
    "marketCapRank": 122,
    "addresses": {
      "solana": "7dHbWXmci3dT8UFYWYZweBLXgycu7Y3iL6trKn1Y7ARj"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "lif3",
    "filePath": "token:LIF3",
    "symbol": "lif3",
    "name": "LIF3 (OLD)",
    "marketCapRank": 857,
    "addresses": {
      "fantom": "0xbf60e7414ef09026733c1e7de72e7393888c64da",
      "tombchain": "0x4200000000000000000000000000000000000108"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "limewire-token",
    "filePath": "token:LMWR",
    "symbol": "lmwr",
    "name": "LimeWire",
    "marketCapRank": 602,
    "addresses": {
      "ethereum": "0x628a3b2e302c7e896acc432d2d0dd22b6cb9bc88",
      "binance-smart-chain": "0x307bc76e3d59ed73886a9cf9360a9286f6281ba7"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "linda-2",
    "filePath": "token:LINDA",
    "symbol": "linda",
    "name": "Linda",
    "marketCapRank": 2085,
    "addresses": {
      "linea": "0x82cc61354d78b846016b559e3ccd766fa7e793d5",
      "ethereum": "0x039d2e8f097331278bd6c1415d839310e0d5ece4",
      "binance-smart-chain": "0x039d2e8f097331278bd6c1415d839310e0d5ece4",
      "avalanche": "0x039d2e8f097331278bd6c1415d839310e0d5ece4",
      "polygon-pos": "0x039d2e8f097331278bd6c1415d839310e0d5ece4",
      "arbitrum-one": "0x039d2e8f097331278bd6c1415d839310e0d5ece4"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "linear",
    "filePath": "token:LINA",
    "symbol": "lina",
    "name": "Linear",
    "marketCapRank": 579,
    "addresses": {
      "ethereum": "0x3e9bc21c9b189c09df3ef1b824798658d5011937",
      "harmony-shard-0": "0x946c8286bd9b52b81f681903210e1a57872fdd85",
      "binance-smart-chain": "0x762539b45a1dcce3d36d080f74d1aed37844b878"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "lingose",
    "filePath": "token:LING",
    "symbol": "ling",
    "name": "Lingose",
    "marketCapRank": 1072,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "link",
    "filePath": "token:FNSA",
    "symbol": "fnsa",
    "name": "FINSCHIA",
    "marketCapRank": 286,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "linkeye",
    "filePath": "token:LET",
    "symbol": "let",
    "name": "Linkeye",
    "marketCapRank": 2586,
    "addresses": {
      "ethereum": "0xfa3118b34522580c35ae27f6cf52da1dbb756288"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "liquiddriver",
    "filePath": "token:LQDR",
    "symbol": "lqdr",
    "name": "LiquidDriver",
    "marketCapRank": 2033,
    "addresses": {
      "arbitrum-one": "0x816e21c33fa5f8440ebcdf6e01d39314541bea72",
      "fantom": "0x4b6b3d425f82248996d77ecc3f3df1e500aac1db",
      "kava": "0x332c72dd7e77070740f01d2d35851c461585d5d0",
      "polygon-pos": "0x0294d8eb7857d43feb1210db72456d41481f9ede",
      "binance-smart-chain": "0x4b6b3d425f82248996d77ecc3f3df1e500aac1db"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "liquity",
    "filePath": "token:LQTY",
    "symbol": "lqty",
    "name": "Liquity",
    "marketCapRank": 411,
    "addresses": {
      "ethereum": "0x6dea81c8171d0ba574754ef6f8b412f2ed88c54d",
      "arbitrum-one": "0xfb9e5d956d889d91a82737b9bfcdac1dce3e1449"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "liquity-usd",
    "filePath": "token:LUSD",
    "symbol": "lusd",
    "name": "Liquity USD",
    "marketCapRank": 467,
    "addresses": {
      "ethereum": "0x5f98805a4e8be255a32880fdec7f6728c6568ba0",
      "zksync": "0x503234f203fc7eb888eec8513210612a43cf6115",
      "optimistic-ethereum": "0xc40f949f8a4e094d1b49a23ea9241d289b7b2819",
      "arbitrum-one": "0x93b346b6bc2548da6a1e7d98e9a421b42541425b",
      "polygon-pos": "0x23001f892c0c82b79303edc9b9033cd190bb21c7"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "lisk",
    "filePath": "token:LSK",
    "symbol": "lsk",
    "name": "Lisk",
    "marketCapRank": 277,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "litecoin",
    "filePath": "token:LTC",
    "symbol": "ltc",
    "name": "Litecoin",
    "marketCapRank": 22,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "litecoin-cash",
    "filePath": "token:LCC",
    "symbol": "lcc",
    "name": "Litecoin Cash",
    "marketCapRank": 1871,
    "addresses": {},
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "litentry",
    "filePath": "token:LIT",
    "symbol": "lit",
    "name": "Litentry",
    "marketCapRank": 581,
    "addresses": {
      "ethereum": "0xb59490ab09a0f526cc7305822ac65f2ab12f9723"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "lithium-finance",
    "filePath": "token:LITH",
    "symbol": "lith",
    "name": "Lithium Finance",
    "marketCapRank": 1355,
    "addresses": {
      "ethereum": "0x188e817b02e635d482ae4d81e25dda98a97c4a42"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "litlab-games",
    "filePath": "token:LITT",
    "symbol": "litt",
    "name": "LitLab Games",
    "marketCapRank": 1316,
    "addresses": {
      "binance-smart-chain": "0xcebef3df1f3c5bfd90fde603e71f31a53b11944d"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "livepeer",
    "filePath": "token:LPT",
    "symbol": "lpt",
    "name": "Livepeer",
    "marketCapRank": 170,
    "addresses": {
      "ethereum": "0x58b6a8a3302369daec383334672404ee733ab239",
      "arbitrum-one": "0x289ba1701c2f088cf0faf8b3705246331cb8a839",
      "harmony-shard-0": "0xbd3e698b51d340cc53b0cc549b598c13e0172b7c"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "liza-2",
    "filePath": "token:LIZA",
    "symbol": "liza",
    "name": "LIZA",
    "marketCapRank": 1495,
    "addresses": {
      "ethereum": "0x8b227d72570d3ead66014bca8305cbef7f90d1ee"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "localcoinswap",
    "filePath": "token:LCS",
    "symbol": "lcs",
    "name": "LocalCoinSwap",
    "marketCapRank": 2050,
    "addresses": {
      "ethereum": "0xaa19961b6b858d9f18a115f25aa1d98abc1fdba8"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "lockchain",
    "filePath": "token:LOC",
    "symbol": "loc",
    "name": "LockTrip",
    "marketCapRank": 2036,
    "addresses": {
      "ethereum": "0x5e3346444010135322268a4630d2ed5f8d09446c",
      "hydra": "4ab26aaa1803daa638910d71075c06386e391147"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "lodestar",
    "filePath": "token:LODE",
    "symbol": "lode",
    "name": "Lodestar",
    "marketCapRank": 2176,
    "addresses": {
      "arbitrum-one": "0xf19547f9ed24aa66b03c3a552d181ae334fbb8db"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "loki-network",
    "filePath": "token:OXEN",
    "symbol": "oxen",
    "name": "Oxen",
    "marketCapRank": 1437,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "looksrare",
    "filePath": "token:LOOKS",
    "symbol": "looks",
    "name": "LooksRare",
    "marketCapRank": 440,
    "addresses": {
      "ethereum": "0xf4d2888d29d722226fafa5d9b24f9164c092421e"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "loom-network-new",
    "filePath": "token:LOOM",
    "symbol": "loom",
    "name": "Loom Network (NEW)",
    "marketCapRank": 427,
    "addresses": {
      "ethereum": "0x42476f744292107e34519f9c357927074ea3f75d",
      "energi": "0xb506a79b296b78965f0a5c15e1474b026c23d9fa"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "loopring",
    "filePath": "token:LRC",
    "symbol": "lrc",
    "name": "Loopring",
    "marketCapRank": 197,
    "addresses": {
      "ethereum": "0xbbbbca6a901c926f240b89eacb641d8aec7aeafd",
      "energi": "0x193da10f8a969d4c081b9097b15337b1488cbbec",
      "arbitrum-one": "0x46d0ce7de6247b0a95f67b43b589b4041bae7fbe"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "lords",
    "filePath": "token:LORDS",
    "symbol": "lords",
    "name": "LORDS",
    "marketCapRank": 1032,
    "addresses": {
      "ethereum": "0x686f2404e77ab0d9070a46cdfb0b7fecdd2318b0",
      "starknet": "0x0124aeb495b947201f5fac96fd1138e326ad86195b98df6dec9009158a533b49"
    },
    "variants": [
      "mono"
    ]
  },
  {
    "id": "lossless",
    "filePath": "token:LSS",
    "symbol": "lss",
    "name": "Lossless",
    "marketCapRank": 1227,
    "addresses": {
      "ethereum": "0x3b9be07d622accaed78f479bc0edabfd6397e320",
      "binance-smart-chain": "0xf7686f43591302cd9b4b9c4fe1291473fae7d9c9"
    },
    "variants": [
      "mono"
    ]
  },
  {
    "id": "loungem",
    "filePath": "token:LZM",
    "symbol": "lzm",
    "name": "LoungeM",
    "marketCapRank": 1920,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "lovely-inu-finance",
    "filePath": "token:LOVELY",
    "symbol": "lovely",
    "name": "Lovely Inu finance",
    "marketCapRank": 1533,
    "addresses": {
      "binance-smart-chain": "0x9e24415d1e549ebc626a13a482bb117a2b43e9cf"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "lto-network",
    "filePath": "token:LTO",
    "symbol": "lto",
    "name": "LTO Network",
    "marketCapRank": 487,
    "addresses": {
      "ethereum": "0xd01409314acb3b245cea9500ece3f6fd4d70ea30",
      "binance-smart-chain": "0x857b222fc79e1cbbf8ca5f78cb133d1b7cf34bbd"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "lua-token",
    "filePath": "token:LUA",
    "symbol": "lua",
    "name": "LuaSwap",
    "marketCapRank": 1528,
    "addresses": {
      "ethereum": "0xb1f66997a5760428d3a87d68b90bfe0ae64121cc",
      "tomochain": "0x7262fa193e9590b2e075c3c16170f3f2f32f5c74"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "luca",
    "filePath": "token:LUCA",
    "symbol": "luca",
    "name": "LUCA",
    "marketCapRank": 1702,
    "addresses": {
      "binance-smart-chain": "0x51e6ac1533032e72e92094867fd5921e3ea1bfa0"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "lucidao",
    "filePath": "token:LCD",
    "symbol": "lcd",
    "name": "Lucidao",
    "marketCapRank": 1660,
    "addresses": {
      "polygon-pos": "0xc2a45fe7d40bcac8369371b08419ddafd3131b4a"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "lucro",
    "filePath": "token:LCR",
    "symbol": "lcr",
    "name": "Lucro",
    "marketCapRank": 1784,
    "addresses": {
      "binance-smart-chain": "0x988f7c894e4001eeb7b570cde80dffe21cf7b6b9"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "lukso-token",
    "filePath": "token:LYXE",
    "symbol": "lyxe",
    "name": "LUKSO [OLD]",
    "marketCapRank": 628,
    "addresses": {
      "ethereum": "0xa8b919680258d369114910511cc87595aec0be6d",
      "harmony-shard-0": "0x8a8ca151562a68ed3732fd963ec4e0e713b39bb3"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "lukso-token-2",
    "filePath": "token:LYX",
    "symbol": "lyx",
    "name": "LUKSO",
    "marketCapRank": 439,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "luna-inu",
    "filePath": "token:LINU",
    "symbol": "linu",
    "name": "Luna Inu",
    "marketCapRank": 1441,
    "addresses": {
      "ethereum": "0x78132543d8e20d2417d8a07d9ae199d458a0d581"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "lunr-token",
    "filePath": "token:LUNR",
    "symbol": "lunr",
    "name": "LunarCrush",
    "marketCapRank": 1110,
    "addresses": {
      "zilliqa": "zil1xxl6yp2twxvljdnn87g9fk7wykdrcv66xdy4rc",
      "stacks": "SP3K8BC0PPEVCV7NZ6QSRWPQ2JE9E5B6N3PA0KBR9.token-slunr",
      "ethereum": "0xa87135285ae208e22068acdbff64b11ec73eaa5a",
      "polygon-pos": "0xbbfe0b60de96a189bf09079de86a2db7bf0c7883",
      "binance-smart-chain": "0x37807d4fbeb84124347b8899dd99616090d3e304"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "luxurious-pro-network-token",
    "filePath": "token:LPNT",
    "symbol": "lpnt",
    "name": "Luxurious Pro Network",
    "marketCapRank": 1657,
    "addresses": {
      "ethereum": "0x6a4c76874e686a7d080d173987a35a9c48905583"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "lybra-finance",
    "filePath": "token:LBR",
    "symbol": "lbr",
    "name": "Lybra",
    "marketCapRank": 1319,
    "addresses": {
      "ethereum": "0xed1167b6dc64e8a366db86f2e952a482d0981ebd",
      "arbitrum-one": "0xa23e44aea714fbbc08ef28340d78067b9a8cad73"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "lympo",
    "filePath": "token:LYM",
    "symbol": "lym",
    "name": "Lympo",
    "marketCapRank": 1942,
    "addresses": {
      "ethereum": "0xc690f7c7fcffa6a82b79fab7508c466fefdfc8c5"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "lyra-finance",
    "filePath": "token:LYRA",
    "symbol": "lyra",
    "name": "Lyra Finance",
    "marketCapRank": 544,
    "addresses": {
      "ethereum": "0x01ba67aac7f75f647d94220cc98fb30fcc5105bf",
      "optimistic-ethereum": "0x50c5725949a6f0c72e6c4a641f24049a917db0cb",
      "arbitrum-one": "0x079504b86d38119f859c4194765029f692b7b7aa"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "mad-meerkat-etf",
    "filePath": "token:METF",
    "symbol": "metf",
    "name": "Mad Meerkat ETF",
    "marketCapRank": 2282,
    "addresses": {
      "cronos": "0xb8df27c687c6af9afe845a2afad2d01e199f4878"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "mad-meerkat-optimizer",
    "filePath": "token:MMO",
    "symbol": "mmo",
    "name": "Mad Meerkat Optimizer",
    "marketCapRank": 2716,
    "addresses": {
      "cronos": "0x50c0c5bda591bc7e89a342a3ed672fb59b3c46a7"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "magic-internet-money",
    "filePath": "token:MIM",
    "symbol": "mim",
    "name": "Magic Internet Money",
    "marketCapRank": 723,
    "addresses": {
      "ethereum": "0x99d8a9c45b2eca8864373a26d1459e3dff1e17f3",
      "blast": "0x76da31d7c9cbeae102aff34d3398bc450c8374c1",
      "fantom": "0x82f0b8b456c1a451378467398982d4834b6829c1",
      "kava": "0x471EE749bAl270eb4c1165B5AD95E614947f6fCeb",
      "avalanche": "0x130966628846bfd36ff31a822705796e8cb8c18d",
      "optimistic-ethereum": "0xb153fb3d196a8eb25522705560ac152eeec57901",
      "linea": "0xdd3b8084af79b9bae3d1b668c0de08ccc2c9429a",
      "polygon-pos": "0x49a0400587a7f65072c87c4910449fdcc5c47242",
      "base": "0x4a3a6dd60a34bb2aba60d73b4c88315e9ceb6a3d",
      "moonriver": "0x0cae51e1032e8461f4806e26332c030e34de3adb",
      "arbitrum-one": "0xfea7a6a0b346362bf88a9e4a88416b77a57d6c2a",
      "binance-smart-chain": "0xfe19f0b51438fd612f6fd59c1dbb3ea319f433ba"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "magiccraft",
    "filePath": "token:MCRT",
    "symbol": "mcrt",
    "name": "MagicCraft",
    "marketCapRank": 1574,
    "addresses": {
      "binance-smart-chain": "0x4b8285ab433d8f69cb48d5ad62b415ed1a221e4f",
      "fantom": "0xe705af5f63fcabdcdf5016aa838eaaac35d12890",
      "ethereum": "0xde16ce60804a881e9f8c4ebb3824646edecd478d"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "magpie",
    "filePath": "token:MGP",
    "symbol": "mgp",
    "name": "Magpie",
    "marketCapRank": 925,
    "addresses": {
      "binance-smart-chain": "0xd06716e1ff2e492cc5034c2e81805562dd3b45fa",
      "arbitrum-one": "0xa61f74247455a40b01b0559ff6274441fafa22a3"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "mahadao",
    "filePath": "token:MAHA",
    "symbol": "maha",
    "name": "MahaDAO",
    "marketCapRank": 1627,
    "addresses": {
      "ethereum": "0x745407c86df8db893011912d3ab28e68b62e49b0",
      "polygon-pos": "0xeb99748e91afca94a6289db3b02e7ef4a8f0a22d",
      "arbitrum-one": "0xedd6ca8a4202d4a36611e2fff109648c4863ae19"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "maiar-dex",
    "filePath": "token:MEX",
    "symbol": "mex",
    "name": "xExchange",
    "marketCapRank": 1008,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "maidsafecoin",
    "filePath": "token:EMAID",
    "symbol": "emaid",
    "name": "MaidSafeCoin",
    "marketCapRank": 1273,
    "addresses": {
      "ethereum": "0x329c6e459ffa7475718838145e5e85802db2a303"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "mainframe",
    "filePath": "token:MFT",
    "symbol": "mft",
    "name": "Mainframe",
    "marketCapRank": 526,
    "addresses": {
      "ethereum": "0xdf2c7238198ad8b389666574f2d8bc411a4b7428",
      "energi": "0x9594e7431144e80178b1bc6849edcba7d2d5bb27"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "maker",
    "filePath": "token:MKR",
    "symbol": "mkr",
    "name": "Maker",
    "marketCapRank": 42,
    "addresses": {
      "ethereum": "0x9f8f72aa9304c8b593d555f12ef6589cc3a579a2",
      "avalanche": "0x88128fd4b259552a9a1d457f435a6527aab72d42",
      "polygon-pos": "0x6f7c932e7684666c9fd1d44527765433e01ff61d",
      "energi": "0x050317d93f29d1ba5ff3eac3b8157fd4e345588d",
      "sora": "0x00ec184ef0b4bd955db05eea5a8489ae72888ab6e63682a15beca1cd39344c8f"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "mancium",
    "filePath": "token:MANC",
    "symbol": "manc",
    "name": "Mancium",
    "marketCapRank": 1520,
    "addresses": {
      "ethereum": "0xe0c05ec44775e4ad62cdc2eecdf337aa7a143363"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "mango-markets",
    "filePath": "token:MNGO",
    "symbol": "mngo",
    "name": "Mango",
    "marketCapRank": 1066,
    "addresses": {
      "solana": "MangoCzJ36AjZyKwVj3VnYU4GTonjfVEnJmvvWaxLac",
      "neon-evm": "0x6d12eaa69f8e4902d3f83d546b31f7318717014c"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "mangoman-intelligent",
    "filePath": "token:MMIT",
    "symbol": "mmit",
    "name": "MangoMan Intelligent",
    "marketCapRank": 1443,
    "addresses": {
      "binance-smart-chain": "0x9767c8e438aa18f550208e6d1fdf5f43541cc2c8"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "manifold-finance",
    "filePath": "token:FOLD",
    "symbol": "fold",
    "name": "Manifold Finance",
    "marketCapRank": 836,
    "addresses": {
      "ethereum": "0xd084944d3c05cd115c09d072b9f44ba3e0e45921"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "mantle",
    "filePath": "token:MNT",
    "symbol": "mnt",
    "name": "Mantle",
    "marketCapRank": 35,
    "addresses": {
      "ethereum": "0x3c3a81e81dc49a522a592e7622a7e711c06bf354",
      "mantle": "0xdeaddeaddeaddeaddeaddeaddeaddeaddead0000"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "mantra-dao",
    "filePath": "token:OM",
    "symbol": "om",
    "name": "MANTRA",
    "marketCapRank": 175,
    "addresses": {
      "ethereum": "0x3593d125a4f7849a1b059e64f4517a86dd60c95d",
      "polygon-pos": "0xc3ec80343d2bae2f8e680fdadde7c17e71e114ea",
      "binance-smart-chain": "0xf78d2e7936f5fe18308a3b2951a93b6c4a41f5e2"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "maple",
    "filePath": "token:MPL",
    "symbol": "mpl",
    "name": "Maple",
    "marketCapRank": 386,
    "addresses": {
      "ethereum": "0x33349b282065b0284d756f0577fb39c158f935e6"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "maps",
    "filePath": "token:MAPS",
    "symbol": "maps",
    "name": "MAPS",
    "marketCapRank": 2216,
    "addresses": {
      "solana": "MAPS41MDahZ9QdKXhVa4dWB9RuyfV4XqhyAZ8XcYepb",
      "energi": "0x0702bf2abbb53f8feb101a71199965b891dbae97"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "marblex",
    "filePath": "token:MBX",
    "symbol": "mbx",
    "name": "Marblex",
    "marketCapRank": 393,
    "addresses": {
      "binance-smart-chain": "0xf95a5532d67c944dfa7eddd2f8c358fe0dc7fac2",
      "klay-token": "0xd068c52d81f4409b9502da926ace3301cc41f623",
      "aptos": "0x665d06fcd9c94430099f82973f2a5e5f13142e42fa172e72ce14f51a64bd8ad9::coin_mbx::MBX"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "marcopolo",
    "filePath": "token:MAP",
    "symbol": "map",
    "name": "MAP Protocol",
    "marketCapRank": 593,
    "addresses": {
      "ethereum": "0x9e976f211daea0d652912ab99b0dc21a7fd728e4"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "marinade",
    "filePath": "token:MNDE",
    "symbol": "mnde",
    "name": "Marinade",
    "marketCapRank": 597,
    "addresses": {
      "solana": "MNDEFzGvMt87ueuHvVU9VcTqsAP5b3fTGPsHuuPA5ey"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "market-making-pro",
    "filePath": "token:MMPRO",
    "symbol": "mmpro",
    "name": "Market Making Pro",
    "marketCapRank": 1568,
    "addresses": {
      "binance-smart-chain": "0x6067490d05f3cf2fdffc0e353b1f5fd6e5ccdf70"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "marlin",
    "filePath": "token:POND",
    "symbol": "pond",
    "name": "Marlin",
    "marketCapRank": 284,
    "addresses": {
      "ethereum": "0x57b946008913b82e4df85f501cbaed910e58d26c",
      "arbitrum-one": "0xda0a57b710768ae17941a9fa33f8b720c8bd9ddd"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "mars4",
    "filePath": "token:MARS4",
    "symbol": "mars4",
    "name": "MARS4",
    "marketCapRank": 1672,
    "addresses": {
      "ethereum": "0x16cda4028e9e872a38acb903176719299beaed87",
      "binance-smart-chain": "0x9cd9c5a44cb8fab39b2ee3556f5c439e65e4fddd"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "marsdao",
    "filePath": "token:MDAO",
    "symbol": "mdao",
    "name": "MarsDAO",
    "marketCapRank": 1302,
    "addresses": {
      "binance-smart-chain": "0x60322971a672b81bcce5947706d22c19daecf6fb"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "mask-network",
    "filePath": "token:MASK",
    "symbol": "mask",
    "name": "Mask Network",
    "marketCapRank": 180,
    "addresses": {
      "ethereum": "0x69af81e73a73b40adf4f3d4223cd9b1ece623074",
      "energi": "0x746514e2c7d91e1e84c20c54d1f6f537b28a7d8e",
      "polygon-pos": "0x2b9e7ccdf0f4e5b24757c1e1a80e311e34cb10c7",
      "binance-smart-chain": "0x2ed9a5c8c13b93955103b9a7c167b67ef4d568a3"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "masq",
    "filePath": "token:MASQ",
    "symbol": "masq",
    "name": "MASQ",
    "marketCapRank": 1514,
    "addresses": {
      "ethereum": "0x06f3c323f0238c72bf35011071f2b5b7f43a054c",
      "polygon-pos": "0xee9a352f6aac4af1a5b9f467f6a93e0ffbe9dd35",
      "tomochain": "0xea478716a70dc086707e23de17965acb5c7b7840"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "mass-vehicle-ledger",
    "filePath": "token:MVL",
    "symbol": "mvl",
    "name": "MVL",
    "marketCapRank": 367,
    "addresses": {
      "ethereum": "0xa849eaae994fb86afa73382e9bd88c2b6b18dc71",
      "binance-smart-chain": "0x5f588efaf8eb57e3837486e834fc5a4e07768d98"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "materium",
    "filePath": "token:MTRM",
    "symbol": "mtrm",
    "name": "Materium",
    "marketCapRank": 2088,
    "addresses": {
      "ethereum": "0xcd17fa52528f37facb3028688e62ec82d9417581"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "math",
    "filePath": "token:MATH",
    "symbol": "math",
    "name": "MATH",
    "marketCapRank": 915,
    "addresses": {
      "ethereum": "0x08d967bb0134f2d07f7cfb6e246680c53927dd30",
      "arbitrum-one": "0x99f40b01ba9c469193b360f72740e416b17ac332",
      "binance-smart-chain": "0xf218184af829cf2b0019f8e6f0b2423498a36983"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "matic-network",
    "filePath": "token:MATIC",
    "symbol": "matic",
    "name": "Polygon",
    "marketCapRank": 20,
    "addresses": {
      "ethereum": "0x7d1afa7b718fb893db30a3abc0cfc608aacfebb0",
      "sora": "0x009134d5c7b7fda8863985531f456f89bef5fbd76684a8acdb737b3e451d0877",
      "energi": "0x98997e1651919faeacee7b96afbb3dfd96cb6036",
      "polygon-pos": "0x0000000000000000000000000000000000001010",
      "harmony-shard-0": "0x301259f392b551ca8c592c9f676fcd2f9a0a84c5",
      "moonriver": "0x682f81e57eaa716504090c3ecba8595fb54561d8",
      "moonbeam": "0x3405a1bd46b85c5c029483fbecf2f3e611026e45",
      "binance-smart-chain": "0xcc42724c6683b7e57334c4e856f4c9965ed682bd"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "matrix-ai-network",
    "filePath": "token:MAN",
    "symbol": "man",
    "name": "Matrix AI Network",
    "marketCapRank": 1126,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "maverick-protocol",
    "filePath": "token:MAV",
    "symbol": "mav",
    "name": "Maverick Protocol",
    "marketCapRank": 390,
    "addresses": {
      "ethereum": "0x7448c7456a97769f6cd04f1e83a4a23ccdc46abd",
      "zksync": "0x787c09494ec8bcb24dcaf8659e7d5d69979ee508",
      "binance-smart-chain": "0xd691d9a68c887bdf34da8c36f63487333acfd103"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "maxity",
    "filePath": "token:MAX",
    "symbol": "max",
    "name": "Maxity",
    "marketCapRank": 1764,
    "addresses": {
      "ethereum": "0x63f7b1b538a78cb699e5399621b3d2e047c40de4"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "mbd-financials",
    "filePath": "token:MBD",
    "symbol": "mbd",
    "name": "MBD Financials",
    "marketCapRank": 1727,
    "addresses": {
      "binance-smart-chain": "0xf899e83e6c6df1a0d4887cf0209193aa97236322"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "mcdex",
    "filePath": "token:MCB",
    "symbol": "mcb",
    "name": "MUX Protocol",
    "marketCapRank": 809,
    "addresses": {
      "ethereum": "0x4e352cf164e64adcbad318c3a1e222e9eba4ce42",
      "arbitrum-one": "0x4e352cf164e64adcbad318c3a1e222e9eba4ce42",
      "binance-smart-chain": "0x5fe80d2cd054645b9419657d3d10d26391780a7b"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "mch-coin",
    "filePath": "token:MCHC",
    "symbol": "mchc",
    "name": "MCH Coin",
    "marketCapRank": 2065,
    "addresses": {
      "ethereum": "0xd69f306549e9d96f183b1aeca30b8f4353c2ecc3",
      "polygon-pos": "0xee7666aacaefaa6efeef62ea40176d3eb21953b9"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "mcontent",
    "filePath": "token:MCONTENT",
    "symbol": "mcontent",
    "name": "MContent",
    "marketCapRank": 1662,
    "addresses": {
      "binance-smart-chain": "0x799e1cf88a236e42b4a87c544a22a94ae95a6910",
      "ethereum": "0xd3c51de3e6dd9b53d7f37699afb3ee3bf9b9b3f4"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "mcpepe-s",
    "filePath": "token:PEPES",
    "symbol": "pepes",
    "name": "McPepe's",
    "marketCapRank": 2582,
    "addresses": {
      "ethereum": "0x6bf765c43030387a983f429c1438e9d2025b7e12"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "mdex",
    "filePath": "token:MDX",
    "symbol": "mdx",
    "name": "Mdex (HECO)",
    "marketCapRank": 753,
    "addresses": {
      "huobi-token": "0x25d2e80cb6b86881fd7e07dd263fb79f4abe033c"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "meanfi",
    "filePath": "token:MEAN",
    "symbol": "mean",
    "name": "Mean DAO",
    "marketCapRank": 1685,
    "addresses": {
      "solana": "MEANeD3XDdUmNMsRGjASkSWdC8prLYsoRJ61pPeHctD",
      "ethereum": "0x9b25889c493ae6df34ceef1ecb10d77c1ba73318",
      "polygon-pos": "0x4867b60ad7c6adc98653f661f1aea31740986ba5",
      "binance-smart-chain": "0x6c9297be2e3ce9c10c480a25b7157a43fd992942"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "measurable-data-token",
    "filePath": "token:MDT",
    "symbol": "mdt",
    "name": "Measurable Data",
    "marketCapRank": 656,
    "addresses": {
      "ethereum": "0x814e0908b12a99fecf5bc101bb5d0b8b5cdf7d26"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "media-network",
    "filePath": "token:MEDIA",
    "symbol": "media",
    "name": "Media Network",
    "marketCapRank": 1771,
    "addresses": {
      "solana": "ETAtLmCmsoiEEKfNrHKJ2kYy3MoABhU6NQvpSfij5tDs",
      "ethereum": "0xdb726152680ece3c9291f1016f1d36f3995f6941",
      "base": "0x6e51b3a19f114013e5dc09d0477a536c7e4e0207"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "medibloc",
    "filePath": "token:MED",
    "symbol": "med",
    "name": "Medibloc",
    "marketCapRank": 427,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "medicinal-pork",
    "filePath": "token:MORK",
    "symbol": "mork",
    "name": "Medicinal Pork",
    "marketCapRank": null,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "meeds-dao",
    "filePath": "token:MEED",
    "symbol": "meed",
    "name": "Meeds DAO",
    "marketCapRank": 1934,
    "addresses": {
      "ethereum": "0x8503a7b00b4b52692cc6c14e5b96f142e30547b7",
      "polygon-pos": "0x6aca77cf3bab0c4e8210a09b57b07854a995289a"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "meld-2",
    "filePath": "token:MELD",
    "symbol": "meld",
    "name": "MELD",
    "marketCapRank": 590,
    "addresses": {
      "cardano": "a2944573e99d2ed3055b808eaa264f0bf119e01fc6b18863067c63e44d454c44",
      "avalanche": "0x333000333b26ee30214b4af6419d9ab07a450400",
      "ethereum": "0x333000333b26ee30214b4af6419d9ab07a450400"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "melon",
    "filePath": "token:MLN",
    "symbol": "mln",
    "name": "Enzyme",
    "marketCapRank": 914,
    "addresses": {
      "ethereum": "0xec67005c4e498ec7f55e092bd1d35cbc47c91892",
      "polygon-pos": "0xa9f37d84c856fda3812ad0519dad44fa0a3fe207"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "meme-ai-coin",
    "filePath": "token:MEMEAI",
    "symbol": "memeai",
    "name": "Meme AI Coin",
    "marketCapRank": 1774,
    "addresses": {
      "ethereum": "0x695d38eb4e57e0f137e36df7c1f0f2635981246b"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "memecoin",
    "filePath": "token:MEME",
    "symbol": "meme",
    "name": "Memecoin",
    "marketCapRank": 169,
    "addresses": {
      "ethereum": "0xb131f4a55907b10d1f0a50d8ab8fa09ec342cd74"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "meridian-mst",
    "filePath": "token:MST",
    "symbol": "mst",
    "name": "Meridian MST",
    "marketCapRank": 2663,
    "addresses": {
      "base": "0x2f3b1a07e3efb1fcc64bd09b86bd0fa885d93552"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "merit-circle",
    "filePath": "token:MC",
    "symbol": "mc",
    "name": "Merit Circle",
    "marketCapRank": 550,
    "addresses": {
      "ethereum": "0x949d48eca67b17269629c7194f4b727d4ef9e5d6",
      "binance-smart-chain": "0x949d48eca67b17269629c7194f4b727d4ef9e5d6"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "messier",
    "filePath": "token:M87",
    "symbol": "m87",
    "name": "MESSIER",
    "marketCapRank": 1724,
    "addresses": {
      "ethereum": "0x80122c6a83c8202ea365233363d3f4837d13e888"
    },
    "variants": [
      "mono"
    ]
  },
  {
    "id": "meta",
    "filePath": "token:MTA",
    "symbol": "mta",
    "name": "mStable Governance: Meta",
    "marketCapRank": 2478,
    "addresses": {
      "ethereum": "0xa3bed4e1c75d00fa6f4e5e6922db7261b5e9acd2",
      "optimistic-ethereum": "0x929b939f8524c3be977af57a4a0ad3fb1e374b50",
      "polygon-pos": "0xf501dd45a1198c2e1b5aef5314a68b9006d842e0"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "meta-apes-peel",
    "filePath": "token:PEEL",
    "symbol": "peel",
    "name": "Meta Apes PEEL",
    "marketCapRank": 1868,
    "addresses": {
      "binance-smart-chain": "0x734548a9e43d2d564600b1b2ed5be9c2b911c6ab"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "metacade",
    "filePath": "token:MCADE",
    "symbol": "mcade",
    "name": "Metacade",
    "marketCapRank": 873,
    "addresses": {
      "ethereum": "0xed328e9c1179a30ddc1e7595e036aed8760c22af"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "metadium",
    "filePath": "token:META",
    "symbol": "meta",
    "name": "Metadium",
    "marketCapRank": 562,
    "addresses": {
      "ethereum": "0xde2f7766c8bf14ca67193128535e5c7454f8387c"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "metafighter",
    "filePath": "token:MF",
    "symbol": "mf",
    "name": "MetaFighter",
    "marketCapRank": 2479,
    "addresses": {
      "binance-smart-chain": "0xbb6cdedac5cab4a420211a4a8e8b5dca879b31de"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "metahero",
    "filePath": "token:HERO",
    "symbol": "hero",
    "name": "Metahero",
    "marketCapRank": 831,
    "addresses": {
      "binance-smart-chain": "0xd40bedb44c081d2935eeba6ef5a3c8a31a1bbe13"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "metal",
    "filePath": "token:MTL",
    "symbol": "mtl",
    "name": "Metal DAO",
    "marketCapRank": 425,
    "addresses": {
      "ethereum": "0xf433089366899d83a9f26a773d59ec7ecf30355e",
      "energi": "0xd2d28530a79634423154c1fd5bdb7c1b0216cd1a"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "metaplex",
    "filePath": "token:MPLX",
    "symbol": "mplx",
    "name": "Metaplex",
    "marketCapRank": 473,
    "addresses": {
      "solana": "METAewgxyPbgwsseH8T16a39CQ5VyVxZi9zXiDPY18m"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "metars-genesis",
    "filePath": "token:MRS",
    "symbol": "mrs",
    "name": "Metars Genesis",
    "marketCapRank": 417,
    "addresses": {
      "binance-smart-chain": "0x238d02ee3f80fbf5e381f049616025c186889b68"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "metastrike",
    "filePath": "token:MTS",
    "symbol": "mts",
    "name": "Metastrike",
    "marketCapRank": 2036,
    "addresses": {
      "binance-smart-chain": "0x496cc0b4ee12aa2ac4c42e93067484e7ff50294b"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "metavault-dao",
    "filePath": "token:MVD",
    "symbol": "mvd",
    "name": "Metavault DAO",
    "marketCapRank": 2603,
    "addresses": {
      "ethereum": "0x788b6d2b37aa51d916f2837ae25b05f0e61339d1",
      "arbitrum-one": "0x15a808ed3846d25e88ae868de79f1bcb1ac382b5"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "metavault-trade",
    "filePath": "token:MVX",
    "symbol": "mvx",
    "name": "Metavault Trade",
    "marketCapRank": 1898,
    "addresses": {
      "polygon-pos": "0x2760e46d9bb43dafcbecaad1f64b93207f9f0ed7",
      "linea": "0x0018d96c579121a94307249d47f053e2d687b5e7",
      "scroll": "0x0018d96c579121a94307249d47f053e2d687b5e7",
      "zksync": "0xc8ac6191cdc9c7bf846ad6b52aaaa7a0757ee305"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "metaverse-etp",
    "filePath": "token:ETP",
    "symbol": "etp",
    "name": "Metaverse ETP",
    "marketCapRank": 2358,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "metaverse-index",
    "filePath": "token:MVI",
    "symbol": "mvi",
    "name": "Metaverse Index",
    "marketCapRank": 1587,
    "addresses": {
      "ethereum": "0x72e364f2abdc788b7e918bc238b21f109cd634d7",
      "polygon-pos": "0xfe712251173a2cd5f5be2b46bb528328ea3565e1"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "metaverse-network-pioneer",
    "filePath": "token:NEER",
    "symbol": "neer",
    "name": "MNet Pioneer",
    "marketCapRank": 1872,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "metaverser",
    "filePath": "token:MTVT",
    "symbol": "mtvt",
    "name": "Metaverser",
    "marketCapRank": 2435,
    "addresses": {
      "binance-smart-chain": "0xb92c5e0135a510a4a3a8803f143d2cb085bbaf73"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "metavpad",
    "filePath": "token:METAV",
    "symbol": "metav",
    "name": "MetaVPad",
    "marketCapRank": 2381,
    "addresses": {
      "binance-smart-chain": "0x62858686119135cc00c4a3102b436a0eb314d402"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "meter",
    "filePath": "token:MTRG",
    "symbol": "mtrg",
    "name": "Meter Governance",
    "marketCapRank": 626,
    "addresses": {
      "meter": "0x228ebbee999c6a7ad74a6130e81b12f9fe237ba3",
      "binance-smart-chain": "0xbd2949f67dcdc549c6ebe98696449fa79d988a9f",
      "theta": "0xbd2949f67dcdc549c6ebe98696449fa79d988a9f"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "metfi-2",
    "filePath": "token:METFI",
    "symbol": "metfi",
    "name": "MetFi",
    "marketCapRank": 1875,
    "addresses": {
      "binance-smart-chain": "0x3e7f1039896454b9cb27c53cc7383e1ab9d9512a"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "metis-token",
    "filePath": "token:METIS",
    "symbol": "metis",
    "name": "Metis",
    "marketCapRank": 186,
    "addresses": {
      "ethereum": "0x9e32b13ce7f2e80a01932b42553652e053d6ed8e",
      "metis-andromeda": "0xdeaddeaddeaddeaddeaddeaddeaddeaddead0000"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "metronome",
    "filePath": "token:MET",
    "symbol": "met",
    "name": "Metronome",
    "marketCapRank": 1553,
    "addresses": {
      "ethereum": "0x2ebd53d035150f328bd754d6dc66b99b0edb89aa"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "mettalex",
    "filePath": "token:MTLX",
    "symbol": "mtlx",
    "name": "Mettalex",
    "marketCapRank": 1191,
    "addresses": {
      "ethereum": "0x2e1e15c44ffe4df6a0cb7371cd00d5028e571d14",
      "binance-smart-chain": "0x5921dee8556c4593eefcfad3ca5e2f618606483b"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "microvisionchain",
    "filePath": "token:SPACE",
    "symbol": "space",
    "name": "MicrovisionChain",
    "marketCapRank": 736,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "milady-meme-coin",
    "filePath": "token:LADYS",
    "symbol": "ladys",
    "name": "Milady Meme Coin",
    "marketCapRank": 315,
    "addresses": {
      "ethereum": "0x12970e6868f88f6557b76120662c1b3e50a646bf",
      "arbitrum-one": "0x3b60ff35d3f7f62d636b067dd0dc0dfdad670e4e"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "milk-alliance",
    "filePath": "token:MLK",
    "symbol": "mlk",
    "name": "MiL.k Alliance",
    "marketCapRank": 430,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "million",
    "filePath": "token:MM",
    "symbol": "mm",
    "name": "Million",
    "marketCapRank": 2347,
    "addresses": {
      "ethereum": "0x6b4c7a5e3f0b99fcd83e9c089bddd6c7fce5c611",
      "binance-smart-chain": "0xbf05279f9bf1ce69bbfed670813b7e431142afa4",
      "tomochain": "0x0f320856fa4bc7e4030a6ab989d494c5e4d58308"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "mimatic",
    "filePath": "token:MIMATIC",
    "symbol": "mimatic",
    "name": "MAI",
    "marketCapRank": 1122,
    "addresses": {
      "polygon-pos": "0xa3fa99a148fa48d14ed51d610c367c61876997f1",
      "moonriver": "0x7f5a79576620c046a293f54ffcdbd8f2468174f1",
      "xdai": "0x3f56e0c36d275367b8c502090edf38289b3dea0d",
      "iotex": "0x3f56e0c36d275367b8c502090edf38289b3dea0d",
      "cronos": "0x2ae35c8e3d4bd57e8898ff7cd2bbff87166ef8cb",
      "metis-andromeda": "0xdfa46478f9e5ea86d57387849598dbfb2e964b02",
      "aurora": "0xdfa46478f9e5ea86d57387849598dbfb2e964b02",
      "harmony-shard-0": "0x3f56e0c36d275367b8c502090edf38289b3dea0d",
      "boba": "0x3f56e0c36d275367b8c502090edf38289b3dea0d",
      "moonbeam": "0xdfa46478f9e5ea86d57387849598dbfb2e964b02",
      "milkomeda-cardano": "0xb9c8f0d3254007ee4b98970b94544e473cd610ec",
      "syscoin": "0x2611fa1cae2a3e20ed47fb1b293437c14f41b00f",
      "klay-token": "0x3f56e0c36d275367b8c502090edf38289b3dea0d",
      "celo": "0xb9c8f0d3254007ee4b98970b94544e473cd610ec",
      "solana": "9mWRABuz2x6koTPCWiCPM49WUbcrNqGTHBV9T9k7y1o7"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "mimblewimblecoin",
    "filePath": "token:MWC",
    "symbol": "mwc",
    "name": "MimbleWimbleCoin",
    "marketCapRank": 462,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "mimo-parallel-governance-token",
    "filePath": "token:MIMO",
    "symbol": "mimo",
    "name": "Mimo Governance",
    "marketCapRank": 1672,
    "addresses": {
      "ethereum": "0x90b831fa3bebf58e9744a14d638e25b4ee06f9bc",
      "fantom": "0x1d1764f04de29da6b90ffbef372d1a45596c4855",
      "polygon-pos": "0xadac33f543267c4d59a8c299cf804c303bc3e4ac"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "mina-protocol",
    "filePath": "token:MINA",
    "symbol": "mina",
    "name": "Mina Protocol",
    "marketCapRank": 90,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "minativerse",
    "filePath": "token:MNTC",
    "symbol": "mntc",
    "name": "MINATIVERSE",
    "marketCapRank": 1601,
    "addresses": {
      "binance-smart-chain": "0xe4e11e02aa14c7f24db749421986eaec1369e8c9"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "mind-language",
    "filePath": "token:MND",
    "symbol": "mnd",
    "name": "Mind",
    "marketCapRank": 1472,
    "addresses": {
      "ethereum": "0xa0dd6dd7775e93eb842db0aa142c9c581031ed3b"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "mineable",
    "filePath": "token:MNB",
    "symbol": "mnb",
    "name": "Mineable",
    "marketCapRank": 3384,
    "addresses": {
      "ethereum": "0x42b91f1d05afea671a2da3c780eda2abf0a2a366"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "mineral",
    "filePath": "token:MNR",
    "symbol": "mnr",
    "name": "Mineral",
    "marketCapRank": 2078,
    "addresses": {
      "klay-token": "0x27dcd181459bcddc63c37bab1e404a313c0dfd79"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "minswap",
    "filePath": "token:MIN",
    "symbol": "min",
    "name": "Minswap",
    "marketCapRank": 828,
    "addresses": {
      "cardano": "29d222ce763455e3d7a09a665ce554f00ac89d2e99a1a83d267170c6"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "minted",
    "filePath": "token:MTD",
    "symbol": "mtd",
    "name": "Minted",
    "marketCapRank": 1475,
    "addresses": {
      "cronos": "0x0224010ba2d567ffa014222ed960d1fa43b8c8e1",
      "ethereum": "0x809e130e10e787139c54e1d12d3d1971b7a675bf"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "mintlayer",
    "filePath": "token:ML",
    "symbol": "ml",
    "name": "Mintlayer",
    "marketCapRank": 839,
    "addresses": {
      "ethereum": "0x059956483753947536204e89bfad909e1a434cc6"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "minto",
    "filePath": "token:BTCMT",
    "symbol": "btcmt",
    "name": "Minto",
    "marketCapRank": 1888,
    "addresses": {
      "huobi-token": "0x410a56541bd912f9b60943fcb344f1e3d6f09567",
      "binance-smart-chain": "0x410a56541bd912f9b60943fcb344f1e3d6f09567"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "minu",
    "filePath": "token:MINU",
    "symbol": "minu",
    "name": "Minu",
    "marketCapRank": 2024,
    "addresses": {
      "binance-smart-chain": "0xf48f91df403976060cc05dbbf8a0901b09fdefd4"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "mirror-protocol",
    "filePath": "token:MIR",
    "symbol": "mir",
    "name": "Mirror Protocol",
    "marketCapRank": 1424,
    "addresses": {
      "ethereum": "0x09a3ecafa817268f77be1283176b946c4ff2e608",
      "energi": "0x7e58cef7c589e0e1771b9c049cba313fdec31976",
      "binance-smart-chain": "0x5b6dcf557e2abe2323c48445e8cc948910d8c2c9",
      "terra": "terra15gwkyepfc6xgca5t5zefzwy42uts8l2m4g40k6"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "mixmarvel",
    "filePath": "token:MIX",
    "symbol": "mix",
    "name": "MixMarvel",
    "marketCapRank": 1052,
    "addresses": {
      "ethereum": "0x5d285f735998f36631f678ff41fb56a10a4d0429",
      "binance-smart-chain": "0xcf1b55d79e824da0ae0652f96c66fe33263d743f"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "mixmob",
    "filePath": "token:MXM",
    "symbol": "mxm",
    "name": "MixMob",
    "marketCapRank": 1458,
    "addresses": {
      "solana": "H53UGEyBrB9easo9ego8yYk7o4Zq1G5cCtkxD3E3hZav"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "mizar",
    "filePath": "token:MZR",
    "symbol": "mzr",
    "name": "Mizar",
    "marketCapRank": 1998,
    "addresses": {
      "arbitrum-one": "0xbbea044f9e7c0520195e49ad1e561572e7e1b948"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "mmfinance",
    "filePath": "token:MMF",
    "symbol": "mmf",
    "name": "MMFinance (Cronos)",
    "marketCapRank": 1749,
    "addresses": {
      "cronos": "0x97749c9b61f878a880dfe312d2594ae07aed7656"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "mobius",
    "filePath": "token:MOBI",
    "symbol": "mobi",
    "name": "Mobius",
    "marketCapRank": 1774,
    "addresses": {
      "stellar": "OBI-GA6HCMBLTZS5VYYBCATRBRZ3BZJMAFUDKYYF6AH6MVCMGWMRDNSWJPIH"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "mobox",
    "filePath": "token:MBOX",
    "symbol": "mbox",
    "name": "Mobox",
    "marketCapRank": 457,
    "addresses": {
      "binance-smart-chain": "0x3203c9e46ca618c8c1ce5dc67e7e9d75f5da2377"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "moby",
    "filePath": "token:MOBY",
    "symbol": "moby",
    "name": "Moby",
    "marketCapRank": 1215,
    "addresses": {
      "ethereum": "0x40a7df3df8b56147b781353d379cb960120211d7"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "mochi-thecatcoin",
    "filePath": "token:MOCHI",
    "symbol": "mochi",
    "name": "Mochi",
    "marketCapRank": 734,
    "addresses": {
      "base": "0xf6e932ca12afa26665dc4dde7e27be02a7c02e50"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "modefi",
    "filePath": "token:MOD",
    "symbol": "mod",
    "name": "Modefi",
    "marketCapRank": 2482,
    "addresses": {
      "ethereum": "0xea1ea0972fa092dd463f2968f9bb51cc4c981d71",
      "fantom": "0xe64b9fd040d1f9d4715c645e0d567ef69958d3d9",
      "binance-smart-chain": "0xd4fbc57b6233f268e7fba3b66e62719d74deecbc",
      "polygon-pos": "0x8346ab8d5ea7a9db0209aed2d1806afa0e2c4c21"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "moe-3",
    "filePath": "token:MOE",
    "symbol": "moe",
    "name": "MOE",
    "marketCapRank": 1591,
    "addresses": {
      "mantle": "0x4515a45337f461a11ff0fe8abf3c606ae5dc00c9"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "mog-coin",
    "filePath": "token:MOG",
    "symbol": "mog",
    "name": "Mog Coin",
    "marketCapRank": 270,
    "addresses": {
      "ethereum": "0xaaee1a9723aadb7afa2810263653a34ba2c21c7a"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "monavale",
    "filePath": "token:MONA",
    "symbol": "mona",
    "name": "Monavale",
    "marketCapRank": 2327,
    "addresses": {
      "ethereum": "0x275f5ad03be0fa221b4c6649b8aee09a42d9412a",
      "polygon-pos": "0x6968105460f67c3bf751be7c15f92f5286fd0ce5"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "monero",
    "filePath": "token:XMR",
    "symbol": "xmr",
    "name": "Monero",
    "marketCapRank": 57,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "monetha",
    "filePath": "token:MTH",
    "symbol": "mth",
    "name": "Monetha",
    "marketCapRank": 2675,
    "addresses": {
      "ethereum": "0xaf4dce16da2877f8c9e00544c93b62ac40631f16"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "moon",
    "filePath": "token:MOON",
    "symbol": "moon",
    "name": "r/CryptoCurrency Moons",
    "marketCapRank": 1104,
    "addresses": {
      "arbitrum-nova": "0x0057ac2d777797d31cd3f8f13bf5e927571d6ad0",
      "arbitrum-one": "0x24404dc041d74cd03cfe28855f555559390c931b"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "moon-tropica",
    "filePath": "token:CAH",
    "symbol": "cah",
    "name": "Moon Tropica",
    "marketCapRank": 544,
    "addresses": {
      "ethereum": "0x8e0e57dcb1ce8d9091df38ec1bfc3b224529754a"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "moonbeam",
    "filePath": "token:GLMR",
    "symbol": "glmr",
    "name": "Moonbeam",
    "marketCapRank": 215,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "moonedge",
    "filePath": "token:MOONED",
    "symbol": "mooned",
    "name": "MoonEdge",
    "marketCapRank": 2107,
    "addresses": {
      "polygon-pos": "0x7e4c577ca35913af564ee2a24d882a4946ec492b"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "moonriver",
    "filePath": "token:MOVR",
    "symbol": "movr",
    "name": "Moonriver",
    "marketCapRank": 352,
    "addresses": {
      "moonriver": "0x98878b06940ae243284ca214f92bb71a2b032b8a",
      "meter": "0xb158870beb809ad955bf56065c5c10d7fd957cc0"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "moonstarter",
    "filePath": "token:MNST",
    "symbol": "mnst",
    "name": "MoonStarter",
    "marketCapRank": 2455,
    "addresses": {
      "binance-smart-chain": "0x6a6ccf15b38da4b5b0ef4c8fe9fefcb472a893f9"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "moonwell-artemis",
    "filePath": "token:WELL",
    "symbol": "well",
    "name": "Moonwell",
    "marketCapRank": 549,
    "addresses": {
      "moonbeam": "0x511ab53f793683763e5a8829738301368a2411e3",
      "base": "0xff8adec2221f9f4d8dfbafa6b9a297d17603493d"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "morpheus-labs",
    "filePath": "token:MIND",
    "symbol": "mind",
    "name": "Morpheus Labs",
    "marketCapRank": 2245,
    "addresses": {
      "ethereum": "0xc9eb61ffb66d5815d643bbb8195e17c49687ae1e",
      "polygon-pos": "0x280053c54006a624c26989cb8354fa4cb86f14d1"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "morpheus-network",
    "filePath": "token:MNW",
    "symbol": "mnw",
    "name": "Morpheus Network",
    "marketCapRank": 821,
    "addresses": {
      "ethereum": "0xd3e4ba569045546d09cf021ecc5dfe42b1d7f6e4",
      "polygon-pos": "0x3c59798620e5fec0ae6df1a19c6454094572ab92"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "mossland",
    "filePath": "token:MOC",
    "symbol": "moc",
    "name": "Mossland",
    "marketCapRank": 737,
    "addresses": {
      "ethereum": "0x865ec58b06bf6305b886793aa20a2da31d034e68"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "moviebloc",
    "filePath": "token:MBL",
    "symbol": "mbl",
    "name": "MovieBloc",
    "marketCapRank": 500,
    "addresses": {
      "ontology": "e5a49d7fd57e7178e189d3965d1ee64368a1036d"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "msol",
    "filePath": "token:MSOL",
    "symbol": "msol",
    "name": "Marinade staked SOL",
    "marketCapRank": 100,
    "addresses": {
      "solana": "mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "mt-pelerin-shares",
    "filePath": "token:MPS",
    "symbol": "mps",
    "name": "Mt Pelerin Shares",
    "marketCapRank": 2254,
    "addresses": {
      "ethereum": "0x96c645d3d3706f793ef52c19bbace441900ed47d",
      "xdai": "0xfa57aa7beed63d03aaf85ffd1753f5f6242588fb"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "multivac",
    "filePath": "token:MTV",
    "symbol": "mtv",
    "name": "MultiVAC",
    "marketCapRank": 1708,
    "addresses": {
      "ethereum": "0x6226e00bcac68b0fe55583b90a1d727c14fab77f",
      "binance-smart-chain": "0x8aa688ab789d1848d131c65d98ceaa8875d97ef1"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "mummy-finance",
    "filePath": "token:MMY",
    "symbol": "mmy",
    "name": "Mummy Finance",
    "marketCapRank": 2126,
    "addresses": {
      "fantom": "0x01e77288b38b416f972428d562454fb329350bac",
      "optimistic-ethereum": "0x47536f17f4ff30e64a96a7555826b8f9e66ec468"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "musd",
    "filePath": "token:MUSD",
    "symbol": "musd",
    "name": "mStable USD",
    "marketCapRank": 2075,
    "addresses": {
      "ethereum": "0xe2f2a5c287993345a840db3b0845fbc70f5935a5"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "muse-2",
    "filePath": "token:MUSE",
    "symbol": "muse",
    "name": "Muse DAO",
    "marketCapRank": 1176,
    "addresses": {
      "ethereum": "0xb6ca7399b4f9ca56fc27cbff44f4d2e4eef1fc81"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "mute",
    "filePath": "token:MUTE",
    "symbol": "mute",
    "name": "Mute",
    "marketCapRank": 1109,
    "addresses": {
      "ethereum": "0xa49d7499271ae71cd8ab9ac515e6694c755d400c",
      "zksync": "0x0e97c7a0f8b2c9885c8ac9fc6136e829cbc21d42"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "mx-token",
    "filePath": "token:MX",
    "symbol": "mx",
    "name": "MX",
    "marketCapRank": 214,
    "addresses": {
      "ethereum": "0x11eef04c884e24d9b7b4760e7476d06ddf797f36"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "mxc",
    "filePath": "token:MXC",
    "symbol": "mxc",
    "name": "MXC",
    "marketCapRank": 736,
    "addresses": {
      "ethereum": "0x5ca381bbfb58f0092df149bd3d243b08b9a8386e"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "my-defi-pet",
    "filePath": "token:DPET",
    "symbol": "dpet",
    "name": "My DeFi Pet",
    "marketCapRank": 1848,
    "addresses": {
      "binance-smart-chain": "0xfb62ae373aca027177d1c18ee0862817f9080d08",
      "kardiachain": "0xfb62ae373aca027177d1c18ee0862817f9080d08",
      "ethereum": "0xfb62ae373aca027177d1c18ee0862817f9080d08"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "my-neighbor-alice",
    "filePath": "token:ALICE",
    "symbol": "alice",
    "name": "My Neighbor Alice",
    "marketCapRank": 386,
    "addresses": {
      "ethereum": "0xac51066d7bec65dc4589368da368b212745d63e8",
      "binance-smart-chain": "0xac51066d7bec65dc4589368da368b212745d63e8"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "myria",
    "filePath": "token:MYRIA",
    "symbol": "myria",
    "name": "Myria",
    "marketCapRank": 378,
    "addresses": {
      "ethereum": "0xa0ef786bf476fe0810408caba05e536ac800ff86"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "mysterium",
    "filePath": "token:MYST",
    "symbol": "myst",
    "name": "Mysterium",
    "marketCapRank": 1808,
    "addresses": {
      "ethereum": "0x4cf89ca06ad997bc732dc876ed2a7f26a9e7f361",
      "polygon-pos": "0x1379e8886a944d2d9d440b3d88df536aea08d9f3",
      "binance-smart-chain": "0x2ff0b946a6782190c4fe5d4971cfe79f0b6e4df2"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "nabox",
    "filePath": "token:NABOX",
    "symbol": "nabox",
    "name": "Nabox",
    "marketCapRank": 2245,
    "addresses": {
      "ethereum": "0x03d1e72765545729a035e909edd9371a405f77fb",
      "binance-smart-chain": "0x755f34709e369d37c6fa52808ae84a32007d1155"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "nada-protocol-token",
    "filePath": "token:NADA",
    "symbol": "nada",
    "name": "NADA Protocol Token",
    "marketCapRank": 1453,
    "addresses": {
      "hedera-hashgraph": "0.0.4622883"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "naga",
    "filePath": "token:NGC",
    "symbol": "ngc",
    "name": "NAGA",
    "marketCapRank": 2005,
    "addresses": {
      "ethereum": "0x72dd4b6bd852a3aa172be4d6c5a6dbec588cf131"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "nakamoto-games",
    "filePath": "token:NAKA",
    "symbol": "naka",
    "name": "Nakamoto Games",
    "marketCapRank": 422,
    "addresses": {
      "polygon-pos": "0x311434160d7537be358930def317afb606c0d737"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "nals",
    "filePath": "token:NALS",
    "symbol": "nals",
    "name": "NALS",
    "marketCapRank": 2073,
    "addresses": {
      "ordinals": "fd8a5b4d53d9afb37ee2845bb5bb70a490373293bf281728bbe712ee9b0872dbi0"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "nano",
    "filePath": "token:XNO",
    "symbol": "xno",
    "name": "Nano",
    "marketCapRank": 326,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "nanobyte",
    "filePath": "token:NBT",
    "symbol": "nbt",
    "name": "NanoByte",
    "marketCapRank": 2081,
    "addresses": {
      "binance-smart-chain": "0x1d3437e570e93581bd94b2fd8fbf202d4a65654a",
      "ethereum": "0x446f2a8a39cc730ef378be759a3c57f1a3fe824c"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "naos-finance",
    "filePath": "token:NAOS",
    "symbol": "naos",
    "name": "NAOS Finance",
    "marketCapRank": 1836,
    "addresses": {
      "ethereum": "0x4a615bb7166210cce20e6642a6f8fb5d4d044496",
      "binance-smart-chain": "0x758d08864fb6cce3062667225ca10b8f00496cc2"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "napoli-fan-token",
    "filePath": "token:NAP",
    "symbol": "nap",
    "name": "Napoli Fan Token",
    "marketCapRank": 1823,
    "addresses": {
      "chiliz": "0xbe7f1ebb1fd6246844e093b04991ae0e66d12c77"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "nav-coin",
    "filePath": "token:NAV",
    "symbol": "nav",
    "name": "Navcoin",
    "marketCapRank": 1997,
    "addresses": {
      "binance-smart-chain": "0xbfef6ccfc830d3baca4f6766a0d4aaa242ca9f3d"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "near",
    "filePath": "token:NEAR",
    "symbol": "near",
    "name": "NEAR Protocol",
    "marketCapRank": 23,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "neighbourhoods",
    "filePath": "token:NHT",
    "symbol": "nht",
    "name": "Neighbourhoods",
    "marketCapRank": 1888,
    "addresses": {
      "ethereum": "0x84342e932797fc62814189f01f0fb05f52519708",
      "polygon-pos": "0x84342e932797fc62814189f01f0fb05f52519708"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "nem",
    "filePath": "token:XEM",
    "symbol": "xem",
    "name": "NEM",
    "marketCapRank": 201,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "neo",
    "filePath": "token:NEO",
    "symbol": "neo",
    "name": "NEO",
    "marketCapRank": 105,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "neon",
    "filePath": "token:NEON",
    "symbol": "neon",
    "name": "Neon",
    "marketCapRank": 537,
    "addresses": {
      "solana": "NeonTjSjsuo3rexg9o6vHuMXw62f9V7zvmu8M8Zut44"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "neon-exchange",
    "filePath": "token:NEX",
    "symbol": "nex",
    "name": "Nash",
    "marketCapRank": 1664,
    "addresses": {
      "neo": "3a4acd3647086e7c44398aac0349802e6a171129",
      "ethereum": "0xe2dc070524a6e305ddb64d8513dc444b6a1ec845",
      "polygon-pos": "0xa486c6bc102f409180ccb8a94ba045d39f8fc7cb"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "neos-credits",
    "filePath": "token:NCR",
    "symbol": "ncr",
    "name": "Neos Credits",
    "marketCapRank": 2047,
    "addresses": {
      "ethereum": "0xdb5c3c46e28b53a39c255aa39a411dd64e5fed9c"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "neptune-mutual",
    "filePath": "token:NPM",
    "symbol": "npm",
    "name": "Neptune Mutual",
    "marketCapRank": 2110,
    "addresses": {
      "ethereum": "0x57f12fe6a4e5fe819eec699fadf9db2d06606bb4",
      "arbitrum-one": "0x57f12fe6a4e5fe819eec699fadf9db2d06606bb4",
      "polygon-pos": "0x57f12fe6a4e5fe819eec699fadf9db2d06606bb4",
      "binance-smart-chain": "0x57f12fe6a4e5fe819eec699fadf9db2d06606bb4"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "nervenetwork",
    "filePath": "token:NVT",
    "symbol": "nvt",
    "name": "NerveNetwork",
    "marketCapRank": 1684,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "nervos-network",
    "filePath": "token:CKB",
    "symbol": "ckb",
    "name": "Nervos Network",
    "marketCapRank": 129,
    "addresses": {},
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "nest",
    "filePath": "token:NEST",
    "symbol": "nest",
    "name": "Nest Protocol",
    "marketCapRank": 1083,
    "addresses": {
      "ethereum": "0xcd6926193308d3b371fdd6a6219067e550000000",
      "binance-smart-chain": "0xcd6926193308d3b371fdd6a6219067e550000000"
    },
    "variants": [
      "mono",
      "background",
      "branded"
    ]
  },
  {
    "id": "netswap",
    "filePath": "token:NETT",
    "symbol": "nett",
    "name": "Netswap",
    "marketCapRank": 1761,
    "addresses": {
      "metis-andromeda": "0x90fe084f877c65e1b577c7b2ea64b8d8dd1ab278"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "neurai",
    "filePath": "token:XNA",
    "symbol": "xna",
    "name": "Neurai",
    "marketCapRank": 981,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "neuroni-ai",
    "filePath": "token:NEURONI",
    "symbol": "neuroni",
    "name": "Neuroni AI",
    "marketCapRank": 1901,
    "addresses": {
      "ethereum": "0x922e2708462c7a3d014d8344f7c4d92b27ecf332"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "neutrino-system-base-token",
    "filePath": "token:NSBT",
    "symbol": "nsbt",
    "name": "Neutrino System Base",
    "marketCapRank": 2335,
    "addresses": {
      "waves": "6nSpVyNH7yM69eg446wrQR94ipbbcmZMU1ENPwanC97g",
      "ethereum": "0x9d79d5b61de59d882ce90125b18f74af650acb93"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "new-order",
    "filePath": "token:NEWO",
    "symbol": "newo",
    "name": "New Order",
    "marketCapRank": 2453,
    "addresses": {
      "ethereum": "0x98585dfc8d9e7d48f0b1ae47ce33332cf4237d96",
      "avalanche": "0x4bfc90322dd638f81f034517359bd447f8e0235a"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "newscrypto-coin",
    "filePath": "token:NWC",
    "symbol": "nwc",
    "name": "Newscrypto Coin",
    "marketCapRank": 1045,
    "addresses": {
      "stellar": "NWC-GDZJD363YP7P3TNYDK3ZD6GLXFMAI3GLVIH7CGFLNZWIZBQUCVE6PTU7",
      "ethereum": "0x968f6f898a6df937fc1859b323ac2f14643e3fed",
      "binance-smart-chain": "0x968f6f898a6df937fc1859b323ac2f14643e3fed"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "nexacoin",
    "filePath": "token:NEXA",
    "symbol": "nexa",
    "name": "Nexa",
    "marketCapRank": 1011,
    "addresses": {},
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "nexo",
    "filePath": "token:NEXO",
    "symbol": "nexo",
    "name": "NEXO",
    "marketCapRank": 143,
    "addresses": {
      "ethereum": "0xb62132e35a6c13ee1ee0f84dc5d40bad8d815206",
      "energi": "0x04640dc771edd73cbeb934fb5461674830baea11",
      "polygon-pos": "0x41b3966b4ff7b427969ddf5da3627d6aeae9a48e",
      "fantom": "0x7c598c96d02398d89fbcb9d41eab3df0c16f227d",
      "sora": "0x003005b2417b5046455e73f7fc39779a013f1a33b4518bcd83a790900dca49ff"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "nft-art-finance",
    "filePath": "token:NFTART",
    "symbol": "nftart",
    "name": "NFT Art Finance",
    "marketCapRank": 2397,
    "addresses": {
      "binance-smart-chain": "0xf7844cb890f4c339c497aeab599abdc3c874b67a"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "nft-worlds",
    "filePath": "token:WRLD",
    "symbol": "wrld",
    "name": "NFT Worlds",
    "marketCapRank": 909,
    "addresses": {
      "ethereum": "0xd5d86fc8d5c0ea1ac1ac5dfab6e529c9967a45e9",
      "polygon-pos": "0xd5d86fc8d5c0ea1ac1ac5dfab6e529c9967a45e9"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "nftb",
    "filePath": "token:NFTB",
    "symbol": "nftb",
    "name": "NFTb",
    "marketCapRank": 1841,
    "addresses": {
      "binance-smart-chain": "0xde3dbbe30cfa9f437b293294d1fd64b26045c71a"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "nftbooks",
    "filePath": "token:NFTBS",
    "symbol": "nftbs",
    "name": "NFTBooks",
    "marketCapRank": 2296,
    "addresses": {
      "polygon-pos": "0x6396252377f54ad33cff9131708da075b21d9b88"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "nftx",
    "filePath": "token:NFTX",
    "symbol": "nftx",
    "name": "NFTX",
    "marketCapRank": 1625,
    "addresses": {
      "ethereum": "0x87d73e916d7057945c9bcd8cdd94e42a6f47f776"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "nimiq-2",
    "filePath": "token:NIM",
    "symbol": "nim",
    "name": "Nimiq",
    "marketCapRank": 1202,
    "addresses": {},
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "nitro-cartel",
    "filePath": "token:TROVE",
    "symbol": "trove",
    "name": "Arbitrove Governance Token",
    "marketCapRank": 2377,
    "addresses": {
      "arbitrum-one": "0x982239d38af50b0168da33346d85fb12929c4c07"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "nix-bridge-token",
    "filePath": "token:VOICE",
    "symbol": "voice",
    "name": "Voice",
    "marketCapRank": 1946,
    "addresses": {
      "ethereum": "0x2e2364966267b5d7d2ce6cd9a9b5bd19d9c7c6a9"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "nkn",
    "filePath": "token:NKN",
    "symbol": "nkn",
    "name": "NKN",
    "marketCapRank": 454,
    "addresses": {
      "ethereum": "0x5cf04716ba20127f1e2297addcf4b5035000c9eb"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "nodle-network",
    "filePath": "token:NODL",
    "symbol": "nodl",
    "name": "Nodle Network",
    "marketCapRank": 973,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "noia-network",
    "filePath": "token:NOIA",
    "symbol": "noia",
    "name": "Syntropy",
    "marketCapRank": 349,
    "addresses": {
      "ethereum": "0xa8c8cfb141a3bb59fea1e2ea6b79b5ecbcd7b6ca"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "nolus",
    "filePath": "token:NLS",
    "symbol": "nls",
    "name": "Nolus",
    "marketCapRank": 1322,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "nominex",
    "filePath": "token:NMX",
    "symbol": "nmx",
    "name": "Nominex",
    "marketCapRank": 2532,
    "addresses": {
      "binance-smart-chain": "0xd32d01a43c869edcd1117c640fbdcfcfd97d9d65"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "non-playable-coin",
    "filePath": "token:NPC",
    "symbol": "npc",
    "name": "Non-Playable Coin",
    "marketCapRank": 1173,
    "addresses": {
      "ethereum": "0x8ed97a637a790be1feff5e888d43629dc05408f6",
      "base": "0xb166e8b140d35d9d8226e40c09f757bac5a4d87d"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "nord-finance",
    "filePath": "token:NORD",
    "symbol": "nord",
    "name": "Nord Finance",
    "marketCapRank": 2574,
    "addresses": {
      "ethereum": "0x6e9730ecffbed43fd876a264c982e254ef05a0de",
      "fantom": "0xeaf26191ac1d35ae30baa19a5ad5558dd8156aef",
      "binance-smart-chain": "0x6e9730ecffbed43fd876a264c982e254ef05a0de",
      "polygon-pos": "0xf6f85b3f9fd581c2ee717c404f7684486f057f95"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "nosana",
    "filePath": "token:NOS",
    "symbol": "nos",
    "name": "Nosana",
    "marketCapRank": 223,
    "addresses": {
      "solana": "nosXBVoaCTtYdLvKY6Csb4AC8JCdQKKAaWYtx2ZMoo7"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "not-financial-advice",
    "filePath": "token:NFAI",
    "symbol": "nfai",
    "name": "Not Financial Advice",
    "marketCapRank": 2394,
    "addresses": {
      "ethereum": "0x17c50d62e6e8d20d2dc18e9ad79c43263d0720d9"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "nucleon-xcfx",
    "filePath": "token:XCFX",
    "symbol": "xcfx",
    "name": "Nucleon xCFX",
    "marketCapRank": 1490,
    "addresses": {
      "conflux": "0x889138644274a7dc602f25a7e7d53ff40e6d0091"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "nuco-cloud",
    "filePath": "token:NCDT",
    "symbol": "ncdt",
    "name": "nuco.cloud",
    "marketCapRank": 990,
    "addresses": {
      "ethereum": "0xe0c8b298db4cffe05d1bea0bb1ba414522b33c1b"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "nuls",
    "filePath": "token:NULS",
    "symbol": "nuls",
    "name": "NULS",
    "marketCapRank": 554,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "numbers-protocol",
    "filePath": "token:NUM",
    "symbol": "num",
    "name": "Numbers Protocol",
    "marketCapRank": 610,
    "addresses": {
      "ethereum": "0x3496b523e5c00a4b4150d6721320cddb234c3079",
      "binance-smart-chain": "0xeceb87cf00dcbf2d4e2880223743ff087a995ad9"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "numeraire",
    "filePath": "token:NMR",
    "symbol": "nmr",
    "name": "Numeraire",
    "marketCapRank": 319,
    "addresses": {
      "ethereum": "0x1776e1f26f98b1a5df9cd347953a26dd3cb46671",
      "energi": "0xd72922e849477a042a7e6dc84309f4bc1c1227a2"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "nunet",
    "filePath": "token:NTX",
    "symbol": "ntx",
    "name": "NuNet",
    "marketCapRank": 778,
    "addresses": {
      "ethereum": "0xf0d33beda4d734c72684b5f9abbebf715d0a7935",
      "cardano": "edfd7a1d77bcb8b884c474bdc92a16002d1fb720e454fa6e993444794e5458",
      "binance-smart-chain": "0x5c4bcc4dbaeabc7659f6435bce4e659314ebad87"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "nuritopia",
    "filePath": "token:NBLU",
    "symbol": "nblu",
    "name": "Nuritopia",
    "marketCapRank": 2275,
    "addresses": {
      "binance-smart-chain": "0x6ba5657bbff83cb579503847c6baa47295ef79a8"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "nusd",
    "filePath": "token:SUSD",
    "symbol": "susd",
    "name": "sUSD",
    "marketCapRank": 772,
    "addresses": {
      "ethereum": "0x57ab1ec28d129707052df4df418d58a2d46d5f51",
      "fantom": "0x0e1694483ebb3b74d3054e383840c6cf011e518e",
      "optimistic-ethereum": "0x8c6f28f2f1a3c87f0f938b96d27520d9751ec8d9",
      "arbitrum-one": "0xa970af1a584579b618be4d69ad6f73459d112f95"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "nvirworld",
    "filePath": "token:NVIR",
    "symbol": "nvir",
    "name": "NvirWorld",
    "marketCapRank": 1128,
    "addresses": {
      "ethereum": "0x9d71ce49ab8a0e6d2a1e7bfb89374c9392fd6804",
      "binance-smart-chain": "0x9d71ce49ab8a0e6d2a1e7bfb89374c9392fd6804"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "nxm",
    "filePath": "token:NXM",
    "symbol": "nxm",
    "name": "Nexus Mutual",
    "marketCapRank": 271,
    "addresses": {
      "ethereum": "0xd7c49cee7e9188cca6ad8ff264c1da2e69d4cf3b"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "nxt",
    "filePath": "token:NXT",
    "symbol": "nxt",
    "name": "NXT",
    "marketCapRank": 2496,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "nym",
    "filePath": "token:NYM",
    "symbol": "nym",
    "name": "Nym",
    "marketCapRank": 358,
    "addresses": {
      "ethereum": "0x525a8f6f3ba4752868cde25164382bfbae3990e1"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "o3-swap",
    "filePath": "token:O3",
    "symbol": "o3",
    "name": "O3 Swap",
    "marketCapRank": 2442,
    "addresses": {
      "binance-smart-chain": "0xee9801669c6138e84bd50deb500827b776777d28",
      "fantom": "0xee9801669c6138e84bd50deb500827b776777d28",
      "avalanche": "0xee9801669c6138e84bd50deb500827b776777d28",
      "optimistic-ethereum": "0xee9801669c6138e84bd50deb500827b776777d28",
      "ethereum": "0xee9801669c6138e84bd50deb500827b776777d28",
      "huobi-token": "0xee9801669c6138e84bd50deb500827b776777d28",
      "arbitrum-one": "0xee9801669c6138e84bd50deb500827b776777d28",
      "polygon-pos": "0xee9801669c6138e84bd50deb500827b776777d28",
      "okex-chain": "0xee9801669c6138e84bd50deb500827b776777d28"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "oasis-network",
    "filePath": "token:ROSE",
    "symbol": "rose",
    "name": "Oasis Network",
    "marketCapRank": 120,
    "addresses": {
      "binance-smart-chain": "0xf00600ebc7633462bc4f9c61ea2ce99f5aaebd4a"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "oasys",
    "filePath": "token:OAS",
    "symbol": "oas",
    "name": "Oasys",
    "marketCapRank": 376,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "oath",
    "filePath": "token:OATH",
    "symbol": "oath",
    "name": "OATH",
    "marketCapRank": 1923,
    "addresses": {
      "fantom": "0x21ada0d2ac28c3a5fa3cd2ee30882da8812279b6",
      "ethereum": "0xd20523b39faf1d6e9023a4d6085f87b7b0de7926",
      "polygon-pos": "0x7c603c3c0c97a565cf202c94ab5298bf8510f7dc",
      "arbitrum-one": "0x00e1724885473b63bce08a9f0a52f35b0979e35a",
      "optimistic-ethereum": "0x00e1724885473b63bce08a9f0a52f35b0979e35a",
      "avalanche": "0xad090976ce846935dcff1ded852668beed912916",
      "binance-smart-chain": "0x73f4c95af5c2892253c068850b8c9a753636f58d"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "obortech",
    "filePath": "token:OBOT",
    "symbol": "obot",
    "name": "Obortech",
    "marketCapRank": 1287,
    "addresses": {
      "ethereum": "0xedadeb5faa413e6c8623461849dfd0b7c3790c32",
      "binance-smart-chain": "0xb5be8d87fce6ce87a24b90abdb019458a8ec31f9",
      "polygon-pos": "0x221743dc9e954be4f86844649bf19b43d6f8366d"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "observer-coin",
    "filePath": "token:OBSR",
    "symbol": "obsr",
    "name": "Observer",
    "marketCapRank": 1204,
    "addresses": {
      "klay-token": "0x3cb6be2fc6677a63cb52b07aed523f93f5a06cb4"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "ocean-protocol",
    "filePath": "token:OCEAN",
    "symbol": "ocean",
    "name": "Ocean Protocol",
    "marketCapRank": 131,
    "addresses": {
      "ethereum": "0x967da4048cd07ab37855c090aaf366e4ce1b9f48",
      "sora": "0x002ca40397c794e25dba18cf807910eeb69eb8e81b3f07bb54f7c5d1d8ab76b9",
      "energi": "0x99a17fb61fbdc4e42f6b0f496fe92ba820ce5d2b",
      "optimistic-ethereum": "0x2561aa2bb1d2eb6629edd7b0938d7679b8b49f9e",
      "polygon-pos": "0x282d8efce846a88b159800bd4130ad77443fa1a1"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "oceanex",
    "filePath": "token:OCE",
    "symbol": "oce",
    "name": "OceanEX",
    "marketCapRank": 2198,
    "addresses": {
      "vechain": "0x0ce6661b4ba86a0ea7ca2bd86a0de87b0b860f14"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "octaspace",
    "filePath": "token:OCTA",
    "symbol": "octa",
    "name": "OctaSpace",
    "marketCapRank": 898,
    "addresses": {},
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "octavia",
    "filePath": "token:VIA",
    "symbol": "via",
    "name": "Octavia",
    "marketCapRank": 1342,
    "addresses": {
      "binance-smart-chain": "0x21ac3bb914f90a2bb1a16088e673a9fdda641434"
    },
    "variants": [
      "mono"
    ]
  },
  {
    "id": "octo-gaming",
    "filePath": "token:OTK",
    "symbol": "otk",
    "name": "Octokn",
    "marketCapRank": 1082,
    "addresses": {
      "solana": "octo82drBEdm8CSDaEKBymVn86TBtgmPnDdmE64PTqJ"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "octus-bridge",
    "filePath": "token:BRIDGE",
    "symbol": "bridge",
    "name": "Octus Bridge",
    "marketCapRank": 1560,
    "addresses": {
      "everscale": "0:f2679d80b682974e065e03bf42bbee285ce7c587eb153b41d761ebfd954c45e1"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "oddz",
    "filePath": "token:ODDZ",
    "symbol": "oddz",
    "name": "Oddz",
    "marketCapRank": 2444,
    "addresses": {
      "ethereum": "0xcd2828fc4d8e8a0ede91bb38cf64b1a81de65bf6",
      "avalanche": "0xb0a6e056b587d0a85640b39b1cb44086f7a26a1e",
      "binance-smart-chain": "0xcd40f2670cf58720b694968698a5514e924f742d",
      "polygon-pos": "0x4e830f67ec499e69930867f9017aeb5b3f629c73"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "odin-protocol",
    "filePath": "token:ODIN",
    "symbol": "odin",
    "name": "Odin Protocol",
    "marketCapRank": 2318,
    "addresses": {
      "cosmos": "ibc/c360ef34a86d334f625e4cbb7da3223aea97174b61f35bb3758081a8160f7d9b"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "oec-token",
    "filePath": "token:OKT",
    "symbol": "okt",
    "name": "OKT Chain",
    "marketCapRank": 234,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "offshift",
    "filePath": "token:XFT",
    "symbol": "xft",
    "name": "Offshift",
    "marketCapRank": 1713,
    "addresses": {
      "ethereum": "0x76bc677d444f1e9d57daf5187ee2b7dc852745ae",
      "binance-smart-chain": "0xe138c66982fd5c890c60b94fdba1747faf092c20"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "oggy-inu",
    "filePath": "token:OGGY",
    "symbol": "oggy",
    "name": "Oggy Inu",
    "marketCapRank": 1823,
    "addresses": {
      "binance-smart-chain": "0x92ed61fb8955cc4e392781cb8b7cd04aadc43d0c"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "okb",
    "filePath": "token:OKB",
    "symbol": "okb",
    "name": "OKB",
    "marketCapRank": 39,
    "addresses": {
      "ethereum": "0x75231f58b43240c9718dd58b4967c5114342a86c",
      "okex-chain": "0xdf54b6c6195ea4d948d03bfd818d365cf175cfc2",
      "sora": "0x0080edc40a944d29562b2dea2de42ed27b9047d16eeea27c5bc1b2e02786abe9"
    },
    "variants": [
      "mono"
    ]
  },
  {
    "id": "okratech-token",
    "filePath": "token:ORT",
    "symbol": "ort",
    "name": "Okratech",
    "marketCapRank": 1820,
    "addresses": {
      "binance-smart-chain": "0x9e711221b34a2d4b8f552bd5f4a6c4e7934920f7"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "omax-token",
    "filePath": "token:OMAX",
    "symbol": "omax",
    "name": "Omax",
    "marketCapRank": 1412,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "omisego",
    "filePath": "token:OMG",
    "symbol": "omg",
    "name": "OMG Network",
    "marketCapRank": 400,
    "addresses": {
      "ethereum": "0xd26114cd6ee289accf82350c8d8487fedb8a0c07",
      "boba": "0xe1e2ec9a85c607092668789581251115bcbd20de"
    },
    "variants": [
      "mono"
    ]
  },
  {
    "id": "ommniverse",
    "filePath": "token:OMMI",
    "symbol": "ommi",
    "name": "Ommniverse",
    "marketCapRank": 1603,
    "addresses": {
      "polygon-pos": "0xbc2659ead8d2d13a157a75bfc5acc156e1ea06df"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "omnicat",
    "filePath": "token:OMNI",
    "symbol": "omni",
    "name": "OmniCat",
    "marketCapRank": 843,
    "addresses": {
      "ethereum": "0x9e20461bc2c4c980f62f1b279d71734207a6a356",
      "blast": "0x9e20461bc2c4c980f62f1b279d71734207a6a356",
      "canto": "0x9e20461bc2c4c980f62f1b279d71734207a6a356",
      "polygon-pos": "0x9e20461bc2c4c980f62f1b279d71734207a6a356",
      "arbitrum-one": "0x9e20461bc2c4c980f62f1b279d71734207a6a356",
      "base": "0xc48e605c7b722a57277e087a6170b9e227e5ac0a",
      "binance-smart-chain": "0x9e20461bc2c4c980f62f1b279d71734207a6a356",
      "solana": "7mmXL6Et4SbpDs2iXoZQ3oPEeXeAiyETxh1QjDNi5qnV"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "onbuff",
    "filePath": "token:ONIT",
    "symbol": "onit",
    "name": "ONBUFF",
    "marketCapRank": 953,
    "addresses": {
      "ethereum": "0x410e731c2970dce3add351064acf5ce9e33fdbf0"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "one-ledger",
    "filePath": "token:OLT",
    "symbol": "olt",
    "name": "OneLedger",
    "marketCapRank": 2452,
    "addresses": {
      "ethereum": "0x64a60493d888728cf42616e034a0dfeae38efcf0"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "onerare",
    "filePath": "token:ORARE",
    "symbol": "orare",
    "name": "OneRare",
    "marketCapRank": 2400,
    "addresses": {
      "polygon-pos": "0xff2382bd52efacef02cc895bcbfc4618608aa56f"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "ong",
    "filePath": "token:ONG",
    "symbol": "ong",
    "name": "Ontology Gas",
    "marketCapRank": 398,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "oni-token",
    "filePath": "token:ONI",
    "symbol": "oni",
    "name": "ONINO",
    "marketCapRank": 1389,
    "addresses": {
      "binance-smart-chain": "0xea89199344a492853502a7a699cc4230854451b8",
      "fantom": "0x667c856f1a624baefe89fc4909c8701296c86c98"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "onomy-protocol",
    "filePath": "token:NOM",
    "symbol": "nom",
    "name": "Onomy Protocol",
    "marketCapRank": 869,
    "addresses": {
      "osmosis": "ibc/B9606D347599F0F2FDF82BA3EE339000673B7D274EA50F59494DC51EFCD42163"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "onooks",
    "filePath": "token:OOKS",
    "symbol": "ooks",
    "name": "Onooks",
    "marketCapRank": 1811,
    "addresses": {
      "ethereum": "0x69d9905b2e5f6f5433212b7f3c954433f23c1572"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "ontology",
    "filePath": "token:ONT",
    "symbol": "ont",
    "name": "Ontology",
    "marketCapRank": 254,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "ooki",
    "filePath": "token:OOKI",
    "symbol": "ooki",
    "name": "Ooki",
    "marketCapRank": 1245,
    "addresses": {
      "ethereum": "0x0de05f6447ab4d22c8827449ee4ba2d5c288379b"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "openanx",
    "filePath": "token:OAX",
    "symbol": "oax",
    "name": "OAX",
    "marketCapRank": 1420,
    "addresses": {
      "ethereum": "0x701c244b988a513c945973defa05de933b23fe1d"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "openocean",
    "filePath": "token:OOE",
    "symbol": "ooe",
    "name": "OpenOcean",
    "marketCapRank": 1422,
    "addresses": {
      "binance-smart-chain": "0x8ea5219a16c2dbf1d6335a6aa0c6bd45c50347c5",
      "arbitrum-one": "0xdcbf4cb83d27c408b30dd7f39bfcabd7176b1ba3"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "opium",
    "filePath": "token:OPIUM",
    "symbol": "opium",
    "name": "Opium",
    "marketCapRank": 2179,
    "addresses": {
      "ethereum": "0x888888888889c00c67689029d7856aac1065ec11",
      "binance-smart-chain": "0x566cedd201f67e542a6851a2959c1a449a041945",
      "polygon-pos": "0xe8f157e041df3b28151b667364e9c90789da7923"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "optimism",
    "filePath": "token:OP",
    "symbol": "op",
    "name": "Optimism",
    "marketCapRank": 40,
    "addresses": {
      "optimistic-ethereum": "0x4200000000000000000000000000000000000042"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "optimus-ai",
    "filePath": "token:OPTI",
    "symbol": "opti",
    "name": "Optimus AI",
    "marketCapRank": 927,
    "addresses": {
      "ethereum": "0x562e362876c8aee4744fc2c6aac8394c312d215d"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "opulous",
    "filePath": "token:OPUL",
    "symbol": "opul",
    "name": "Opulous",
    "marketCapRank": 451,
    "addresses": {
      "ethereum": "0x80d55c03180349fff4a229102f62328220a96444",
      "arbitrum-one": "0x0c5fa0e07949f941a6c2c29a008252db1527d6ee",
      "algorand": "287867876",
      "binance-smart-chain": "0x686318000d982bc8dcc1cdcf8ffd22322f0960ed"
    },
    "variants": [
      "mono"
    ]
  },
  {
    "id": "oraichain-token",
    "filePath": "token:ORAI",
    "symbol": "orai",
    "name": "Oraichain",
    "marketCapRank": 313,
    "addresses": {
      "ethereum": "0x4c11249814f11b9346808179cf06e71ac328c1b5",
      "binance-smart-chain": "0xa325ad6d9c92b55a3fc5ad7e412b1518f96441c0"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "orbofi-ai",
    "filePath": "token:OBI",
    "symbol": "obi",
    "name": "Orbofi AI",
    "marketCapRank": 1296,
    "addresses": {
      "ethereum": "0xbb3a8fd6ec4bf0fdc6cd2739b1e41192d12b1873",
      "binance-smart-chain": "0x69a87c8788d4a48c1362b3b357d0e6b59c11d93f"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "orbs",
    "filePath": "token:ORBS",
    "symbol": "orbs",
    "name": "Orbs",
    "marketCapRank": 343,
    "addresses": {
      "ethereum": "0xff56cc6b1e6ded347aa0b7676c85ab0b3d08b0fa",
      "fantom": "0x43a8cab15d06d3a5fe5854d714c37e7e9246f170",
      "avalanche": "0x3ab1c9adb065f3fca0059652cd7a52b05c98f9a9",
      "arbitrum-one": "0xf3c091ed43de9c270593445163a41a876a0bb3dd",
      "binance-smart-chain": "0x43a8cab15d06d3a5fe5854d714c37e7e9246f170",
      "polygon-pos": "0x614389eaae0a6821dc49062d56bda3d9d45fa2ff"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "orchid-protocol",
    "filePath": "token:OXT",
    "symbol": "oxt",
    "name": "Orchid Protocol",
    "marketCapRank": 555,
    "addresses": {
      "ethereum": "0x4575f41308ec1483f3d399aa9a2826d74da13deb"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "ordinals",
    "filePath": "token:ORDI",
    "symbol": "ordi",
    "name": "ORDI",
    "marketCapRank": 87,
    "addresses": {
      "ordinals": "b61b0172d95e266c18aea0c624db987e971a5d6d4ebc2aaed85da4642d635735i0"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "origin-dollar",
    "filePath": "token:OUSD",
    "symbol": "ousd",
    "name": "Origin Dollar",
    "marketCapRank": 1466,
    "addresses": {
      "ethereum": "0x2a8e1e676ec238d8a992307b495b45b3feaa5e86",
      "astar": "0x29f6e49c6e3397c3a84f715885f9f233a441165c"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "origin-ether",
    "filePath": "token:OETH",
    "symbol": "oeth",
    "name": "Origin Ether",
    "marketCapRank": 403,
    "addresses": {
      "ethereum": "0x856c4efb76c1d1ae02e20ceb03a2a6a08b0b8dc3"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "origin-protocol",
    "filePath": "token:OGN",
    "symbol": "ogn",
    "name": "Origin Protocol",
    "marketCapRank": 490,
    "addresses": {
      "ethereum": "0x8207c1ffc5b6804f6024322ccf34f29c3541ae26",
      "sora": "0x0064c02f602195e298780323c79a0eb5b4fd0ffcad68d440a7ca7725bc79d912",
      "energi": "0x1e3eed9c1eba5e5114d4c185dc71d13c3c66dd84"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "origintrail",
    "filePath": "token:TRAC",
    "symbol": "trac",
    "name": "OriginTrail",
    "marketCapRank": 195,
    "addresses": {
      "ethereum": "0xaa7a9ca87d3694b5755f213b5d04094b8d0f0a6f"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "orion-protocol",
    "filePath": "token:ORN",
    "symbol": "orn",
    "name": "Orion",
    "marketCapRank": 605,
    "addresses": {
      "ethereum": "0x0258f474786ddfd37abce6df6bbb1dd5dfc4434a",
      "energi": "0x5e2d55bc07b63b18af6c9ed8da06cd33258ebb35",
      "binance-smart-chain": "0xe4ca1f75eca6214393fce1c1b316c237664eaa8e"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "osaka-protocol",
    "filePath": "token:OSAK",
    "symbol": "osak",
    "name": "Osaka Protocol",
    "marketCapRank": 317,
    "addresses": {
      "ethereum": "0xa21af1050f7b26e0cff45ee51548254c41ed6b5c",
      "optimistic-ethereum": "0xbfd5206962267c7b4b4a8b3d76ac2e1b2a5c4d5e",
      "arbitrum-one": "0xbfd5206962267c7b4b4a8b3d76ac2e1b2a5c4d5e",
      "avalanche": "0x96e1056a8814de39c8c3cd0176042d6cecd807d7",
      "polygon-pos": "0x11cd72f7a4b699c67f225ca8abb20bc9f8db90c7",
      "base": "0xbfd5206962267c7b4b4a8b3d76ac2e1b2a5c4d5e",
      "binance-smart-chain": "0x11cd72f7a4b699c67f225ca8abb20bc9f8db90c7"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "osmosis",
    "filePath": "token:OSMO",
    "symbol": "osmo",
    "name": "Osmosis",
    "marketCapRank": 121,
    "addresses": {
      "evmos": "0xfa3c22c069b9556a4b2f7ece1ee3b467909f4864",
      "secret": "secret150jec8mc2hzyyqak4umv6cfevelr0x9p0mjxgg"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "outer-ring",
    "filePath": "token:GQ",
    "symbol": "gq",
    "name": "Blink Galaxy",
    "marketCapRank": 1500,
    "addresses": {
      "binance-smart-chain": "0xf700d4c708c2be1463e355f337603183d20e0808"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "ovr",
    "filePath": "token:OVR",
    "symbol": "ovr",
    "name": "Ovr",
    "marketCapRank": 1075,
    "addresses": {
      "ethereum": "0x21bfbda47a0b4b5b1248c767ee49f7caa9b23697",
      "binance-smart-chain": "0x7e35d0e9180bf3a1fc47b0d110be7a21a10b41fe",
      "polygon-pos": "0x1631244689ec1fecbdd22fb5916e920dfc9b8d30"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "ox-fun",
    "filePath": "token:OX",
    "symbol": "ox",
    "name": "OX Coin",
    "marketCapRank": 822,
    "addresses": {
      "ethereum": "0xba0dda8762c24da9487f5fa026a9b64b695a07ea",
      "arbitrum-one": "0xba0dda8762c24da9487f5fa026a9b64b695a07ea",
      "binance-smart-chain": "0xba0dda8762c24da9487f5fa026a9b64b695a07ea",
      "avalanche": "0xba0dda8762c24da9487f5fa026a9b64b695a07ea",
      "polygon-pos": "0xba0dda8762c24da9487f5fa026a9b64b695a07ea"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "oxbull-tech-2",
    "filePath": "token:OXB",
    "symbol": "oxb",
    "name": "Oxbull Tech",
    "marketCapRank": 1387,
    "addresses": {
      "binance-smart-chain": "0x7536c00711e41df6aebcca650791107645b6bc52"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "oxygen",
    "filePath": "token:OXY",
    "symbol": "oxy",
    "name": "Oxygen",
    "marketCapRank": 1309,
    "addresses": {
      "solana": "z3dn17yLaGMKffVogeFHQ9zWVcXgqgf3PQnDsNs2g6M",
      "ethereum": "0x965697b4ef02f0de01384d0d4f9f782b1670c163"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "ozone-chain",
    "filePath": "token:OZO",
    "symbol": "ozo",
    "name": "Ozone Chain",
    "marketCapRank": 537,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "paal-ai",
    "filePath": "token:PAAL",
    "symbol": "paal",
    "name": "PAAL AI",
    "marketCapRank": 222,
    "addresses": {
      "ethereum": "0x14fee680690900ba0cccfc76ad70fd1b95d10e16"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "paccoin",
    "filePath": "token:PAC",
    "symbol": "pac",
    "name": "PAC Protocol",
    "marketCapRank": 2533,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "paid-network",
    "filePath": "token:PAID",
    "symbol": "paid",
    "name": "PAID Network",
    "marketCapRank": 665,
    "addresses": {
      "ethereum": "0x1614f18fc94f47967a3fbe5ffcd46d4e7da3d787",
      "binance-smart-chain": "0xad86d0e9764ba90ddd68747d64bffbd79879a238"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "paint-swap",
    "filePath": "token:BRUSH",
    "symbol": "brush",
    "name": "Paint Swap",
    "marketCapRank": 1414,
    "addresses": {
      "fantom": "0x85dec8c4b2680793661bca91a8f129607571863d"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "paladin",
    "filePath": "token:PAL",
    "symbol": "pal",
    "name": "Paladin",
    "marketCapRank": 2293,
    "addresses": {
      "ethereum": "0xab846fb6c81370327e784ae7cbb6d6a6af6ff4bf"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "palm-ai",
    "filePath": "token:PALM",
    "symbol": "palm",
    "name": "PaLM AI",
    "marketCapRank": 613,
    "addresses": {
      "ethereum": "0xf1df7305e4bab3885cab5b1e4dfc338452a67891"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "pancakeswap-token",
    "filePath": "token:CAKE",
    "symbol": "cake",
    "name": "PancakeSwap",
    "marketCapRank": 104,
    "addresses": {
      "binance-smart-chain": "0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82",
      "ethereum": "0x152649ea73beab28c5b49b26eb48f7ead6d4c898",
      "aptos": "0x159df6b7689437016108a019fd5bef736bac692b6d4a1f10c941f6fbb9a74ca6::oft::CakeOFT"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "pangolin",
    "filePath": "token:PNG",
    "symbol": "png",
    "name": "Pangolin",
    "marketCapRank": 508,
    "addresses": {
      "avalanche": "0x60781c2586d68229fde47564546784ab3faca982"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "panther",
    "filePath": "token:ZKP",
    "symbol": "zkp",
    "name": "Panther Protocol",
    "marketCapRank": 1412,
    "addresses": {
      "ethereum": "0x909e34d3f6124c324ac83dcca84b74398a6fa173",
      "polygon-pos": "0x9a06db14d639796b25a6cec6a1bf614fd98815ec"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "paragen",
    "filePath": "token:RGEN",
    "symbol": "rgen",
    "name": "Paragen",
    "marketCapRank": 2592,
    "addresses": {
      "binance-smart-chain": "0x25382fb31e4b22e0ea09cb0761863df5ad97ed72"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "paragonsdao",
    "filePath": "token:PDT",
    "symbol": "pdt",
    "name": "ParagonsDAO",
    "marketCapRank": 1127,
    "addresses": {
      "ethereum": "0x375abb85c329753b1ba849a601438ae77eec9893"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "paraswap",
    "filePath": "token:PSP",
    "symbol": "psp",
    "name": "ParaSwap",
    "marketCapRank": 732,
    "addresses": {
      "ethereum": "0xcafe001067cdef266afb7eb5a286dcfd277f3de5",
      "optimistic-ethereum": "0xd3594e879b358f430e20f82bea61e83562d49d48",
      "binance-smart-chain": "0xcafe001067cdef266afb7eb5a286dcfd277f3de5",
      "polygon-pos": "0x42d61d766b85431666b39b89c43011f24451bff6"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "paratoken-2",
    "filePath": "token:PARA",
    "symbol": "para",
    "name": "Para",
    "marketCapRank": 2123,
    "addresses": {
      "ethereum": "0xd16fd95d949f996e3808eeea0e3881c59e76ef1e"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "parex",
    "filePath": "token:PRX",
    "symbol": "prx",
    "name": "Parex",
    "marketCapRank": 1721,
    "addresses": {
      "binance-smart-chain": "0x90e3414e00e231b962666bd94adb811d5bcd0c2a"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "paribus",
    "filePath": "token:PBX",
    "symbol": "pbx",
    "name": "Paribus",
    "marketCapRank": 1208,
    "addresses": {
      "ethereum": "0xd528cf2e081f72908e086f8800977df826b5a483",
      "cardano": "cc8d1b026353022abbfcc2e1e71159f9e308d9c6e905ac1db24c7fb650617269627573",
      "arbitrum-one": "0xbad58ed9b5f26a002ea250d7a60dc6729a4a2403"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "parrot-usd",
    "filePath": "token:PAI",
    "symbol": "pai",
    "name": "Parrot USD",
    "marketCapRank": 1915,
    "addresses": {
      "solana": "Ea5SjE2Y6yvCeW5dYTn7PYMuW5ikXkvbGdcmSnXeaLjS"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "parsiq",
    "filePath": "token:PRQ",
    "symbol": "prq",
    "name": "PARSIQ",
    "marketCapRank": 840,
    "addresses": {
      "ethereum": "0x362bc847a3a9637d3af6624eec853618a43ed7d2",
      "binance-smart-chain": "0xd21d29b38374528675c34936bf7d5dd693d2a577"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "particl",
    "filePath": "token:PART",
    "symbol": "part",
    "name": "Particl",
    "marketCapRank": 1795,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "passage",
    "filePath": "token:PASG",
    "symbol": "pasg",
    "name": "Passage",
    "marketCapRank": 940,
    "addresses": {
      "osmosis": "ibc/208B2F137CDE510B44C41947C045CFDC27F996A9D990EA64460BDD5B3DBEB2ED"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "pastel",
    "filePath": "token:PSL",
    "symbol": "psl",
    "name": "Pastel",
    "marketCapRank": 2017,
    "addresses": {
      "ethereum": "0xc775c0c30840cb9f51e21061b054ebf1a00acc29"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "pawswap",
    "filePath": "token:PAW",
    "symbol": "paw",
    "name": "PAWSWAP",
    "marketCapRank": 1658,
    "addresses": {
      "ethereum": "0xdc63269ea166b70d4780b3a11f5c825c2b761b01"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "pawthereum",
    "filePath": "token:PAWTH",
    "symbol": "pawth",
    "name": "Pawthereum",
    "marketCapRank": 2183,
    "addresses": {
      "ethereum": "0xaecc217a749c2405b5ebc9857a16d58bdc1c367f",
      "binance-smart-chain": "0x409e215738e31d8ab252016369c2dd9c2008fee0"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "pax-gold",
    "filePath": "token:PAXG",
    "symbol": "paxg",
    "name": "PAX Gold",
    "marketCapRank": 216,
    "addresses": {
      "ethereum": "0x45804880de22913dafe09f4980848ece6ecbaf78",
      "harmony-shard-0": "0x7afb0e2eba6dc938945fe0f42484d3b8f442d0ac",
      "energi": "0xbf8afa4663b30c621a5f7497a972fc63c1a06c66"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "paypal-usd",
    "filePath": "token:PYUSD",
    "symbol": "pyusd",
    "name": "PayPal USD",
    "marketCapRank": 361,
    "addresses": {
      "ethereum": "0x6c3ea9036406852006290770bedfcaba0e23a0e8"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "paysenger-ego",
    "filePath": "token:EGO",
    "symbol": "ego",
    "name": "Paysenger EGO",
    "marketCapRank": 1676,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "pchain",
    "filePath": "token:PI",
    "symbol": "pi",
    "name": "Plian",
    "marketCapRank": 1959,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "peardao",
    "filePath": "token:PEX",
    "symbol": "pex",
    "name": "PearDAO",
    "marketCapRank": 2488,
    "addresses": {
      "binance-smart-chain": "0x6a0b66710567b6beb81a71f7e9466450a91a384b"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "peercoin",
    "filePath": "token:PPC",
    "symbol": "ppc",
    "name": "Peercoin",
    "marketCapRank": 1354,
    "addresses": {
      "ethereum": "0x044d078f1c86508e13328842cc75ac021b272958",
      "polygon-pos": "0x91e7e32c710661c44ae44d10aa86135d91c3ed65"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "pegaxy-stone",
    "filePath": "token:PGX",
    "symbol": "pgx",
    "name": "Pegaxy",
    "marketCapRank": 1954,
    "addresses": {
      "polygon-pos": "0xc1c93d475dc82fe72dbc7074d55f5a734f8ceeae",
      "avalanche": "0x0ef27ddc8f89d4886e89d630de089962ffc12e43"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "pendle",
    "filePath": "token:PENDLE",
    "symbol": "pendle",
    "name": "Pendle",
    "marketCapRank": 191,
    "addresses": {
      "ethereum": "0x808507121b80c02388fad14726482e061b8da827",
      "avalanche": "0xfb98b335551a418cd0737375a2ea0ded62ea213b",
      "optimistic-ethereum": "0xbc7b1ff1c6989f006a1185318ed4e7b5796e66e1",
      "arbitrum-one": "0x0c880f6761f1af8d9aa9c466984b80dab9a8c9e8",
      "binance-smart-chain": "0xb3ed0a426155b79b898849803e3b36552f7ed507"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "penpie",
    "filePath": "token:PNP",
    "symbol": "pnp",
    "name": "Penpie",
    "marketCapRank": 1289,
    "addresses": {
      "ethereum": "0x7dedbce5a2e31e4c75f87fea60bf796c17718715",
      "arbitrum-one": "0x2ac2b254bc18cd4999f64773a966e4f4869c34ee",
      "binance-smart-chain": "0x5012c90f14d190607662ca8344120812aaa2639d"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "pepe",
    "filePath": "token:PEPE",
    "symbol": "pepe",
    "name": "Pepe",
    "marketCapRank": 42,
    "addresses": {
      "ethereum": "0x6982508145454ce325ddbe47a25d4ec3d2311933",
      "arbitrum-one": "0x25d887ce7a35172c62febfd67a1856f20faebb00",
      "binance-smart-chain": "0x25d887ce7a35172c62febfd67a1856f20faebb00"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "pepefork",
    "filePath": "token:PORK",
    "symbol": "pork",
    "name": "PepeFork",
    "marketCapRank": 549,
    "addresses": {
      "ethereum": "0xb9f599ce614feb2e1bbe58f180f370d05b39344e"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "per-project",
    "filePath": "token:PER",
    "symbol": "per",
    "name": "PER Project",
    "marketCapRank": 1838,
    "addresses": {
      "klay-token": "0x7eee60a000986e9efe7f5c90340738558c24317b"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "peri-finance",
    "filePath": "token:PERI",
    "symbol": "peri",
    "name": "PERI Finance",
    "marketCapRank": 2383,
    "addresses": {
      "ethereum": "0x5d30ad9c6374bf925d0a75454fa327aacf778492",
      "binance-smart-chain": "0xb49b7e0742ecb4240ffe91661d2a580677460b6a",
      "polygon-pos": "0xdc0e17eae3b9651875030244b971fa0223a1764f"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "perion",
    "filePath": "token:PERC",
    "symbol": "perc",
    "name": "Perion",
    "marketCapRank": 1301,
    "addresses": {
      "ethereum": "0x60be1e1fe41c1370adaf5d8e66f07cf1c2df2268"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "perpetual-protocol",
    "filePath": "token:PERP",
    "symbol": "perp",
    "name": "Perpetual Protocol",
    "marketCapRank": 507,
    "addresses": {
      "ethereum": "0xbc396689893d065f41bc2c6ecbee5e0085233447",
      "optimistic-ethereum": "0x9e1028f5f1d5ede59748ffcee5532509976840e0",
      "xdai": "0x7ecf26cd9a36990b8ea477853663092333f59979",
      "arbitrum-one": "0x753d224bcf9aafacd81558c32341416df61d3dac",
      "binance-smart-chain": "0x4e7f408be2d4e9d60f49a64b89bb619c84c7c6f5"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "perpy-finance",
    "filePath": "token:PRY",
    "symbol": "pry",
    "name": "Perpy Finance",
    "marketCapRank": 2265,
    "addresses": {
      "arbitrum-one": "0x1824a51c106efc27d35a74efb56d9bf54ddb22d4"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "persistence",
    "filePath": "token:XPRT",
    "symbol": "xprt",
    "name": "Persistence One",
    "marketCapRank": 624,
    "addresses": {
      "osmosis": "ibc/A0CC0CF735BFB30E730C70019D4218A1244FF383503FF7579C9201AB93CA9293"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "petals",
    "filePath": "token:PTS",
    "symbol": "pts",
    "name": "Petals",
    "marketCapRank": 1056,
    "addresses": {
      "binance-smart-chain": "0xfa53a4778431712af31a11621edee4d0926df1ac"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "pha",
    "filePath": "token:PHA",
    "symbol": "pha",
    "name": "Phala",
    "marketCapRank": 388,
    "addresses": {
      "ethereum": "0x6c5ba91642f10282b576d91922ae6448c9d52f4e",
      "sora": "0x0033271716eec64234a5324506c4558de27b7c23c42f3e3b74801f98bdfeebf7"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "phantasma",
    "filePath": "token:SOUL",
    "symbol": "soul",
    "name": "Phantasma",
    "marketCapRank": 1131,
    "addresses": {
      "ethereum": "0x75858677e27c930fb622759feaffee2b754af07f",
      "binance-smart-chain": "0x298eff8af1ecebbb2c034eaa3b9a5d0cc56c59cd"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "phoenix-global",
    "filePath": "token:PHB",
    "symbol": "phb",
    "name": "Phoenix",
    "marketCapRank": 459,
    "addresses": {
      "binance-smart-chain": "0x0409633a72d846fc5bbe2f98d88564d35987904d"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "phonon-dao",
    "filePath": "token:PHONON",
    "symbol": "phonon",
    "name": "Phonon DAO",
    "marketCapRank": 1935,
    "addresses": {
      "ethereum": "0x758b4684be769e92eefea93f60dda0181ea303ec",
      "arbitrum-one": "0x39a49bc5017fc668299cd32e734c9269acc35295"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "pibble",
    "filePath": "token:PIB",
    "symbol": "pib",
    "name": "Pibble",
    "marketCapRank": 1307,
    "addresses": {
      "ethereum": "0x1864ce27e9f7517047933caae530674e8c70b8a7",
      "klay-token": "0xafde910130c335fa5bd5fe991053e3e0a49dce7b"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "picasso",
    "filePath": "token:PICA",
    "symbol": "pica",
    "name": "Picasso",
    "marketCapRank": 879,
    "addresses": {
      "ethereum": "0xbb63a9b64a80e9338b8ea298c51765e57c4f159c",
      "secret": "secret1e0y9vf4xr9wffyxsvlz35jzl5st2srkdl8frac"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "piccolo-inu",
    "filePath": "token:PINU",
    "symbol": "pinu",
    "name": "Piccolo Inu",
    "marketCapRank": 2540,
    "addresses": {
      "ethereum": "0x3a1311b8c404629e38f61d566cefefed083b9670"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "pickle-finance",
    "filePath": "token:PICKLE",
    "symbol": "pickle",
    "name": "Pickle Finance",
    "marketCapRank": 2149,
    "addresses": {
      "ethereum": "0x429881672b9ae42b8eba0e26cd9c73711b891ca5",
      "arbitrum-one": "0x965772e0e9c84b6f359c8597c891108dcf1c5b1a",
      "polygon-pos": "0x2b88ad57897a8b496595925f43048301c37615da",
      "aurora": "0x291c8fceaca3342b29cc36171deb98106f712c66"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "pika-protocol",
    "filePath": "token:PIKA",
    "symbol": "pika",
    "name": "Pika Protocol",
    "marketCapRank": 1451,
    "addresses": {
      "optimistic-ethereum": "0x9a601c5bb360811d96a23689066af316a30c3027"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "pillar",
    "filePath": "token:PLR",
    "symbol": "plr",
    "name": "Pillar",
    "marketCapRank": 2619,
    "addresses": {
      "ethereum": "0xe3818504c1b32bf1557b16c238b2e01fd3149c17",
      "polygon-pos": "0xa6b37fc85d870711c56fbcb8afe2f8db049ae774",
      "binance-smart-chain": "0x790cfdc6ab2e0ee45a433aac5434f183be1f6a20"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "pinksale",
    "filePath": "token:PINKSALE",
    "symbol": "pinksale",
    "name": "PinkSale",
    "marketCapRank": 999,
    "addresses": {
      "binance-smart-chain": "0x602ba546a7b06e0fc7f58fd27eb6996ecc824689"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "pintu-token",
    "filePath": "token:PTU",
    "symbol": "ptu",
    "name": "Pintu",
    "marketCapRank": 1046,
    "addresses": {
      "ethereum": "0xc229c69eb3bb51828d0caa3509a05a51083898dd"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "pip",
    "filePath": "token:PIP",
    "symbol": "pip",
    "name": "PIP",
    "marketCapRank": 1146,
    "addresses": {
      "solana": "HHjoYwUp5aU6pnrvN4s2pwEErwXNZKhxKGYjRJMoBjLw"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "pirate-chain",
    "filePath": "token:ARRR",
    "symbol": "arrr",
    "name": "Pirate Chain",
    "marketCapRank": 946,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "pivx",
    "filePath": "token:PIVX",
    "symbol": "pivx",
    "name": "PIVX",
    "marketCapRank": 896,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "pixels",
    "filePath": "token:PIXEL",
    "symbol": "pixel",
    "name": "Pixels",
    "marketCapRank": 176,
    "addresses": {
      "ethereum": "0x3429d03c6f7521aec737a0bbf2e5ddcef2c3ae31",
      "ronin": "0x7eae20d11ef8c779433eb24503def900b9d28ad7"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "pizabrc",
    "filePath": "token:PIZA",
    "symbol": "piza",
    "name": "PIZA (Ordinals)",
    "marketCapRank": 1915,
    "addresses": {
      "ordinals": "c0dd0bc7d0620a02cfedc57a280cfd79823bc754623f9318d9755bcd3b131d14i0"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "pkt",
    "filePath": "token:PKT",
    "symbol": "pkt",
    "name": "PKT",
    "marketCapRank": 1373,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "planetwatch",
    "filePath": "token:PLANETS",
    "symbol": "planets",
    "name": "PlanetWatch",
    "marketCapRank": 1990,
    "addresses": {
      "algorand": "27165954"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "plasma-finance",
    "filePath": "token:PPAY",
    "symbol": "ppay",
    "name": "Plasma Finance",
    "marketCapRank": 2421,
    "addresses": {
      "ethereum": "0x054d64b73d3d8a21af3d764efd76bcaa774f3bb2",
      "polygon-pos": "0x08158a6b5d4018340387d1a302f882e98a8bc5b4",
      "binance-smart-chain": "0xfb288d60d3b66f9c3e231a9a39ed3f158a4269aa"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "plastiks",
    "filePath": "token:PLASTIK",
    "symbol": "plastik",
    "name": "Plastiks",
    "marketCapRank": 2602,
    "addresses": {
      "celo": "0x27cd006548df7c8c8e9fdc4a67fa05c2e3ca5cf9"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "platon-network",
    "filePath": "token:LAT",
    "symbol": "lat",
    "name": "PlatON Network",
    "marketCapRank": 518,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "playa3ull-games-2",
    "filePath": "token:3ULL",
    "symbol": "3ull",
    "name": "PLAYA3ULL GAMES",
    "marketCapRank": 933,
    "addresses": {
      "avalanche": "0xa77e70d0af1ac7ff86726740db1bd065c3566937"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "playchip",
    "filePath": "token:PLA",
    "symbol": "pla",
    "name": "PlayChip",
    "marketCapRank": null,
    "addresses": {
      "ethereum": "0x0198f46f520f33cd4329bd4be380a25a90536cd5"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "playzap",
    "filePath": "token:PZP",
    "symbol": "pzp",
    "name": "PlayZap",
    "marketCapRank": 1383,
    "addresses": {
      "binance-smart-chain": "0x6ad9e9c098a45b2b41b519119c31c3dcb02accb2",
      "eos": "0xf6f46bd1f85ebf00c6d7490678ad020bc73969a7",
      "solana": "2CnfY3wZu715Mdbj1CeWfMNcsKNqkREPjTmW4o1Psj9J",
      "kucoin-community-chain": "0x22648c12acd87912ea1710357b1302c6a4154ebc",
      "eos-evm": "0xbb8e513b2897ac9c1c47eecfcb42dbd4b77f9275"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "plearn",
    "filePath": "token:PLN",
    "symbol": "pln",
    "name": "PLEARN",
    "marketCapRank": 1359,
    "addresses": {
      "binance-smart-chain": "0xbe0d3526fc797583dada3f30bc390013062a048b"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "pleasure-coin",
    "filePath": "token:NSFW",
    "symbol": "nsfw",
    "name": "Pleasure Coin",
    "marketCapRank": 2003,
    "addresses": {
      "polygon-pos": "0x8f006d1e1d9dc6c98996f50a4c810f17a47fbf19",
      "ethereum": "0x8f006d1e1d9dc6c98996f50a4c810f17a47fbf19",
      "binance-smart-chain": "0xaa076b62efc6f357882e07665157a271ab46a063"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "plebbit",
    "filePath": "token:PLEB",
    "symbol": "pleb",
    "name": "Plebbit",
    "marketCapRank": 1366,
    "addresses": {
      "ethereum": "0xea81dab2e0ecbc6b5c4172de4c22b6ef6e55bd8f"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "plex",
    "filePath": "token:PLEX",
    "symbol": "plex",
    "name": "PLEX",
    "marketCapRank": 1698,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "plugin",
    "filePath": "token:PLI",
    "symbol": "pli",
    "name": "Plugin",
    "marketCapRank": 1836,
    "addresses": {
      "xdc-network": "xdcff7412ea7c8445c46a8254dfb557ac1e48094391"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "pluton",
    "filePath": "token:PLU",
    "symbol": "plu",
    "name": "Pluton",
    "marketCapRank": 994,
    "addresses": {
      "ethereum": "0xd8912c10681d8b21fd3742244f44658dba12264e"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "pnetwork",
    "filePath": "token:PNT",
    "symbol": "pnt",
    "name": "pNetwork",
    "marketCapRank": 1805,
    "addresses": {
      "ethereum": "0x89ab32156e46f46d02ade3fecbe5fc4243b9aaed",
      "binance-smart-chain": "0xdaacb0ab6fb34d24e8a67bfa14bf4d95d4c7af92"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "pocket-network",
    "filePath": "token:POKT",
    "symbol": "pokt",
    "name": "Pocket Network",
    "marketCapRank": 244,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "pointpay",
    "filePath": "token:PXP",
    "symbol": "pxp",
    "name": "PointPay",
    "marketCapRank": 1976,
    "addresses": {
      "ethereum": "0x95aa5d2dbd3c16ee3fdea82d5c6ec3e38ce3314f"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "polaris-share",
    "filePath": "token:POLA",
    "symbol": "pola",
    "name": "Polaris Share",
    "marketCapRank": 1114,
    "addresses": {
      "ethereum": "0xc691bc298a304d591ad9b352c7a8d216de9f2ced"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "polka-city",
    "filePath": "token:POLC",
    "symbol": "polc",
    "name": "Polkacity",
    "marketCapRank": 1539,
    "addresses": {
      "ethereum": "0xaa8330fb2b4d5d07abfe7a72262752a8505c6b37",
      "binance-smart-chain": "0x6ae9701b9c423f40d54556c9a443409d79ce170a"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "polkabridge",
    "filePath": "token:PBR",
    "symbol": "pbr",
    "name": "PolkaBridge",
    "marketCapRank": 1851,
    "addresses": {
      "ethereum": "0x298d492e8c1d909d3f63bc4a36c66c64acb3d695",
      "polygon-pos": "0x0d6ae2a429df13e44a07cd2969e085e4833f64a0",
      "binance-smart-chain": "0x1d1cb8997570e73949930c01fe5796c88d7336c6"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "polkadex",
    "filePath": "token:PDEX",
    "symbol": "pdex",
    "name": "Polkadex",
    "marketCapRank": 1729,
    "addresses": {
      "ethereum": "0xf59ae934f6fe444afc309586cc60a84a0f89aaea",
      "sora": "0x008a99c642c508f4f718598f32fa9ecbeea854e335312fecdbd298b92de26e21"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "polkadot",
    "filePath": "token:DOT",
    "symbol": "dot",
    "name": "Polkadot",
    "marketCapRank": 14,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "polkafoundry",
    "filePath": "token:PKF",
    "symbol": "pkf",
    "name": "Red Kite",
    "marketCapRank": 1283,
    "addresses": {
      "ethereum": "0x8b39b70e39aa811b69365398e0aace9bee238aeb"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "polkamarkets",
    "filePath": "token:POLK",
    "symbol": "polk",
    "name": "Polkamarkets",
    "marketCapRank": 1912,
    "addresses": {
      "ethereum": "0xd478161c952357f05f0292b56012cd8457f1cfbf"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "polkastarter",
    "filePath": "token:POLS",
    "symbol": "pols",
    "name": "Polkastarter",
    "marketCapRank": 481,
    "addresses": {
      "ethereum": "0x83e6f1e41cdd28eaceb20cb649155049fac3d5aa",
      "binance-smart-chain": "0x7e624fa0e1c4abfd309cc15719b7e2580887f570"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "polkaswap",
    "filePath": "token:PSWAP",
    "symbol": "pswap",
    "name": "Polkaswap",
    "marketCapRank": 1542,
    "addresses": {
      "ethereum": "0x519c1001d550c0a1dae7d1fc220f7d14c2a521bb",
      "sora": "0x0200050000000000000000000000000000000000000000000000000000000000"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "polker",
    "filePath": "token:PKR",
    "symbol": "pkr",
    "name": "Polker",
    "marketCapRank": 2324,
    "addresses": {
      "polygon-pos": "0x140a4e80dd8184536acc45f1c452d7540472e6e1"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "polychain-monsters",
    "filePath": "token:PMON",
    "symbol": "pmon",
    "name": "Polychain Monsters",
    "marketCapRank": 2080,
    "addresses": {
      "ethereum": "0x1796ae0b0fa4862485106a0de9b654efe301d0b2",
      "binance-smart-chain": "0x1796ae0b0fa4862485106a0de9b654efe301d0b2",
      "polygon-pos": "0x1796ae0b0fa4862485106a0de9b654efe301d0b2"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "polydoge",
    "filePath": "token:POLYDOGE",
    "symbol": "polydoge",
    "name": "PolyDoge",
    "marketCapRank": 1465,
    "addresses": {
      "polygon-pos": "0x8a953cfe442c5e8855cc6c61b1293fa648bae472"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "polygon-ecosystem-token",
    "filePath": "token:POL",
    "symbol": "pol",
    "name": "Polygon Ecosystem Token",
    "marketCapRank": 487,
    "addresses": {
      "ethereum": "0x455e53cbb86018ac2b8092fdcd39d8444affc3f6"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "polylastic",
    "filePath": "token:POLX",
    "symbol": "polx",
    "name": "Polylastic",
    "marketCapRank": 2054,
    "addresses": {
      "polygon-pos": "0x187ae45f2d361cbce37c6a8622119c91148f261b"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "polymath",
    "filePath": "token:POLY",
    "symbol": "poly",
    "name": "Polymath",
    "marketCapRank": 540,
    "addresses": {
      "ethereum": "0x9992ec3cf6a55b00978cddf2b27bc6882d88d1ec",
      "energi": "0xe99bbd3b25a014aac93127cf868d3de07386c4dd"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "polymesh",
    "filePath": "token:POLYX",
    "symbol": "polyx",
    "name": "Polymesh",
    "marketCapRank": 157,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "polypad",
    "filePath": "token:POLYPAD",
    "symbol": "polypad",
    "name": "PolyPad",
    "marketCapRank": 2305,
    "addresses": {
      "polygon-pos": "0x30ea765d4dda26e0f89e1b23a7c7b2526b7d29ec",
      "binance-smart-chain": "0x8ae619d633cce175a2fbcfa1cea119ddc80f1342"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "polyswarm",
    "filePath": "token:NCT",
    "symbol": "nct",
    "name": "PolySwarm",
    "marketCapRank": 755,
    "addresses": {
      "ethereum": "0x9e46a38f5daabe8683e10793b06749eef7d733d1",
      "polygon-pos": "0x4985e0b13554fb521840e893574d3848c10fcc6f"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "polytrade",
    "filePath": "token:TRADE",
    "symbol": "trade",
    "name": "Polytrade",
    "marketCapRank": 601,
    "addresses": {
      "ethereum": "0x6e5970dbd6fc7eb1f29c6d2edf2bc4c36124c0c1",
      "arbitrum-one": "0xe22c452bd2ade15dfc8ad98286bc6bdf0c9219b7",
      "polygon-pos": "0x692ac1e363ae34b6b489148152b12e2785a3d8d6",
      "binance-smart-chain": "0x6ba7a8f9063c712c1c8cabc776b1da7126805f3b"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "pooh",
    "filePath": "token:POOH",
    "symbol": "pooh",
    "name": "POOH",
    "marketCapRank": 1121,
    "addresses": {
      "ethereum": "0xb69753c06bb5c366be51e73bfc0cc2e3dc07e371",
      "solana": "J8XFfJgS1cs5WVGxGwZb9Rt5rJZizdyzaLhidtvDnYjC"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "poollotto-finance",
    "filePath": "token:PLT",
    "symbol": "plt",
    "name": "Poollotto.finance",
    "marketCapRank": 1133,
    "addresses": {
      "binance-smart-chain": "0x631c2f0edabac799f07550aee4ff0bf7fd35212b"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "poolz-finance-2",
    "filePath": "token:POOLX",
    "symbol": "poolx",
    "name": "Poolz Finance",
    "marketCapRank": 1082,
    "addresses": {
      "binance-smart-chain": "0xbaea9aba1454df334943951d51116ae342eab255"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "popcat",
    "filePath": "token:POPCAT",
    "symbol": "popcat",
    "name": "Popcat",
    "marketCapRank": 259,
    "addresses": {
      "solana": "7GCihgDB8fe6KNjn2MYtkzZcRjQy3t9GHdC8uHYmW2hr"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "popcorn",
    "filePath": "token:POP",
    "symbol": "pop",
    "name": "Popcorn",
    "marketCapRank": 2835,
    "addresses": {
      "ethereum": "0xd0cd466b34a24fcb2f87676278af2005ca8a78c4",
      "optimistic-ethereum": "0x6f0fecbc276de8fc69257065fe47c5a03d986394",
      "arbitrum-one": "0x68ead55c258d6fa5e46d67fc90f53211eab885be",
      "binance-smart-chain": "0xe8647ea19496e87c061bbad79f457928b2f52b5a",
      "polygon-pos": "0xc5b57e9a1e7914fda753a88f24e5703e617ee50c"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "populous",
    "filePath": "token:PPT",
    "symbol": "ppt",
    "name": "Populous",
    "marketCapRank": 2529,
    "addresses": {
      "ethereum": "0xd4fa1460f537bb9085d22c7bccb5dd450ef28e3a",
      "energi": "0x2483a716a4a5476da5e657be13a37cf62b608ab6"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "portal-2",
    "filePath": "token:PORTAL",
    "symbol": "portal",
    "name": "Portal",
    "marketCapRank": 251,
    "addresses": {
      "ethereum": "0x1bbe973bef3a977fc51cbed703e8ffdefe001fed"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "power",
    "filePath": "token:PWR",
    "symbol": "pwr",
    "name": "MaxxChain",
    "marketCapRank": 2824,
    "addresses": {
      "ethereum": "0xd9dcd611bed2be9a4700c725a3810870b9bff094"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "power-ledger",
    "filePath": "token:POWR",
    "symbol": "powr",
    "name": "Powerledger",
    "marketCapRank": 331,
    "addresses": {
      "ethereum": "0x595832f8fc6bf59c85c527fec3740a1b7a361269",
      "energi": "0xd1bbc2a68b97a8ae4b423bbf534e767ef6275a30"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "premia",
    "filePath": "token:PREMIA",
    "symbol": "premia",
    "name": "Premia",
    "marketCapRank": 1352,
    "addresses": {
      "ethereum": "0x6399c842dd2be3de30bf99bc7d1bbf6fa3650e70",
      "fantom": "0x3028b4395f98777123c7da327010c40f3c7cc4ef",
      "optimistic-ethereum": "0x374ad0f47f4ca39c78e5cc54f1c9e426ff8f231a",
      "arbitrum-one": "0x51fc0f6660482ea73330e414efd7808811a57fa2"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "presearch",
    "filePath": "token:PRE",
    "symbol": "pre",
    "name": "Presearch",
    "marketCapRank": 1421,
    "addresses": {
      "ethereum": "0xec213f83defb583af3a000b1c0ada660b1902a0f"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "primal-b3099cd0-995a-4311-80d5-9c133153b38e",
    "filePath": "token:PRIMAL",
    "symbol": "primal",
    "name": "PRIMAL",
    "marketCapRank": 2560,
    "addresses": {
      "binance-smart-chain": "0xcb5327ed4649548e0d73e70b633cdfd99af6da87",
      "ethereum": "0xdd13dedecebda566322195bc4451d672a148752c",
      "step-network": "0x0bbe45a033aab7a90006c05aa648efd3d2993f9e"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "prism",
    "filePath": "token:PRISM",
    "symbol": "prism",
    "name": "Prism",
    "marketCapRank": 1694,
    "addresses": {
      "solana": "PRSMNsEPqhGVCH1TtWiJqPjJyh2cKrLostPZTNy1o5x"
    },
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "probit-exchange",
    "filePath": "token:PROB",
    "symbol": "prob",
    "name": "Probit",
    "marketCapRank": 2096,
    "addresses": {
      "ethereum": "0xfb559ce67ff522ec0b9ba7f5dc9dc7ef6c139803"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "project-galaxy",
    "filePath": "token:GAL",
    "symbol": "gal",
    "name": "Galxe",
    "marketCapRank": 187,
    "addresses": {
      "ethereum": "0x5faa989af96af85384b8a938c2ede4a7378d9875",
      "binance-smart-chain": "0xe4cc45bb5dbda06db6183e8bf016569f40497aa5"
    },
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "project-with",
    "filePath": "token:WIKEN",
    "symbol": "wiken",
    "name": "Project WITH",
    "marketCapRank": 1279,
    "addresses": {
      "klay-token": "0x275f942985503d8ce9558f8377cc526a3aba3566"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "prometeus",
    "filePath": "token:PROM",
    "symbol": "prom",
    "name": "Prom",
    "marketCapRank": 298,
    "addresses": {
      "ethereum": "0xfc82bb4ba86045af6f327323a46e80412b91b27d",
      "binance-smart-chain": "0xaf53d56ff99f1322515e54fdde93ff8b3b7dafd5"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "propbase",
    "filePath": "token:PROPS",
    "symbol": "props",
    "name": "Propbase",
    "marketCapRank": 628,
    "addresses": {
      "aptos": "0xe50684a338db732d8fb8a3ac71c4b8633878bd0193bca5de2ebc852a83b35099"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "propchain",
    "filePath": "token:PROPC",
    "symbol": "propc",
    "name": "Propchain",
    "marketCapRank": 595,
    "addresses": {
      "ethereum": "0x9ff58067bd8d239000010c154c6983a325df138e"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "propy",
    "filePath": "token:PRO",
    "symbol": "pro",
    "name": "Propy",
    "marketCapRank": 495,
    "addresses": {
      "ethereum": "0x226bb599a12c826476e3a771454697ea52e9e220"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "prosper",
    "filePath": "token:PROS",
    "symbol": "pros",
    "name": "Prosper",
    "marketCapRank": 1242,
    "addresses": {
      "ethereum": "0x8642a849d0dcb7a15a974794668adcfbe4794b56",
      "polygon-pos": "0x6109cb051c5c64093830121ed76272ab04bbdd7c",
      "binance-smart-chain": "0xed8c8aa8299c10f067496bb66f8cc7fb338a3405"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "protectorate-protocol",
    "filePath": "token:PRTC",
    "symbol": "prtc",
    "name": "Protectorate Protocol",
    "marketCapRank": 2276,
    "addresses": {
      "ethereum": "0xb9098d3669a78e9afe8b94a97290407400d9da31"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "proteo-defi",
    "filePath": "token:PROTEO",
    "symbol": "proteo",
    "name": "Proteo DeFi",
    "marketCapRank": 2371,
    "addresses": {
      "elrond": "PROTEO-0c7311"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "proton",
    "filePath": "token:XPR",
    "symbol": "xpr",
    "name": "XPR Network",
    "marketCapRank": 778,
    "addresses": {
      "ethereum": "0xd7efb00d12c2c13131fd319336fdf952525da2af",
      "binance-smart-chain": "0x5de3939b2f811a61d830e6f52d13b066881412ab"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "proximax",
    "filePath": "token:XPX",
    "symbol": "xpx",
    "name": "ProximaX",
    "marketCapRank": 1737,
    "addresses": {
      "binance-smart-chain": "0x6f3aaf802f57d045efdd2ac9c06d8879305542af"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "pstake-finance",
    "filePath": "token:PSTAKE",
    "symbol": "pstake",
    "name": "pSTAKE Finance",
    "marketCapRank": 705,
    "addresses": {
      "ethereum": "0xfb5c6815ca3ac72ce9f5006869ae67f18bf77006",
      "binance-smart-chain": "0x4c882ec256823ee773b25b414d36f92ef58a7c0c"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "pumlx",
    "filePath": "token:PUMLX",
    "symbol": "pumlx",
    "name": "PUMLx",
    "marketCapRank": 2378,
    "addresses": {
      "ethereum": "0x8c088775e4139af116ac1fa6f281bbf71e8c1c73"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "pundi-x",
    "filePath": "token:NPXS",
    "symbol": "npxs",
    "name": "Pundi X [OLD]",
    "marketCapRank": 593,
    "addresses": {
      "ethereum": "0xa15c7ebe1f07caf6bff097d8a589fb8ac49ae5b3",
      "energi": "0x1bf6ea422574e0f5d336083a771768cb4e11390d"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "pundi-x-2",
    "filePath": "token:PUNDIX",
    "symbol": "pundix",
    "name": "Pundi X",
    "marketCapRank": 382,
    "addresses": {
      "ethereum": "0x0fd10b9899882a6f2fcb5c371e17e70fdee00c38"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "pundi-x-purse",
    "filePath": "token:PURSE",
    "symbol": "purse",
    "name": "Pundi X PURSE",
    "marketCapRank": 1570,
    "addresses": {
      "binance-smart-chain": "0x29a63f4b209c29b4dc47f06ffa896f32667dad2c",
      "function-x": "0x5fd55a1b9fc24967c4db09c513c3ba0dfa7ff687",
      "ethereum": "0x95987b0cdc7f65d989a30b3b7132a38388c548eb"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "purefi",
    "filePath": "token:UFI",
    "symbol": "ufi",
    "name": "PureFi",
    "marketCapRank": 1217,
    "addresses": {
      "ethereum": "0xcda4e840411c00a614ad9205caec807c7458a0e3",
      "binance-smart-chain": "0xe2a59d5e33c6540e18aaa46bf98917ac3158db0d",
      "polygon-pos": "0x3c205c8b3e02421da82064646788c82f7bd753b9"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "pussy-financial",
    "filePath": "token:PUSSY",
    "symbol": "pussy",
    "name": "Pussy Financial",
    "marketCapRank": 2133,
    "addresses": {
      "ethereum": "0x9196e18bc349b1f64bc08784eae259525329a1ad",
      "binance-smart-chain": "0xd9e8d20bde081600fac0d94b88eafaddce55aa43"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "pyth-network",
    "filePath": "token:PYTH",
    "symbol": "pyth",
    "name": "Pyth Network",
    "marketCapRank": 86,
    "addresses": {
      "solana": "HZ1JovNiVvGrGNiiYvEozEVgZ58xaU3RKwX8eACQBCt3",
      "manta-pacific": "0x90e95735378a31bfad2dcd87128fbb80ffeb6917",
      "neon-evm": "0x0575dd4afd93b7522fee4e0179f243eca3856137"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "qanplatform",
    "filePath": "token:QANX",
    "symbol": "qanx",
    "name": "QANplatform",
    "marketCapRank": 423,
    "addresses": {
      "ethereum": "0xaaa9214f675316182eaa21c85f0ca99160cc3aaa",
      "binance-smart-chain": "0xaaa9214f675316182eaa21c85f0ca99160cc3aaa"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "qash",
    "filePath": "token:QASH",
    "symbol": "qash",
    "name": "QASH",
    "marketCapRank": 1149,
    "addresses": {
      "ethereum": "0x618e75ac90b12c6049ba3b27f5d5f8651b0037f6"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "qlink",
    "filePath": "token:QLC",
    "symbol": "qlc",
    "name": "Kepple [OLD]",
    "marketCapRank": 1427,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "qmall",
    "filePath": "token:QMALL",
    "symbol": "qmall",
    "name": "Qmall",
    "marketCapRank": 1742,
    "addresses": {
      "binance-smart-chain": "0x07e551e31a793e20dc18494ff6b03095a8f8ee36",
      "ethereum": "0x2217e5921b7edfb4bb193a6228459974010d2198",
      "velas": "0x2217e5921b7edfb4bb193a6228459974010d2198"
    },
    "variants": [
      "mono"
    ]
  },
  {
    "id": "qredo",
    "filePath": "token:QRDO",
    "symbol": "qrdo",
    "name": "Qredo",
    "marketCapRank": 689,
    "addresses": {
      "ethereum": "0x4123a133ae3c521fd134d7b13a2dec35b56c2463"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "qrolli",
    "filePath": "token:QR",
    "symbol": "qr",
    "name": "Qrolli",
    "marketCapRank": 2261,
    "addresses": {
      "ethereum": "0xccdb064a41afcd432bcea6f6d0d1e7c371d0b002"
    },
    "variants": [
      "mono"
    ]
  },
  {
    "id": "qtum",
    "filePath": "token:QTUM",
    "symbol": "qtum",
    "name": "Qtum",
    "marketCapRank": 190,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "quadency",
    "filePath": "token:QUAD",
    "symbol": "quad",
    "name": "Quadency",
    "marketCapRank": 2291,
    "addresses": {
      "ethereum": "0xab2a7b5876d707e0126b3a75ef7781c77c8877ee"
    },
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "quadrant-protocol",
    "filePath": "token:EQUAD",
    "symbol": "equad",
    "name": "Quadrant Protocol",
    "marketCapRank": 1982,
    "addresses": {
      "ethereum": "0xc28e931814725bbeb9e670676fabbcb694fe7df2"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "quant-network",
    "filePath": "token:QNT",
    "symbol": "qnt",
    "name": "Quant",
    "marketCapRank": 65,
    "addresses": {
      "ethereum": "0x4a220e6096b25eadb88358cb44068a3248254675",
      "energi": "0x462b35452e552a66b519ecf70aedb1835d434965"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "quantum-resistant-ledger",
    "filePath": "token:QRL",
    "symbol": "qrl",
    "name": "Quantum Resistant Ledger",
    "marketCapRank": 1095,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "quark-chain",
    "filePath": "token:QKC",
    "symbol": "qkc",
    "name": "QuarkChain",
    "marketCapRank": 505,
    "addresses": {
      "ethereum": "0xea26c4ac16d4a5a106820bc8aee85fd0b7b2b664",
      "energi": "0x02c6c53930b20bced86ddf64007bebcd923e1093"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "quasar-2",
    "filePath": "token:QSR",
    "symbol": "qsr",
    "name": "Quasar",
    "marketCapRank": 494,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "quick",
    "filePath": "token:QUICK",
    "symbol": "quick",
    "name": "Quickswap [OLD]",
    "marketCapRank": 739,
    "addresses": {
      "ethereum": "0x6c28aef8977c9b773996d0e8376d2ee379446f2f",
      "polygon-pos": "0x831753dd7087cac61ab5644b308642cc1c33dc13"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "quidd",
    "filePath": "token:QUIDD",
    "symbol": "quidd",
    "name": "Quidd",
    "marketCapRank": 3058,
    "addresses": {
      "ethereum": "0xda9fdab21bc4a5811134a6e0ba6ca06624e67c07",
      "polygon-pos": "0x123706cdd8e60324e610e9a2cc7012d0f45a5b8e",
      "binance-smart-chain": "0x7961ade0a767c0e5b67dd1a1f78ba44f727642ed"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "quint",
    "filePath": "token:QUINT",
    "symbol": "quint",
    "name": "Quint",
    "marketCapRank": 1746,
    "addresses": {
      "binance-smart-chain": "0x64619f611248256f7f4b72fe83872f89d5d60d64"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "quiztok",
    "filePath": "token:QTCON",
    "symbol": "qtcon",
    "name": "Quiztok",
    "marketCapRank": 1215,
    "addresses": {
      "ethereum": "0x1bf7fd22709733ccd7c45ab27dd02c7ec8e50078",
      "solana": "DkNihsQs1hqEwf9TgKP8FmGv7dmMQ7hnKjS2ZSmMZZBE"
    },
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "r",
    "filePath": "token:R",
    "symbol": "r",
    "name": "R",
    "marketCapRank": 2381,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "rabbitx",
    "filePath": "token:RBX",
    "symbol": "rbx",
    "name": "RabbitX",
    "marketCapRank": 1006,
    "addresses": {
      "ethereum": "0x3ba925fdeae6b46d0bb4d424d829982cb2f7309e"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "radiant",
    "filePath": "token:RXD",
    "symbol": "rxd",
    "name": "Radiant",
    "marketCapRank": 1091,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "radiant-capital",
    "filePath": "token:RDNT",
    "symbol": "rdnt",
    "name": "Radiant Capital",
    "marketCapRank": 393,
    "addresses": {
      "arbitrum-one": "0x3082cc23568ea640225c2467653db90e9250aaa0",
      "ethereum": "0x137ddb47ee24eaa998a535ab00378d6bfa84f893",
      "binance-smart-chain": "0xf7de7e8a6bd59ed41a4b5fe50278b3b7f31384df"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "radicle",
    "filePath": "token:RAD",
    "symbol": "rad",
    "name": "Radworks",
    "marketCapRank": 408,
    "addresses": {
      "ethereum": "0x31c8eacbffdd875c74b94b077895bd78cf1e64a3"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "radioshack",
    "filePath": "token:RADIO",
    "symbol": "radio",
    "name": "RadioShack",
    "marketCapRank": 2241,
    "addresses": {
      "polygon-pos": "0x613a489785c95afeb3b404cc41565ccff107b6e0",
      "avalanche": "0x02bfd11499847003de5f0f5aa081c43854d48815",
      "optimistic-ethereum": "0xf899e3909b4492859d44260e1de41a9e663e70f5",
      "binance-smart-chain": "0x30807d3b851a31d62415b8bb7af7dca59390434a",
      "ethereum": "0x7a5d3a9dcd33cb8d527f7b5f96eb4fef43d55636",
      "cronos": "0xf899e3909b4492859d44260e1de41a9e663e70f5",
      "fantom": "0xf899e3909b4492859d44260e1de41a9e663e70f5"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "radix",
    "filePath": "token:XRD",
    "symbol": "xrd",
    "name": "Radix",
    "marketCapRank": 134,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "rae-token",
    "filePath": "token:RAE",
    "symbol": "rae",
    "name": "Receive Access Ecosystem",
    "marketCapRank": 1671,
    "addresses": {
      "ethereum": "0xe5a3229ccb22b6484594973a03a3851dcd948756"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "rai",
    "filePath": "token:RAI",
    "symbol": "rai",
    "name": "Rai Reflex Index",
    "marketCapRank": 1787,
    "addresses": {
      "ethereum": "0x03ab458634910aad20ef5f1c8ee96f1d6ac54919",
      "avalanche": "0x97cd1cfe2ed5712660bb6c14053c0ecb031bff7d",
      "optimistic-ethereum": "0x7fb688ccf682d58f86d7e38e03f9d22e7705448b",
      "polygon-pos": "0x00e5646f60ac6fb446f621d146b6e1886f002905"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "rai-finance",
    "filePath": "token:SOFI",
    "symbol": "sofi",
    "name": "RAI Finance",
    "marketCapRank": 1206,
    "addresses": {
      "ethereum": "0xb49fa25978abf9a248b8212ab4b87277682301c0",
      "base": "0x703d57164ca270b0b330a87fd159cfef1490c0a5",
      "binance-smart-chain": "0x1a28ed8472f644e8898a169a644503b779748d6e"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "raiden-network",
    "filePath": "token:RDN",
    "symbol": "rdn",
    "name": "Raiden Network",
    "marketCapRank": 2458,
    "addresses": {
      "ethereum": "0x255aa6df07540cb5d3d297f0d0d4d84cb52bc8e6"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "railgun",
    "filePath": "token:RAIL",
    "symbol": "rail",
    "name": "Railgun",
    "marketCapRank": 979,
    "addresses": {
      "ethereum": "0xe76c6c83af64e4c60245d8c7de953df673a7a33d"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "rainbow-token-2",
    "filePath": "token:RBW",
    "symbol": "rbw",
    "name": "Rainbow Token",
    "marketCapRank": 1379,
    "addresses": {
      "polygon-pos": "0x431cd3c9ac9fc73644bf68bf5691f4b83f9e104f"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "rake-com",
    "filePath": "token:RAKE",
    "symbol": "rake",
    "name": "Rake.com",
    "marketCapRank": 1699,
    "addresses": {
      "ethereum": "0x6553565eac5daa9bfc5e2892b36291634c9b2ad6"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "rally-2",
    "filePath": "token:RLY",
    "symbol": "rly",
    "name": "Rally",
    "marketCapRank": 492,
    "addresses": {
      "ethereum": "0xf1f955016ecbcd7321c7266bccfb96c68ea5e49b"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "ramp",
    "filePath": "token:RAMP",
    "symbol": "ramp",
    "name": "RAMP [OLD]",
    "marketCapRank": 875,
    "addresses": {
      "ethereum": "0x33d0568941c0c64ff7e0fb4fba0b11bd37deed9f",
      "binance-smart-chain": "0x8519ea49c997f50ceffa444d240fb655e89248aa",
      "polygon-pos": "0xaecebfcf604ad245eaf0d5bd68459c3a7a6399c2"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "ramses-exchange",
    "filePath": "token:RAM",
    "symbol": "ram",
    "name": "Ramses Exchange",
    "marketCapRank": 1742,
    "addresses": {
      "arbitrum-one": "0xaaa6c1e32c55a7bfa8066a6fae9b42650f262418"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "rangers-protocol-gas",
    "filePath": "token:RPG",
    "symbol": "rpg",
    "name": "Rangers Protocol Gas",
    "marketCapRank": 1193,
    "addresses": {
      "ethereum": "0x1f16d41f9b3db03b462bdd6c92245ee708d1c103",
      "binance-smart-chain": "0x61dc650c10ec3c758d251cd2d1ab45af1a43e941"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "raptoreum",
    "filePath": "token:RTM",
    "symbol": "rtm",
    "name": "Raptoreum",
    "marketCapRank": 1706,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "rari-governance-token",
    "filePath": "token:RGT",
    "symbol": "rgt",
    "name": "Rari Governance",
    "marketCapRank": 1863,
    "addresses": {
      "ethereum": "0xd291e7a03283640fdc51b121ac401383a46cc623",
      "arbitrum-one": "0xef888bca6ab6b1d26dbec977c455388ecd794794",
      "fantom": "0xcf726a06f3dcec8ef2b033336d138caa0eae5af2",
      "polygon-pos": "0xf4bb0ed25ac7bcc9c327b88bac5ca288a08ec41e",
      "energi": "0xf4bb0ed25ac7bcc9c327b88bac5ca288a08ec41e"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "rarible",
    "filePath": "token:RARI",
    "symbol": "rari",
    "name": "RARI",
    "marketCapRank": 703,
    "addresses": {
      "ethereum": "0xfca59cd816ab1ead66534d82bc21e7515ce441cf",
      "energi": "0x87ce5dde0595d9306db44dc0baa9703ace18c415"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "raven-protocol",
    "filePath": "token:RAVEN",
    "symbol": "raven",
    "name": "Raven Protocol",
    "marketCapRank": 1597,
    "addresses": {
      "binancecoin": "RAVEN-F66",
      "binance-smart-chain": "0xcd7c5025753a49f1881b31c48caa7c517bb46308"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "ravencoin",
    "filePath": "token:RVN",
    "symbol": "rvn",
    "name": "Ravencoin",
    "marketCapRank": 160,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "raydium",
    "filePath": "token:RAY",
    "symbol": "ray",
    "name": "Raydium",
    "marketCapRank": 171,
    "addresses": {
      "solana": "4k3Dyjzvzp8eMZWUXbBCjEvwSkkk59S5iCNLY3QrkX6R"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "razor-network",
    "filePath": "token:RAZOR",
    "symbol": "razor",
    "name": "Razor Network",
    "marketCapRank": 1803,
    "addresses": {
      "ethereum": "0x50de6856358cc35f3a9a57eaaa34bd4cb707d2cd",
      "binance-smart-chain": "0x50de6856358cc35f3a9a57eaaa34bd4cb707d2cd",
      "polygon-pos": "0xc91c06db0f7bffba61e2a5645cc15686f0a8c828"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "realfevr",
    "filePath": "token:FEVR",
    "symbol": "fevr",
    "name": "RealFevr",
    "marketCapRank": 1877,
    "addresses": {
      "binance-smart-chain": "0x82030cdbd9e4b7c5bb0b811a61da6360d69449cc",
      "avalanche": "0x73178fceb736a9d6c1a9ef1fe413f09cba2d4a68",
      "ethereum": "0x9fb83c0635de2e815fd1c21b3a292277540c2e8d",
      "polygon-pos": "0xe6b9d092223f39013656702a40dbe6b7decc5746"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "realm",
    "filePath": "token:REALM",
    "symbol": "realm",
    "name": "Realm",
    "marketCapRank": 2075,
    "addresses": {
      "ethereum": "0x464fdb8affc9bac185a7393fd4298137866dcfb8",
      "binance-smart-chain": "0x464fdb8affc9bac185a7393fd4298137866dcfb8"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "rebel-bots",
    "filePath": "token:RBLS",
    "symbol": "rbls",
    "name": "Rebel Bots",
    "marketCapRank": 1520,
    "addresses": {
      "polygon-pos": "0xe26cda27c13f4f87cffc2f437c5900b27ebb5bbb"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "reboot",
    "filePath": "token:GG",
    "symbol": "gg",
    "name": "Reboot",
    "marketCapRank": 1643,
    "addresses": {
      "arbitrum-one": "0x000000000026839b3f4181f2cf69336af6153b99",
      "arbitrum-nova": "0x000000000026839b3f4181f2cf69336af6153b99"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "redacted",
    "filePath": "token:BTRFLY",
    "symbol": "btrfly",
    "name": "Redacted",
    "marketCapRank": 583,
    "addresses": {
      "ethereum": "0xc55126051b22ebb829d00368f4b12bde432de5da"
    },
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "reddcoin",
    "filePath": "token:RDD",
    "symbol": "rdd",
    "name": "Reddcoin",
    "marketCapRank": 2029,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "redfox-labs-2",
    "filePath": "token:RFOX",
    "symbol": "rfox",
    "name": "RFOX",
    "marketCapRank": 1470,
    "addresses": {
      "ethereum": "0xa1d6df714f91debf4e0802a542e13067f31b8262",
      "energi": "0xaad4add9b6ed577f3fe9e6bccbbe3bdce596b062",
      "binance-smart-chain": "0x0a3a21356793b49154fd3bbe91cbc2a16c0457f5"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "reef",
    "filePath": "token:REEF",
    "symbol": "reef",
    "name": "Reef",
    "marketCapRank": 619,
    "addresses": {
      "ethereum": "0xfe3e6a25e6b192a42a44ecddcd13796471735acf",
      "sora": "0x0004d3168f737e96b66b72fbb1949a2a23d4ef87182d1e8bf64096f1bb348e0b",
      "energi": "0x2c969b248144dc371b428705da84b413203d9e76",
      "binance-smart-chain": "0xf21768ccbc73ea5b6fd3c687208a7c2def2d966e",
      "harmony-shard-0": "0x9ab0db833557d95aff98c09b560145ad34e681b8"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "ref-finance",
    "filePath": "token:REF",
    "symbol": "ref",
    "name": "Ref Finance",
    "marketCapRank": 1304,
    "addresses": {
      "near-protocol": "token.v2.ref-finance.near"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "refund",
    "filePath": "token:RFD",
    "symbol": "rfd",
    "name": "Refund",
    "marketCapRank": 1663,
    "addresses": {
      "ethereum": "0x955d5c14c8d4944da1ea7836bd44d54a8ec35ba1"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "regen",
    "filePath": "token:REGEN",
    "symbol": "regen",
    "name": "Regen",
    "marketCapRank": 1401,
    "addresses": {
      "osmosis": "ibc/1DCC8A6CB5689018431323953344A9F6CC4D0BFB261E88C9F7777372C10CD076",
      "evmos": "0x0ce35b0d42608ca54eb7bcc8044f7087c18e7717"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "rejuve-ai",
    "filePath": "token:RJV",
    "symbol": "rjv",
    "name": "Rejuve.AI",
    "marketCapRank": 1077,
    "addresses": {
      "ethereum": "0xa1f410f13b6007fca76833ee7eb58478d47bc5ef",
      "cardano": "8cfd6893f5f6c1cc954cec1a0a1460841b74da6e7803820dde62bb78",
      "binance-smart-chain": "0x602b6c6cce5f95c00603bd07d8fa7ebaf3747d44"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "renbtc",
    "filePath": "token:RENBTC",
    "symbol": "renbtc",
    "name": "renBTC",
    "marketCapRank": 1156,
    "addresses": {
      "ethereum": "0xeb4c2781e4eba804ce9a9803c67d0893436bb27d",
      "sora": "0x00438aac3a91cc6cee0c8d2f14e4bf7ec4512ca708b180cc0fda47b0eb1ad538",
      "binance-smart-chain": "0xfce146bf3146100cfe5db4129cf6c82b0ef4ad8c",
      "polygon-pos": "0xdbf31df14b66535af65aac99c32e9ea844e14501",
      "harmony-shard-0": "0x41ca97b94d5dee79195856034d196ddfa0d43edd"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "render-token",
    "filePath": "token:RNDR",
    "symbol": "rndr",
    "name": "Render",
    "marketCapRank": 35,
    "addresses": {
      "ethereum": "0x6de037ef9ad2725eb40118bb1702ebb27e4aeb24",
      "polygon-pos": "0x61299774020da444af134c82fa83e3810b309991",
      "solana": "rndrizKT3MK1iimdxRdWabcF7Zg7AR5T4nud4EkHBof"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "renewable-energy",
    "filePath": "token:RET",
    "symbol": "ret",
    "name": "Renewable Energy",
    "marketCapRank": 1980,
    "addresses": {
      "binance-smart-chain": "0x10b9dd394467f2cfbc769e07e88dc7e2c41b0965"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "republic-protocol",
    "filePath": "token:REN",
    "symbol": "ren",
    "name": "Ren",
    "marketCapRank": 528,
    "addresses": {
      "ethereum": "0x408e41876cccdc0f92210600ef50372656052a38",
      "harmony-shard-0": "0x451e129b6045b6e4f48e7247388f21163f7743b7",
      "sora": "0x00e8a7823b8207e4cab2e46cd10b54d1be6b82c284037b6ee76afd52c0dceba6",
      "energi": "0x83ab721c8b3dd30ad711460f666371366550c5a7",
      "near-protocol": "408e41876cccdc0f92210600ef50372656052a38.factory.bridge.near"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "request-network",
    "filePath": "token:REQ",
    "symbol": "req",
    "name": "Request",
    "marketCapRank": 460,
    "addresses": {
      "ethereum": "0x8f8221afbb33998d8584a2b05749ba73c37a938a",
      "polygon-pos": "0xb25e20de2f2ebb4cffd4d16a55c7b395e8a94762"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "researchcoin",
    "filePath": "token:RSC",
    "symbol": "rsc",
    "name": "ResearchCoin",
    "marketCapRank": 656,
    "addresses": {
      "ethereum": "0xd101dcc414f310268c37eeb4cd376ccfa507f571"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "reserve-rights-token",
    "filePath": "token:RSR",
    "symbol": "rsr",
    "name": "Reserve Rights",
    "marketCapRank": 180,
    "addresses": {
      "ethereum": "0x320623b8e4ff03373931769a31fc52a4e78b5d70",
      "base": "0xab36452dbac151be02b16ca17d8919826072f64a",
      "energi": "0xfce13bb63b60f6e20ed846ae73ed242d29129800"
    },
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "reunit-wallet",
    "filePath": "token:REUNI",
    "symbol": "reuni",
    "name": "Reunit Wallet",
    "marketCapRank": 2209,
    "addresses": {
      "arbitrum-one": "0x9ed7e4b1bff939ad473da5e7a218c771d1569456",
      "avalanche": "0x9ed7e4b1bff939ad473da5e7a218c771d1569456",
      "optimistic-ethereum": "0x9ed7e4b1bff939ad473da5e7a218c771d1569456",
      "ethereum": "0x9ed7e4b1bff939ad473da5e7a218c771d1569456",
      "binance-smart-chain": "0x9ed7e4b1bff939ad473da5e7a218c771d1569456"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "rev3al",
    "filePath": "token:REV3L",
    "symbol": "rev3l",
    "name": "REV3AL",
    "marketCapRank": 1515,
    "addresses": {
      "binance-smart-chain": "0x30b5e345c79255101b8af22a19805a6fb96ddebb"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "revain",
    "filePath": "token:REV",
    "symbol": "rev",
    "name": "Revain",
    "marketCapRank": 1807,
    "addresses": {
      "ethereum": "0x2ef52ed7de8c5ce03a4ef0efbe9b7450f2d7edc9",
      "tron": "TD4bVgcwj3FRbmAo283HxNvqZvY7T3uD8k"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "revenant",
    "filePath": "token:GAMEFI",
    "symbol": "gamefi",
    "name": "Revenant",
    "marketCapRank": 2347,
    "addresses": {
      "metis-andromeda": "0x966b25d174be6ba703e0ff80c68bb6e167236ba2"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "revenue-coin",
    "filePath": "token:RVC",
    "symbol": "rvc",
    "name": "Revenue Coin",
    "marketCapRank": 2069,
    "addresses": {
      "binance-smart-chain": "0xbcbdecf8e76a5c32dba69de16985882ace1678c6"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "revest-finance",
    "filePath": "token:RVST",
    "symbol": "rvst",
    "name": "Revest Finance",
    "marketCapRank": 967,
    "addresses": {
      "ethereum": "0x120a3879da835a5af037bb2d1456bebd6b54d4ba"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "revomon-2",
    "filePath": "token:REVO",
    "symbol": "revo",
    "name": "Revomon",
    "marketCapRank": 1820,
    "addresses": {
      "binance-smart-chain": "0xaab09b5cd1694d12c8c980306f5e2f5d65b00e1c"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "revv",
    "filePath": "token:REVV",
    "symbol": "revv",
    "name": "REVV",
    "marketCapRank": 1347,
    "addresses": {
      "ethereum": "0x557b933a7c2c45672b610f8954a3deb39a51a8ca",
      "polygon-pos": "0x70c006878a5a50ed185ac4c87d837633923de296",
      "binance-smart-chain": "0x833f307ac507d47309fd8cdd1f835bef8d702a93"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "rhinofi",
    "filePath": "token:DVF",
    "symbol": "dvf",
    "name": "Rhino.fi",
    "marketCapRank": 1533,
    "addresses": {
      "ethereum": "0xdddddd4301a082e62e84e43f474f044423921918",
      "arbitrum-one": "0xa7aa2921618e3d63da433829d448b58c9445a4c3"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "ribbit-meme",
    "filePath": "token:RIBBIT",
    "symbol": "ribbit",
    "name": "Ribbit Meme",
    "marketCapRank": 2597,
    "addresses": {
      "ethereum": "0xb794ad95317f75c44090f64955954c3849315ffe"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "ribbon-finance",
    "filePath": "token:RBN",
    "symbol": "rbn",
    "name": "Ribbon Finance",
    "marketCapRank": 74,
    "addresses": {
      "ethereum": "0x6123b0049f904d730db3c36a31167d9d4121fa6b"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "ridotto",
    "filePath": "token:RDT",
    "symbol": "rdt",
    "name": "Ridotto",
    "marketCapRank": 1508,
    "addresses": {
      "ethereum": "0x4740735aa98dc8aa232bd049f8f0210458e7fca3",
      "binance-smart-chain": "0xe9c64384deb0c2bf06d991a8d708c77eb545e3d5"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "rif-token",
    "filePath": "token:RIF",
    "symbol": "rif",
    "name": "RSK Infrastructure Framework",
    "marketCapRank": 291,
    "addresses": {
      "rootstock": "0x2acc95758f8b5f583470ba265eb685a8f45fc9d5"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "rigoblock",
    "filePath": "token:GRG",
    "symbol": "grg",
    "name": "RigoBlock",
    "marketCapRank": 1207,
    "addresses": {
      "ethereum": "0x4fbb350052bca5417566f188eb2ebce5b19bc964",
      "optimistic-ethereum": "0xecf46257ed31c329f204eb43e254c609dee143b3",
      "polygon-pos": "0xbc0bea8e634ec838a2a45f8a43e7e16cd2a8ba99",
      "arbitrum-one": "0x7f4638a58c0615037decc86f1dae60e55fe92874",
      "base": "0x09188484e1ab980daef53a9755241d759c5b7d60",
      "binance-smart-chain": "0x3d473c3ef4cd4c909b020f48477a2ee2617a8e3c"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "ripio-credit-network",
    "filePath": "token:RCN",
    "symbol": "rcn",
    "name": "Ripio Credit Network",
    "marketCapRank": 2477,
    "addresses": {
      "ethereum": "0xf970b8e36e23f7fc3fd752eea86f8be8d83375a6"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "ripple",
    "filePath": "token:XRP",
    "symbol": "xrp",
    "name": "XRP",
    "marketCapRank": 6,
    "addresses": {},
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "risitas",
    "filePath": "token:RISITA",
    "symbol": "risita",
    "name": "Risitas",
    "marketCapRank": 3745,
    "addresses": {
      "ethereum": "0xe6f47303032a09c8c0f8ebb713c00e6ed345e8c3",
      "arbitrum-one": "0x7d86f1eaff29f076576b2ff09ce3bcc7533fd2c5"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "ritestream",
    "filePath": "token:RITE",
    "symbol": "rite",
    "name": "ritestream",
    "marketCapRank": 1745,
    "addresses": {
      "binance-smart-chain": "0x0808bf94d57c905f1236212654268ef82e1e594e"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "rmrk",
    "filePath": "token:RMRK",
    "symbol": "rmrk",
    "name": "RMRK",
    "marketCapRank": 1140,
    "addresses": {
      "ethereum": "0x524d524b4c9366be706d3a90dcf70076ca037ae3",
      "moonbeam": "0x524d524b4c9366be706d3a90dcf70076ca037ae3",
      "binance-smart-chain": "0x524d524b4c9366be706d3a90dcf70076ca037ae3",
      "polygon-pos": "0x524d524b4c9366be706d3a90dcf70076ca037ae3",
      "base": "0x524d524b4c9366be706d3a90dcf70076ca037ae3"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "roasthimjim",
    "filePath": "token:JIM",
    "symbol": "jim",
    "name": "Jim",
    "marketCapRank": 2307,
    "addresses": {
      "ethereum": "0xd807f7e2818db8eda0d28b5be74866338eaedb86"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "robo-inu-finance",
    "filePath": "token:RBIF",
    "symbol": "rbif",
    "name": "Robo Inu Finance",
    "marketCapRank": 1560,
    "addresses": {
      "ethereum": "0x0e6fa9c050c8a707e7f56a2b3695665e4f9eac9b"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "robonomics-network",
    "filePath": "token:XRT",
    "symbol": "xrt",
    "name": "Robonomics Network",
    "marketCapRank": 1534,
    "addresses": {
      "ethereum": "0x7de91b204c1c737bcee6f000aaa6569cf7061cb7",
      "sora": "0x0083d5cbb4b90163b6a003e8f771eb7c0e2b706892cd0cbadb03f55cb9e06919"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "rocket-pool",
    "filePath": "token:RPL",
    "symbol": "rpl",
    "name": "Rocket Pool",
    "marketCapRank": 166,
    "addresses": {
      "ethereum": "0xd33526068d116ce69f19a9ee46f0bd304f21a51f",
      "polygon-pos": "0x7205705771547cf79201111b4bd8aaf29467b9ec",
      "arbitrum-one": "0xb766039cc6db368759c1e56b79affe831d0cc507"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "rocket-pool-eth",
    "filePath": "token:RETH",
    "symbol": "reth",
    "name": "Rocket Pool ETH",
    "marketCapRank": 62,
    "addresses": {
      "ethereum": "0xae78736cd615f374d3085123a210448e74fc6393",
      "optimistic-ethereum": "0x9bcef72be871e61ed4fbbc7630889bee758eb81d",
      "arbitrum-one": "0xec70dcb4a1efa46b8f2d97c310c9c4790ba5ffa8",
      "polygon-pos": "0x0266f4f08d82372cf0fcbccc0ff74309089c74d1",
      "base": "0xb6fe221fe9eef5aba221c348ba20a1bf5e73624c"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "rocketx",
    "filePath": "token:RVF",
    "symbol": "rvf",
    "name": "RocketX Exchange",
    "marketCapRank": 806,
    "addresses": {
      "ethereum": "0xdc8af07a7861bedd104b8093ae3e9376fc8596d2",
      "binance-smart-chain": "0x872a34ebb2d54af86827810eebc7b9dc6b2144aa",
      "polygon-pos": "0x2ce13e4199443fdfff531abb30c9b6594446bbc7"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "roko-network",
    "filePath": "token:ROKO",
    "symbol": "roko",
    "name": "Roko Network",
    "marketCapRank": 1334,
    "addresses": {
      "ethereum": "0x6f222e04f6c53cc688ffb0abe7206aac66a8ff98"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "rollbit-coin",
    "filePath": "token:RLB",
    "symbol": "rlb",
    "name": "Rollbit Coin",
    "marketCapRank": 262,
    "addresses": {
      "ethereum": "0x046eee2cc3188071c02bfc1745a6b17c656e3f3d"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "rome",
    "filePath": "token:ROME",
    "symbol": "rome",
    "name": "Rome",
    "marketCapRank": 2179,
    "addresses": {
      "moonriver": "0x4a436073552044d5f2f49b176853ad3ad473d9d6"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "roobee",
    "filePath": "token:ROOBEE",
    "symbol": "roobee",
    "name": "Roobee",
    "marketCapRank": 2505,
    "addresses": {
      "ethereum": "0xa31b1767e09f842ecfd4bc471fe44f830e3891aa",
      "avalanche": "0x4036f3d9c45a20f44f0b8b85dd6ca33005ff9654",
      "optimistic-ethereum": "0xb12c13e66ade1f72f71834f2fc5082db8c091358",
      "arbitrum-one": "0x3bd2dfd03bc7c3011ed7fb8c4d0949b382726cee",
      "polygon-pos": "0xfafa220145dfa5c3ec85b6fa8a75aee2451cde5e",
      "binance-smart-chain": "0xf77351d8f4ee853135961a936bb8d2e4ffa75f9d"
    },
    "variants": [
      "mono"
    ]
  },
  {
    "id": "rook",
    "filePath": "token:ROOK",
    "symbol": "rook",
    "name": "Rook",
    "marketCapRank": 2391,
    "addresses": {
      "ethereum": "0xfa5047c9c78b8877af97bdcb85db743fd7313d4a",
      "harmony-shard-0": "0x08310baf9deb5f13b885edf5eea6fd19dc21af3a",
      "sora": "0x00f58df67a15fe6c45d122767251c8660f33a2c544b5e2b70084c465b7cf84e7",
      "energi": "0xf653d401a6af0ec568183d9d0714e3c5e61691d2"
    },
    "variants": [
      "mono"
    ]
  },
  {
    "id": "route",
    "filePath": "token:ROUTE",
    "symbol": "route",
    "name": "Router Protocol",
    "marketCapRank": 689,
    "addresses": {
      "ethereum": "0x16eccfdbb4ee1a85a33f3a9b21175cd7ae753db4",
      "avalanche": "0xf44ff799ea2bbfec96f9a50498209aac3c2b3b8b",
      "fantom": "0x11bbf12363dc8375b78d2719395d505f52a02f68",
      "aurora": "0xa1fc14bc890a98142443b7abc0eeccae6186cd9a",
      "optimistic-ethereum": "0x8413041a7702603d9d991f2c4add29e4e8a241f8",
      "arbitrum-one": "0x11bbf12363dc8375b78d2719395d505f52a02f68",
      "binance-smart-chain": "0xfd2700c51812753215754de9ec51cdd42bf725b9",
      "polygon-pos": "0x16eccfdbb4ee1a85a33f3a9b21175cd7ae753db4"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "rowan-coin",
    "filePath": "token:RWN",
    "symbol": "rwn",
    "name": "Rowan Coin",
    "marketCapRank": 784,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "rss3",
    "filePath": "token:RSS3",
    "symbol": "rss3",
    "name": "RSS3",
    "marketCapRank": 232,
    "addresses": {
      "ethereum": "0xc98d64da73a6616c42117b582e832812e7b8d57f"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "rubidium",
    "filePath": "token:RBD",
    "symbol": "rbd",
    "name": "Rubidium",
    "marketCapRank": 2418,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "rug-rugged-art",
    "filePath": "token:RUG",
    "symbol": "rug",
    "name": "Rug",
    "marketCapRank": 3052,
    "addresses": {
      "ethereum": "0xbe33f57f41a20b2f00dec91dcc1169597f36221f",
      "binance-smart-chain": "0xea4821632b139b7f08e37533d8152d50976618c6",
      "solana": "BJRfDU8abGXmPiAj72kuc8AtXfxV8KFZAvdG3GTuB5Qc"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "rupiah-token",
    "filePath": "token:IDRT",
    "symbol": "idrt",
    "name": "Rupiah Token",
    "marketCapRank": 1415,
    "addresses": {
      "ethereum": "0x998ffe1e43facffb941dc337dd0468d52ba5b48a",
      "harmony-shard-0": "0xcefbea899cfccdc653b171d063481b622086be3f",
      "polygon-pos": "0x554cd6bdd03214b10aafa3e0d4d42de0c5d2937b",
      "binance-smart-chain": "0x66207e39bb77e6b99aab56795c7c340c08520d83"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "sacabam",
    "filePath": "token:SCB",
    "symbol": "scb",
    "name": "Sacabam",
    "marketCapRank": 2079,
    "addresses": {
      "sui": "0x9a5502414b5d51d01c8b5641db7436d789fa15a245694b24aa37c25c2a6ce001::scb::SCB"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "safe",
    "filePath": "token:SAFE",
    "symbol": "safe",
    "name": "Safe",
    "marketCapRank": null,
    "addresses": {
      "ethereum": "0x5afe3855358e112b5647b952709e6165e1c1eeee"
    },
    "variants": [
      "branded",
      "background",
      "mono"
    ]
  },
  {
    "id": "safe-deal",
    "filePath": "token:SFD",
    "symbol": "sfd",
    "name": "SafeDeal",
    "marketCapRank": 1181,
    "addresses": {},
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "safe-haven",
    "filePath": "token:SHA",
    "symbol": "sha",
    "name": "Safe Haven",
    "marketCapRank": 1962,
    "addresses": {
      "vechain": "0x5db3c8a942333f6468176a870db36eef120a34dc",
      "binance-smart-chain": "0x40fed5691e547885cabd7a2990de719dcc8497fc",
      "polygon-pos": "0x534f39c5f4df9cb13e16b24ca07c7c8c0e2eadb7",
      "ethereum": "0x40fed5691e547885cabd7a2990de719dcc8497fc"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "safemars",
    "filePath": "token:SAFEMARS",
    "symbol": "safemars",
    "name": "Safemars",
    "marketCapRank": 1839,
    "addresses": {
      "binance-smart-chain": "0x3ad9594151886ce8538c1ff615efa2385a8c3a88"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "safemoon-2",
    "filePath": "token:SFM",
    "symbol": "sfm",
    "name": "SafeMoon",
    "marketCapRank": 615,
    "addresses": {
      "binance-smart-chain": "0x42981d0bfbaf196529376ee702f2a9eb9092fcb5"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "safemoon-inu",
    "filePath": "token:SMI",
    "symbol": "smi",
    "name": "SafeMoon Inu",
    "marketCapRank": 2560,
    "addresses": {
      "ethereum": "0xcd7492db29e2ab436e819b249452ee1bbdf52214"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "safepal",
    "filePath": "token:SFP",
    "symbol": "sfp",
    "name": "SafePal",
    "marketCapRank": 240,
    "addresses": {
      "ethereum": "0x12e2b8033420270db2f3b328e32370cb5b2ca134",
      "binance-smart-chain": "0xd41fdb03ba84762dd66a0af1a6c8540ff1ba5dfb",
      "energi": "0x12490d720747e312be64029dfd475837ed285cfe"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "saffron-finance",
    "filePath": "token:SFI",
    "symbol": "sfi",
    "name": "saffron.finance",
    "marketCapRank": 2112,
    "addresses": {
      "ethereum": "0xb753428af26e81097e7fd17f40c88aaa3e04902c",
      "energi": "0x09319044a98e6bb4d95a6c112789afcebe5b58ac"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "sai",
    "filePath": "token:SAI",
    "symbol": "sai",
    "name": "Sai",
    "marketCapRank": 769,
    "addresses": {
      "ethereum": "0x89d24a6b4ccb1b6faa2625fe562bdd9a23260359"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "sail-2",
    "filePath": "token:SAIL",
    "symbol": "sail",
    "name": "Clipper SAIL",
    "marketCapRank": 1792,
    "addresses": {
      "ethereum": "0xd8f1460044925d2d5c723c7054cd9247027415b7"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "saitama-inu",
    "filePath": "token:SAITAMA",
    "symbol": "saitama",
    "name": "Saitama",
    "marketCapRank": 531,
    "addresses": {
      "ethereum": "0xce3f08e664693ca792cace4af1364d5e220827b2"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "saitarealty",
    "filePath": "token:SRLTY",
    "symbol": "srlty",
    "name": "SaitaRealty",
    "marketCapRank": 1966,
    "addresses": {
      "ethereum": "0x142a774e8b52550e88e196cedd7a5835acb646d0",
      "binance-smart-chain": "0xee8ed80bb013325ea63df19233aae584e94f3826"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "saito",
    "filePath": "token:SAITO",
    "symbol": "saito",
    "name": "Saito",
    "marketCapRank": 1227,
    "addresses": {
      "ethereum": "0xfa14fa6958401314851a17d6c5360ca29f74b57b",
      "binance-smart-chain": "0x3c6dad0475d3a1696b359dc04c99fd401be134da"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "sakai-vault",
    "filePath": "token:SAKAI",
    "symbol": "sakai",
    "name": "Sakai Vault",
    "marketCapRank": 1941,
    "addresses": {
      "binance-smart-chain": "0x43b35e89d15b91162dea1c51133c4c93bdd1c4af"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "salt",
    "filePath": "token:SALT",
    "symbol": "salt",
    "name": "SALT",
    "marketCapRank": 2382,
    "addresses": {
      "ethereum": "0x4156d3342d5c385a87d264f90653733592000581"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "samoyedcoin",
    "filePath": "token:SAMO",
    "symbol": "samo",
    "name": "Samoyedcoin",
    "marketCapRank": 696,
    "addresses": {
      "solana": "7xKXtg2CW87d97TXJSDpbD5jBkheTqA83TZRuJosgAsU"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "samsunspor-fan-token",
    "filePath": "token:SAM",
    "symbol": "sam",
    "name": "Samsunspor Fan Token",
    "marketCapRank": 2050,
    "addresses": {
      "chiliz": "0xfc21c38f4802ab29aed8cc7367542a0955cfa9d7"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "sandclock",
    "filePath": "token:QUARTZ",
    "symbol": "quartz",
    "name": "Sandclock",
    "marketCapRank": 2518,
    "addresses": {
      "ethereum": "0xba8a621b4a54e61c442f5ec623687e2a942225ef",
      "polygon-pos": "0xa91fe5a535967f52d3abebdffb3b306d964ace13"
    },
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "sanin-inu",
    "filePath": "token:SANI",
    "symbol": "sani",
    "name": "Sanin Inu",
    "marketCapRank": 1942,
    "addresses": {
      "ethereum": "0x4521c9ad6a3d4230803ab752ed238be11f8b342f"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "santiment-network-token",
    "filePath": "token:SAN",
    "symbol": "san",
    "name": "Santiment Network",
    "marketCapRank": 1646,
    "addresses": {
      "ethereum": "0x7c5a0ce9267ed19b22f8cae653f198e3e8daf098"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "sats-ordinals",
    "filePath": "token:SATS",
    "symbol": "sats",
    "name": "SATS (Ordinals)",
    "marketCapRank": 109,
    "addresses": {
      "ordinals": "9b664bdd6f5ed80d8d88957b63364c41f3ad4efb8eee11366aa16435974d9333i0"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "satt",
    "filePath": "token:SATT",
    "symbol": "satt",
    "name": "SaTT",
    "marketCapRank": 3102,
    "addresses": {
      "ethereum": "0xdf49c9f599a0a9049d97cff34d0c30e468987389"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "saucerswap",
    "filePath": "token:SAUCE",
    "symbol": "sauce",
    "name": "SaucerSwap",
    "marketCapRank": 560,
    "addresses": {
      "hedera-hashgraph": "0x00000000000000000000000000000000000b2ad5"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "savage",
    "filePath": "token:SAVG",
    "symbol": "savg",
    "name": "SAVAGE",
    "marketCapRank": 1880,
    "addresses": {
      "polygon-pos": "0x981aecc6eb4d382b96a02b75e931900705e95a31"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "saveplanetearth",
    "filePath": "token:SPE",
    "symbol": "spe",
    "name": "SavePlanetEarth",
    "marketCapRank": 1809,
    "addresses": {
      "binance-smart-chain": "0x4ac81e3631dcda62109e3117c4cae7bf70bbbbd2"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "sbtc",
    "filePath": "token:SBTC",
    "symbol": "sbtc",
    "name": "sBTC",
    "marketCapRank": 1220,
    "addresses": {
      "ethereum": "0xfe18be6b3bd88a2d2a7f928d00292e7a9963cfc6"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "scallop",
    "filePath": "token:SCLP",
    "symbol": "sclp",
    "name": "Scallop",
    "marketCapRank": 821,
    "addresses": {
      "binance-smart-chain": "0xf2c96e402c9199682d5ded26d3771c6b192c01af"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "secret",
    "filePath": "token:SCRT",
    "symbol": "scrt",
    "name": "Secret",
    "marketCapRank": 365,
    "addresses": {
      "secret": "secret1k0jntykt7e4g3y88ltc60czgjuqdy4c9e8fzek"
    },
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "seedify-fund",
    "filePath": "token:SFUND",
    "symbol": "sfund",
    "name": "Seedify.fund",
    "marketCapRank": 285,
    "addresses": {
      "binance-smart-chain": "0x477bc8d23c634c154061869478bce96be6045d12",
      "ethereum": "0x560363bda52bc6a44ca6c8c9b4a5fadbda32fa60",
      "arbitrum-one": "0x560363bda52bc6a44ca6c8c9b4a5fadbda32fa60"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "sei-network",
    "filePath": "token:SEI",
    "symbol": "sei",
    "name": "Sei",
    "marketCapRank": 60,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "selfkey",
    "filePath": "token:KEY",
    "symbol": "key",
    "name": "SelfKey",
    "marketCapRank": 660,
    "addresses": {
      "ethereum": "0x4cc19356f2d37338b9802aa8e8fc58b0373296e7",
      "polygon-pos": "0x32dc2dd3c2be453a369625e6fe0e438aed814919"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "senate",
    "filePath": "token:SENATE",
    "symbol": "senate",
    "name": "SENATE",
    "marketCapRank": 1322,
    "addresses": {
      "ethereum": "0x34be5b8c30ee4fde069dc878989686abe9884470"
    },
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "send-token",
    "filePath": "token:SEND",
    "symbol": "send",
    "name": "/send",
    "marketCapRank": 1425,
    "addresses": {
      "ethereum": "0x3f14920c99beb920afa163031c4e47a3e03b3e4a",
      "base": "0x3f14920c99beb920afa163031c4e47a3e03b3e4a"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "sensegenesis",
    "filePath": "token:SENSE",
    "symbol": "sense",
    "name": "Sense",
    "marketCapRank": null,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "sentinel",
    "filePath": "token:DVPN",
    "symbol": "dvpn",
    "name": "Sentinel",
    "marketCapRank": 846,
    "addresses": {
      "osmosis": "ibc/9712DBB13B9631EDFA9BF61B55F1B2D290B2ADB67E3A4EB3A875F3B6081B3B84"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "sentinel-protocol",
    "filePath": "token:UPP",
    "symbol": "upp",
    "name": "Sentinel Protocol",
    "marketCapRank": 723,
    "addresses": {
      "ethereum": "0xc86d054809623432210c107af2e3f619dcfbf652"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "serum",
    "filePath": "token:SRM",
    "symbol": "srm",
    "name": "Serum",
    "marketCapRank": 1070,
    "addresses": {
      "ethereum": "0x476c5e26a75bd202a9683ffd34359c0cc15be0ff",
      "energi": "0x83af4137ed450f4765a72831dd938b5203f5d2fb",
      "tomochain": "0xc01643ac912b6a8ffc50cf8c1390934a6142bc91",
      "solana": "SRMuApVNdxXokk5GT7XD5cUUgXMBCoAz2LHeuAoKWRt"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "seth",
    "filePath": "token:SETH",
    "symbol": "seth",
    "name": "sETH",
    "marketCapRank": 829,
    "addresses": {
      "ethereum": "0x5e74c9036fb86bd7ecdcb084a0673efc32ea31cb",
      "optimistic-ethereum": "0xe405de8f52ba7559f9df3c368500b6e6ae6cee49"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "seth2",
    "filePath": "token:SETH2",
    "symbol": "seth2",
    "name": "sETH2",
    "marketCapRank": 588,
    "addresses": {
      "ethereum": "0xfe2e637202056d30016725477c5da089ab0a043a"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "shiba-inu",
    "filePath": "token:SHIB",
    "symbol": "shib",
    "name": "Shiba Inu",
    "marketCapRank": 13,
    "addresses": {
      "ethereum": "0x95ad61b0a150d79219dcf64e1e6cc01f0b64c4ce"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "shiba-predator",
    "filePath": "token:QOM",
    "symbol": "qom",
    "name": "Shiba Predator",
    "marketCapRank": 1017,
    "addresses": {
      "ethereum": "0xa71d0588eaf47f12b13cf8ec750430d21df04974"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "shiba-saga",
    "filePath": "token:SHIA",
    "symbol": "shia",
    "name": "Shiba Saga",
    "marketCapRank": 1627,
    "addresses": {
      "ethereum": "0x43d7e65b8ff49698d9550a7f315c87e67344fb59"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "shibadoge",
    "filePath": "token:SHIBDOGE",
    "symbol": "shibdoge",
    "name": "ShibaDoge",
    "marketCapRank": 1936,
    "addresses": {
      "ethereum": "0x6adb2e268de2aa1abf6578e4a8119b960e02928f"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "shiden",
    "filePath": "token:SDN",
    "symbol": "sdn",
    "name": "Shiden Network",
    "marketCapRank": 1184,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "shido-2",
    "filePath": "token:SHIDO",
    "symbol": "shido",
    "name": "Shido",
    "marketCapRank": 896,
    "addresses": {
      "ethereum": "0xe2512a2f19f0388ad3d7a5263eaa82acd564827b"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "shikoku",
    "filePath": "token:SHIK",
    "symbol": "shik",
    "name": "Shikoku",
    "marketCapRank": 2432,
    "addresses": {
      "ethereum": "0x24da31e7bb182cb2cabfef1d88db19c2ae1f5572"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "shina-inu",
    "filePath": "token:SHI",
    "symbol": "shi",
    "name": "Shina Inu",
    "marketCapRank": 1252,
    "addresses": {
      "ethereum": "0x243cacb4d5ff6814ad668c3e225246efa886ad5a"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "shockwaves",
    "filePath": "token:NEUROS",
    "symbol": "neuros",
    "name": "Shockwaves",
    "marketCapRank": 2081,
    "addresses": {
      "binance-smart-chain": "0x95b0fffabd2817959ce410070600d77bce93d454"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "shrapnel-2",
    "filePath": "token:SHRAP",
    "symbol": "shrap",
    "name": "Shrapnel",
    "marketCapRank": 477,
    "addresses": {
      "avalanche": "0xd402298a793948698b9a63311404fbbee944eafd",
      "ethereum": "0x31e4efe290973ebe91b3a875a7994f650942d28f",
      "binance-smart-chain": "0x31e4efe290973ebe91b3a875a7994f650942d28f"
    },
    "variants": [
      "mono"
    ]
  },
  {
    "id": "shroom-finance",
    "filePath": "token:SHROOM",
    "symbol": "shroom",
    "name": "Niftyx Protocol",
    "marketCapRank": 2044,
    "addresses": {
      "ethereum": "0xed0439eacf4c4965ae4613d77a5c2efe10e5f183"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "shyft-network-2",
    "filePath": "token:SHFT",
    "symbol": "shft",
    "name": "Shyft Network",
    "marketCapRank": 1539,
    "addresses": {
      "ethereum": "0xb17c88bda07d28b3838e0c1de6a30eafbcf52d85"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "siacoin",
    "filePath": "token:SC",
    "symbol": "sc",
    "name": "Siacoin",
    "marketCapRank": 175,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "siaprime-coin",
    "filePath": "token:SCP",
    "symbol": "scp",
    "name": "ScPrime",
    "marketCapRank": 1506,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "sidus",
    "filePath": "token:SIDUS",
    "symbol": "sidus",
    "name": "Sidus",
    "marketCapRank": 486,
    "addresses": {
      "ethereum": "0x549020a9cb845220d66d3e9c6d9f9ef61c981102"
    },
    "variants": [
      "mono"
    ]
  },
  {
    "id": "signum",
    "filePath": "token:SIGNA",
    "symbol": "signa",
    "name": "Signum",
    "marketCapRank": 2116,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "silent-notary",
    "filePath": "token:UBSN",
    "symbol": "ubsn",
    "name": "Silent Notary",
    "marketCapRank": 2359,
    "addresses": {
      "ethereum": "0x86efc496dca70bcfd92d19194290e8457a375773"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "silk-bcec1136-561c-4706-a42c-8b67d0d7f7d2",
    "filePath": "token:SILK",
    "symbol": "silk",
    "name": "Silk",
    "marketCapRank": 1912,
    "addresses": {
      "secret": "secret1fl449muk5yq8dlad7a22nje4p5d2pnsgymhjfd",
      "osmosis": "ibc/8A025A1E70101E39DE0C0F153E582A30806D3DA16795F6D868A3AA247D2DEDF7"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "silo-finance",
    "filePath": "token:SILO",
    "symbol": "silo",
    "name": "Silo Finance",
    "marketCapRank": 972,
    "addresses": {
      "ethereum": "0x6f80310ca7f2c654691d1383149fa1a57d8ab1f8",
      "arbitrum-one": "0x0341c0c0ec423328621788d4854119b97f44e391"
    },
    "variants": [
      "mono"
    ]
  },
  {
    "id": "singularitydao",
    "filePath": "token:SDAO",
    "symbol": "sdao",
    "name": "SingularityDAO",
    "marketCapRank": 546,
    "addresses": {
      "ethereum": "0x993864e43caa7f7f12953ad6feb1d1ca635b875f",
      "binance-smart-chain": "0x90ed8f1dc86388f14b64ba8fb4bbd23099f18240"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "singularitynet",
    "filePath": "token:AGIX",
    "symbol": "agix",
    "name": "SingularityNET",
    "marketCapRank": 73,
    "addresses": {
      "ethereum": "0x5b7533812759b45c2b44c19e320ba2cd2681b542",
      "sora": "0x005e152271f8816d76221c7a0b5c6cafcb54fdfb6954dd8812f0158bfeac900d",
      "cardano": "f43a62fdc3965df486de8a0d32fe800963589c41b38946602a0dc535"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "sipher",
    "filePath": "token:SIPHER",
    "symbol": "sipher",
    "name": "SIPHER",
    "marketCapRank": 850,
    "addresses": {
      "ethereum": "0x9f52c8ecbee10e00d9faaac5ee9ba0ff6550f511"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "siren",
    "filePath": "token:SI",
    "symbol": "si",
    "name": "Siren",
    "marketCapRank": 2417,
    "addresses": {
      "ethereum": "0xd23ac27148af6a2f339bd82d0e3cff380b5093de"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "six-network",
    "filePath": "token:SIX",
    "symbol": "six",
    "name": "SIX Network",
    "marketCapRank": 1446,
    "addresses": {
      "stellar": "SIX-GDMS6EECOH6MBMCP3FYRYEVRBIV3TQGLOFQIPVAITBRJUMTI6V7A2X6Z"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "skale",
    "filePath": "token:SKL",
    "symbol": "skl",
    "name": "SKALE",
    "marketCapRank": 161,
    "addresses": {
      "ethereum": "0x00c83aecc790e8a4453e5dd3b0b4b3680501a7a7"
    },
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "skeb",
    "filePath": "token:SKEB",
    "symbol": "skeb",
    "name": "Skeb",
    "marketCapRank": 1588,
    "addresses": {
      "ethereum": "0x6d614686550b9e1c1df4b2cd8f91c9d4df66c810"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "skey-network",
    "filePath": "token:SKEY",
    "symbol": "skey",
    "name": "Skey Network",
    "marketCapRank": 1140,
    "addresses": {
      "ethereum": "0x06a01a4d579479dd5d884ebf61a31727a3d8d442"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "slam-token",
    "filePath": "token:SLAM",
    "symbol": "slam",
    "name": "Slam",
    "marketCapRank": 2421,
    "addresses": {
      "binance-smart-chain": "0x000851476180bfc499ea68450a5327d21c9b050e"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "sleepless-ai",
    "filePath": "token:AI",
    "symbol": "ai",
    "name": "Sleepless AI",
    "marketCapRank": 321,
    "addresses": {
      "binance-smart-chain": "0xbda011d7f8ec00f66c1923b049b94c67d148d8b2"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "smardex",
    "filePath": "token:SDEX",
    "symbol": "sdex",
    "name": "SmarDex",
    "marketCapRank": 377,
    "addresses": {
      "ethereum": "0x5de8ab7e27f6e7a1fff3e5b337584aa43961beef",
      "arbitrum-one": "0xabd587f2607542723b17f14d00d99b987c29b074",
      "polygon-pos": "0x6899face15c14348e1759371049ab64a3a06bfa6",
      "base": "0xfd4330b0312fdeec6d4225075b82e00493ff2e3f",
      "binance-smart-chain": "0xfdc66a08b0d0dc44c17bbd471b88f49f50cdd20f"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "smart-valor",
    "filePath": "token:VALOR",
    "symbol": "valor",
    "name": "Smart Valor",
    "marketCapRank": 1358,
    "addresses": {
      "ethereum": "0x297e4e5e59ad72b1b0a2fd446929e76117be0e0a"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "smartcredit-token",
    "filePath": "token:SMARTCREDIT",
    "symbol": "smartcredit",
    "name": "SmartCredit",
    "marketCapRank": 2413,
    "addresses": {
      "ethereum": "0x72e9d9038ce484ee986fea183f8d8df93f9ada13"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "smooth-love-potion",
    "filePath": "token:SLP",
    "symbol": "slp",
    "name": "Smooth Love Potion",
    "marketCapRank": 305,
    "addresses": {
      "ronin": "0xa8754b9fa15fc18bb59458815510e40a12cd2014",
      "ethereum": "0xcc8fa225d80b9c7d42f96e9570156c65d6caaa25",
      "energi": "0xa598b856fa2d5e016d2e84a6a86ff99d69dd841e"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "snailbrook",
    "filePath": "token:SNAIL",
    "symbol": "snail",
    "name": "SnailBrook",
    "marketCapRank": 1271,
    "addresses": {
      "ethereum": "0x6bc40d4099f9057b23af309c08d935b890d7adc0"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "snek",
    "filePath": "token:SNEK",
    "symbol": "snek",
    "name": "Snek",
    "marketCapRank": 506,
    "addresses": {
      "cardano": "279c909f348e533da5808898f87f9a14bb2c3dfbbacccd631d927a3f"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "solana",
    "filePath": "token:SOL",
    "symbol": "sol",
    "name": "Solana",
    "marketCapRank": 5,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "solanium",
    "filePath": "token:SLIM",
    "symbol": "slim",
    "name": "Solanium",
    "marketCapRank": 955,
    "addresses": {
      "solana": "xxxxa1sKNGwFtw2kFn8XauW9xq8hBZ5kVtcSesTT9fW"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "solarcoin",
    "filePath": "token:SLR",
    "symbol": "slr",
    "name": "Solarcoin",
    "marketCapRank": 2484,
    "addresses": {
      "zksync": "0xe027d939f7de6f521675907cf086f59e4d75b876",
      "ethereum": "0x4e9e4ab99cfc14b852f552f5fb3aa68617825b6c"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "solcasino-token",
    "filePath": "token:SCS",
    "symbol": "scs",
    "name": "Solcasino Token",
    "marketCapRank": 573,
    "addresses": {
      "solana": "SCSuPPNUSypLBsV4darsrYNg4ANPgaGhKhsA3GmMyjz"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "solchat",
    "filePath": "token:CHAT",
    "symbol": "chat",
    "name": "Solchat",
    "marketCapRank": 619,
    "addresses": {
      "solana": "947tEoG318GUmyjVYhraNRvWpMX7fpBTDQFBoJvSkSG3"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "solcial",
    "filePath": "token:SLCL",
    "symbol": "slcl",
    "name": "Solcial",
    "marketCapRank": 2158,
    "addresses": {
      "solana": "SLCLww7nc1PD2gQPQdGayHviVVcpMthnqUz2iWKhNQV"
    },
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "soldex",
    "filePath": "token:SOLX",
    "symbol": "solx",
    "name": "Soldex",
    "marketCapRank": 3821,
    "addresses": {
      "solana": "CH74tuRLTYcxG7qNJCsV9rghfLXJCQJbsu7i52a8F1Gn"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "solend",
    "filePath": "token:SLND",
    "symbol": "slnd",
    "name": "Solend",
    "marketCapRank": 648,
    "addresses": {
      "solana": "SLNDpmoWTVADgEdndyvWzroNL7zSi1dF9PC3xHGtPwp"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "solfarm",
    "filePath": "token:TULIP",
    "symbol": "tulip",
    "name": "Tulip Protocol",
    "marketCapRank": 2321,
    "addresses": {
      "solana": "TuLipcqtGVXP9XR62wM8WWCm6a9vhLs7T1uoWBk6FDs"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "solidlydex",
    "filePath": "token:SOLID",
    "symbol": "solid",
    "name": "Solidly",
    "marketCapRank": 1753,
    "addresses": {
      "ethereum": "0x777172d858dc1599914a1c4c6c9fc48c99a60990",
      "fantom": "0x777cf5ba9c291a1a8f57ff14836f6f9dc5c0f9dd"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "solidus-aitech",
    "filePath": "token:AITECH",
    "symbol": "aitech",
    "name": "Solidus Ai Tech",
    "marketCapRank": 419,
    "addresses": {
      "binance-smart-chain": "0x2d060ef4d6bf7f9e5edde373ab735513c0e4f944"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "solo-coin",
    "filePath": "token:SOLO",
    "symbol": "solo",
    "name": "Sologenic",
    "marketCapRank": 680,
    "addresses": {},
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "solve-care",
    "filePath": "token:SOLVE",
    "symbol": "solve",
    "name": "SOLVE",
    "marketCapRank": 1199,
    "addresses": {
      "ethereum": "0x446c9033e7516d820cc9a2ce2d0b7328b579406f"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "sombra-network",
    "filePath": "token:SMBR",
    "symbol": "smbr",
    "name": "Sombra",
    "marketCapRank": 2438,
    "addresses": {
      "binance-smart-chain": "0x16b3e050e9e2f0ac4f1bea1b3e4fdc43d7f062dd",
      "ethereum": "0x16b3e050e9e2f0ac4f1bea1b3e4fdc43d7f062dd"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "somesing",
    "filePath": "token:SSX",
    "symbol": "ssx",
    "name": "SOMESING Exchange",
    "marketCapRank": 1847,
    "addresses": {
      "klay-token": "0xdcd62c57182e780e23d2313c4782709da85b9d6c"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "sommelier",
    "filePath": "token:SOMM",
    "symbol": "somm",
    "name": "Sommelier",
    "marketCapRank": 805,
    "addresses": {
      "cosmos": "ibc/9BBA9A1C257E971E38C1422780CE6F0B0686F0A3085E2D61118D904BFE0F5F5E",
      "ethereum": "0xa670d7237398238de01267472c6f13e5b8010fd1"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "somnium-space-cubes",
    "filePath": "token:CUBE",
    "symbol": "cube",
    "name": "Somnium Space CUBEs",
    "marketCapRank": 1246,
    "addresses": {
      "ethereum": "0xdf801468a808a32656d2ed2d2d80b72a129739f4"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "sonne-finance",
    "filePath": "token:SONNE",
    "symbol": "sonne",
    "name": "Sonne Finance",
    "marketCapRank": 1406,
    "addresses": {
      "optimistic-ethereum": "0x1db2466d9f5e10d7090e7152b68d62703a2245f0",
      "base": "0x22a2488fe295047ba13bd8cccdbc8361dbd8cf7c"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "soonswap",
    "filePath": "token:SOON",
    "symbol": "soon",
    "name": "SoonVerse",
    "marketCapRank": 1750,
    "addresses": {
      "ethereum": "0x574d22e2555cac0ce71e44778f6de2e7487ae229"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "sophiaverse",
    "filePath": "token:SOPH",
    "symbol": "soph",
    "name": "SophiaVerse",
    "marketCapRank": 1136,
    "addresses": {
      "binance-smart-chain": "0x73fbd93bfda83b111ddc092aa3a4ca77fd30d380",
      "ethereum": "0x73fbd93bfda83b111ddc092aa3a4ca77fd30d380"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "sora",
    "filePath": "token:XOR",
    "symbol": "xor",
    "name": "Sora",
    "marketCapRank": 2092,
    "addresses": {
      "ethereum": "0x40fd72257597aa14c7231a7b1aaa29fce868f677",
      "sora": "0x0200000000000000000000000000000000000000000000000000000000000000"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "source",
    "filePath": "token:SOURCE",
    "symbol": "source",
    "name": "Source",
    "marketCapRank": 1139,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "source-protocol",
    "filePath": "token:SRCX",
    "symbol": "srcx",
    "name": "Source Protocol",
    "marketCapRank": 2250,
    "addresses": {
      "binance-smart-chain": "0x454b90716a9435e7161a9aea5cf00e0acbe565ae"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "sovryn",
    "filePath": "token:SOV",
    "symbol": "sov",
    "name": "Sovryn",
    "marketCapRank": 605,
    "addresses": {
      "ethereum": "0xbdab72602e9ad40fc6a6852caf43258113b8f7a5",
      "rootstock": "0xefc78fc7d48b64958315949279ba181c2114abbd"
    },
    "variants": [
      "mono"
    ]
  },
  {
    "id": "space-id",
    "filePath": "token:ID",
    "symbol": "id",
    "name": "SPACE ID",
    "marketCapRank": 202,
    "addresses": {
      "binance-smart-chain": "0x2dff88a56767223a5529ea5960da7a3f5f766406",
      "ethereum": "0x2dff88a56767223a5529ea5960da7a3f5f766406"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "spacechain-erc-20",
    "filePath": "token:SPC",
    "symbol": "spc",
    "name": "SpaceChain (ERC-20)",
    "marketCapRank": 1965,
    "addresses": {
      "ethereum": "0x86ed939b500e121c0c5f493f399084db596dad20"
    },
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "spacefalcon",
    "filePath": "token:FCON",
    "symbol": "fcon",
    "name": "SpaceFalcon",
    "marketCapRank": 1661,
    "addresses": {
      "solana": "HovGjrBGTfna4dvg6exkMxXuexB3tUfEZKcut8AWowXj"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "spacen",
    "filePath": "token:SN",
    "symbol": "sn",
    "name": "SpaceN",
    "marketCapRank": 1281,
    "addresses": {
      "binance-smart-chain": "0x939dd9e433552e325d78c33a16ef4cd8004d2f9c"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "spain-national-fan-token",
    "filePath": "token:SNFT",
    "symbol": "snft",
    "name": "Spain National Football Team Fan Token",
    "marketCapRank": 2206,
    "addresses": {
      "Bitcichain": "0x3e6f1be54feb9cc37dbfc31a894a8810357c3f9c"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "spankchain",
    "filePath": "token:SPANK",
    "symbol": "spank",
    "name": "SpankChain",
    "marketCapRank": 1757,
    "addresses": {
      "ethereum": "0x42d6622dece394b54999fbd73d108123806f6a18"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "sparkpoint",
    "filePath": "token:SRK",
    "symbol": "srk",
    "name": "SparkPoint",
    "marketCapRank": 2320,
    "addresses": {
      "ethereum": "0x0488401c3f535193fa8df029d9ffe615a06e74e6",
      "harmony-shard-0": "0x9500a1fbef7014dbd384633fd20bb1e6916d6fca"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "spartadex",
    "filePath": "token:SPARTA",
    "symbol": "sparta",
    "name": "SpartaDEX",
    "marketCapRank": 1170,
    "addresses": {
      "arbitrum-one": "0x11f98c7e42a367dab4f200d2fdc460fb445ce9a8"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "spell-token",
    "filePath": "token:SPELL",
    "symbol": "spell",
    "name": "Spell",
    "marketCapRank": 372,
    "addresses": {
      "ethereum": "0x090185f2135308bad17527004364ebcc2d37e5f6",
      "avalanche": "0xce1bffbd5374dac86a2893119683f4911a2f7814",
      "fantom": "0x468003b688943977e6130f4f68f23aad939a1040",
      "arbitrum-one": "0x3e6648c5a70a150a88bce65f4ad4d506fe15d2af"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "sperax",
    "filePath": "token:SPA",
    "symbol": "spa",
    "name": "Sperax",
    "marketCapRank": 987,
    "addresses": {
      "arbitrum-one": "0x5575552988a3a80504bbaeb1311674fcfd40ad4b",
      "ethereum": "0xb4a3b0faf0ab53df58001804dda5bfc6a3d59008"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "sphere-finance",
    "filePath": "token:SPHERE",
    "symbol": "sphere",
    "name": "Sphere Finance",
    "marketCapRank": 1866,
    "addresses": {
      "polygon-pos": "0x62f594339830b90ae4c084ae7d223ffafd9658a7"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "spheroid-universe",
    "filePath": "token:SPH",
    "symbol": "sph",
    "name": "Spheroid Universe",
    "marketCapRank": 1707,
    "addresses": {
      "ethereum": "0xa0cf46eb152656c7090e769916eb44a138aaa406"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "spiritswap",
    "filePath": "token:SPIRIT",
    "symbol": "spirit",
    "name": "SpiritSwap",
    "marketCapRank": 1918,
    "addresses": {
      "fantom": "0x5cc61a78f164885776aa610fb0fe1257df78e59b"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "splyt",
    "filePath": "token:SHOPX",
    "symbol": "shopx",
    "name": "SHOPX",
    "marketCapRank": 1447,
    "addresses": {
      "ethereum": "0x7bef710a5759d197ec0bf621c3df802c2d60d848"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "spool-dao-token",
    "filePath": "token:SPOOL",
    "symbol": "spool",
    "name": "Spool",
    "marketCapRank": 1350,
    "addresses": {
      "ethereum": "0x40803cea2b2a32bda1be61d3604af6a814e70976",
      "arbitrum-one": "0xeca14f81085e5b8d1c9d32dcb596681574723561"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "spore",
    "filePath": "token:SPORE",
    "symbol": "spore",
    "name": "Spore",
    "marketCapRank": 2501,
    "addresses": {
      "avalanche": "0x6e7f5c0b9f4432716bdd0a77a3601291b9d9e985",
      "binance-smart-chain": "0x33a3d962955a3862c8093d1273344719f03ca17c"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "spx6900",
    "filePath": "token:SPX",
    "symbol": "spx",
    "name": "SPX6900",
    "marketCapRank": 2171,
    "addresses": {
      "ethereum": "0xe0f63a424a4439cbe457d80e4f4b51ad25b2c56c",
      "base": "0x50da645f148798f68ef2d7db7c1cb22a6819bb2c",
      "solana": "J3NKxxXZcnNiMjKw9hYb2K4LUxgwB6t1FtPtQVsv3KFr"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "squad",
    "filePath": "token:SQUAD",
    "symbol": "squad",
    "name": "Superpower Squad",
    "marketCapRank": 2551,
    "addresses": {
      "binance-smart-chain": "0x724a32dfff9769a0a0e1f0515c0012d1fb14c3bd",
      "arbitrum-nova": "0x223fb0ceb2c6e5310264efe38151d7d083db91f1",
      "arbitrum-one": "0xd45e486a90ebb84e9336d371a35dcb021424b96c"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "squidgrow",
    "filePath": "token:SQUIDGROW",
    "symbol": "squidgrow",
    "name": "SquidGrow",
    "marketCapRank": 1294,
    "addresses": {
      "binance-smart-chain": "0xd8fa690304d2b2824d918c0c7376e2823704557a",
      "ethereum": "0xd8fa690304d2b2824d918c0c7376e2823704557a"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "ssv-network",
    "filePath": "token:SSV",
    "symbol": "ssv",
    "name": "SSV Network",
    "marketCapRank": 219,
    "addresses": {
      "ethereum": "0x9d65ff81a3c488d585bbfb0bfe3c7707c7917f54"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "stacktical",
    "filePath": "token:DSLA",
    "symbol": "dsla",
    "name": "DSLA Protocol",
    "marketCapRank": 1836,
    "addresses": {
      "ethereum": "0x3affcca64c2a6f4e3b6bd9c64cd2c969efd1ecbe",
      "harmony-shard-0": "0x34704c70e9ec9fb9a921da6daad7d3e19f43c734",
      "arbitrum-one": "0x7ce746b45eabd0c4321538dec1b849c79a9a8476",
      "avalanche": "0xd7c295e399ca928a3a14b01d760e794f1adf8990",
      "polygon-pos": "0xa0e390e9cea0d0e8cd40048ced9fa9ea10d71639",
      "binance-smart-chain": "0x1861c9058577c3b48e73d91d6f25c18b17fbffe0",
      "fantom": "0x25a528af62e56512a19ce8c3cab427807c28cc19"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "stader-ethx",
    "filePath": "token:ETHX",
    "symbol": "ethx",
    "name": "Stader ETHx",
    "marketCapRank": 211,
    "addresses": {
      "ethereum": "0xa35b1b31ce002fbf2058d22f30f95d405200a15b"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "stader-maticx",
    "filePath": "token:MATICX",
    "symbol": "maticx",
    "name": "Stader MaticX",
    "marketCapRank": 415,
    "addresses": {
      "ethereum": "0xf03a7eb46d01d9ecaa104558c732cf82f6b6b645",
      "manta-pacific": "0x01d27580c464d5b3b26f78bee12e684901dbc02a",
      "polygon-pos": "0xfa68fb4628dff1028cfec22b4162fccd0d45efb6"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "stader-sftmx",
    "filePath": "token:SFTMX",
    "symbol": "sftmx",
    "name": "BeethovenX sFTMX",
    "marketCapRank": 1104,
    "addresses": {
      "fantom": "0xd7028092c830b5c8fce061af2e593413ebbc1fc1"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "stafi",
    "filePath": "token:FIS",
    "symbol": "fis",
    "name": "Stafi",
    "marketCapRank": 452,
    "addresses": {
      "polkadot": "0xef3a930e1ffffacd2fc13434ac81bd278b0ecc8d",
      "sora": "0x00e6df883c9844e34b354b840e3a527f5fc6bfc937138c67908b1c8f2931f3e9",
      "ethereum": "0xef3a930e1ffffacd2fc13434ac81bd278b0ecc8d"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "stake-dao",
    "filePath": "token:SDT",
    "symbol": "sdt",
    "name": "Stake DAO",
    "marketCapRank": 1278,
    "addresses": {
      "ethereum": "0x73968b9a57c6e53d41345fd57a6e6ae27d6cdb2f",
      "arbitrum-one": "0x7ba4a00d54a07461d9db2aef539e91409943adc9",
      "polygon-pos": "0x361a5a4993493ce00f61c32d4ecca5512b82ce90"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "stake-link",
    "filePath": "token:SDL",
    "symbol": "sdl",
    "name": "stake.link",
    "marketCapRank": 1493,
    "addresses": {
      "ethereum": "0xa95c5ebb86e0de73b4fb8c47a45b792cfea28c23"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "staked-frax-ether",
    "filePath": "token:SFRXETH",
    "symbol": "sfrxeth",
    "name": "Staked Frax Ether",
    "marketCapRank": 159,
    "addresses": {
      "ethereum": "0xac3e018457b222d93114458476f3e3416abbe38f",
      "moonbeam": "0xecf91116348af1cffe335e9807f0051332be128d",
      "fantom": "0xb90ccd563918ff900928dc529aa01046795ccb4a",
      "optimistic-ethereum": "0x484c2d6e3cdd945a8b2df735e079178c1036578c",
      "arbitrum-one": "0x95ab45875cffdba1e5f451b950bc2e42c0053f39",
      "polygon-pos": "0x6d1fdbb266fcc09a16a22016369210a15bb95761",
      "binance-smart-chain": "0x3cd55356433c89e50dc51ab07ee0fa0a95623d53"
    },
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "stakewise",
    "filePath": "token:SWISE",
    "symbol": "swise",
    "name": "StakeWise",
    "marketCapRank": 1286,
    "addresses": {
      "ethereum": "0x48c3399719b582dd63eb5aadf12a40b4c3f52fa2"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "star-atlas",
    "filePath": "token:ATLAS",
    "symbol": "atlas",
    "name": "Star Atlas",
    "marketCapRank": 470,
    "addresses": {
      "solana": "ATLASXmbPQxBUYbxPsV97usA3fPQYEqzQBUHgiFCUsXx"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "stargate-finance",
    "filePath": "token:STG",
    "symbol": "stg",
    "name": "Stargate Finance",
    "marketCapRank": 406,
    "addresses": {
      "ethereum": "0xaf5191b0de278c7286d6c7cc6ab6bb8a73ba2cd6",
      "avalanche": "0x2f6f07cdcf3588944bf4c42ac74ff24bf56e7590",
      "optimistic-ethereum": "0x296f55f8fb28e498b858d0bcda06d955b2cb3f97",
      "arbitrum-one": "0x6694340fc020c5e6b96567843da2df01b2ce1eb6",
      "fantom": "0x2f6f07cdcf3588944bf4c42ac74ff24bf56e7590",
      "polygon-pos": "0x2f6f07cdcf3588944bf4c42ac74ff24bf56e7590",
      "binance-smart-chain": "0xb0d502e938ed5f4df2e681fe6e419ff29631d62b"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "stargaze",
    "filePath": "token:STARS",
    "symbol": "stars",
    "name": "Stargaze",
    "marketCapRank": 653,
    "addresses": {
      "cosmos": "ibc/987C17B11ABC2B20019178ACE62929FE9840202CE79498E29FE8E5CB02B7C0A4",
      "evmos": "0x5ad523d94efb56c400941eb6f34393b84c75ba39"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "starknet",
    "filePath": "token:STRK",
    "symbol": "strk",
    "name": "Starknet",
    "marketCapRank": 78,
    "addresses": {
      "ethereum": "0xca14007eff0db1f8135f4c25b34de49ab0d42766",
      "starknet": "0x4718f5a0fc34cc1af16a1cdee98ffb20c31f5cd61d6ab07201858f4287c938d"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "starlink",
    "filePath": "token:STARL",
    "symbol": "starl",
    "name": "StarLink",
    "marketCapRank": 883,
    "addresses": {
      "ethereum": "0x8e6cd950ad6ba651f6dd608dc70e5886b1aa6b24"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "stasis-eurs",
    "filePath": "token:EURS",
    "symbol": "eurs",
    "name": "STASIS EURO",
    "marketCapRank": 444,
    "addresses": {
      "ethereum": "0xdb25f211ab05b1c97d595516f45794528a807ad8",
      "polygon-pos": "0xe111178a87a3bff0c8d18decba5798827539ae99"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "stat",
    "filePath": "token:STAT",
    "symbol": "stat",
    "name": "STAT",
    "marketCapRank": 1567,
    "addresses": {
      "ethereum": "0x4fc15c91a9c4a9efb404174464687e8e128730c2"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "status",
    "filePath": "token:SNT",
    "symbol": "snt",
    "name": "Status",
    "marketCapRank": 345,
    "addresses": {
      "ethereum": "0x744d70fdbe2ba4cf95131626614a1763df805b9e",
      "energi": "0x6bb14afedc740dce4904b7a65807fe3b967f4c94"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "steem",
    "filePath": "token:STEEM",
    "symbol": "steem",
    "name": "Steem",
    "marketCapRank": 399,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "steem-dollars",
    "filePath": "token:SBD",
    "symbol": "sbd",
    "name": "Steem Dollars",
    "marketCapRank": 672,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "stellar",
    "filePath": "token:XLM",
    "symbol": "xlm",
    "name": "Stellar",
    "marketCapRank": 37,
    "addresses": {},
    "variants": [
      "mono"
    ]
  },
  {
    "id": "stellaswap",
    "filePath": "token:STELLA",
    "symbol": "stella",
    "name": "StellaSwap",
    "marketCapRank": 2056,
    "addresses": {
      "moonbeam": "0x0e358838ce72d5e61e0018a2ffac4bec5f4c88d2"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "step-app-fitfi",
    "filePath": "token:FITFI",
    "symbol": "fitfi",
    "name": "Step App",
    "marketCapRank": 984,
    "addresses": {
      "avalanche": "0x714f020c54cc9d104b6f4f6998c63ce2a31d1888",
      "binance-smart-chain": "0x7588df009c3d82378be6ab81f2108fa963c10fc8",
      "step-network": "0xb58a9d5920af6ac1a9522b0b10f55df16686d1b6"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "step-finance",
    "filePath": "token:STEP",
    "symbol": "step",
    "name": "Step Finance",
    "marketCapRank": 1032,
    "addresses": {
      "solana": "StepAscQoEioFxxWGnh2sLBDFp9d8rvKz2Yp39iDpyT"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "stfx",
    "filePath": "token:STFX",
    "symbol": "stfx",
    "name": "STFX",
    "marketCapRank": 1037,
    "addresses": {
      "ethereum": "0x9343e24716659a3551eb10aff9472a2dcad5db2d",
      "arbitrum-one": "0x7dd747d63b094971e6638313a6a2685e80c7fb2e"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "stima",
    "filePath": "token:STIMA",
    "symbol": "stima",
    "name": "STIMA",
    "marketCapRank": 2071,
    "addresses": {
      "ethereum": "0xd2e5decc08a80be6538f89f9ab8ff296e2f724df"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "stobox-token",
    "filePath": "token:STBU",
    "symbol": "stbu",
    "name": "Stobox",
    "marketCapRank": 1128,
    "addresses": {
      "ethereum": "0xa6422e3e219ee6d4c1b18895275fe43556fd50ed",
      "binance-smart-chain": "0xb0c4080a8fa7afa11a09473f3be14d44af3f8743",
      "polygon-pos": "0xcf403036bc139d30080d2cf0f5b48066f98191bb"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "storj",
    "filePath": "token:STORJ",
    "symbol": "storj",
    "name": "Storj",
    "marketCapRank": 485,
    "addresses": {
      "ethereum": "0xb64ef51c888972c908cfacf59b47c1afbc0ab8ac",
      "harmony-shard-0": "0x266f341e33aa61c30c6a9af89314811a5b097cb4",
      "energi": "0xcde71daaffb6a12d584f55777d4c9e9d3c353c1e"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "storm",
    "filePath": "token:STMX",
    "symbol": "stmx",
    "name": "StormX",
    "marketCapRank": 449,
    "addresses": {
      "ethereum": "0xa62cc35625b0c8dc1faea39d33625bb4c15bd71c"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "storx",
    "filePath": "token:SRX",
    "symbol": "srx",
    "name": "StorX",
    "marketCapRank": 1229,
    "addresses": {
      "xdc-network": "xdc5d5f074837f5d4618b3916ba74de1bf9662a3fed"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "stp-network",
    "filePath": "token:STPT",
    "symbol": "stpt",
    "name": "STP",
    "marketCapRank": 405,
    "addresses": {
      "ethereum": "0xde7d85157d9714eadf595045cc12ca4a5f3e2adb"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "stratis",
    "filePath": "token:STRAX",
    "symbol": "strax",
    "name": "Stratis",
    "marketCapRank": 2109,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "stratos",
    "filePath": "token:STOS",
    "symbol": "stos",
    "name": "Stratos",
    "marketCapRank": 559,
    "addresses": {
      "ethereum": "0x08c32b0726c5684024ea6e141c50ade9690bbdcc"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "streamr",
    "filePath": "token:DATA",
    "symbol": "data",
    "name": "Streamr",
    "marketCapRank": 674,
    "addresses": {
      "ethereum": "0x8f693ca8d21b157107184d29d398a8d082b38b76",
      "binance-smart-chain": "0x0864c156b3c5f69824564dec60c629ae6401bf2a",
      "polygon-pos": "0x3a9a81d576d83ff21f26f325066054540720fc34",
      "xdai": "0x256eb8a51f382650b2a1e946b8811953640ee47d"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "streamr-xdata",
    "filePath": "token:XDATA",
    "symbol": "xdata",
    "name": "Streamr XDATA",
    "marketCapRank": 716,
    "addresses": {
      "ethereum": "0x0cf0ee63788a0849fe5297f3407f701e122cc023"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "stride",
    "filePath": "token:STRD",
    "symbol": "strd",
    "name": "Stride",
    "marketCapRank": 280,
    "addresses": {
      "osmosis": "ibc/A8CA5EE328FA10C9519DF6057DA1F69682D28F7D0F5CCC7ECB72E3DCA2D157A4"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "stride-staked-atom",
    "filePath": "token:STATOM",
    "symbol": "statom",
    "name": "Stride Staked Atom",
    "marketCapRank": 751,
    "addresses": {
      "evmos": "0xc8b4d3e67238e38b20d38908646ff6f4f48de5ec",
      "secret": "secret155w9uxruypsltvqfygh5urghd5v0zc6f9g69sq",
      "osmosis": "ibc/C140AFD542AE77BD7DCC83F13FDD8C5E5BB8C4929785E6EC2F4C636F98F17901"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "stride-staked-juno",
    "filePath": "token:STJUNO",
    "symbol": "stjuno",
    "name": "Stride Staked Juno",
    "marketCapRank": 2505,
    "addresses": {
      "osmosis": "ibc/84502A75BCA4A5F68D464C00B3F610CE2585847D59B52E5FFB7C3C9D2DDCD3FE",
      "secret": "secret1097nagcaavlkchl87xkqptww2qkwuvhdnsqs2v"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "stride-staked-osmo",
    "filePath": "token:STOSMO",
    "symbol": "stosmo",
    "name": "Stride Staked Osmo",
    "marketCapRank": 969,
    "addresses": {
      "osmosis": "ibc/D176154B0C63D1F9C6DCFB4F70349EBF2E2B5A87A05902F57A6AE92B863E9AEC"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "stride-staked-stars",
    "filePath": "token:STSTARS",
    "symbol": "ststars",
    "name": "Stride Staked Stars",
    "marketCapRank": 2547,
    "addresses": {
      "cosmos": "ibc/5DD1F95ED336014D00CE2520977EC71566D282F9749170ADC83A392E0EA7426A"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "strikecoin",
    "filePath": "token:STRX",
    "symbol": "strx",
    "name": "StrikeX",
    "marketCapRank": 663,
    "addresses": {
      "binance-smart-chain": "0xd6fdde76b8c1c45b33790cc8751d5b88984c44ec"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "strips-finance",
    "filePath": "token:STRP",
    "symbol": "strp",
    "name": "Strips Finance",
    "marketCapRank": 1896,
    "addresses": {
      "ethereum": "0x97872eafd79940c7b24f7bcc1eadb1457347adc9",
      "arbitrum-one": "0x326c33fd1113c1f29b35b4407f3d6312a8518431"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "strong",
    "filePath": "token:STRONG",
    "symbol": "strong",
    "name": "Strong",
    "marketCapRank": 2322,
    "addresses": {
      "ethereum": "0x990f341946a3fdb507ae7e52d17851b87168017c"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "stronghold-token",
    "filePath": "token:SHX",
    "symbol": "shx",
    "name": "Stronghold",
    "marketCapRank": 789,
    "addresses": {
      "stellar": "SHX-GDSTRSHXHGJ7ZIVRBXEYE5Q74XUVCUSEKEBR7UCHEUUEK72N7I7KJ6JH"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "subsocial",
    "filePath": "token:SUB",
    "symbol": "sub",
    "name": "Subsocial",
    "marketCapRank": 1709,
    "addresses": {
      "moonbeam": "0xffffffff43b4560bc0c451a3386e082bff50ac90"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "sudoswap",
    "filePath": "token:SUDO",
    "symbol": "sudo",
    "name": "sudoswap",
    "marketCapRank": 1819,
    "addresses": {
      "ethereum": "0x3446dd70b2d52a6bf4a5a192d9b0a161295ab7f9"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "sui",
    "filePath": "token:SUI",
    "symbol": "sui",
    "name": "Sui",
    "marketCapRank": 58,
    "addresses": {
      "sui": "0x2::sui::SUI"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "suipad",
    "filePath": "token:SUIP",
    "symbol": "suip",
    "name": "SuiPad",
    "marketCapRank": 1626,
    "addresses": {
      "sui": "0xe4239cd951f6c53d9c41e25270d80d31f925ad1655e5ba5b543843d4a66975ee::SUIP::SUIP"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "suiswap",
    "filePath": "token:SSWP",
    "symbol": "sswp",
    "name": "Suiswap",
    "marketCapRank": 1323,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "suku",
    "filePath": "token:SUKU",
    "symbol": "suku",
    "name": "SUKU",
    "marketCapRank": 1021,
    "addresses": {
      "ethereum": "0x0763fdccf1ae541a5961815c0872a8c5bc6de4d7"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "sun-token",
    "filePath": "token:SUN",
    "symbol": "sun",
    "name": "Sun Token",
    "marketCapRank": 403,
    "addresses": {
      "tron": "TSSMHYeV2uE9qYH95DqyoCuNCzEL1NvU3S"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "suncontract",
    "filePath": "token:SNC",
    "symbol": "snc",
    "name": "SunContract",
    "marketCapRank": 1621,
    "addresses": {
      "ethereum": "0xf4134146af2d511dd5ea8cdb1c4ac88c57d60404"
    },
    "variants": [
      "mono"
    ]
  },
  {
    "id": "super-zero",
    "filePath": "token:SERO",
    "symbol": "sero",
    "name": "SERO",
    "marketCapRank": 2316,
    "addresses": {},
    "variants": [
      "mono"
    ]
  },
  {
    "id": "superlauncher-dao",
    "filePath": "token:LAUNCH",
    "symbol": "launch",
    "name": "Superlauncher",
    "marketCapRank": 2420,
    "addresses": {
      "zksync": "0xf6d9a093a1c69a152d87e269a7d909e9d76b1815"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "superrare",
    "filePath": "token:RARE",
    "symbol": "rare",
    "name": "SuperRare",
    "marketCapRank": 451,
    "addresses": {
      "ethereum": "0xba5bde662c17e2adff1075610382b9b691296350"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "superwalk",
    "filePath": "token:GRND",
    "symbol": "grnd",
    "name": "SuperWalk",
    "marketCapRank": 1473,
    "addresses": {
      "klay-token": "0x84f8c3c8d6ee30a559d73ec570d574f671e82647"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "sushi",
    "filePath": "token:SUSHI",
    "symbol": "sushi",
    "name": "Sushi",
    "marketCapRank": 238,
    "addresses": {
      "ethereum": "0x6b3595068778dd592e39a122f4f5a5cf09c90fe2",
      "fantom": "0xae75a438b2e0cb8bb01ec1e1e376de11d44477cc",
      "harmony-shard-0": "0xbec775cb42abfa4288de81f387a9b1a3c4bc552a",
      "avalanche": "0x37b608519f91f70f2eeb0e5ed9af4061722e4f76",
      "energi": "0x32aff6adc46331dac93e608a9cd4b0332d93a23a",
      "near-protocol": "6b3595068778dd592e39a122f4f5a5cf09c90fe2.factory.bridge.near",
      "arbitrum-one": "0xd4d42f0b6def4ce0383636770ef773390d85c61a",
      "polygon-pos": "0x0b3f868e0be5597d5db7feb59e1cadbb0fdda50a",
      "binance-smart-chain": "0x947950bcc74888a40ffa2593c5798f11fc9124c4",
      "sora": "0x0078f4e6c5113b3d8c954dff62ece8fc36a8411f86f1cbb48a52527e22e73be2",
      "celo": "0xd15ec721c2a896512ad29c671997dd68f9593226",
      "solana": "ChVzxWRmrTeSgwd3Ui3UumcN8KX7VK3WaD4KGeSKpypj"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "suterusu",
    "filePath": "token:SUTER",
    "symbol": "suter",
    "name": "Suterusu",
    "marketCapRank": 2349,
    "addresses": {
      "ethereum": "0xaa2ce7ae64066175e0b90497ce7d9c190c315db4"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "swarm-bzz",
    "filePath": "token:BZZ",
    "symbol": "bzz",
    "name": "Swarm",
    "marketCapRank": 864,
    "addresses": {
      "ethereum": "0x19062190b1925b5b6689d7073fdfc8c2976ef8cb",
      "xdai": "0xdbf3ea6f5bee45c02255b2c26a16f300502f68da"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "swarm-markets",
    "filePath": "token:SMT",
    "symbol": "smt",
    "name": "Swarm Markets",
    "marketCapRank": 744,
    "addresses": {
      "ethereum": "0xb17548c7b510427baac4e267bea62e800b247173",
      "base": "0x2974dc646e375e83bd1c0342625b49f288987fa4",
      "polygon-pos": "0xe631dabef60c37a37d70d3b4f812871df663226f"
    },
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "swash",
    "filePath": "token:SWASH",
    "symbol": "swash",
    "name": "Swash",
    "marketCapRank": 1149,
    "addresses": {
      "ethereum": "0xa130e3a33a4d84b04c3918c4e5762223ae252f80",
      "xdai": "0x84e2c67cbefae6b5148fca7d02b341b12ff4b5bb",
      "polygon-pos": "0xba3cb8329d442e6f9eb70fafe1e214251df3d275",
      "binance-smart-chain": "0x41065e3428188ba6eb27fbdde8526ae3af8e3830"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "sweatcoin",
    "filePath": "token:SWEAT",
    "symbol": "sweat",
    "name": "Sweat Economy",
    "marketCapRank": 517,
    "addresses": {
      "ethereum": "0xb4b9dc1c77bdbb135ea907fd5a08094d98883a35",
      "near-protocol": "token.sweat"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "sweth",
    "filePath": "token:SWETH",
    "symbol": "sweth",
    "name": "Swell Ethereum",
    "marketCapRank": 137,
    "addresses": {
      "ethereum": "0xf951e335afb289353dc249e82926178eac7ded78",
      "arbitrum-one": "0xbc011a12da28e8f0f528d9ee5e7039e22f91cf18"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "swftcoin",
    "filePath": "token:SWFTC",
    "symbol": "swftc",
    "name": "SWFTCOIN",
    "marketCapRank": 728,
    "addresses": {
      "ethereum": "0x0bb217e40f8a5cb79adf04e1aab60e5abd0dfc1e",
      "binance-smart-chain": "0xe64e30276c2f826febd3784958d6da7b55dfbad3"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "swipe",
    "filePath": "token:SXP",
    "symbol": "sxp",
    "name": "SXP",
    "marketCapRank": 274,
    "addresses": {
      "ethereum": "0x8ce9137d39326ad0cd6491fb5cc0cba0e089b6a9",
      "harmony-shard-0": "0x77d046614710fddf5ca3e3ce85f4f09f7abc283c",
      "binance-smart-chain": "0x47bead2563dcbf3bf2c9407fea4dc236faba485a"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "switcheo",
    "filePath": "token:SWTH",
    "symbol": "swth",
    "name": "Carbon Protocol",
    "marketCapRank": 1298,
    "addresses": {
      "osmosis": "ibc/8FEFAE6AECF6E2A255585617F781F35A8D5709A545A804482A261C0C9548A9D3",
      "neo": "ab38352559b8b203bde5fddfa0b07d8b2525e132",
      "zilliqa": "zil1yk93f957fanapf0yszgm84p62xrxxfytj4d2tl",
      "arbitrum-one": "0xf763fa322dc58dee588252fafee5f448e863b633",
      "binance-smart-chain": "0xc0ecb8499d8da2771abcbf4091db7f65158f1468"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "sylo",
    "filePath": "token:SYLO",
    "symbol": "sylo",
    "name": "Sylo",
    "marketCapRank": 1337,
    "addresses": {
      "ethereum": "0xf293d23bf2cdc05411ca0eddd588eb1977e8dcd4"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "symbiosis-finance",
    "filePath": "network:symbiosis",
    "symbol": "sis",
    "name": "Symbiosis",
    "marketCapRank": 1014,
    "addresses": {
      "ethereum": "0xd38bb40815d2b0c2d2c866e0c72c5728ffc76dd9",
      "linea": "0x6ef95b6f3b0f39508e3e04054be96d5ee39ede0d",
      "zksync": "0xdd9f72afed3631a6c85b5369d84875e6c42f1827",
      "arbitrum-one": "0x9e758b8a98a42d612b3d38b66a22074dc03d7370",
      "scroll": "0x1467b62a6ae5cdcb10a6a8173cfe187dd2c5a136",
      "binance-smart-chain": "0xf98b660adf2ed7d9d9d9daacc2fb0cace4f21835"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "syncus",
    "filePath": "token:SYNC",
    "symbol": "sync",
    "name": "Syncus",
    "marketCapRank": 627,
    "addresses": {
      "ethereum": "0xa41d2f8ee4f47d3b860a149765a7df8c3287b7f0",
      "zksync": "0x2d20b8891f2f9ed0ebf1b179b2279f936dec9282"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "synesis-one",
    "filePath": "token:SNS",
    "symbol": "sns",
    "name": "Synesis One",
    "marketCapRank": 651,
    "addresses": {
      "solana": "SNSNkV9zfG5ZKWQs6x4hxvBRV6s8SqMfSGCtECDvdMd"
    },
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "syscoin",
    "filePath": "token:SYS",
    "symbol": "sys",
    "name": "Syscoin",
    "marketCapRank": 312,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "taboo-token",
    "filePath": "token:TABOO",
    "symbol": "taboo",
    "name": "Taboo",
    "marketCapRank": 1097,
    "addresses": {
      "binance-smart-chain": "0x9abdba20edfba06b782126b4d8d72a5853918fd0"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "taki",
    "filePath": "token:TAKI",
    "symbol": "taki",
    "name": "Taki Games",
    "marketCapRank": 908,
    "addresses": {
      "solana": "Taki7fi3Zicv7Du1xNAWLaf6mRK7ikdn77HeGzgwvo4",
      "polygon-pos": "0xe78aee6ccb05471a69677fb74da80f5d251c042b"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "tamadoge",
    "filePath": "token:TAMA",
    "symbol": "tama",
    "name": "Tamadoge",
    "marketCapRank": 1553,
    "addresses": {
      "ethereum": "0x12b6893ce26ea6341919fe289212ef77e51688c8"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "tap",
    "filePath": "token:XTP",
    "symbol": "xtp",
    "name": "Tap",
    "marketCapRank": 1689,
    "addresses": {
      "ethereum": "0x6368e1e18c4c419ddfc608a0bed1ccb87b9250fc"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "taraxa",
    "filePath": "token:TARA",
    "symbol": "tara",
    "name": "Taraxa",
    "marketCapRank": 901,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "tarot",
    "filePath": "token:TAROT",
    "symbol": "tarot",
    "name": "Tarot V1",
    "marketCapRank": 2382,
    "addresses": {
      "fantom": "0xc5e2b037d30a390e62180970b3aa4e91868764cd",
      "optimistic-ethereum": "0x375488f097176507e39b9653b88fdc52cde736bf",
      "ethereum": "0x837d904a3799c0769079be9ecbaddf1abd4ccd6e",
      "arbitrum-one": "0x6688b00f0c23a4a546beaae51a7c90c439895d48",
      "binance-smart-chain": "0xa8cd6e4bf45724d3ac27f9e31e47ba4e399a7b52"
    },
    "variants": [
      "mono"
    ]
  },
  {
    "id": "tbtc",
    "filePath": "token:TBTC",
    "symbol": "tbtc",
    "name": "tBTC",
    "marketCapRank": 488,
    "addresses": {
      "ethereum": "0x18084fba666a33d37592fa2633fd49a74dd93a88",
      "polygon-pos": "0x236aa50979d5f3de3bd1eeb40e81137f22ab794b",
      "optimistic-ethereum": "0x6c84a8f1c29108f47a79964b5fe888d4f4d0de40",
      "arbitrum-one": "0x6c84a8f1c29108f47a79964b5fe888d4f4d0de40",
      "base": "0x236aa50979d5f3de3bd1eeb40e81137f22ab794b",
      "solana": "6DNSN2BJsaPFdFFc1zP37kkeNe4Usc1Sqkzr9C9vPWcU"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "tectonic",
    "filePath": "token:TONIC",
    "symbol": "tonic",
    "name": "Tectonic",
    "marketCapRank": 931,
    "addresses": {
      "cronos": "0xdd73dea10abc2bff99c60882ec5b2b81bb1dc5b2"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "tectum",
    "filePath": "token:TET",
    "symbol": "tet",
    "name": "Tectum",
    "marketCapRank": 332,
    "addresses": {
      "ethereum": "0x68a47fe1cf42eba4a030a10cd4d6a1031ca3ca0a"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "teh-fund",
    "filePath": "token:FUND",
    "symbol": "fund",
    "name": "Teh Fund",
    "marketCapRank": 2557,
    "addresses": {
      "ethereum": "0x7d8d7c26179b7a6aebbf66a91c38ed92d5b4996b"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "telcoin",
    "filePath": "token:TEL",
    "symbol": "tel",
    "name": "Telcoin",
    "marketCapRank": 259,
    "addresses": {
      "ethereum": "0x467bccd9d29f223bce8043b84e8c8b282827790f",
      "sora": "0x008f925e3e422218604fac1cc2f06f3ef9c1e244e0d2a9a823e5bd8ce9778434",
      "polygon-pos": "0xdf7837de1f2fa4631d716cf2502f8b230f1dcc32"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "tellor",
    "filePath": "token:TRB",
    "symbol": "trb",
    "name": "Tellor Tributes",
    "marketCapRank": 308,
    "addresses": {
      "ethereum": "0x88df592f8eb5d7bd38bfef7deb0fbc02cf3778a0",
      "manta-pacific": "0x8d7090ddda057f48fdbbb2abcea22d1113ab566a",
      "optimistic-ethereum": "0xaf8ca653fa2772d58f4368b0a71980e9e3ceb888",
      "arbitrum-one": "0xd58d345fd9c82262e087d2d0607624b410d88242",
      "xdai": "0xaad66432d27737ecf6ed183160adc5ef36ab99f2",
      "polygon-pos": "0xe3322702bedaaed36cddab233360b939775ae5f1"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "telos",
    "filePath": "token:TLOS",
    "symbol": "tlos",
    "name": "Telos",
    "marketCapRank": 390,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "tenet-1b000f7b-59cb-4e06-89ce-d62b32d362b9",
    "filePath": "token:TENET",
    "symbol": "tenet",
    "name": "TENET",
    "marketCapRank": 958,
    "addresses": {
      "ethereum": "0x788d86e00ab31db859c3d6b80d5a9375801d7f2a"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "tenset",
    "filePath": "token:10SET",
    "symbol": "10set",
    "name": "Tenset",
    "marketCapRank": 374,
    "addresses": {
      "binance-smart-chain": "0x1ae369a6ab222aff166325b7b87eb9af06c86e57"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "tenx",
    "filePath": "token:PAY",
    "symbol": "pay",
    "name": "TenX",
    "marketCapRank": 2614,
    "addresses": {
      "ethereum": "0xb97048628db6b661d4c2aa833e95dbe1a905b280"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "terra-luna",
    "filePath": "token:LUNC",
    "symbol": "lunc",
    "name": "Terra Luna Classic",
    "marketCapRank": 125,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "terra-luna-2",
    "filePath": "token:LUNA",
    "symbol": "luna",
    "name": "Terra",
    "marketCapRank": 140,
    "addresses": {
      "osmosis": "ibc/785AFEC6B3741100D15E7AF01374E3C4C36F24888E96479B1C33F5C71F364EF9"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "terracoin",
    "filePath": "token:TRC",
    "symbol": "trc",
    "name": "Terracoin",
    "marketCapRank": 1395,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "terrausd",
    "filePath": "token:USTC",
    "symbol": "ustc",
    "name": "TerraClassicUSD",
    "marketCapRank": 302,
    "addresses": {
      "terra": "uusd"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "tether",
    "filePath": "token:USDT",
    "symbol": "usdt",
    "name": "Tether",
    "marketCapRank": 3,
    "addresses": {
      "ethereum": "0xdac17f958d2ee523a2206206994597c13d831ec7",
      "avalanche": "0x9702230a8ea53601f5cd2dc00fdbc13d4df4a8c7",
      "kava": "0x919c1c267bc06a7039e03fcc2ef738525769109c",
      "tron": "TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t",
      "near-protocol": "usdt.tether-token.near",
      "solana": "Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "tether-eurt",
    "filePath": "token:EURT",
    "symbol": "eurt",
    "name": "Euro Tether",
    "marketCapRank": 887,
    "addresses": {
      "ethereum": "0xc581b735a1688071a1746c968e0798d642ede491"
    },
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "tether-gold",
    "filePath": "token:XAUT",
    "symbol": "xaut",
    "name": "Tether Gold",
    "marketCapRank": 180,
    "addresses": {
      "ethereum": "0x68749665ff8d2d112fa859aa293f07a622782f38"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "tetu",
    "filePath": "token:TETU",
    "symbol": "tetu",
    "name": "TETU",
    "marketCapRank": 2443,
    "addresses": {
      "polygon-pos": "0x255707b70bf90aa112006e1b07b9aea6de021424",
      "fantom": "0x65c9d9d080714cda7b5d58989dc27f897f165179"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "tezos",
    "filePath": "token:XTZ",
    "symbol": "xtz",
    "name": "Tezos",
    "marketCapRank": 88,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "tgold",
    "filePath": "token:TXAU",
    "symbol": "txau",
    "name": "tGOLD",
    "marketCapRank": 1776,
    "addresses": {
      "polygon-pos": "0xa6da8c8999c094432c77e7d318951d34019af24b",
      "ethereum": "0xe4a6f23fb9e00fca037aa0ea0a6954de0a6c53bf"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "thales",
    "filePath": "token:THALES",
    "symbol": "thales",
    "name": "Thales",
    "marketCapRank": 1206,
    "addresses": {
      "ethereum": "0x8947da500eb47f82df21143d0c01a29862a8c3c5",
      "optimistic-ethereum": "0x217d47011b23bb961eb6d93ca9945b7501a5bb11",
      "arbitrum-one": "0xe85b662fe97e8562f4099d8a1d5a92d4b453bf30",
      "base": "0xf34e0cff046e154cafcae502c7541b9e5fd8c249",
      "polygon-pos": "0x692c44990e4f408ba0917f5c78a83160c1557237"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "the-4th-pillar",
    "filePath": "token:FOUR",
    "symbol": "four",
    "name": "FOUR",
    "marketCapRank": 2489,
    "addresses": {
      "ethereum": "0x4730fb1463a6f1f44aeb45f6c5c422427f37f4d0",
      "binance-smart-chain": "0xd882739fca9cbae00f3821c4c65189e2d7e26147",
      "polygon-pos": "0x48cbc913de09317df2365e6827df50da083701d5",
      "solana": "DAtU322C23YpoZyWBm8szk12QyqHa9rUQe1EYXzbm1JE"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "the-abyss",
    "filePath": "token:ABYSS",
    "symbol": "abyss",
    "name": "Abyss",
    "marketCapRank": 2203,
    "addresses": {
      "ethereum": "0x0e8d6b471e332f140e7d9dbb99e5e3822f728da6",
      "harmony-shard-0": "0xa52d0c7943cc1020a926b23dd1c64fc60b4fadde"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "the-doge-nft",
    "filePath": "token:DOG",
    "symbol": "dog",
    "name": "The Doge NFT",
    "marketCapRank": 281,
    "addresses": {
      "ethereum": "0xbaac2b4491727d78d2b78815144570b9f2fe8899",
      "base": "0xafb89a09d82fbde58f18ac6437b3fc81724e4df6",
      "optimistic-ethereum": "0x8f69ee043d52161fd29137aedf63f5e70cd504d5",
      "polygon-pos": "0xeee3371b89fc43ea970e908536fcddd975135d8a",
      "arbitrum-one": "0x4425742f1ec8d98779690b5a3a6276db85ddc01a",
      "binance-smart-chain": "0xaa88c603d142c371ea0eac8756123c5805edee03"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "the-graph",
    "filePath": "token:GRT",
    "symbol": "grt",
    "name": "The Graph",
    "marketCapRank": 41,
    "addresses": {
      "ethereum": "0xc944e90c64b2c07662a292be6244bdf05cda44a7",
      "harmony-shard-0": "0x002fa662f2e09de7c306d2bab0085ee9509488ff",
      "energi": "0x771513ba693d457df3678c951c448701f2eaaad5",
      "near-protocol": "c944e90c64b2c07662a292be6244bdf05cda44a7.factory.bridge.near",
      "avalanche": "0x8a0cac13c7da965a312f08ea4229c37869e85cb9",
      "polygon-pos": "0x5fe2b58c013d7601147dcdd68c143a77499f5531",
      "arbitrum-one": "0x9623063377ad1b27544c965ccd7342f7ea7e88c7",
      "sora": "0x00d1fb79bbd1005a678fbf2de9256b3afe260e8eead49bb07bd3a566f9fe8355"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "the-open-network",
    "filePath": "network:ton",
    "symbol": "TON",
    "name": "Toncoin",
    "marketCapRank": 12,
    "addresses": {
      "ethereum": "0x582d872a1b094fc48f5de31d3b73f2d9be47def1",
      "binance-smart-chain": "0x76a797a59ba2c17726896976b7b3747bfd1d220f",
      "ton": "EQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAM9c"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "the-sandbox",
    "filePath": "token:SAND",
    "symbol": "sand",
    "name": "The Sandbox",
    "marketCapRank": 77,
    "addresses": {
      "ethereum": "0x3845badade8e6dff049820680d1f14bd3903a5d0",
      "harmony-shard-0": "0x35de8649e1e4fd1a7bd3b14f7e24e5e7887174ed",
      "polygon-pos": "0xbbba073c31bf03b8acf7c28ef0738decf3695683",
      "energi": "0x73a4ac88c12d66ad08c1cfc891bf47883919ba74"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "the-three-kingdoms",
    "filePath": "token:TTK",
    "symbol": "ttk",
    "name": "The Three Kingdoms",
    "marketCapRank": 2310,
    "addresses": {
      "binance-smart-chain": "0x39703a67bac0e39f9244d97f4c842d15fbad9c1f"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "the-unfettered-souls",
    "filePath": "token:SOULS",
    "symbol": "souls",
    "name": "The Unfettered Ecosystem",
    "marketCapRank": 1840,
    "addresses": {
      "polygon-pos": "0xaa4fbc6809a8e1924520fc85282ac4c76a7671d7"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "the-virtua-kolect",
    "filePath": "token:TVK",
    "symbol": "tvk",
    "name": "Virtua",
    "marketCapRank": 761,
    "addresses": {
      "ethereum": "0xd084b83c305dafd76ae3e1b4e1f1fe2ecccb3988"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "the-winkyverse",
    "filePath": "token:WNK",
    "symbol": "wnk",
    "name": "Winkies",
    "marketCapRank": 1990,
    "addresses": {
      "ethereum": "0xe1bda0c3bfa2be7f740f0119b6a34f057bd58eba",
      "binance-smart-chain": "0xb160a5f19ebccd8e0549549327e43ddd1d023526"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "thena",
    "filePath": "token:THE",
    "symbol": "the",
    "name": "Thena",
    "marketCapRank": 1254,
    "addresses": {
      "binance-smart-chain": "0xf4c8e32eadec4bfe97e0f595add0f4450a863a11",
      "opbnb": "0x9d94a7ff461e83f161c8c040e78557e31d8cba72"
    },
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "theopetra",
    "filePath": "token:THEO",
    "symbol": "theo",
    "name": "Theopetra",
    "marketCapRank": 1335,
    "addresses": {
      "ethereum": "0xfac0403a24229d7e2edd994d50f5940624cbeac2"
    },
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "theta-fuel",
    "filePath": "token:TFUEL",
    "symbol": "tfuel",
    "name": "Theta Fuel",
    "marketCapRank": 182,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "theta-token",
    "filePath": "token:THETA",
    "symbol": "theta",
    "name": "Theta Network",
    "marketCapRank": 50,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "thetadrop",
    "filePath": "token:TDROP",
    "symbol": "tdrop",
    "name": "ThetaDrop",
    "marketCapRank": 707,
    "addresses": {
      "theta": "0x1336739b05c7ab8a526d40dcc0d04a826b5f8b03"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "thol-token",
    "filePath": "token:THOL",
    "symbol": "thol",
    "name": "AngelBlock",
    "marketCapRank": 1646,
    "addresses": {
      "ethereum": "0x207e14389183a94343942de7afbc607f57460618"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "thorchain",
    "filePath": "token:RUNE",
    "symbol": "rune",
    "name": "THORChain",
    "marketCapRank": 49,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "thorstarter",
    "filePath": "token:XRUNE",
    "symbol": "xrune",
    "name": "Thorstarter",
    "marketCapRank": 2091,
    "addresses": {
      "ethereum": "0x69fa0fee221ad11012bab0fdb45d444d3d2ce71c",
      "fantom": "0xe1e6b01ae86ad82b1f1b4eb413b219ac32e17bf6",
      "terra": "terra1td743l5k5cmfy7tqq202g7vkmdvq35q48u2jfm"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "thorswap",
    "filePath": "token:THOR",
    "symbol": "thor",
    "name": "THORSwap",
    "marketCapRank": 690,
    "addresses": {
      "ethereum": "0xa5f2211b9b8170f694421f2046281775e8468044"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "thorwallet",
    "filePath": "token:TGT",
    "symbol": "tgt",
    "name": "THORWallet DEX",
    "marketCapRank": 1394,
    "addresses": {
      "ethereum": "0x108a850856db3f85d0269a2693d896b394c80325"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "thought",
    "filePath": "token:THT",
    "symbol": "tht",
    "name": "Thought",
    "marketCapRank": 874,
    "addresses": {},
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "threshold-network-token",
    "filePath": "token:T",
    "symbol": "t",
    "name": "Threshold Network",
    "marketCapRank": 195,
    "addresses": {
      "ethereum": "0xcdf7028ceab81fa0c6971208e83fa7872994bee5"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "thunder-token",
    "filePath": "token:TT",
    "symbol": "tt",
    "name": "ThunderCore",
    "marketCapRank": 674,
    "addresses": {
      "ethereum": "0x1e053d89e08c24aa2ce5c5b4206744dc2d7bd8f5"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "tidal-finance",
    "filePath": "token:TIDAL",
    "symbol": "tidal",
    "name": "Tidal Finance",
    "marketCapRank": 2252,
    "addresses": {
      "ethereum": "0x29cbd0510eec0327992cd6006e63f9fa8e7f33b7",
      "polygon-pos": "0xb41ec2c036f8a42da384dde6ada79884f8b84b26"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "tierion",
    "filePath": "token:TNT",
    "symbol": "tnt",
    "name": "Tierion",
    "marketCapRank": 2122,
    "addresses": {
      "ethereum": "0x08f5a9235b08173b7569f83645d2c7fb55e8ccd8"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "tifi-token",
    "filePath": "token:TIFI",
    "symbol": "tifi",
    "name": "TiFi",
    "marketCapRank": 2308,
    "addresses": {
      "binance-smart-chain": "0x17e65e6b9b166fb8e7c59432f0db126711246bc0"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "tigris",
    "filePath": "token:TIG",
    "symbol": "tig",
    "name": "Tigris",
    "marketCapRank": 2363,
    "addresses": {
      "arbitrum-one": "0x3a33473d7990a605a88ac72a78ad4efc40a54adb"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "titanswap",
    "filePath": "token:TITAN",
    "symbol": "titan",
    "name": "TitanSwap",
    "marketCapRank": 2199,
    "addresses": {
      "ethereum": "0x3a8cccb969a61532d1e6005e2ce12c200caece87"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "token-in",
    "filePath": "token:TIN",
    "symbol": "tin",
    "name": "Token IN",
    "marketCapRank": 2577,
    "addresses": {
      "aptos": "0xc32ba5d293577cbb1df390f35b2bc6369a593b736d0865fedec1a2b08565de8e::in_coin::InCoin"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "tokencard",
    "filePath": "token:TKN",
    "symbol": "tkn",
    "name": "Monolith",
    "marketCapRank": 2006,
    "addresses": {
      "ethereum": "0xaaaf91d9b90df800df4f55c205fd6989c977e73a"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "tokenfi",
    "filePath": "token:TOKEN",
    "symbol": "token",
    "name": "TokenFi",
    "marketCapRank": 314,
    "addresses": {
      "ethereum": "0x4507cef57c46789ef8d1a19ea45f4216bae2b528",
      "binance-smart-chain": "0x4507cef57c46789ef8d1a19ea45f4216bae2b528"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "tokenize-xchange",
    "filePath": "token:TKX",
    "symbol": "tkx",
    "name": "Tokenize Xchange",
    "marketCapRank": 102,
    "addresses": {
      "ethereum": "0x667102bd3413bfeaa3dffb48fa8288819e480a88"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "tokenlon",
    "filePath": "token:LON",
    "symbol": "lon",
    "name": "Tokenlon",
    "marketCapRank": 540,
    "addresses": {
      "ethereum": "0x0000000000095413afc295d19edeb1ad7b71c952",
      "arbitrum-one": "0x55678cd083fcdc2947a0df635c93c838c89454a3"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "tokocrypto",
    "filePath": "token:TKO",
    "symbol": "tko",
    "name": "Tokocrypto",
    "marketCapRank": 763,
    "addresses": {
      "binance-smart-chain": "0x9f589e3eabe42ebc94a44727b3f3531c0c877809"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "tokpie",
    "filePath": "token:TKP",
    "symbol": "tkp",
    "name": "TOKPIE",
    "marketCapRank": 680,
    "addresses": {
      "ethereum": "0xd31695a1d35e489252ce57b129fd4b1b05e6acac",
      "binance-smart-chain": "0x7849ed1447250d0b896f89b58f3075b127ca29b3"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "tomb",
    "filePath": "token:TOMB",
    "symbol": "tomb",
    "name": "Tomb",
    "marketCapRank": 2053,
    "addresses": {
      "fantom": "0x6c021ae822bea943b2e66552bde1d2696a53fbb7",
      "tombchain": "0xdeaddeaddeaddeaddeaddeaddeaddeaddead0000",
      "avalanche": "0xb84527d59b6ecb96f433029ecc890d4492c5dce1",
      "binance-smart-chain": "0x8f01d597d2022656494e30fb76eccf1eea2e092e",
      "polygon-pos": "0x0e98c977b943f06075b2d795794238fbfb9b9a34"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "tominet",
    "filePath": "token:TOMI",
    "symbol": "tomi",
    "name": "tomiNet",
    "marketCapRank": 556,
    "addresses": {
      "ethereum": "0x4385328cc4d643ca98dfea734360c0f596c83449"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "top-network",
    "filePath": "token:TOP",
    "symbol": "top",
    "name": "TOP Network",
    "marketCapRank": 2558,
    "addresses": {
      "ethereum": "0xdcd85914b8ae28c1e62f1c488e1d968d5aaffe2b"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "tor",
    "filePath": "token:TOR",
    "symbol": "tor",
    "name": "TOR",
    "marketCapRank": 360,
    "addresses": {
      "fantom": "0x74e23df9110aa9ea0b6ff2faee01e740ca1c642e",
      "binance-smart-chain": "0x1d6cbdc6b29c6afbae65444a1f65ba9252b8ca83"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "tornado-cash",
    "filePath": "token:TORN",
    "symbol": "torn",
    "name": "Tornado Cash",
    "marketCapRank": 1464,
    "addresses": {
      "ethereum": "0x77777feddddffc19ff86db637967013e6c6a116c",
      "binance-smart-chain": "0x1ba8d3c4c219b124d351f603060663bd1bcd9bbf"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "torum",
    "filePath": "token:XTM",
    "symbol": "xtm",
    "name": "Torum",
    "marketCapRank": 1341,
    "addresses": {
      "binance-smart-chain": "0x443cab9583b83eaa7a712c9d64525e57e2a7eb3f"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "toshi",
    "filePath": "token:TOSHI",
    "symbol": "toshi",
    "name": "Toshi",
    "marketCapRank": 332,
    "addresses": {
      "base": "0xac1bd2486aaf3b5c0fc3fd868558b082a531b2b4"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "toucan-protocol-base-carbon-tonne",
    "filePath": "token:BCT",
    "symbol": "bct",
    "name": "Toucan Protocol: Base Carbon Tonne",
    "marketCapRank": 1164,
    "addresses": {
      "polygon-pos": "0x2f800db0fdb5223b3c3f354886d907a671414a7f"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "tower",
    "filePath": "token:TOWER",
    "symbol": "tower",
    "name": "Tower",
    "marketCapRank": 1559,
    "addresses": {
      "ethereum": "0x1c9922314ed1415c95b9fd453c3818fd41867d0b",
      "base": "0xf7c1cefcf7e1dd8161e00099facd3e1db9e528ee",
      "polygon-pos": "0x2bc07124d8dac638e290f401046ad584546bc47b",
      "binance-smart-chain": "0xe7c9c6bc87b86f9e5b57072f907ee6460b593924"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "trava-finance",
    "filePath": "token:TRAVA",
    "symbol": "trava",
    "name": "Trava Finance",
    "marketCapRank": 2512,
    "addresses": {
      "binance-smart-chain": "0x0391be54e72f7e001f6bbc331777710b4f2999ef",
      "ethereum": "0x186d0ba3dfc3386c464eecd96a61fbb1e2da00bf",
      "fantom": "0x477a9d5df9beda06f6b021136a2efe7be242fcc9"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "traxx",
    "filePath": "token:TRAXX",
    "symbol": "traxx",
    "name": "Traxx",
    "marketCapRank": 2626,
    "addresses": {
      "ethereum": "0xd43be54c1aedf7ee4099104f2dae4ea88b18a249"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "tree-capital",
    "filePath": "token:TREE",
    "symbol": "tree",
    "name": "Tree",
    "marketCapRank": 1256,
    "addresses": {
      "ethereum": "0xba25b2281214300e4e649fead9a6d6acd25f1c0a"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "treeb",
    "filePath": "token:TREEB",
    "symbol": "treeb",
    "name": "Retreeb",
    "marketCapRank": 1552,
    "addresses": {
      "fantom": "0xc60d7067dfbc6f2caf30523a064f416a5af52963"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "treecle",
    "filePath": "token:TRCL",
    "symbol": "trcl",
    "name": "Treecle",
    "marketCapRank": 2557,
    "addresses": {
      "klay-token": "0x4b91c67a89d4c4b2a4ed9fcde6130d7495330972"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "trias-token",
    "filePath": "token:TRIAS",
    "symbol": "trias",
    "name": "TriasLab",
    "marketCapRank": 471,
    "addresses": {
      "binance-smart-chain": "0xa4838122c683f732289805fc3c207febd55babdd",
      "ethereum": "0x3a856d4effa670c54585a5d523e96513e148e95d"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "tribe-2",
    "filePath": "token:TRIBE",
    "symbol": "tribe",
    "name": "Tribe",
    "marketCapRank": 331,
    "addresses": {
      "ethereum": "0xc7283b66eb1eb5fb86327f08e1b5816b0720212b"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "tribeone",
    "filePath": "token:HAKA",
    "symbol": "haka",
    "name": "TribeOne",
    "marketCapRank": 2273,
    "addresses": {
      "ethereum": "0xd85ad783cc94bd04196a13dc042a3054a9b52210",
      "binance-smart-chain": "0xd85ad783cc94bd04196a13dc042a3054a9b52210"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "tron",
    "filePath": "token:TRX",
    "symbol": "trx",
    "name": "TRON",
    "marketCapRank": 18,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "tronpad",
    "filePath": "token:TRONPAD",
    "symbol": "tronpad",
    "name": "TRONPAD",
    "marketCapRank": 2386,
    "addresses": {
      "binance-smart-chain": "0x1bf7aedec439d6bfe38f8f9b20cf3dc99e3571c4"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "troy",
    "filePath": "token:TROY",
    "symbol": "troy",
    "name": "TROY",
    "marketCapRank": 944,
    "addresses": {
      "binancecoin": "TROY-9B8"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "true-usd",
    "filePath": "token:TUSD",
    "symbol": "tusd",
    "name": "TrueUSD",
    "marketCapRank": 192,
    "addresses": {
      "ethereum": "0x0000000000085d4780b73119b644ae5ecd22b376",
      "avalanche": "0x1c20e891bab6b1727d14da358fae2984ed9b59eb",
      "binance-smart-chain": "0x40af3827f39d0eacbf4a168f8d4ee67c121d11c9",
      "tron": "TUpMhErZL2fhh4sVNULAbNKLokS4GjC1F4",
      "binancecoin": "TUSDB-888"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "truefi",
    "filePath": "token:TRU",
    "symbol": "tru",
    "name": "TrueFi",
    "marketCapRank": 386,
    "addresses": {
      "ethereum": "0x4c19596f5aaff459fa38b0f7ed92f11ae6543784"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "trust-wallet-token",
    "filePath": "token:TWT",
    "symbol": "twt",
    "name": "Trust Wallet",
    "marketCapRank": 175,
    "addresses": {
      "binance-smart-chain": "0x4b0f1812e5df2a09796481ff14017e6005508003",
      "energi": "0xfaa02b262130431b44c929fdd960e202ffeabfe3",
      "binancecoin": "TWT-8C2"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "trustpad-2-0",
    "filePath": "token:TPAD",
    "symbol": "tpad",
    "name": "TrustPad",
    "marketCapRank": 2001,
    "addresses": {
      "binance-smart-chain": "0x7029f86dc4634c5d59ee3f1578c193783505e2c1"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "trustswap",
    "filePath": "token:SWAP",
    "symbol": "swap",
    "name": "TrustSwap",
    "marketCapRank": 1110,
    "addresses": {
      "ethereum": "0xcc4304a31d09258b0029ea7fe63d032f52e44efe",
      "energi": "0x324a1e5707f356218356c95cfe20d5d9b1440f30",
      "polygon-pos": "0x3809dcdd5dde24b37abe64a5a339784c3323c44f",
      "avalanche": "0xc7b5d72c836e718cda8888eaf03707faef675079",
      "binance-smart-chain": "0x82443a77684a7da92fdcb639c8d2bd068a596245"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "tutellus",
    "filePath": "token:TUT",
    "symbol": "tut",
    "name": "Tutellus",
    "marketCapRank": 2531,
    "addresses": {
      "polygon-pos": "0x12a34a6759c871c4c1e8a0a42cfc97e4d7aaf68d"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "ubxs-token",
    "filePath": "token:UBXS",
    "symbol": "ubxs",
    "name": "UBXS",
    "marketCapRank": 1064,
    "addresses": {
      "binance-smart-chain": "0x4f1960e29b2ca581a38c5c474e123f420f8092db"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "ultra",
    "filePath": "token:UOS",
    "symbol": "uos",
    "name": "Ultra",
    "marketCapRank": 523,
    "addresses": {
      "ethereum": "0xd13c7342e1ef687c5ad21b27c2b65d772cab5c8c"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "uma",
    "filePath": "token:UMA",
    "symbol": "uma",
    "name": "UMA",
    "marketCapRank": 251,
    "addresses": {
      "ethereum": "0x04fa0d235c4abf4bcf4787af4cf447de572ef828",
      "avalanche": "0x3bd2b1c7ed8d396dbb98ded3aebb41350a5b2339"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "umami-finance",
    "filePath": "token:UMAMI",
    "symbol": "umami",
    "name": "Umami",
    "marketCapRank": 2132,
    "addresses": {
      "arbitrum-one": "0x1622bf67e6e5747b81866fe0b85178a93c7f86e3"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "umbrella-network",
    "filePath": "token:UMB",
    "symbol": "umb",
    "name": "Umbrella Network",
    "marketCapRank": 1334,
    "addresses": {
      "ethereum": "0x6fc13eace26590b80cccab1ba5d51890577d83b2",
      "binance-smart-chain": "0x846f52020749715f02aef25b5d1d65e48945649d"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "undead-blocks",
    "filePath": "token:UNDEAD",
    "symbol": "undead",
    "name": "Undead Blocks",
    "marketCapRank": 2303,
    "addresses": {
      "ethereum": "0x310c8f00b9de3c31ab95ea68feb6c877538f7947"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "unibot",
    "filePath": "token:UNIBOT",
    "symbol": "unibot",
    "name": "Unibot",
    "marketCapRank": 1128,
    "addresses": {
      "ethereum": "0xf819d9cb1c2a819fd991781a822de3ca8607c3c9"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "unibright",
    "filePath": "token:UBT",
    "symbol": "ubt",
    "name": "Unibright",
    "marketCapRank": 1234,
    "addresses": {
      "ethereum": "0x8400d94a5cb0fa0d041a3788e395285d61c9ee5e",
      "energi": "0xe3d7a5c28d5a4143831242e8ab218d7e9b5c2c87",
      "polygon-pos": "0x7fbc10850cae055b27039af31bd258430e714c62"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "unicrypt-2",
    "filePath": "token:UNCX",
    "symbol": "uncx",
    "name": "UNCX Network",
    "marketCapRank": 1403,
    "addresses": {
      "ethereum": "0xadb2437e6f65682b85f814fbc12fec0508a7b1d0",
      "xdai": "0x0116e28b43a358162b96f70b4de14c98a4465f25",
      "binance-smart-chain": "0x09a6c44c3947b69e2b45f4d51b67e6a39acfb506"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "unidef",
    "filePath": "token:U",
    "symbol": "u",
    "name": "Unidef",
    "marketCapRank": 1770,
    "addresses": {
      "binance-smart-chain": "0x89db9b433fec1307d3dc8908f2813e9f7a1d38f0"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "unifi-protocol-dao",
    "filePath": "token:UNFI",
    "symbol": "unfi",
    "name": "Unifi Protocol DAO",
    "marketCapRank": 702,
    "addresses": {
      "ethereum": "0x441761326490cacf7af299725b6292597ee822c2",
      "binance-smart-chain": "0x728c5bac3c3e370e372fc4671f9ef6916b814d8b"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "unilayer",
    "filePath": "token:LAYER",
    "symbol": "layer",
    "name": "UniLayer",
    "marketCapRank": 2337,
    "addresses": {
      "ethereum": "0x0ff6ffcfda92c53f615a4a75d982f399c989366b",
      "binance-smart-chain": "0xc2c23a86def9e9f5972a633b3d25f7ecbfa5e575",
      "harmony-shard-0": "0xe88699ad32d5a610987a3ba8519c06289549cca7"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "unisocks",
    "filePath": "token:SOCKS",
    "symbol": "socks",
    "name": "Unisocks",
    "marketCapRank": 1490,
    "addresses": {
      "ethereum": "0x23b608675a2b2fb1890d3abbd85c5775c51691d5",
      "pulsechain": "0x23b608675a2b2fb1890d3abbd85c5775c51691d5"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "uniswap",
    "filePath": "token:UNI",
    "symbol": "uni",
    "name": "Uniswap",
    "marketCapRank": 19,
    "addresses": {
      "ethereum": "0x1f9840a85d5af5bf1d1762f925bdaddc4201f984",
      "xdai": "0x4537e328bf7e4efa29d05caea260d7fe26af9d74",
      "avalanche": "0x8ebaf22b6f053dffeaf46f4dd9efa95d89ba8580",
      "near-protocol": "1f9840a85d5af5bf1d1762f925bdaddc4201f984.factory.bridge.near",
      "energi": "0x665b3a802979ec24e076c80025bff33c18eb6007",
      "optimistic-ethereum": "0x6fd9d7ad17242c41f7131d257212c54a0e816691",
      "arbitrum-one": "0xfa7f8980b0f1e64a2062791cc3b0871572f1f7f0",
      "huobi-token": "0x22c54ce8321a4015740ee1109d9cbc25815c46e6",
      "polygon-pos": "0xb33eaad8d922b1083446dc23f610c2567fb5180f",
      "harmony-shard-0": "0x90d81749da8867962c760414c1c25ec926e889b6",
      "sora": "0x009be848df92a400da2f217256c88d1a9b1a0304f9b3e90991a67418e1d3b08c",
      "binance-smart-chain": "0xbf5140a22578168fd562dccf235e5d43a02ce9b1"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "unix",
    "filePath": "token:UNIX",
    "symbol": "unix",
    "name": "UniX",
    "marketCapRank": 1946,
    "addresses": {
      "ethereum": "0xddd6a0ecc3c6f6c102e5ea3d8af7b801d1a77ac8",
      "avalanche": "0x6f97d3f120fbbdaacf1c9da61a8ad126b7426861"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "unizen",
    "filePath": "token:ZCX",
    "symbol": "zcx",
    "name": "Unizen",
    "marketCapRank": 324,
    "addresses": {
      "ethereum": "0xc52c326331e9ce41f04484d3b5e5648158028804"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "unlend-finance",
    "filePath": "token:UFT",
    "symbol": "uft",
    "name": "UniLend Finance",
    "marketCapRank": 759,
    "addresses": {
      "ethereum": "0x0202be363b8a4820f3f4de7faf5224ff05943ab1",
      "polygon-pos": "0x5b4cf2c120a9702225814e18543ee658c5f8631e",
      "binance-smart-chain": "0x2645d5f59d952ef2317c8e0aaa5a61c392ccd44d"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "unmarshal",
    "filePath": "token:MARSH",
    "symbol": "marsh",
    "name": "Unmarshal",
    "marketCapRank": 1303,
    "addresses": {
      "ethereum": "0x5a666c7d92e5fa7edcb6390e4efd6d0cdd69cf37",
      "binance-smart-chain": "0x2fa5daf6fe0708fbd63b1a7d1592577284f52256"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "uno-re",
    "filePath": "token:UNO",
    "symbol": "uno",
    "name": "Uno Re",
    "marketCapRank": 1766,
    "addresses": {
      "ethereum": "0x474021845c4643113458ea4414bdb7fb74a01a77",
      "binance-smart-chain": "0x474021845c4643113458ea4414bdb7fb74a01a77"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "unsheth",
    "filePath": "token:USH",
    "symbol": "ush",
    "name": "unshETHing_Token",
    "marketCapRank": 2595,
    "addresses": {
      "ethereum": "0xe60779cc1b2c1d0580611c526a8df0e3f870ec48",
      "arbitrum-one": "0x51a80238b5738725128d3a3e06ab41c1d4c05c74",
      "binance-smart-chain": "0x91d6d6af7635b7b23a8ced9508117965180e2362"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "unstoppable-defi",
    "filePath": "token:UND",
    "symbol": "und",
    "name": "Unstoppable DeFi",
    "marketCapRank": 2389,
    "addresses": {
      "arbitrum-one": "0xb5a628803ee72d82098d4bcaf29a42e63531b441"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "uquid-coin",
    "filePath": "token:UQC",
    "symbol": "uqc",
    "name": "Uquid Coin",
    "marketCapRank": 549,
    "addresses": {
      "ethereum": "0x8806926ab68eb5a7b909dcaf6fdbe5d93271d6e2"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "urus-token",
    "filePath": "token:URUS",
    "symbol": "urus",
    "name": "Aurox",
    "marketCapRank": 2111,
    "addresses": {
      "ethereum": "0xc6dddb5bc6e61e0841c54f3e723ae1f3a807260b",
      "binance-smart-chain": "0xc6dddb5bc6e61e0841c54f3e723ae1f3a807260b"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "usd-coin",
    "filePath": "token:USDC",
    "symbol": "usdc",
    "name": "USDC",
    "marketCapRank": 8,
    "addresses": {
      "ethereum": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
      "polkadot": "1337",
      "flow": "A.b19436aae4d94622.FiatToken",
      "avalanche": "0xb97ef9ef8734c71904d8002f8b6bc66dd9c48a6e",
      "optimistic-ethereum": "0x0b2c639c533813f4aa9d7837caf62653d097ff85",
      "stellar": "USDC-GA5ZSEJYB37JRC5AVCIA5MOP4RHTM335X2KGX3IHOJAPP5RE34K4KZVN",
      "near-protocol": "17208628f84f5d6ad33f0da3bbbeb27ffcb398eac501a31bd6ad2011e36133a1",
      "hedera-hashgraph": "0.0.456858",
      "tron": "TEkxiTehnzSmSe2XqrBj4w32RUN966rdz8",
      "celo": "0xceba9300f2b948710d2653dd7b07f33a8b32118c",
      "arbitrum-one": "0xaf88d065e77c8cc2239327c5edb3a432268e5831",
      "base": "0x833589fcd6edb6e08f4c7c32d4f71b54bda02913",
      "polygon-pos": "0x3c499c542cef5e3811e1192ce70d8cc03d5c3359",
      "solana": "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "usdd",
    "filePath": "token:USDD",
    "symbol": "usdd",
    "name": "USDD",
    "marketCapRank": 145,
    "addresses": {
      "tron": "TPYmHEhy5n8TCEfYGqW2rPxsghSfzghPDn",
      "near-protocol": "0c10bf8fcb7bf5412187a595ab97a3609160b5c6.factory.bridge.near",
      "avalanche": "0xb514cabd09ef5b169ed3fe0fa8dbd590741e81c2",
      "bittorrent": "0x17f235fd5974318e4e2a5e37919a209f7c37a6d1",
      "ethereum": "0x0c10bf8fcb7bf5412187a595ab97a3609160b5c6",
      "arbitrum-one": "0x680447595e8b7b3aa1b43beb9f6098c79ac2ab3f",
      "binance-smart-chain": "0xd17479997f34dd9156deef8f95a52d81d265be9c"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "usdx",
    "filePath": "token:USDX",
    "symbol": "usdx",
    "name": "USDX",
    "marketCapRank": 530,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "utility-web3shot",
    "filePath": "token:UW3S",
    "symbol": "uw3s",
    "name": "Utility Web3Shot",
    "marketCapRank": 1904,
    "addresses": {
      "binance-smart-chain": "0x961e149db8bfbdb318c182152725ac806d7be3f4"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "utrust",
    "filePath": "token:UTK",
    "symbol": "utk",
    "name": "xMoney",
    "marketCapRank": null,
    "addresses": {
      "ethereum": "0xdc9ac3c20d1ed0b540df9b1fedc10039df13f99c",
      "elrond": "UTK-2f80e9"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "uwu-lend",
    "filePath": "token:UWU",
    "symbol": "uwu",
    "name": "UwU Lend",
    "marketCapRank": 835,
    "addresses": {
      "ethereum": "0x55c08ca52497e2f1534b59e2917bf524d4765257"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "v-systems",
    "filePath": "token:VSYS",
    "symbol": "vsys",
    "name": "V.SYSTEMS",
    "marketCapRank": 1756,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "vabble",
    "filePath": "token:VAB",
    "symbol": "vab",
    "name": "Vabble",
    "marketCapRank": 2131,
    "addresses": {
      "ethereum": "0xe7ae6d0c56cacaf007b7e4d312f9af686a9e9a04",
      "polygon-pos": "0xea73dcf6f49f8d6ad5a129aaede776d78d418cfd"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "vaiot",
    "filePath": "token:VAI",
    "symbol": "vai",
    "name": "Vaiot",
    "marketCapRank": 559,
    "addresses": {
      "ethereum": "0xd13cfd3133239a3c73a9e535a5c4dadee36b395c"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "valencia-cf-fan-token",
    "filePath": "token:VCF",
    "symbol": "vcf",
    "name": "Valencia CF Fan Token",
    "marketCapRank": 2315,
    "addresses": {
      "chiliz": "0xba0c26485b1909f80476067272d74a99cc0e1d57"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "vcore",
    "filePath": "token:VCORE",
    "symbol": "vcore",
    "name": "IMVU",
    "marketCapRank": 2247,
    "addresses": {
      "ethereum": "0x733b5056a0697e7a4357305fe452999a0c409feb"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "vechain",
    "filePath": "token:VET",
    "symbol": "vet",
    "name": "VeChain",
    "marketCapRank": 44,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "vector-finance",
    "filePath": "token:VTX",
    "symbol": "vtx",
    "name": "Vector Finance",
    "marketCapRank": 2132,
    "addresses": {
      "avalanche": "0x5817d4f0b62a59b17f75207da1848c2ce75e7af4"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "vectorspace",
    "filePath": "token:VXV",
    "symbol": "vxv",
    "name": "Vectorspace AI",
    "marketCapRank": 858,
    "addresses": {
      "ethereum": "0x7d29a64504629172a429e64183d6673b9dacbfce"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "vega-protocol",
    "filePath": "token:VEGA",
    "symbol": "vega",
    "name": "Vega Protocol",
    "marketCapRank": 714,
    "addresses": {
      "ethereum": "0xcb84d72e61e383767c4dfeb2d8ff7f4fb89abc6e"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "vela-token",
    "filePath": "token:VELA",
    "symbol": "vela",
    "name": "Vela Token",
    "marketCapRank": 1348,
    "addresses": {
      "arbitrum-one": "0x088cd8f5ef3652623c22d48b1605dcfe860cd704",
      "base": "0x5a76a56ad937335168b30df3aa1327277421c6ae"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "velas",
    "filePath": "token:VLX",
    "symbol": "vlx",
    "name": "Velas",
    "marketCapRank": 780,
    "addresses": {
      "ethereum": "0x8c543aed163909142695f2d2acd0d55791a9edb9",
      "binance-smart-chain": "0xe9c803f48dffe50180bd5b01dc04da939e3445fc"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "velaspad",
    "filePath": "token:VLXPAD",
    "symbol": "vlxpad",
    "name": "VelasPad",
    "marketCapRank": 1997,
    "addresses": {
      "binance-smart-chain": "0xb8e3bb633f7276cc17735d86154e0ad5ec9928c0",
      "ethereum": "0xb8e3bb633f7276cc17735d86154e0ad5ec9928c0",
      "velas": "0xa065e0858417dfc7abc6f2bd4d0185332475c180"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "velhalla",
    "filePath": "token:SCAR",
    "symbol": "scar",
    "name": "ScarQuest",
    "marketCapRank": 1548,
    "addresses": {
      "binance-smart-chain": "0x8d9fb713587174ee97e91866050c383b5cee6209"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "veloce-vext",
    "filePath": "token:VEXT",
    "symbol": "vext",
    "name": "Veloce",
    "marketCapRank": 1401,
    "addresses": {
      "polygon-pos": "0x27842334c55c01ddfe81bf687425f906816c5141",
      "ethereum": "0xb2492e97a68a6e4b9e9a11b99f6c42e5accd38c7"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "velodrome-finance",
    "filePath": "token:VELO",
    "symbol": "velo",
    "name": "Velodrome Finance",
    "marketCapRank": 372,
    "addresses": {
      "optimistic-ethereum": "0x9560e827af36c94d2ac33a39bce1fe78631088db"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "vempire-ddao",
    "filePath": "token:VEMP",
    "symbol": "vemp",
    "name": "VEMP",
    "marketCapRank": 2160,
    "addresses": {
      "ethereum": "0xcfeb09c3c5f0f78ad72166d55f9e6e9a60e96eec",
      "fantom": "0x526f1dc408cfe7fc5330ab9f1e78474ceff2a5dd",
      "pulsechain": "0xa712329708af665991c3fcff43bc5734924f7b9a",
      "binance-smart-chain": "0xedf3ce4dd6725650a8e9398e5c6398d061fa7955",
      "okex-chain": "0x2c9a1d0e1226939edb7bbb68c43a080c28743c5c"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "veno-finance",
    "filePath": "token:VNO",
    "symbol": "vno",
    "name": "Veno Finance",
    "marketCapRank": 627,
    "addresses": {
      "cronos": "0xdb7d0a1ec37de1de924f8e8adac6ed338d4404e9",
      "zksync": "0xe75a17b4f5c4f844688d5670b684515d7c785e63"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "vent-finance",
    "filePath": "token:VENT",
    "symbol": "vent",
    "name": "Vent Finance",
    "marketCapRank": 1990,
    "addresses": {
      "ethereum": "0x5f0bc16d50f72d10b719dbf6845de2e599eb5624",
      "polygon-pos": "0xf21441f9ec4c1fe69cb7cf186eceab31af2b658d",
      "binance-smart-chain": "0x872d068c25511be88c1f5990c53eeffcdf46c9b4"
    },
    "variants": [
      "mono"
    ]
  },
  {
    "id": "venus",
    "filePath": "token:XVS",
    "symbol": "xvs",
    "name": "Venus",
    "marketCapRank": 305,
    "addresses": {
      "binance-smart-chain": "0xcf6bb5389c92bdda8a3747ddb454cb7a64626c63",
      "ethereum": "0xd3cc9d8f3689b83c91b7b59cab4946b063eb894a"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "verasity",
    "filePath": "token:VRA",
    "symbol": "vra",
    "name": "Verasity",
    "marketCapRank": 547,
    "addresses": {
      "ethereum": "0xf411903cbc70a74d22900a5de66a2dda66507255"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "verge",
    "filePath": "token:XVG",
    "symbol": "xvg",
    "name": "Verge",
    "marketCapRank": 499,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "verified-usd-foundation-usdv",
    "filePath": "token:USDV",
    "symbol": "usdv",
    "name": "Verified USD",
    "marketCapRank": 1086,
    "addresses": {
      "ethereum": "0x0e573ce2736dd9637a0b21058352e1667925c7a8",
      "tomochain": "0x323665443cef804a3b5206103304bd4872ea4253",
      "avalanche": "0x323665443cef804a3b5206103304bd4872ea4253",
      "optimistic-ethereum": "0x323665443cef804a3b5206103304bd4872ea4253",
      "arbitrum-one": "0x323665443cef804a3b5206103304bd4872ea4253",
      "polygon-pos": "0x323665443cef804a3b5206103304bd4872ea4253",
      "binance-smart-chain": "0x323665443cef804a3b5206103304bd4872ea4253"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "versagames",
    "filePath": "token:VERSA",
    "symbol": "versa",
    "name": "VersaGames",
    "marketCapRank": 2400,
    "addresses": {
      "cronos": "0x00d7699b71290094ccb1a5884cd835bd65a78c17",
      "polygon-pos": "0x8497842420cfdbc97896c2353d75d89fc8d5be5d"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "verse-bitcoin",
    "filePath": "token:VERSE",
    "symbol": "verse",
    "name": "Verse",
    "marketCapRank": 1962,
    "addresses": {
      "ethereum": "0x249ca82617ec3dfb2589c4c17ab7ec9765350a18",
      "polygon-pos": "0xc708d6f2153933daa50b2d0758955be0a93a8fec"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "vertcoin",
    "filePath": "token:VTC",
    "symbol": "vtc",
    "name": "Vertcoin",
    "marketCapRank": 1910,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "vesper-finance",
    "filePath": "token:VSP",
    "symbol": "vsp",
    "name": "Vesper Finance",
    "marketCapRank": 1943,
    "addresses": {
      "ethereum": "0x1b40183efb4dd766f11bda7a7c3ad8982e998421",
      "fantom": "0x461d52769884ca6235b685ef2040f47d30c94eb5",
      "polygon-pos": "0x09c5a4bca808bd1ba2b8e6b3aaf7442046b4ca5b"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "vesta-finance",
    "filePath": "token:VSTA",
    "symbol": "vsta",
    "name": "Vesta Finance",
    "marketCapRank": 1380,
    "addresses": {
      "arbitrum-one": "0xa684cd057951541187f288294a1e1c2646aa2d24"
    },
    "variants": [
      "mono"
    ]
  },
  {
    "id": "vethor-token",
    "filePath": "token:VTHO",
    "symbol": "vtho",
    "name": "VeThor",
    "marketCapRank": 265,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "vexanium",
    "filePath": "token:VEX",
    "symbol": "vex",
    "name": "Vexanium",
    "marketCapRank": 2523,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "viberate",
    "filePath": "token:VIB",
    "symbol": "vib",
    "name": "Viberate",
    "marketCapRank": 1160,
    "addresses": {
      "ethereum": "0x2c974b2d0ba1716e644c1fc59982a89ddd2ff724"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "victoria-vr",
    "filePath": "token:VR",
    "symbol": "vr",
    "name": "Victoria VR",
    "marketCapRank": 374,
    "addresses": {
      "ethereum": "0x7d5121505149065b562c789a0145ed750e6e8cdd"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "vidt-dao",
    "filePath": "token:VIDT",
    "symbol": "vidt",
    "name": "VIDT DAO",
    "marketCapRank": 814,
    "addresses": {
      "ethereum": "0x3be7bf1a5f23bd8336787d0289b70602f1940875"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "vidya",
    "filePath": "token:VIDYA",
    "symbol": "vidya",
    "name": "Vidya",
    "marketCapRank": 2063,
    "addresses": {
      "ethereum": "0x3d3d35bb9bec23b06ca00fe472b50e7a4c692c30"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "vigorus",
    "filePath": "token:VIS",
    "symbol": "vis",
    "name": "Vigorus",
    "marketCapRank": 2498,
    "addresses": {
      "polygon-pos": "0xcc1b9517460d8ae86fe576f614d091fca65a28fc"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "vinuchain",
    "filePath": "token:VC",
    "symbol": "vc",
    "name": "VinuChain",
    "marketCapRank": 1537,
    "addresses": {
      "binance-smart-chain": "0x2bf83d080d8bc4715984e75e5b3d149805d11751"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "virtual-versions",
    "filePath": "token:VV",
    "symbol": "vv",
    "name": "Virtual Versions",
    "marketCapRank": 2556,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "virtuswap",
    "filePath": "token:VRSW",
    "symbol": "vrsw",
    "name": "VirtuSwap",
    "marketCapRank": 1892,
    "addresses": {
      "ethereum": "0x99a01a4d6a4d621094983050d9a2f10b2912e53d",
      "arbitrum-one": "0xd1e094cabc5acb9d3b0599c3f76f2d01ff8d3563",
      "polygon-pos": "0x57999936fc9a9ec0751a8d146cce11901be8bed0"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "vita-inu",
    "filePath": "token:VINU",
    "symbol": "vinu",
    "name": "Vita Inu",
    "marketCapRank": 1161,
    "addresses": {
      "binance-smart-chain": "0xfebe8c1ed424dbf688551d4e2267e7a53698f0aa",
      "vite": "tti_541b25bd5e5db35166864096",
      "polygon-pos": "0xafcdd4f666c84fed1d8bd825aa762e3714f652c9",
      "ethereum": "0xafcdd4f666c84fed1d8bd825aa762e3714f652c9"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "vitadao",
    "filePath": "token:VITA",
    "symbol": "vita",
    "name": "VitaDAO",
    "marketCapRank": 632,
    "addresses": {
      "ethereum": "0x81f8f0bb1cb2a06649e51913a151f0e7ef6fa321"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "vite",
    "filePath": "token:VITE",
    "symbol": "vite",
    "name": "Vite",
    "marketCapRank": 898,
    "addresses": {
      "ethereum": "0xadd5e881984783dd432f80381fb52f45b53f3e70",
      "binance-smart-chain": "0x2794dad4077602ed25a88d03781528d1637898b4",
      "vite": "tti_5649544520544f4b454e6e40"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "vixco",
    "filePath": "token:VIX",
    "symbol": "vix",
    "name": "Vixco",
    "marketCapRank": 1440,
    "addresses": {
      "ethereum": "0xc0b68eb52c89e3fffa62d78012ac8b661bfaa323"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "vlaunch-2",
    "filePath": "token:VPAD",
    "symbol": "vpad",
    "name": "VLaunch",
    "marketCapRank": 1167,
    "addresses": {
      "binance-smart-chain": "0xf574ba6bde97cc09784e616ebaed432b4e896b49"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "vnx-euro",
    "filePath": "token:VEUR",
    "symbol": "veur",
    "name": "VNX EURO",
    "marketCapRank": 2220,
    "addresses": {
      "ethereum": "0x6ba75d640bebfe5da1197bb5a2aff3327789b5d3",
      "avalanche": "0x7678e162f38ec9ef2bfd1d0aaf9fd93355e5fa0b",
      "tezos": "KT1FenS7BCUjn1otfFyfrfxguiGnL4UTF3aG",
      "polygon-pos": "0xe4095d9372e68d108225c306a4491cacfb33b097",
      "solana": "C4Kkr9NZU3VbyedcgutU6LKmi6MKz81sx6gRmk5pX519"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "volt-inu-2",
    "filePath": "token:VOLT",
    "symbol": "volt",
    "name": "Volt Inu",
    "marketCapRank": 902,
    "addresses": {
      "ethereum": "0x7f792db54b0e580cdc755178443f0430cf799aca",
      "polygon-pos": "0x7f792db54b0e580cdc755178443f0430cf799aca",
      "binance-smart-chain": "0x7f792db54b0e580cdc755178443f0430cf799aca"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "voxies",
    "filePath": "token:VOXEL",
    "symbol": "voxel",
    "name": "Voxies",
    "marketCapRank": 798,
    "addresses": {
      "polygon-pos": "0xd0258a3fd00f38aa8090dfee343f10a9d4d30d3f"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "vulcan-forged",
    "filePath": "token:PYR",
    "symbol": "pyr",
    "name": "Vulcan Forged",
    "marketCapRank": 374,
    "addresses": {
      "ethereum": "0x430ef9263e76dae63c84292c3409d61c598e9682",
      "polygon-pos": "0x430ef9263e76dae63c84292c3409d61c598e9682"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "vvs-finance",
    "filePath": "token:VVS",
    "symbol": "vvs",
    "name": "VVS Finance",
    "marketCapRank": 320,
    "addresses": {
      "cronos": "0x2d03bece6747adc00e1a131bba1469c15fd11e03",
      "ethereum": "0x839e71613f9aa06e5701cf6de63e303616b0dde3"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "wagmi-2",
    "filePath": "token:WAGMI",
    "symbol": "wagmi",
    "name": "Wagmi",
    "marketCapRank": 1087,
    "addresses": {
      "metis-andromeda": "0xaf20f5f19698f1d19351028cd7103b63d30de7d7",
      "fantom": "0xb1f795776cb9ddac6e7e162f31c7419dd3d48297",
      "kava": "0xaf20f5f19698f1d19351028cd7103b63d30de7d7",
      "avalanche": "0xaf20f5f19698f1d19351028cd7103b63d30de7d7",
      "optimistic-ethereum": "0xaf20f5f19698f1d19351028cd7103b63d30de7d7",
      "ethereum": "0x92cc36d66e9d739d50673d1f27929a371fb83a67",
      "zksync": "0x3613ad277df1d5935d41400a181aa9ec1dc2dc9e",
      "polygon-pos": "0x07ed33a242bd9c08ca3c198e01189e35265024da",
      "arbitrum-one": "0xaf20f5f19698f1d19351028cd7103b63d30de7d7",
      "binance-smart-chain": "0xaf20f5f19698f1d19351028cd7103b63d30de7d7"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "wagmi-game-2",
    "filePath": "token:WAGMIGAMES",
    "symbol": "wagmigames",
    "name": "WAGMI Games",
    "marketCapRank": 832,
    "addresses": {
      "ethereum": "0x3b604747ad1720c01ded0455728b62c0d2f100f0"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "walken",
    "filePath": "token:WLKN",
    "symbol": "wlkn",
    "name": "Walken",
    "marketCapRank": 1897,
    "addresses": {
      "solana": "EcQCUYv57C4V6RoPxkVUiDwtX1SP8y8FP5AEToYL8Az"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "wam",
    "filePath": "token:WAM",
    "symbol": "wam",
    "name": "Wam",
    "marketCapRank": 1744,
    "addresses": {
      "binance-smart-chain": "0xebbaeff6217d22e7744394061d874015709b8141"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "wanchain",
    "filePath": "token:WAN",
    "symbol": "wan",
    "name": "Wanchain",
    "marketCapRank": 594,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "wasder",
    "filePath": "token:WAS",
    "symbol": "was",
    "name": "Wasder",
    "marketCapRank": 1355,
    "addresses": {
      "ethereum": "0x0c572544a4ee47904d54aaa6a970af96b6f00e1b"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "waves",
    "filePath": "token:WAVES",
    "symbol": "waves",
    "name": "Waves",
    "marketCapRank": 227,
    "addresses": {
      "ethereum": "0x1cf4592ebffd730c7dc92c1bdffdfc3b9efcf29a"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "wax",
    "filePath": "token:WAXP",
    "symbol": "waxp",
    "name": "WAX",
    "marketCapRank": 250,
    "addresses": {
      "ethereum": "0x2a79324c19ef2b89ea98b23bc669b7e7c9f8a517"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "wazirx",
    "filePath": "token:WRX",
    "symbol": "wrx",
    "name": "WazirX",
    "marketCapRank": 418,
    "addresses": {
      "binancecoin": "WRX-ED1",
      "energi": "0x0894840ba7d57c7adf2caf8fd3c41eb79af5b8e7",
      "polygon-pos": "0x72d6066f486bd0052eefb9114b66ae40e0a6031a",
      "binance-smart-chain": "0x8e17ed70334c87ece574c9d537bc153d8609e2a3"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "web3war",
    "filePath": "token:FPS",
    "symbol": "fps",
    "name": "web3war",
    "marketCapRank": 1580,
    "addresses": {
      "binance-smart-chain": "0x351da1e7500aba1d168b9435dce73415718d212f",
      "zilliqa": "zil1j2wrzjljwyjelspmtr63vfl34c467ype2w3mjl"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "webchain",
    "filePath": "token:MINTME",
    "symbol": "mintme",
    "name": "MintMe.com Coin",
    "marketCapRank": 2425,
    "addresses": {
      "binance-smart-chain": "0x138218c8e064ed2a011c9ff203759a8a1e23e6c8",
      "ethereum": "0x772722b55cdc2a086abd064267a17855eb15e8b3",
      "cronos": "0xd652776de7ad802be5ec7bebfafda37600222b48",
      "arbitrum-one": "0x7d05d38e6109a3aeeebf0a570eb8f6856cb4b55e"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "wefi-finance",
    "filePath": "token:WEFI",
    "symbol": "wefi",
    "name": "Wefi Finance",
    "marketCapRank": 1901,
    "addresses": {
      "polygon-pos": "0xffa188493c15dfaf2c206c97d8633377847b6a52",
      "ethereum": "0xffa188493c15dfaf2c206c97d8633377847b6a52",
      "zksync": "0x81e7186947fb59aaaaeb476a47daac60680cbbaf",
      "arbitrum-one": "0xffa188493c15dfaf2c206c97d8633377847b6a52",
      "binance-smart-chain": "0xffa188493c15dfaf2c206c97d8633377847b6a52"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "wemix-token",
    "filePath": "token:WEMIX",
    "symbol": "wemix",
    "name": "WEMIX",
    "marketCapRank": 131,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "wesendit",
    "filePath": "token:WSI",
    "symbol": "wsi",
    "name": "WeSendit",
    "marketCapRank": 1831,
    "addresses": {
      "binance-smart-chain": "0x837a130aed114300bab4f9f1f4f500682f7efd48"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "weway",
    "filePath": "token:WWY",
    "symbol": "wwy",
    "name": "WeWay",
    "marketCapRank": 976,
    "addresses": {
      "binance-smart-chain": "0x9ab70e92319f0b9127df78868fd3655fb9f1e322",
      "ethereum": "0x9ab70e92319f0b9127df78868fd3655fb9f1e322"
    },
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "whales-market",
    "filePath": "token:WHALES",
    "symbol": "whales",
    "name": "Whales Market",
    "marketCapRank": 914,
    "addresses": {
      "solana": "GTH3wG3NErjwcf7VGCoXEXkgXSHvYhx5gtATeeM5JAS1"
    },
    "variants": [
      "mono"
    ]
  },
  {
    "id": "white-whale",
    "filePath": "token:WHALE",
    "symbol": "whale",
    "name": "White Whale",
    "marketCapRank": 1350,
    "addresses": {
      "migaloo": "migaloo1ull9s4el2pmkdevdgrjt6pwa4e5xhkda40w84kghftnlxg4h3knqpm5u3n",
      "injective": "ibc/D6E6A20ABDD600742D22464340A7701558027759CE14D12590F8EA869CCCF445",
      "juno": "ibc/3A6ADE78FB8169C034C29C4F2E1A61CE596EC8235366F22381D981A98F1F5A5C",
      "terra-2": "ibc/36A02FFC4E74DF4F64305130C3DFA1B06BEAC775648927AA44467C76A77AB8DB"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "whitebit",
    "filePath": "token:WBT",
    "symbol": "wbt",
    "name": "WhiteBIT Coin",
    "marketCapRank": 101,
    "addresses": {
      "ethereum": "0x925206b8a707096ed26ae47c84747fe0bb734f59",
      "tron": "TFptbWaARrWTX5Yvy3gNG5Lm8BmhPx82Bt"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "whiteheart",
    "filePath": "token:WHITE",
    "symbol": "white",
    "name": "Whiteheart",
    "marketCapRank": 745,
    "addresses": {
      "ethereum": "0x5f0e628b693018f639d10e4a4f59bd4d8b2b6b44"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "wicrypt",
    "filePath": "token:WNT",
    "symbol": "wnt",
    "name": "Wicrypt",
    "marketCapRank": 1238,
    "addresses": {
      "polygon-pos": "0x82a0e6c02b91ec9f6ff943c0a933c03dbaa19689",
      "arbitrum-one": "0xad4b9c1fbf4923061814dd9d5732eb703faa53d4"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "wifi",
    "filePath": "token:WIFI",
    "symbol": "wifi",
    "name": "WiFi Map",
    "marketCapRank": 810,
    "addresses": {
      "polygon-pos": "0xe238ecb42c424e877652ad82d8a939183a04c35f"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "wigoswap",
    "filePath": "token:WIGO",
    "symbol": "wigo",
    "name": "WigoSwap",
    "marketCapRank": 1118,
    "addresses": {
      "fantom": "0xe992beab6659bff447893641a378fbbf031c5bd6"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "wild-goat-coin",
    "filePath": "token:WGC",
    "symbol": "wgc",
    "name": "Wild Goat Coin",
    "marketCapRank": 2240,
    "addresses": {
      "solana": "AfPeB1BDUotBeNoLv82XRDCNQcdAA1mqis3YC5SMTe7a",
      "polygon-pos": "0x382586651f043cbdec7bb586e367d77b26d7d149"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "wing-finance",
    "filePath": "token:WING",
    "symbol": "wing",
    "name": "Wing Finance",
    "marketCapRank": 869,
    "addresses": {},
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "wink",
    "filePath": "token:WIN",
    "symbol": "win",
    "name": "WINkLink",
    "marketCapRank": 395,
    "addresses": {
      "tron": "TLa2f6VPqDgRE67v1736s7bJ8Ray5wYjU7"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "winr-protocol",
    "filePath": "token:WINR",
    "symbol": "winr",
    "name": "WINR Protocol",
    "marketCapRank": 1068,
    "addresses": {
      "arbitrum-one": "0xd77b108d4f6cefaa0cae9506a934e825becca46e",
      "solana": "CsxCtA8usvWKdRhe7KhLU5GgwzYaLkoHsz1MKBVZ4W3M"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "wirex",
    "filePath": "token:WXT",
    "symbol": "wxt",
    "name": "WXT Token",
    "marketCapRank": 1263,
    "addresses": {
      "ethereum": "0xa02120696c7b8fe16c09c749e4598819b2b0e915",
      "avalanche": "0xfcde4a87b8b6fa58326bb462882f1778158b02f1",
      "stellar": "WXT-GASBLVHS5FOABSDNW5SPPH3QRJYXY5JHA2AOA2QHH2FJLZBRXSG4SWXT"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "wise-token11",
    "filePath": "token:WISE",
    "symbol": "wise",
    "name": "Wise",
    "marketCapRank": 1286,
    "addresses": {
      "ethereum": "0x66a0f676479cee1d7373f3dc2e2952778bff5bd6",
      "harmony-shard-0": "0xe7e3c4d1cfc722b45a428736845b6aff862842a1"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "witch-token",
    "filePath": "token:WITCH",
    "symbol": "witch",
    "name": "Witch Token",
    "marketCapRank": 1477,
    "addresses": {
      "ethereum": "0xdc524e3c6910257744c1f93cf15e9f472b5bd236"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "wliti",
    "filePath": "token:WLITI",
    "symbol": "wliti",
    "name": "wLITI",
    "marketCapRank": 2669,
    "addresses": {
      "ethereum": "0x0b63128c40737b13647552e0c926bcfeccc35f93"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "wojak",
    "filePath": "token:WOJAK",
    "symbol": "wojak",
    "name": "Wojak",
    "marketCapRank": 1005,
    "addresses": {
      "ethereum": "0x5026f006b85729a8b14553fae6af249ad16c9aab"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "wom-token",
    "filePath": "token:WOM",
    "symbol": "wom",
    "name": "WOM Protocol",
    "marketCapRank": 1432,
    "addresses": {
      "ethereum": "0xbd356a39bff2cada8e9248532dd879147221cf76"
    },
    "variants": [
      "mono"
    ]
  },
  {
    "id": "wombat",
    "filePath": "token:WOMBAT",
    "symbol": "wombat",
    "name": "Wombat",
    "marketCapRank": 1511,
    "addresses": {
      "ethereum": "0x0c9c7712c83b3c70e7c5e11100d33d9401bdf9dd",
      "polygon-pos": "0x0c9c7712c83b3c70e7c5e11100d33d9401bdf9dd"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "wonderman-nation",
    "filePath": "token:WNDR",
    "symbol": "wndr",
    "name": "Wonderman Nation",
    "marketCapRank": 2534,
    "addresses": {
      "binance-smart-chain": "0xdfd7b0dd7bf1012dfdf3307a964c36b972300ac8"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "woo-network",
    "filePath": "token:WOO",
    "symbol": "woo",
    "name": "WOO",
    "marketCapRank": 130,
    "addresses": {
      "ethereum": "0x4691937a7508860f876c9c0a2a617e7d9e945d4b",
      "fantom": "0x6626c47c00f1d87902fc13eecfac3ed06d5e8d8a",
      "avalanche": "0xabc9547b534519ff73921b1fba6e672b5f58d083",
      "zksync": "0x9e22d758629761fc5708c171d06c2fabb60b5159",
      "arbitrum-one": "0xcafcd85d8ca7ad1e1c6f82f651fa15e33aefd07b",
      "binance-smart-chain": "0x4691937a7508860f876c9c0a2a617e7d9e945d4b",
      "huobi-token": "0x3befb2308bce92da97264077faf37dcd6c8a75e6",
      "okex-chain": "0x5427a224e50a9af4d030aeecd2a686d41f348dfe",
      "polygon-pos": "0x1b815d120b3ef02039ee11dc2d33de7aa4a8c603",
      "near-protocol": "4691937a7508860f876c9c0a2a617e7d9e945d4b.factory.bridge.near",
      "solana": "E5rk3nmgLUuKUiS94gg4bpWwWwyjCMtddsAXkTFLtHEy"
    },
    "variants": [
      "mono"
    ]
  },
  {
    "id": "woof-token",
    "filePath": "token:WOOF",
    "symbol": "woof",
    "name": "WOOF",
    "marketCapRank": 2172,
    "addresses": {
      "solana": "9nEqaUcb16sQ3Tn1psbkWqyhPdLmfHWjKGymREjsAgTE"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "wownero",
    "filePath": "token:WOW",
    "symbol": "wow",
    "name": "Wownero",
    "marketCapRank": 1381,
    "addresses": {},
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "wozx",
    "filePath": "token:WOZX",
    "symbol": "wozx",
    "name": "Efforce",
    "marketCapRank": 1810,
    "addresses": {
      "ethereum": "0x34950ff2b487d9e5282c5ab342d08a2f712eb79f"
    },
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "wrapped-accumulate",
    "filePath": "token:WACME",
    "symbol": "wacme",
    "name": "Wrapped Accumulate",
    "marketCapRank": 1877,
    "addresses": {
      "ethereum": "0xdf4ef6ee483953fe3b84abd08c6a060445c01170"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "wrapped-ampleforth",
    "filePath": "token:WAMPL",
    "symbol": "wampl",
    "name": "Wrapped Ampleforth",
    "marketCapRank": 1220,
    "addresses": {
      "ethereum": "0xedb171c18ce90b633db442f2a6f72874093b49ef",
      "base": "0x489fe42c267fe0366b16b0c39e7aeef977e841ef"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "wrapped-beacon-eth",
    "filePath": "token:WBETH",
    "symbol": "wbeth",
    "name": "Wrapped Beacon ETH",
    "marketCapRank": 295,
    "addresses": {
      "ethereum": "0xa2e3356610840701bdf5611a53974510ae27e2e1",
      "binance-smart-chain": "0xa2e3356610840701bdf5611a53974510ae27e2e1"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "wrapped-bitcoin",
    "filePath": "token:WBTC",
    "symbol": "wbtc",
    "name": "Wrapped Bitcoin",
    "marketCapRank": 17,
    "addresses": {
      "ethereum": "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599",
      "thundercore": "0x18fb0a62f207a2a082ca60aa78f47a1af4985190",
      "fantom": "0x321162cd933e2be498cd2267a90534a804051b11",
      "polygon-zkevm": "0xea034fb02eb1808c2cc3adbc15f447b93cbe08e1",
      "sora": "0x002c48630dcb8c75cc36162cbdbc8ff27b843973b951ba9b6e260f869d45bcdc",
      "avalanche": "0x50b7545627a5162f82a992c33b87adc75187b218",
      "optimistic-ethereum": "0x68f180fcce6836688e9084f035309e29bf0a2095",
      "cronos": "0x062e66477faf219f25d27dced647bf57c3107d52",
      "zksync": "0xbbeb516fb02a01611cbbe0453fe3c580d7281011",
      "energi": "0x29a791703e5a5a8d1578f8611b4d3691377cebc0",
      "polygon-pos": "0x1bfd67037b42cf73acf2047067bd4f2c47d9bfd6",
      "tomochain": "0x503b2ddc059b81788fd1239561596614b27faade",
      "harmony-shard-0": "0x3095c7557bcb296ccc6e363de01b760ba031f2d9",
      "moonriver": "0x6ab6d61428fde76768d7b45d8bfeec19c6ef91a8",
      "boba": "0xdc0486f8bf31df57a952bcd3c1d3e166e3d9ec8b",
      "metis-andromeda": "0xa5b55ab1daf0f8e1efc0eb1931a957fd89b918f4",
      "xdai": "0x8e5bbbb09ed1ebde8674cda39a0c169401db4252",
      "aurora": "0xf4eb217ba2454613b15dbdea6e5f22276410e89e",
      "fuse": "0x33284f95ccb7b948d9d352e1439561cf83d8d00d",
      "meter": "0xc1f6c86abee8e2e0b6fd5bd80f0b51fef783635c",
      "moonbeam": "0x922d641a426dcffaef11680e5358f34d97d112e1",
      "telos": "0xf390830df829cf22c53c8840554b98eafc5dcbc2",
      "syscoin": "0xc9baa8cfdde8e328787e29b4b078abf2dadc2055",
      "milkomeda-cardano": "0x6ab6d61428fde76768d7b45d8bfeec19c6ef91a8",
      "conflux": "0x1f545487c62e5acfea45dcadd9c627361d1616d8",
      "kava": "0x818ec0a7fe18ff94269904fced6ae3dae6d6dc0b",
      "astar": "0xad543f18cff85c77e140e3e5e3c3392f6ba9d5ca",
      "cube": "0x040ea5c10e6ba4badb6c433a365ccc4968697230",
      "velas": "0x639a647fbe20b6c8ac19e48e2de44ea792c62c5c",
      "klay-token": "0xdcbacf3f7a069922e677912998c8d57423c37dfa",
      "hydra": "27a459ac47204f1e7fc5c48ffeafa990af244e13",
      "step-network": "0xb44a9b6905af7c801311e8f4e76932ee959c663c",
      "arbitrum-one": "0x2f2a2543b76a4166549f7aab2e75bef0aefc5b0f",
      "near-protocol": "2260fac5e5542a773aa44fbcfedf7c193bc2c599.factory.bridge.near",
      "celo": "0xd629eb00deced2a080b7ec630ef6ac117e614f1b"
    },
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "wrapped-centrifuge",
    "filePath": "token:WCFG",
    "symbol": "wcfg",
    "name": "Wrapped Centrifuge",
    "marketCapRank": 231,
    "addresses": {
      "ethereum": "0xc221b7e65ffc80de234bbb6667abdd46593d34f0"
    },
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "wrapped-nxm",
    "filePath": "token:WNXM",
    "symbol": "wnxm",
    "name": "Wrapped NXM",
    "marketCapRank": 591,
    "addresses": {
      "ethereum": "0x0d438f3b5175bebc262bf23753c1e53d03432bde"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "x-world-games",
    "filePath": "token:XWG",
    "symbol": "xwg",
    "name": "X World Games",
    "marketCapRank": 1536,
    "addresses": {
      "binance-smart-chain": "0x6b23c89196deb721e6fd9726e6c76e4810a464bc",
      "arbitrum-one": "0xeb4d25db65dcef52380c99ba7e1344c820ecb1fc",
      "ethereum": "0x0a77ef9bf662d62fbf9ba4cf861eaa83f9cc4fec"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "x2y2",
    "filePath": "token:X2Y2",
    "symbol": "x2y2",
    "name": "X2Y2",
    "marketCapRank": 1831,
    "addresses": {
      "ethereum": "0x1e4ede388cbc9f4b5c79681b7f94d36a11abebc9"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "xana",
    "filePath": "token:XETA",
    "symbol": "xeta",
    "name": "XANA",
    "marketCapRank": 660,
    "addresses": {
      "avalanche": "0x31c994ac062c1970c086260bc61babb708643fac",
      "ethereum": "0x967fb0d760ed3ce53afe2f0a071674cccae73550",
      "binance-smart-chain": "0xbc7370641ddcf16a27eea11230af4a9f247b61f9",
      "step-network": "0xf390830df829cf22c53c8840554b98eafc5dcbc2"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "xaurum",
    "filePath": "token:XAUR",
    "symbol": "xaur",
    "name": "Xaurum",
    "marketCapRank": 2671,
    "addresses": {
      "ethereum": "0x4df812f6064def1e5e029f1ca858777cc98d2d81"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "xcad-network",
    "filePath": "token:XCAD",
    "symbol": "xcad",
    "name": "XCAD Network",
    "marketCapRank": 638,
    "addresses": {
      "ethereum": "0x7659ce147d0e714454073a5dd7003544234b6aa0",
      "binance-smart-chain": "0xa026ad2ceda16ca5fc28fd3c72f99e2c332c8a26",
      "polygon-pos": "0xa55870278d6389ec5b524553d03c04f5677c061e",
      "zilliqa": "zil1z5l74hwy3pc3pr3gdh3nqju4jlyp0dzkhq2f5y",
      "metis-andromeda": "0x66673f0a3b5d99524ba76a558b93a9ca1386f4cd",
      "step-network": "0xe6801928061cdbe32ac5ad0634427e140efd05f9"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "xdce-crowd-sale",
    "filePath": "token:XDC",
    "symbol": "xdc",
    "name": "XDC Network",
    "marketCapRank": 151,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "xdefi",
    "filePath": "token:XDEFI",
    "symbol": "xdefi",
    "name": "XDEFI",
    "marketCapRank": 1245,
    "addresses": {
      "ethereum": "0x72b886d09c117654ab7da13a14d603001de0b777",
      "arbitrum-one": "0x180f7cf38805d1be95c7632f653e26b0838e2969"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "xels",
    "filePath": "token:XELS",
    "symbol": "xels",
    "name": "XELS",
    "marketCapRank": 1608,
    "addresses": {
      "ethereum": "0x397deb686c72384fad502a81f4d7fdb89e1f1280"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "xfinite-entertainment-token",
    "filePath": "token:XET",
    "symbol": "xet",
    "name": "Xfinite Entertainment",
    "marketCapRank": 2536,
    "addresses": {
      "algorand": "283820866"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "xfund",
    "filePath": "token:XFUND",
    "symbol": "xfund",
    "name": "xFUND",
    "marketCapRank": 1741,
    "addresses": {
      "ethereum": "0x892a6f9df0147e5f079b0993f486f9aca3c87881",
      "sora": "0x007e908e399cc73f3dad9f02f9c5c83a7adcd07e78dd91676ff3c002e245d8e9"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "xi-token",
    "filePath": "token:XI",
    "symbol": "xi",
    "name": "Xi",
    "marketCapRank": 2212,
    "addresses": {
      "ethereum": "0x295b42684f90c77da7ea46336001010f2791ec8c"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "xido-finance",
    "filePath": "token:XIDO",
    "symbol": "xido",
    "name": "Xido Finance",
    "marketCapRank": 907,
    "addresses": {
      "ethereum": "0xf6650117017ffd48b725b4ec5a00b414097108a7",
      "binance-smart-chain": "0x3764bc0de9b6a68c67929130aaec16b6060cab8c"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "xmon",
    "filePath": "token:XMON",
    "symbol": "xmon",
    "name": "XMON",
    "marketCapRank": 2259,
    "addresses": {
      "ethereum": "0x3aada3e213abf8529606924d8d1c55cbdc70bf74"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "xp-network",
    "filePath": "token:XPNET",
    "symbol": "xpnet",
    "name": "XP Network",
    "marketCapRank": 2292,
    "addresses": {
      "binance-smart-chain": "0x8cf8238abf7b933bf8bb5ea2c7e4be101c11de2a"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "xpla",
    "filePath": "token:XPLA",
    "symbol": "xpla",
    "name": "XPLA",
    "marketCapRank": 441,
    "addresses": {
      "osmosis": "ibc/95C9B5870F95E21A242E6AF9ADCB1F212EE4A8855087226C36FBE43FC41A77B8"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "xsgd",
    "filePath": "token:XSGD",
    "symbol": "xsgd",
    "name": "XSGD",
    "marketCapRank": 883,
    "addresses": {
      "ethereum": "0x70e8de73ce538da2beed35d14187f6959a8eca96",
      "zilliqa": "zil180v66mlw007ltdv8tq5t240y7upwgf7djklmwh",
      "polygon-pos": "0xdc3326e71d45186f113a2f448984ca0e8d201995"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "xsushi",
    "filePath": "token:XSUSHI",
    "symbol": "xsushi",
    "name": "xSUSHI",
    "marketCapRank": 722,
    "addresses": {
      "ethereum": "0x8798249c2e607446efb7ad49ec89dd1865ff4272"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "xswap-protocol",
    "filePath": "token:XSP",
    "symbol": "xsp",
    "name": "XSwap Protocol",
    "marketCapRank": 2227,
    "addresses": {
      "xdc-network": "xdc36726235dadbdb4658d33e62a249dca7c4b2bc68"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "xwin-finance",
    "filePath": "token:XWIN",
    "symbol": "xwin",
    "name": "xWIN Finance",
    "marketCapRank": 1753,
    "addresses": {
      "binance-smart-chain": "0xd88ca08d8eec1e9e09562213ae83a7853ebb5d28",
      "polygon-pos": "0x6cd6cb131764c704ba9167c29930fbdc38901ab7"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "xy-finance",
    "filePath": "token:XY",
    "symbol": "xy",
    "name": "XY Finance",
    "marketCapRank": 2167,
    "addresses": {
      "ethereum": "0x77777777772cf0455fb38ee0e75f38034dfa50de",
      "binance-smart-chain": "0x666666661f9b6d8c581602aaa2f76cbead06c401",
      "fantom": "0x444444443b0fcb2733b93f23c910580fba52fffa",
      "polygon-pos": "0x55555555a687343c6ce28c8e1f6641dc71659fad"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "xyo-network",
    "filePath": "token:XYO",
    "symbol": "xyo",
    "name": "XYO Network",
    "marketCapRank": 413,
    "addresses": {
      "ethereum": "0x55296f69f40ea6d20e478533c15a6b08b654e758"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "y2k",
    "filePath": "token:Y2K",
    "symbol": "y2k",
    "name": "Y2K",
    "marketCapRank": 2606,
    "addresses": {
      "arbitrum-one": "0x65c936f008bc34fe819bce9fa5afd9dc2d49977f"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "yam-2",
    "filePath": "token:YAM",
    "symbol": "yam",
    "name": "YAM",
    "marketCapRank": 2350,
    "addresses": {
      "ethereum": "0x0aacfbec6a24756c20d41914f2caba817c0d8521",
      "harmony-shard-0": "0x7202adf025cbd1cc9411fd56e3cc8ef2e9dffa9d"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "yearn-finance",
    "filePath": "token:YFI",
    "symbol": "yfi",
    "name": "yearn.finance",
    "marketCapRank": 272,
    "addresses": {
      "ethereum": "0x0bc529c00c6401aef6d220be8c6ea1667f6ad93e",
      "xdai": "0xbf65bfcb5da067446cee6a706ba3fe2fb1a9fdfd",
      "avalanche": "0x9eaac1b23d935365bd7b542fe22ceee2922f52dc",
      "optimistic-ethereum": "0x9046d36440290ffde54fe0dd84db8b1cfee9107b",
      "near-protocol": "0bc529c00c6401aef6d220be8c6ea1667f6ad93e.factory.bridge.near",
      "energi": "0x2726dd5efb3a209a54c512e9562a2045b8f45dbc",
      "base": "0x9eaf8c1e34f05a589eda6bafdf391cf6ad3cb239",
      "huobi-token": "0xb4f019beac758abbee2f906033aaa2f0f6dacb35",
      "polygon-pos": "0xda537104d6a5edd53c6fbba9a898708e465260b6",
      "harmony-shard-0": "0xa0dc05f84a27fccbd341305839019ab86576bc07",
      "fantom": "0x29b0da86e484e1c0029b56e817912d778ac0ec69",
      "arbitrum-one": "0x82e3a8f066a6989666b031d916c43672085b1582",
      "sora": "0x002676c3edea5b08bc0f9b6809a91aa313b7da35e28b190222e9dc032bf1e662"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "yes-money",
    "filePath": "token:YES",
    "symbol": "yes",
    "name": "YES Money",
    "marketCapRank": 663,
    "addresses": {
      "blast": "0x20fe91f17ec9080e3cac2d688b4ecb48c5ac3a9c"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "yfii-finance",
    "filePath": "token:YFII",
    "symbol": "yfii",
    "name": "DFI.money",
    "marketCapRank": 1132,
    "addresses": {
      "ethereum": "0xa1d0e215a23d7030842fc67ce582a6afa3ccab83",
      "energi": "0xba71e0c0b13e724bf2329ecb9bdf5775a2ce9e8d"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "yield-guild-games",
    "filePath": "token:YGG",
    "symbol": "ygg",
    "name": "Yield Guild Games",
    "marketCapRank": 210,
    "addresses": {
      "ethereum": "0x25f8087ead173b73d6e8b84329989a8eea16cf73",
      "ronin": "0x1c306872bc82525d72bf3562e8f0aa3f8f26e857",
      "polygon-pos": "0x82617aa52dddf5ed9bb7b370ed777b3182a30fd1",
      "harmony-shard-0": "0x63cf309500d8be0b9fdb8f1fb66c821236c0438c"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "yield-yak",
    "filePath": "token:YAK",
    "symbol": "yak",
    "name": "Yield Yak",
    "marketCapRank": 1596,
    "addresses": {
      "avalanche": "0x59414b3089ce2af0010e7523dea7e2b35d776ec7",
      "arbitrum-one": "0x7f4db37d7beb31f445307782bc3da0f18df13696"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "yieldification",
    "filePath": "token:YDF",
    "symbol": "ydf",
    "name": "Yieldification",
    "marketCapRank": 2358,
    "addresses": {
      "ethereum": "0x30dcba0405004cf124045793e1933c798af9e66a",
      "arbitrum-one": "0x30dcba0405004cf124045793e1933c798af9e66a"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "yoshi-exchange",
    "filePath": "token:YOSHI",
    "symbol": "yoshi",
    "name": "Yoshi.exchange",
    "marketCapRank": 1657,
    "addresses": {
      "fantom": "0x3dc57b391262e3aae37a08d91241f9ba9d58b570",
      "binance-smart-chain": "0x4374f26f0148a6331905edf4cd33b89d8eed78d1"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "youves-you-governance",
    "filePath": "token:YOU",
    "symbol": "you",
    "name": "Youves YOU Governance",
    "marketCapRank": 1837,
    "addresses": {
      "tezos": "KT1Xobej4mc6XgEjDoJoHtTKgbD1ELMvcQuL"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "yuan-chain-coin",
    "filePath": "token:YCC",
    "symbol": "ycc",
    "name": "Yuan Chain Coin",
    "marketCapRank": 1651,
    "addresses": {
      "ethereum": "0x37e1160184f7dd29f00b78c050bf13224780b0b0"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "zano",
    "filePath": "token:ZANO",
    "symbol": "zano",
    "name": "Zano",
    "marketCapRank": 783,
    "addresses": {
      "ethereum": "0xdb85f6685950e285b1e611037bebe5b34e2b7d78"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "zap",
    "filePath": "token:ZAP",
    "symbol": "zap",
    "name": "Zap",
    "marketCapRank": 2064,
    "addresses": {
      "ethereum": "0x6781a0f84c7e9e846dcb84a9a5bd49333067b104",
      "solana": "HxPoEHMt1vKeqjKCePcqTj6yYgn6Xqq1fKTY3Pjx4YrX",
      "binance-smart-chain": "0xc5326b32e8baef125acd68f8bc646fd646104f1c"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "zcash",
    "filePath": "token:ZEC",
    "symbol": "zec",
    "name": "Zcash",
    "marketCapRank": 207,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "zcoin",
    "filePath": "token:FIRO",
    "symbol": "firo",
    "name": "Firo",
    "marketCapRank": 1032,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "zebec-protocol",
    "filePath": "token:ZBC",
    "symbol": "zbc",
    "name": "Zebec Protocol",
    "marketCapRank": 346,
    "addresses": {
      "solana": "zebeczgi5fSEtbpfQKVZKCJ3WgYXxjkMUkNNx7fLKAF"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "zeitgeist",
    "filePath": "token:ZTG",
    "symbol": "ztg",
    "name": "Zeitgeist",
    "marketCapRank": 2602,
    "addresses": {},
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "zelcash",
    "filePath": "token:FLUX",
    "symbol": "flux",
    "name": "Flux",
    "marketCapRank": 204,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "zencash",
    "filePath": "token:ZEN",
    "symbol": "zen",
    "name": "Horizen",
    "marketCapRank": 330,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "zenlink-network-token",
    "filePath": "token:ZLK",
    "symbol": "zlk",
    "name": "Zenlink Network",
    "marketCapRank": 2648,
    "addresses": {
      "moonriver": "0x0f47ba9d9bde3442b42175e51d6a367928a1173b",
      "astar": "0x998082c488e548820f970df5173bd2061ce90635"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "zenon-2",
    "filePath": "token:ZNN",
    "symbol": "znn",
    "name": "Zenon",
    "marketCapRank": 1297,
    "addresses": {
      "ethereum": "0xb2e96a63479c2edd2fd62b382c89d5ca79f572d3"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "zeroliquid",
    "filePath": "token:ZERO",
    "symbol": "zero",
    "name": "ZeroLiquid",
    "marketCapRank": 2629,
    "addresses": {
      "ethereum": "0xb0ed33f79d89541dfdcb04a8f04bc2c6be025ecc"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "zeroswap",
    "filePath": "token:ZEE",
    "symbol": "zee",
    "name": "ZeroSwap",
    "marketCapRank": 2194,
    "addresses": {
      "ethereum": "0x2edf094db69d6dcd487f1b3db9febe2eec0dd4c5",
      "avalanche": "0x44754455564474a89358b2c2265883df993b12f0",
      "binance-smart-chain": "0x44754455564474a89358b2c2265883df993b12f0",
      "polygon-pos": "0xfd4959c06fbcc02250952daebf8e0fb38cf9fd8c"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "zignaly",
    "filePath": "token:ZIG",
    "symbol": "zig",
    "name": "Zignaly",
    "marketCapRank": 461,
    "addresses": {
      "ethereum": "0xb2617246d0c6c0087f18703d576831899ca94f01",
      "injective": "peggy0xb2617246d0c6c0087f18703d576831899ca94f01",
      "polygon-pos": "0x7bebd226154e865954a87650faefa8f485d36081",
      "binance-smart-chain": "0x8c907e0a72c3d55627e853f4ec6a96b0c8771145",
      "solana": "ANqY8h3sRSwkC29FvGJenAh7VGRABVVx7Ls6Mq4BuGT"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "zigzag-2",
    "filePath": "token:ZZ",
    "symbol": "zz",
    "name": "ZigZag",
    "marketCapRank": 2150,
    "addresses": {
      "ethereum": "0xc91a71a1ffa3d8b22ba615ba1b9c01b2bbbf55ad"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "zilliqa",
    "filePath": "token:ZIL",
    "symbol": "zil",
    "name": "Zilliqa",
    "marketCapRank": 153,
    "addresses": {
      "binance-smart-chain": "0xb86abcb37c3a4b64f74f59301aff131a1becc787"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "zkapes-token",
    "filePath": "token:ZAT",
    "symbol": "zat",
    "name": "zkApes Token",
    "marketCapRank": 2624,
    "addresses": {
      "zksync": "0x47ef4a5641992a72cfd57b9406c9d9cefee8e0c4"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "zkspace",
    "filePath": "token:ZKB",
    "symbol": "zkb",
    "name": "ZKBase",
    "marketCapRank": 1485,
    "addresses": {
      "ethereum": "0xbbbbbbbb46a1da0f0c3f64522c275baa4c332636",
      "energi": "0xc4efad8386124927fb46b146526625e143e5a63a"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "zksync-id",
    "filePath": "token:ZKID",
    "symbol": "zkid",
    "name": "zkSync id",
    "marketCapRank": 2003,
    "addresses": {
      "zksync": "0x2141d7fe06a1d69c016fc638ba75b6ef92fa1435"
    },
    "variants": [
      "mono",
      "branded",
      "background"
    ]
  },
  {
    "id": "zmine",
    "filePath": "token:ZMN",
    "symbol": "zmn",
    "name": "ZMINE",
    "marketCapRank": 1618,
    "addresses": {
      "binance-smart-chain": "0xfcb8a4b1a0b645e08064e05b98e9cc6f48d2aa57"
    },
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "zoid-pay",
    "filePath": "token:ZPAY",
    "symbol": "zpay",
    "name": "ZoidPay",
    "marketCapRank": 1638,
    "addresses": {
      "tomochain": "0xe1a9a5fae06696d314994a9d6915c12a63ad055d"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "zoomer",
    "filePath": "token:ZOOMER",
    "symbol": "zoomer",
    "name": "Zoomer",
    "marketCapRank": 1913,
    "addresses": {
      "ethereum": "0x0d505c03d30e65f6e9b4ef88855a47a89e4b7676",
      "polygon-pos": "0xb962150760f9a3bb00e3e9cf48297ee20ada4a33",
      "arbitrum-nova": "0xb962150760f9a3bb00e3e9cf48297ee20ada4a33",
      "optimistic-ethereum": "0xb962150760f9a3bb00e3e9cf48297ee20ada4a33",
      "base": "0xd1db4851bcf5b41442caa32025ce0afe6b8eabc2",
      "binance-smart-chain": "0xb962150760f9a3bb00e3e9cf48297ee20ada4a33",
      "solana": "nBZEcHSG771mRbi4y2sSgKjfDUH8jsM2Eo5fNcASLeU"
    },
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "zynecoin",
    "filePath": "token:ZYN",
    "symbol": "zyn",
    "name": "Zynecoin",
    "marketCapRank": 2235,
    "addresses": {},
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "hush",
    "filePath": "token:HUSH",
    "symbol": "HUSH",
    "name": "Hush",
    "marketCapRank": 0,
    "addresses": {},
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "imx",
    "filePath": "token:IMX",
    "symbol": "IMX",
    "name": "Immutable",
    "marketCapRank": 0,
    "addresses": {},
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "pnb",
    "filePath": "token:PNB",
    "symbol": "PNB",
    "name": "Pink BNB",
    "marketCapRank": 0,
    "addresses": {},
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "JOP",
    "filePath": "token:JOP",
    "symbol": "JOP",
    "name": "Japan Open Chain",
    "marketCapRank": 0,
    "addresses": {},
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "0x-protocol",
    "filePath": "token:ZRX",
    "symbol": "ZRX",
    "name": "0x Protocol",
    "marketCapRank": 0,
    "addresses": {},
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "vara",
    "filePath": "token:VARA",
    "symbol": "VARA",
    "name": "Vara",
    "marketCapRank": 0,
    "addresses": {},
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "vine",
    "filePath": "token:VINE",
    "symbol": "VINE",
    "name": "Vine Coin",
    "marketCapRank": 0,
    "addresses": {
      "solana": "6AJcP7wuLwmRYLBNbi825wgguaPsWzPBEHcHndpRpump"
    },
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "SWELL",
    "filePath": "token:SWELL",
    "symbol": "SWELL",
    "name": "Swell",
    "marketCapRank": 0,
    "addresses": {
      "ethereum": "0x0a6e7ba5042b38349e437ec6db6214aec7b35676"
    },
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "ARI",
    "filePath": "token:ARI",
    "symbol": "ARI",
    "name": "ARI",
    "marketCapRank": 0,
    "addresses": {
      "base": "0xd1e6f3f0a7f40d5412f7471875879381441bf722"
    },
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "PEAQ",
    "filePath": "token:PEAQ",
    "symbol": "PEAQ",
    "name": "peaq",
    "marketCapRank": 0,
    "addresses": {
      "ethereum": "0x408480574c803D05a0244b479c5020a97f546c51"
    },
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "EURC",
    "filePath": "token:EURC",
    "symbol": "EURC",
    "name": "EURC",
    "marketCapRank": 0,
    "addresses": {
      "ethereum": "0x1abaea1f7c830bd89acc67ec4af516284b1bc33c",
      "avalanche": "0xC891EB4cbdEFf6e073e859e987815Ed1505c2ACD",
      "solana": "HzwqbKZw8HxMN6bF2yFZNrht3c2iXXzpKcFu7uBEDKtr",
      "stellar": "EURC-GDHU6WRG4IEQXM5NZ4BMPKOXHW76MZM4Y2IEMFDVXBSDP6SJY4ITNPP2",
      "base": "0x60a3e35cc302bfa44cb288bc5a4f316fdb1adb42"
    },
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "A",
    "filePath": "token:A",
    "symbol": "A",
    "name": "Vaulta",
    "marketCapRank": 0,
    "addresses": {
      "ethereum": "0xCc80062086c8fb8d4837C56FCDB25A67Cd9c7d58"
    },
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "minima",
    "filePath": "network:minima",
    "symbol": "MINIMA",
    "name": "Minima",
    "marketCapRank": 0,
    "addresses": {
      "ethereum": "0x669c01CAF0eDcaD7c2b8Dc771474aD937A7CA4AF"
    },
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "ame",
    "filePath": "network:ame-chain",
    "symbol": "AME",
    "name": "Ame Chain",
    "marketCapRank": 0,
    "addresses": {},
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "hype",
    "filePath": "network:hyper-evm",
    "symbol": "HYPE",
    "name": "Hyper EVM",
    "marketCapRank": 0,
    "addresses": {},
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "pecunity",
    "filePath": "token:PEC",
    "symbol": "PEC",
    "name": "Pecunity",
    "marketCapRank": 0,
    "addresses": {
      "binance-smart-chain": "0x413c2834f02003752d6Cc0Bcd1cE85Af04D62fBE"
    },
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "gun",
    "filePath": "network:gunz",
    "symbol": "GUN",
    "name": "GUNZ",
    "marketCapRank": 0,
    "addresses": {},
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "JURIS",
    "filePath": "network:juris",
    "symbol": "JURIS",
    "name": "Juris Protocol",
    "marketCapRank": 0,
    "addresses": {
      "terra-classic": "terra1vhgq25vwuhdhn9xjll0rhl2s67jzw78a4g2t78y5kz89q9lsdskq2pxcj2",
      "osmosis": "ibc/46579C587A0B8CF8B0A1FF6B0EFA2082F11876578E47FC81A9CAAD31F424AF98"
    },
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "HNS",
    "filePath": "token:HNS",
    "symbol": "HNS",
    "name": "Handshake",
    "marketCapRank": 0,
    "addresses": {},
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "MON",
    "filePath": "network:monad",
    "symbol": "MON",
    "name": "Monad",
    "marketCapRank": 0,
    "addresses": {
      "ethereum": "0x6917037f8944201b2648198a89906edf863b9517",
      "solana": "CrAr4RRJMBVwRsZtT62pEhfA9H5utymC2mVx8e7FreP2"
    },
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "crab",
    "filePath": "network:crab",
    "symbol": "CRAB",
    "name": "Crab",
    "marketCapRank": 0,
    "addresses": {},
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "l1",
    "filePath": "network:genesis-l1",
    "symbol": "L1",
    "name": "Genesis L1",
    "marketCapRank": 0,
    "addresses": {},
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "uptick",
    "filePath": "network:uptick",
    "symbol": "UPTICK",
    "name": "Uptick",
    "marketCapRank": 0,
    "addresses": {},
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "xpl",
    "filePath": "network:plasma",
    "symbol": "XPL",
    "name": "Plasma",
    "marketCapRank": 0,
    "addresses": {
      "binance-smart-chain": "0x405FBc9004D857903bFD6b3357792D71a50726b0",
      "plasma": "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee"
    },
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "plume",
    "filePath": "network:plume",
    "symbol": "PLUME",
    "name": "Plume",
    "marketCapRank": 0,
    "addresses": {},
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "pls",
    "filePath": "network:pulsechain",
    "symbol": "PLS",
    "name": "Pulsechain",
    "marketCapRank": 0,
    "addresses": {},
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "CBTC",
    "filePath": "token:CBTC",
    "symbol": "CBTC",
    "name": "cBTC",
    "marketCapRank": 0,
    "addresses": {},
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "USDE",
    "filePath": "token:USDE",
    "symbol": "USDE",
    "name": "USDe",
    "marketCapRank": 0,
    "addresses": {
      "ethereum": "0x4c9EDD5852cd905f086C759E8383e09bff1E68B3"
    },
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  }
]